export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BackupDuration: { input: any; output: any };
  BackupSize: { input: any; output: any };
  /**
   * A string-keyed map represented as a list of { key, value } objects, e.g.
   * [{ key: "X-Header", value: "v" }]. Keys must be unique. Bridges to a proto
   * map<string, string>.
   */
  KeyValuePairs: { input: any; output: any };
  Success: { input: any; output: any };
  Time: { input: any; output: any };
  TimescaleVersion: { input: any; output: any };
  /** Binary file upload via graphql-multipart-request-spec. */
  Upload: { input: any; output: any };
};

export type ActivityLog = {
  __typename?: "ActivityLog";
  description: Scalars["String"]["output"];
  eventType: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  serviceId: Scalars["String"]["output"];
  timestamp: Scalars["Time"]["output"];
  user?: Maybe<User>;
};

export type ActivityLogItem = {
  __typename?: "ActivityLogItem";
  item: ActivityLog;
};

export type ActivityLogItems = {
  __typename?: "ActivityLogItems";
  items: Array<ActivityLogItem>;
};

export type AddAuthenticator = {
  /** Code generated from the secret */
  code: Scalars["String"]["input"];
  /** Base32 encoded, 160bits recommended https://www.rfc-editor.org/rfc/rfc4226#section-4 */
  secret: Scalars["String"]["input"];
};

export type AddCompressionPolicyInput = {
  contAggName?: InputMaybe<Scalars["ID"]["input"]>;
  olderThan: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
  tableName?: InputMaybe<Scalars["ID"]["input"]>;
  tableSchema: Scalars["ID"]["input"];
};

export type AddMfaMethodInput = {
  authenticator?: InputMaybe<AddAuthenticator>;
};

export type AddMfaMethodResponse = {
  __typename?: "AddMfaMethodResponse";
  method: MfaMethod;
  /** Recovery codes nullable because if we support multiple factors it will only be returned for first */
  recoveryCodes?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type AddSupportCaseReplyInput = {
  /** Optional file attachments (max 10, 25 MiB each). */
  attachments?: InputMaybe<Array<Scalars["Upload"]["input"]>>;
  /** The reply text. */
  body: Scalars["String"]["input"];
  /** The Salesforce Case ID to reply to. */
  caseId: Scalars["ID"]["input"];
  /** The project the case belongs to (for authorization). */
  projectId: Scalars["ID"]["input"];
};

export type AddTableToPgSrcConnectorInput = {
  connectorId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  table: ConnectorTableSpecInput;
};

export type AddonIoBoostEntitlement = {
  __typename?: "AddonIOBoostEntitlement";
  enabled: Scalars["Boolean"]["output"];
  max_iops: Scalars["Int"]["output"];
  min_iops: Scalars["Int"]["output"];
};

/** All details on a `BillingAccount`'s address information. */
export type AddressDetails = {
  __typename?: "AddressDetails";
  /** The company address for the associated billing account. */
  companyAddress?: Maybe<AddressInfo>;
};

/** Address info. */
export type AddressInfo = {
  __typename?: "AddressInfo";
  /** City, district, suburb, town, or village. */
  city: Scalars["String"]["output"];
  /** Company name. */
  companyName?: Maybe<Scalars["String"]["output"]>;
  /** Two-letter country code (ISO 3166-1 alpha-2). */
  country: Scalars["String"]["output"];
  /** Address line 1 (e.g., street, PO Box, or company name). */
  line1: Scalars["String"]["output"];
  /** Address line 2 (e.g., apartment, suite, unit, or building). */
  line2: Scalars["String"]["output"];
  /** ZIP or postal code. */
  postalCode: Scalars["String"]["output"];
  /** State, county, province, or region. */
  state: Scalars["String"]["output"];
};

/** Address info input. */
export type AddressInfoInput = {
  /** City, district, suburb, town, or village. */
  city: Scalars["String"]["input"];
  /** Company name. */
  companyName?: InputMaybe<Scalars["String"]["input"]>;
  /** Two-letter country code (ISO 3166-1 alpha-2). */
  country: Scalars["String"]["input"];
  /** Address line 1 (e.g., street, PO Box, or company name). */
  line1: Scalars["String"]["input"];
  /** Address line 2 (e.g., apartment, suite, unit, or building). */
  line2: Scalars["String"]["input"];
  /** ZIP or postal code. */
  postalCode: Scalars["String"]["input"];
  /** State, county, province, or region. */
  state: Scalars["String"]["input"];
};

export type AttachServiceToGenericExporterInput = {
  /** The internal ID of the generic exporter to attach with. */
  exporterId: Scalars["String"]["input"];
  /** The project ID of the service. */
  projectId: Scalars["ID"]["input"];
  /** The ID of the service. */
  serviceId: Scalars["ID"]["input"];
};

export type AttachServiceToMetricExporterInput = {
  /**
   * The internal ID of the metric exporter to attach with.
   * @deprecated use exporterUuid
   */
  exporterId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The UUID of the metric exporter to attach with */
  exporterUuid?: InputMaybe<Scalars["ID"]["input"]>;
  /** The project ID of the service. */
  projectId: Scalars["ID"]["input"];
  /** The ID of the service. */
  serviceId: Scalars["ID"]["input"];
};

export type AttachServiceToPrivateLinkConnectionInput = {
  connectionIds: Array<Scalars["ID"]["input"]>;
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type AttachServiceToVpcInput = {
  /** The project ID of the service. */
  projectId: Scalars["ID"]["input"];
  /** The ID of the service. */
  serviceId: Scalars["ID"]["input"];
  /** The internal forge ID of the shell VPC that we are attaching the service to. */
  vpcId: Scalars["ID"]["input"];
};

export type AuthenticatorMethod = {
  __typename?: "AuthenticatorMethod";
  id: Scalars["ID"]["output"];
};

export type AuthorizationCodeInput = {
  clientId: Scalars["String"]["input"];
  codeChallenge: Scalars["String"]["input"];
  codeChallengeMethod: Scalars["String"]["input"];
  redirectUri: Scalars["String"]["input"];
  responseType: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
};

export type AuthorizationCodeOutput = {
  __typename?: "AuthorizationCodeOutput";
  code: Scalars["String"]["output"];
};

export type AutoscaleSettings = {
  __typename?: "AutoscaleSettings";
  /** Is autoscaling enabled. */
  enabled: Scalars["Boolean"]["output"];
  /** Upper limit measured in GB. */
  upper_limit_gb: Scalars["Int"]["output"];
};

export type AwsAssumeRole = {
  __typename?: "AwsAssumeRole";
  roleArn: Scalars["String"]["output"];
};

export type AwsAssumeRoleInput = {
  roleArn: Scalars["String"]["input"];
};

export type AzureMonitorMetricConfig = {
  __typename?: "AzureMonitorMetricConfig";
  connectionString: Scalars["String"]["output"];
};

export type AzureMonitorMetricConfigInput = {
  connectionString: Scalars["String"]["input"];
};

export type Backup = {
  __typename?: "Backup";
  finishedAt?: Maybe<Scalars["Time"]["output"]>;
  label: Scalars["String"]["output"];
  region?: Maybe<Scalars["String"]["output"]>;
  size?: Maybe<Scalars["BackupSize"]["output"]>;
  startedAt: Scalars["Time"]["output"];
  status: BackupCopyStatus;
  takenTime?: Maybe<Scalars["BackupDuration"]["output"]>;
  type: BackupType;
};

export enum BackupCopyStatus {
  Failed = "FAILED",
  Finished = "FINISHED",
  Retrying = "RETRYING",
  Running = "RUNNING",
  Scheduled = "SCHEDULED",
  Unknown = "UNKNOWN",
}

export type BackupList = {
  __typename?: "BackupList";
  backups: Array<Backup>;
};

export type BackupRegion = {
  __typename?: "BackupRegion";
  createdAt: Scalars["Time"]["output"];
  region: Scalars["String"]["output"];
};

export enum BackupType {
  Full = "FULL",
  Incr = "INCR",
}

export type BackupsRetentionStatusInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type BackupsRetentionStatusResponse = {
  __typename?: "BackupsRetentionStatusResponse";
  retCount: Scalars["Int"]["output"];
  retType: Scalars["String"]["output"];
};

/** A billing account record. */
export type BillingAccount = {
  __typename?: "BillingAccount";
  /**
   * Address info associated with the billing account.
   *
   * This field will be `null` if no address information has ever been configured for this
   * `BillingAccount`.
   */
  addressDetails: AddressDetails;
  /** All permissions which have been granted on this billing account. */
  allPermissions: Array<BillingPermission>;
  /** The date this record was created. */
  created: Scalars["Time"]["output"];
  /** The ID of the billing account. */
  id: Scalars["ID"]["output"];
  isDelinquent: Scalars["Boolean"]["output"];
  /**
   * Does this billing account use corporate invoicing instead of cards.
   * @deprecated use paymentMethodInfo
   */
  isUsingInvoicing: Scalars["Boolean"]["output"];
  /** The display name of this billing account. */
  name: Scalars["String"]["output"];
  /** The organization id of the billing account */
  organizationId: Scalars["ID"]["output"];
  paymentMethodInfo: PaymentMethodInfo;
  /**
   * All payment methods currently configured on this billing account.
   * @deprecated use paymentMethodInfo
   */
  paymentMethods: Array<PaymentMethod>;
  /** The caller's permissions on this billing account. */
  permission: BillingPermission;
  /** A timestamp indicating when this billing account's trial period will end. */
  trialEndDate: Scalars["Time"]["output"];
  trialStatus: TrialStatus;
  trialType: TrialType;
  trialUsage?: Maybe<TrialUsage>;
};

/** All cost information for a specific billing account. */
export type BillingAccountCostInfo = {
  __typename?: "BillingAccountCostInfo";
  /** The end of the current billing period (exclusive), as a unix timestamp. */
  billingPeriodEnd: Scalars["Time"]["output"];
  /** The beginning of the current billing period (inclusive), as a unix timestamp. */
  billingPeriodStart: Scalars["Time"]["output"];
  /** The timestamp when this cache entry was last updated. */
  cacheTimestamp: Scalars["Time"]["output"];
  /** The cost-to-date for the current billing period, minus any trials or credits. */
  costToDate: Scalars["Float"]["output"];
  /** The cost-to-date for the current billing period. */
  costToDateGross: Scalars["Float"]["output"];
  /** The estimated total cost for the current billing period, minus any trials or credits. */
  estimatedTotalCost: Scalars["Float"]["output"];
  /** The estimated total cost for the current billing period. */
  estimatedTotalCostGross: Scalars["Float"]["output"];
  /** The breakdown on the per-product usage */
  productCostInfos: Array<ProductCostInfo>;
  /** The breakdown on the per-service usage */
  serviceCostInfos: Array<ServiceCostInfo>;
};

/** A billing email addr (email tied to a billing account that receives billing emails). */
export type BillingEmailAddress = {
  __typename?: "BillingEmailAddress";
  /** The date at which this email has been activated */
  activated?: Maybe<Scalars["Time"]["output"]>;
  /** The billing account to which this record applies. */
  billingAccountId: Scalars["ID"]["output"];
  /** The date of creation of this email. */
  created: Scalars["Time"]["output"];
  /** The email. */
  email: Scalars["String"]["output"];
  /** The ID of the `BillingEmailAddress`. */
  id: Scalars["ID"]["output"];
};

/** A billing permission record. */
export type BillingPermission = {
  __typename?: "BillingPermission";
  /** The billing account this permission is granted on. */
  billingAccountId: Scalars["ID"]["output"];
  /** The datetime this object was created, as a unix timestamp. */
  created: Scalars["Time"]["output"];
  /** The role associated with this permissions grant. */
  role: BillingRole;
  /** The user this permission is granted to. */
  userId: Scalars["ID"]["output"];
};

/** A role which a user may be granted on a Billing Account. */
export enum BillingRole {
  /** The omnipotent admin role for Billing Accounts. All actions allowed. */
  Admin = "ADMIN",
  /** The read-only viewer role for Billing Accounts. */
  Viewer = "VIEWER",
}

export type BillingTimeline = {
  __typename?: "BillingTimeline";
  currency: Scalars["String"]["output"];
  dailyCompositions: Array<DailyComposition>;
  timelineBegin: Scalars["Time"]["output"];
  timelineEnd: Scalars["Time"]["output"];
};

export type BindIpAllowListInput = {
  listId: Scalars["Int"]["input"];
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type BucketObject = {
  __typename?: "BucketObject";
  bytes: Scalars["Int"]["output"];
  key: Scalars["String"]["output"];
};

export type CancelPendingPaymentDeletionInput = {
  billingAccountId: Scalars["ID"]["input"];
  paymentMethodId: Scalars["ID"]["input"];
};

/** Card expiration input info. */
export type CardExpInput = {
  /** Two-digit number representing the card’s expiration month. */
  expMonth: Scalars["Int"]["input"];
  /** Four-digit number representing the card’s expiration year. */
  expYear: Scalars["Int"]["input"];
};

/** Information on a `PaymentMethod`'s card. */
export type CardInfo = {
  __typename?: "CardInfo";
  /** The brand of the card. */
  brand: Scalars["String"]["output"];
  /** The country where this card was issued. */
  country: Scalars["String"]["output"];
  /** The month this card will expire. */
  expMonth: Scalars["Int"]["output"];
  /** The year this card will expire. */
  expYear: Scalars["Int"]["output"];
  /** The last 4 digits of this card. */
  last4: Scalars["String"]["output"];
};

export type CatalogRestDetails = {
  __typename?: "CatalogRestDetails";
  additionalHeaders?: Maybe<Scalars["KeyValuePairs"]["output"]>;
  clientId: Scalars["String"]["output"];
  oauth2ServerUri?: Maybe<Scalars["String"]["output"]>;
  scope: Scalars["String"]["output"];
  uri: Scalars["String"]["output"];
  vendedCredentials: Scalars["Boolean"]["output"];
  warehouse: Scalars["String"]["output"];
};

export type CatalogRestInput = {
  additionalHeaders?: InputMaybe<Scalars["KeyValuePairs"]["input"]>;
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret: Scalars["String"]["input"];
  /** Explicit OAuth2 token endpoint. When omitted, derived as <uri>/v1/oauth/tokens. */
  oauth2ServerUri?: InputMaybe<Scalars["String"]["input"]>;
  scope?: InputMaybe<Scalars["String"]["input"]>;
  uri: Scalars["String"]["input"];
  vendedCredentials?: InputMaybe<Scalars["Boolean"]["input"]>;
  warehouse: Scalars["String"]["input"];
};

export type CatalogS3TablesDetails = {
  __typename?: "CatalogS3TablesDetails";
  bucketArn: Scalars["String"]["output"];
  iamRoleArn: Scalars["String"]["output"];
};

export type CatalogS3TablesInput = {
  bucketArn: Scalars["String"]["input"];
  iamRoleArn: Scalars["String"]["input"];
};

export type ChangePasswordInput = {
  newPassword: Scalars["String"]["input"];
  newPasswordConfirm: Scalars["String"]["input"];
  oldPassword: Scalars["String"]["input"];
  /** Required if there are MFA methods active for the user  */
  trustChallenge?: InputMaybe<Scalars["String"]["input"]>;
  trustToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type Chunk = {
  __typename?: "Chunk";
  compressedSize: Scalars["Int"]["output"];
  dataNodes?: Maybe<Array<Scalars["String"]["output"]>>;
  endTime: Scalars["String"]["output"];
  indexSize: Scalars["Int"]["output"];
  isCompressed: Scalars["Boolean"]["output"];
  name: Scalars["ID"]["output"];
  precompressedSize: Scalars["Int"]["output"];
  rangeEnd?: Maybe<Scalars["String"]["output"]>;
  rangeStart?: Maybe<Scalars["String"]["output"]>;
  size: Scalars["Int"]["output"];
  startTime: Scalars["String"]["output"];
  uncompressedSize: Scalars["Int"]["output"];
};

export type ChunkTuningStatus = {
  __typename?: "ChunkTuningStatus";
  enabled: Scalars["Boolean"]["output"];
  preTunerInterval?: Maybe<Scalars["Int"]["output"]>;
  recommendedInterval: Scalars["Int"]["output"];
};

export type ClaimPrivateLinkConnectionInput = {
  /** Identifier read from your own cloud resource: on AWS the VPC endpoint ID (vpce-...), on Azure the private endpoint's resourceGuid (f91412e6-...). */
  claimIdentifier: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
};

export type ClientCredentials = {
  __typename?: "ClientCredentials";
  /** ID of the Client Credentials */
  accessKey: Scalars["String"]["output"];
  /** Secret - it filled only on creation */
  secretKey?: Maybe<Scalars["String"]["output"]>;
};

export type CloseSupportCaseInput = {
  /** Optional file attachments, attached to the closing reply (max 10, 25 MiB each). */
  attachments?: InputMaybe<Array<Scalars["Upload"]["input"]>>;
  /** Optional message to send as a visible reply before closing. Required if attachments are provided. */
  body?: InputMaybe<Scalars["String"]["input"]>;
  /** The Salesforce Case ID to close. */
  caseId: Scalars["ID"]["input"];
  /** The project the case belongs to (for authorization). */
  projectId: Scalars["ID"]["input"];
};

export enum CloudProvider {
  Aws = "AWS",
  Azure = "AZURE",
  None = "NONE",
}

export type CloudWatchConfig = {
  __typename?: "CloudWatchConfig";
  awsAccessKey: Scalars["String"]["output"];
  awsRegion: Scalars["String"]["output"];
  awsRoleArn?: Maybe<Scalars["String"]["output"]>;
  awsSecretKey: Scalars["String"]["output"];
  logGroupName: Scalars["String"]["output"];
  logStreamName: Scalars["String"]["output"];
};

export type CloudWatchConfigInput = {
  awsAccessKey?: InputMaybe<Scalars["String"]["input"]>;
  awsRegion: Scalars["String"]["input"];
  awsRoleArn?: InputMaybe<Scalars["String"]["input"]>;
  awsSecretKey?: InputMaybe<Scalars["String"]["input"]>;
  logGroupName: Scalars["String"]["input"];
  logStreamName: Scalars["String"]["input"];
};

export type CloudWatchMetricConfig = {
  __typename?: "CloudWatchMetricConfig";
  awsAccessKey: Scalars["String"]["output"];
  awsRegion: Scalars["String"]["output"];
  awsRoleArn?: Maybe<Scalars["String"]["output"]>;
  awsSecretKey: Scalars["String"]["output"];
  logGroupName: Scalars["String"]["output"];
  logStreamName: Scalars["String"]["output"];
  namespace: Scalars["String"]["output"];
};

export type CloudWatchMetricConfigInput = {
  awsAccessKey?: InputMaybe<Scalars["String"]["input"]>;
  awsRegion: Scalars["String"]["input"];
  awsRoleArn?: InputMaybe<Scalars["String"]["input"]>;
  awsSecretKey?: InputMaybe<Scalars["String"]["input"]>;
  logGroupName: Scalars["String"]["input"];
  logStreamName: Scalars["String"]["input"];
  namespace: Scalars["String"]["input"];
};

export type Column = {
  __typename?: "Column";
  constraints: Array<Scalars["String"]["output"]>;
  default: Scalars["String"]["output"];
  name: Scalars["ID"]["output"];
  nullable: Scalars["Boolean"]["output"];
  type: Scalars["String"]["output"];
};

/** Represents a column mapping from source to destination */
export type ColumnMapping = {
  __typename?: "ColumnMapping";
  /** Destination column name in the target table */
  destination: Scalars["String"]["output"];
  /** Source column name in the original file */
  source: Scalars["String"]["output"];
};

/** Input for column mapping */
export type ColumnMappingInput = {
  /** Destination column name in the target table */
  destination: Scalars["String"]["input"];
  /** Source column name in the original file */
  source: Scalars["String"]["input"];
};

export type ColumnPreview = {
  __typename?: "ColumnPreview";
  content: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type CompressionConfig = {
  enabled: Scalars["Boolean"]["input"];
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  segmentBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** CompressionRecommendationsForOrderBy provides OrderBy Recommendations for a HyperTable. */
export type CompressionRecommendationsForOrderBy = {
  __typename?: "CompressionRecommendationsForOrderBy";
  availableOrderByColumns: Array<Scalars["String"]["output"]>;
  recommendedOrderByColumns: Array<OrderByColumn>;
};

/** Get the recommended order by for a given list of segment by columns */
export type CompressionRecommendationsForOrderByInput = {
  contAggName?: InputMaybe<Scalars["ID"]["input"]>;
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  schema: Scalars["ID"]["input"];
  segmentByColumns: Array<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
  tableName?: InputMaybe<Scalars["ID"]["input"]>;
};

/** CompressionRecommendations provides Segment By Recommendations for a HyperTable. */
export type CompressionRecommendationsForSegmentBy = {
  __typename?: "CompressionRecommendationsForSegmentBy";
  availableSegmentByColumns: Array<Scalars["String"]["output"]>;
  recommendedSegmentByColumns: Array<Scalars["String"]["output"]>;
};

/** Get the recommended segment by for a given hypertable or cagg */
export type CompressionRecommendationsForSegmentByInput = {
  contAggName?: InputMaybe<Scalars["ID"]["input"]>;
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  schema: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  tableName?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CompressionStats = {
  __typename?: "CompressionStats";
  /** Size of compressed data. */
  compressed: Scalars["Int"]["output"];
  /** Size of data on disk, equal to uncompressed + compressed. */
  diskSize: Scalars["Int"]["output"];
  /** Size of data if compression was not applied, equal to uncompressed + precompressed. */
  originalSize: Scalars["Int"]["output"];
  /** Size of compressed data before it was compressed. */
  precompressed: Scalars["Int"]["output"];
  /** @deprecated ratio is deprecated, prefer savings instead. */
  ratio: Scalars["Float"]["output"];
  /** Amount of space saved by using compression, equal to 1.0 - (diskSize / originalSize). */
  savings: Scalars["Float"]["output"];
  /** Size of data not compressed. */
  uncompressed: Scalars["Int"]["output"];
};

/** A measurement of the average cpu/ram used by an instance during a metrics bucket. */
export type ComputeMetricsDataPoint = {
  __typename?: "ComputeMetricsDataPoint";
  memoryMiB: Scalars["Int"]["output"];
  milliCPU: Scalars["Int"]["output"];
  time: Scalars["Time"]["output"];
};

/** A record of the compute resource limits applied to a service during a metrics window. */
export type ComputeMetricsLimits = {
  __typename?: "ComputeMetricsLimits";
  memoryMiB: Scalars["Int"]["output"];
  milliCPU: Scalars["Int"]["output"];
};

/** A window of time in which an instance's role and compute limits were constant, and it's compute usage during that window. */
export type ComputeMetricsWindow = {
  __typename?: "ComputeMetricsWindow";
  data: Array<ComputeMetricsDataPoint>;
  limits: ComputeMetricsLimits;
  ordinal: Scalars["Int"]["output"];
  role: InstanceRole;
};

export enum ComputeState {
  Applied = "APPLIED",
  Queued = "QUEUED",
  Unknown = "UNKNOWN",
}

export type ConfigureIpAllowListInput = {
  /** Pass nil to remove a list with a given ID. */
  cidrBlocks?: InputMaybe<Array<Scalars["String"]["input"]>>;
  description: Scalars["String"]["input"];
  /** Specifying a list ID will re-configure an existing list, while omitting it will create a new one. */
  listId?: InputMaybe<Scalars["Int"]["input"]>;
  projectId: Scalars["ID"]["input"];
};

export type ConfigureIpAllowListOutput = {
  __typename?: "ConfigureIPAllowListOutput";
  listId: Scalars["Int"]["output"];
};

export type ConfluentCloudSchemaRegistryAuth = {
  __typename?: "ConfluentCloudSchemaRegistryAuth";
  basicAuth: HttpBasicAuth;
};

export type ConfluentCloudSchemaRegistryAuthInput = {
  basicAuth: HttpBasicAuthInput;
};

export type ConfluentCloudSchemaRegistryConfig = {
  __typename?: "ConfluentCloudSchemaRegistryConfig";
  auth?: Maybe<ConfluentCloudSchemaRegistryAuth>;
  schemaRegistryUrl: Scalars["String"]["output"];
};

export type ConfluentCloudSchemaRegistryConfigInput = {
  auth: ConfluentCloudSchemaRegistryAuthInput;
  schemaRegistryUrl: Scalars["String"]["input"];
};

export enum ConnectionState {
  Approved = "approved",
  Pending = "pending",
  Rejected = "rejected",
  Removed = "removed",
  Unspecified = "unspecified",
}

export type ConnectorDetails = {
  __typename?: "ConnectorDetails";
  created: Scalars["Time"]["output"];
  displayName: Scalars["String"]["output"];
  icebergdst?: Maybe<IcebergDstConnectorDetails>;
  kafkasrc?: Maybe<KafkaConnectorDetails>;
  pgsrc?: Maybe<PgSrcConnectorDetails>;
  projectId: Scalars["String"]["output"];
  region: Scalars["String"]["output"];
  s3tabledst?: Maybe<S3TableDstConnectorDetails>;
  serviceId: Scalars["String"]["output"];
  state: ConnectorState;
  stateMessage: Scalars["String"]["output"];
};

export type ConnectorHypertableSpecInput = {
  primaryDimension: HypertableRangeDimensionInput;
  secondaryDimensions?: InputMaybe<Array<HypertableDimensionInput>>;
};

export enum ConnectorState {
  Error = "error",
  Initializing = "initializing",
  Ok = "ok",
  Paused = "paused",
  Warning = "warning",
}

export type ConnectorTableColumn = {
  __typename?: "ConnectorTableColumn";
  name: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type ConnectorTableIdentifier = {
  __typename?: "ConnectorTableIdentifier";
  schemaName: Scalars["String"]["output"];
  tableName: Scalars["String"]["output"];
};

export type ConnectorTableIdentifierInput = {
  schemaName: Scalars["String"]["input"];
  tableName: Scalars["String"]["input"];
};

export type ConnectorTableSpec = {
  __typename?: "ConnectorTableSpec";
  hypertableSpec?: Maybe<HypertableSpec>;
  table: ConnectorTableIdentifier;
  tableMapping?: Maybe<ConnectorTableIdentifier>;
};

export type ConnectorTableSpecInput = {
  hypertableSpec?: InputMaybe<ConnectorHypertableSpecInput>;
  publicationName?: InputMaybe<Scalars["String"]["input"]>;
  table: ConnectorTableIdentifierInput;
  tableMapping?: InputMaybe<ConnectorTableIdentifierInput>;
};

export enum ConnectorType {
  IcebergDst = "iceberg_dst",
  KafkaSrc = "kafka_src",
  PgSrc = "pg_src",
  S3TableDst = "s3_table_dst",
}

export type ConnectorsMutator = {
  __typename?: "ConnectorsMutator";
  /** Create connector */
  createConnector: CreateConnectorResponse;
  /** starts a file import given a source, definition and schema */
  createFileImport: CreateFileImportResponse;
  /** Creates a kafka cluster configuration */
  createKafkaClusterConfig: CreateKafkaClusterConfigResponse;
  /**
   * TODO: Migrate to createConnector mutation
   * Create a Kafka connector
   */
  createKafkaConnector: CreateKafkaConnectorResponse;
  /** Create PostgreSQL source configuration */
  createPgSrcConfig: CreatePgSrcConfigResponse;
  /** Creates an S3 live sync request resource. */
  createS3LiveSync: Scalars["Success"]["output"];
  /** Create SSH tunnel configuration */
  createSSHTunnelConfig: CreateSshTunnelConfigResponse;
  /** creates the given schema in the backend */
  createSchema: CreateSchemaResponse;
  /** Create a schema registry configuration */
  createSchemaRegistryConfig: CreateSchemaRegistryConfigResponse;
  /** Delete a connector */
  deleteConnector: DeleteConnectorResponse;
  /** Delete a Kafka connector */
  deleteKafkaConnector: DeleteKafkaConnectorResponse;
  /** removes an S3 live sync. */
  deleteS3LiveSync: Scalars["Success"]["output"];
  /** Generates a presigned URL to upload a single file up to 500MB. */
  generatePresignedURL: GeneratePresignedUrlResponse;
  /** Retries file imports for an S3 live sync that match the specified state and time range filters. */
  retryS3LiveSyncFileImports: RetryS3LiveSyncFileImportsResponse;
  /** Update a connector */
  updateConnector: UpdateConnectorResponse;
  /** Update a connector (V2 - simplified API) */
  updateConnectorV2: UpdateConnectorV2Response;
  /** updates a file import (supports cancel, retry, labels, and pause operations) */
  updateFileImport: UpdateFileImportResponse;
  /** Update PostgreSQL source configuration */
  updatePgSrcConfig: UpdatePgSrcConfigResponse;
  /** Updates an S3 live sync in-place. */
  updateS3LiveSync: S3LiveSync;
  /** Update SSH tunnel configuration */
  updateSSHTunnelConfig: UpdateSshTunnelConfigResponse;
  /** Validate PostgreSQL source replication configuration */
  validateConnectorConfigPgSrc: ValidateConfigResponse;
  /** Validate Iceberg connector specification */
  validateConnectorSpecIceberg: ValidateConnectorSpecIcebergResponse;
  /** Validate generic Iceberg destination connector specification */
  validateConnectorSpecIcebergDst: ValidateConnectorSpecIcebergResponse;
};

export type ConnectorsMutatorCreateConnectorArgs = {
  data: CreateConnectorInput;
};

export type ConnectorsMutatorCreateFileImportArgs = {
  data: CreateFileImportInput;
};

export type ConnectorsMutatorCreateKafkaClusterConfigArgs = {
  data: CreateKafkaClusterConfigInput;
};

export type ConnectorsMutatorCreateKafkaConnectorArgs = {
  data: CreateKafkaConnectorInput;
};

export type ConnectorsMutatorCreatePgSrcConfigArgs = {
  data: CreatePgSrcConfigInput;
};

export type ConnectorsMutatorCreateS3LiveSyncArgs = {
  data: CreateS3LiveSyncInput;
};

export type ConnectorsMutatorCreateSshTunnelConfigArgs = {
  data: CreateSshTunnelConfigInput;
};

export type ConnectorsMutatorCreateSchemaArgs = {
  data: CreateSchemaInput;
};

export type ConnectorsMutatorCreateSchemaRegistryConfigArgs = {
  data: CreateSchemaRegistryConfigInput;
};

export type ConnectorsMutatorDeleteConnectorArgs = {
  data: DeleteConnectorInput;
};

export type ConnectorsMutatorDeleteKafkaConnectorArgs = {
  data: DeleteKafkaConnectorInput;
};

export type ConnectorsMutatorDeleteS3LiveSyncArgs = {
  data: DeleteS3LiveSyncInput;
};

export type ConnectorsMutatorGeneratePresignedUrlArgs = {
  data: GeneratePresignedUrlInput;
};

export type ConnectorsMutatorRetryS3LiveSyncFileImportsArgs = {
  data: RetryS3LiveSyncFileImportsInput;
};

export type ConnectorsMutatorUpdateConnectorArgs = {
  data: UpdateConnectorInput;
};

export type ConnectorsMutatorUpdateConnectorV2Args = {
  data: UpdateConnectorV2Input;
};

export type ConnectorsMutatorUpdateFileImportArgs = {
  data: UpdateFileImportInput;
};

export type ConnectorsMutatorUpdatePgSrcConfigArgs = {
  data: UpdatePgSrcConfigInput;
};

export type ConnectorsMutatorUpdateS3LiveSyncArgs = {
  data: UpdateS3LiveSyncInput;
};

export type ConnectorsMutatorUpdateSshTunnelConfigArgs = {
  data: UpdateSshTunnelConfigInput;
};

export type ConnectorsMutatorValidateConnectorConfigPgSrcArgs = {
  data: ValidateConnectorConfigPgSrcInput;
};

export type ConnectorsMutatorValidateConnectorSpecIcebergArgs = {
  data: ValidateConnectorSpecIcebergInput;
};

export type ConnectorsMutatorValidateConnectorSpecIcebergDstArgs = {
  data: ValidateIcebergDstInput;
};

export type ConnectorsQuerier = {
  __typename?: "ConnectorsQuerier";
  /** Get a specific connector by ID */
  getConnector: GetConnectorResponse;
  /** Get the target tables of a connector, with per-table sync status */
  getConnectorTargetTables: GetConnectorTargetTablesResponse;
  /** Get all connectors for a project */
  getConnectors: GetConnectorsResponse;
  /** Returns a single file import. */
  getFileImport: GetFileImportResponse;
  /** Get kafka clusters configured for a project */
  getKafkaClusters: GetKafkaClustersResponse;
  /** Get status for Kafka connector */
  getKafkaSrcConnectorStatus: GetKafkaSrcConnectorStatusResponse;
  /** Get schema mapping for a Kafka topic */
  getKafkaTopicSchemaMapping: GetKafkaTopicSchemaMappingResponse;
  /** Get topics from a Kafka cluster */
  getKafkaTopicsFromCluster: GetKafkaTopicsFromClusterResponse;
  /** Get a single PostgreSQL source config by ID */
  getPgSrcConfig: GetPgSrcConfigResponse;
  /** Get PostgreSQL source configs for a project */
  getPgSrcConfigs: GetPgSrcConfigsResponse;
  /**
   * Get status for PostgreSQL source connector
   * @deprecated Use getConnector or getConnectors instead, status is now included in PgSrcConnectorDetails
   */
  getPgSrcConnectorStatus: GetPgSrcConnectorStatusResponse;
  /** Get tables configured in a PostgreSQL source connector */
  getPgSrcConnectorTargetTables: GetPgSrcConnectorTargetTablesResponse;
  /** Get tables from a PostgreSQL source publication */
  getPgSrcPublicationTables: GetPgSrcPublicationTablesResponse;
  /** Get publications from a PostgreSQL source */
  getPgSrcPublications: GetPgSrcPublicationsResponse;
  /** Get schemas from a PostgreSQL source */
  getPgSrcSchemas: GetPgSrcSchemasResponse;
  /** Get tables from a PostgreSQL source schema */
  getPgSrcTables: GetPgSrcTablesResponse;
  /** Returns a single S3 live sync available for a service. */
  getS3LiveSync: S3LiveSync;
  /** Returns a list of audit entries for a S3 live sync */
  getS3LiveSyncAudit: GetS3LiveSyncAuditResponse;
  /** Returns runtime/billing audit entries for a S3 live sync */
  getS3LiveSyncRuntimeAudit: GetS3LiveSyncRuntimeAuditResponse;
  /** Returns statistics for a S3 live sync */
  getS3LiveSyncStatistics: GetS3LiveSyncStatisticsResponse;
  /** Get a single SSH tunnel config by ID */
  getSSHTunnelConfig: GetSshTunnelConfigResponse;
  /** Get the SSH tunnel configs for a project */
  getSSHTunnelConfigs: GetSshTunnelConfigsResponse;
  /** Get schema registries configured for a project */
  getSchemaRegistries: GetSchemaRegistriesResponse;
  /**
   * Returns a list of objects in a bucket
   * This is just a wrapper over ListObjectsV2 with our custom filtering based on patterns.
   */
  listBucketObjects: ListBucketObjectsResponse;
  /** Returns a list of file imports */
  listFileImport: ListFileImportResponse;
  /** Returns a list of the S3 live syncs available for a service. */
  listS3LiveSync?: Maybe<Array<S3LiveSync>>;
  /**
   * Given a source, it will attempt to return a schema for it
   * This enpoint is intended to guess the schema of a file. The information returned is not guaranteed to be correct.
   * After user confirms the schema, the endpoint createSchema is used to create the schema in the backend
   */
  previewSource: PreviewSourceResponse;
  /** Verify SSH tunnel configuration */
  verifySSHTunnelConfig: VerifySshTunnelConfigResponse;
};

export type ConnectorsQuerierGetConnectorArgs = {
  data: GetConnectorInput;
};

export type ConnectorsQuerierGetConnectorTargetTablesArgs = {
  data: GetConnectorTargetTablesInput;
};

export type ConnectorsQuerierGetConnectorsArgs = {
  data: GetConnectorsInput;
};

export type ConnectorsQuerierGetFileImportArgs = {
  data: GetFileImportInput;
};

export type ConnectorsQuerierGetKafkaClustersArgs = {
  data: GetKafkaClustersInput;
};

export type ConnectorsQuerierGetKafkaSrcConnectorStatusArgs = {
  data: GetKafkaSrcConnectorStatusInput;
};

export type ConnectorsQuerierGetKafkaTopicSchemaMappingArgs = {
  data: GetKafkaTopicSchemaMappingInput;
};

export type ConnectorsQuerierGetKafkaTopicsFromClusterArgs = {
  data: GetKafkaTopicsFromClusterInput;
};

export type ConnectorsQuerierGetPgSrcConfigArgs = {
  data: GetPgSrcConfigInput;
};

export type ConnectorsQuerierGetPgSrcConfigsArgs = {
  data: GetPgSrcConfigsInput;
};

export type ConnectorsQuerierGetPgSrcConnectorStatusArgs = {
  data: GetPgSrcConnectorStatusInput;
};

export type ConnectorsQuerierGetPgSrcConnectorTargetTablesArgs = {
  data: GetPgSrcConnectorTargetTablesInput;
};

export type ConnectorsQuerierGetPgSrcPublicationTablesArgs = {
  data: GetPgSrcPublicationTablesInput;
};

export type ConnectorsQuerierGetPgSrcPublicationsArgs = {
  data: GetPgSrcPublicationsInput;
};

export type ConnectorsQuerierGetPgSrcSchemasArgs = {
  data: GetPgSrcSchemasInput;
};

export type ConnectorsQuerierGetPgSrcTablesArgs = {
  data: GetPgSrcTablesInput;
};

export type ConnectorsQuerierGetS3LiveSyncArgs = {
  data: GetS3LiveSyncInput;
};

export type ConnectorsQuerierGetS3LiveSyncAuditArgs = {
  data: GetS3LiveSyncAuditInput;
};

export type ConnectorsQuerierGetS3LiveSyncRuntimeAuditArgs = {
  data: GetS3LiveSyncRuntimeAuditInput;
};

export type ConnectorsQuerierGetS3LiveSyncStatisticsArgs = {
  data: GetS3LiveSyncStatisticsInput;
};

export type ConnectorsQuerierGetSshTunnelConfigArgs = {
  data: GetSshTunnelConfigInput;
};

export type ConnectorsQuerierGetSshTunnelConfigsArgs = {
  data: GetSshTunnelConfigsInput;
};

export type ConnectorsQuerierGetSchemaRegistriesArgs = {
  data: GetSchemaRegistriesInput;
};

export type ConnectorsQuerierListBucketObjectsArgs = {
  data: ListBucketObjectsInput;
};

export type ConnectorsQuerierListFileImportArgs = {
  data: ListFileImportInput;
};

export type ConnectorsQuerierListS3LiveSyncArgs = {
  data: ListS3LiveSyncInput;
};

export type ConnectorsQuerierPreviewSourceArgs = {
  data: PreviewSourceInput;
};

export type ConnectorsQuerierVerifySshTunnelConfigArgs = {
  data: VerifySshTunnelConfigInput;
};

export type ContAgg = {
  __typename?: "ContAgg";
  definition: Scalars["String"]["output"];
  materializedOnly: Scalars["Boolean"]["output"];
  name: Scalars["ID"]["output"];
  schema: Scalars["ID"]["output"];
};

export type ContAggId = {
  __typename?: "ContAggID";
  name: Scalars["ID"]["output"];
  schema: Scalars["ID"]["output"];
};

export type ContAggInfo = {
  __typename?: "ContAggInfo";
  chunks: Array<Chunk>;
  definition: Scalars["String"]["output"];
  hyperMetadata: HyperMetadata;
  indexes: Array<Index>;
  metadata: ContAggMetadata;
  policies: Array<Policy>;
  refreshPolicies: Array<ContAggRefreshPolicy>;
  schema: Array<Column>;
};

export type ContAggListResponse = {
  __typename?: "ContAggListResponse";
  contAggs: Array<ContAggId>;
  outdatedContAggs: Array<ContAggId>;
};

export type ContAggMetadata = {
  __typename?: "ContAggMetadata";
  approxRowCount: Scalars["Int"]["output"];
  id: ContAggId;
  lastRefresh: Scalars["String"]["output"];
  materializedOnly: Scalars["Boolean"]["output"];
  nextRefresh: Scalars["String"]["output"];
  owner: Scalars["String"]["output"];
  parentID: ObjectId;
  size: Scalars["Int"]["output"];
};

export type ContAggRefreshPolicy = {
  __typename?: "ContAggRefreshPolicy";
  endOffset: Scalars["String"]["output"];
  interval: Scalars["String"]["output"];
  startOffset: Scalars["String"]["output"];
};

export type CreateBillingEmailAddressInput = {
  billingAccountId: Scalars["ID"]["input"];
  email: Scalars["String"]["input"];
};

export type CreateConnectorInput = {
  displayName: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  /** Connector specification - exactly one spec type should be provided */
  spec: CreateConnectorSpecInput;
};

export type CreateConnectorResponse = {
  __typename?: "CreateConnectorResponse";
  connector: ConnectorDetails;
  id: Scalars["String"]["output"];
};

export type CreateConnectorSpecInput = {
  icebergdst?: InputMaybe<IcebergDstSpecInput>;
  kafkasrc?: InputMaybe<KafkaSpec>;
  pgsrc?: InputMaybe<PgSrcSpecInput>;
  s3tabledst?: InputMaybe<S3TableDstSpecInput>;
};

export type CreateFileImportInput = {
  definition: FileImportDefinitionInput;
  id: Scalars["ID"]["input"];
  labels?: InputMaybe<Array<FileImportLabelInput>>;
  project_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
  settings?: InputMaybe<ImportSettingsInput>;
  source: FileImportSourceInput;
  table_identifier: FileImportTableIdentifierInput;
};

export type CreateFileImportResponse = {
  __typename?: "CreateFileImportResponse";
  error?: Maybe<Scalars["String"]["output"]>;
};

export type CreateGenericExporterInput = {
  config: GenericExporterConfigInput;
  dataType: GenericExporterDataType;
  name: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
  region: Scalars["String"]["input"];
  type: GenericExporterType;
};

export type CreateIcebergSyncInput = {
  projectId: Scalars["ID"]["input"];
  req: IcebergSync;
  serviceId: Scalars["ID"]["input"];
};

export type CreateKafkaClusterConfigInput = {
  brokerUrls: Array<Scalars["String"]["input"]>;
  kafkaAuth: KafkaAuthenticationInput;
  name: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
};

export type CreateKafkaClusterConfigResponse = {
  __typename?: "CreateKafkaClusterConfigResponse";
  clusterConfig: KafkaClusterConfig;
};

export type CreateKafkaConnectorInput = {
  displayName: Scalars["String"]["input"];
  kafkaSpec: KafkaSpec;
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

/** Deprecated: Use CreateConnectorResponse instead. */
export type CreateKafkaConnectorResponse = {
  __typename?: "CreateKafkaConnectorResponse";
  connector: ConnectorDetails;
  /** ID of the created Kafka connector */
  id: Scalars["String"]["output"];
  kafkasrc?: Maybe<KafkaConnectorDetails>;
};

export type CreateMetricExporterInput = {
  config: MetricExporterConfigInput;
  enablePgMetrics?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
  regionCode: Scalars["String"]["input"];
};

export type CreateOrganizationProjectInput = {
  name: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
};

export type CreateOrganizationProjectResponse = {
  __typename?: "CreateOrganizationProjectResponse";
  project: Project;
};

export type CreatePatRecordInput = {
  name: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
};

export type CreatePgSrcConfigInput = {
  connectionString: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  sshTunnelId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreatePgSrcConfigResponse = {
  __typename?: "CreatePgSrcConfigResponse";
  sourceConfig: PgSrcConfig;
};

export type CreatePgSrcConnectorInput = {
  publicationName?: InputMaybe<Scalars["String"]["input"]>;
  sourceConfigId: Scalars["String"]["input"];
};

export type CreateProjectInput = {
  name: Scalars["String"]["input"];
  plan?: InputMaybe<ProjectPlan>;
  /** @deprecated Use 'trialPackage' for strict trial definitions. */
  trialDays?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CreateProjectSecretInput = {
  metadata?: InputMaybe<Array<SecretMetadataItemInput>>;
  name: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
  value: Scalars["String"]["input"];
};

/**
 * Create a new S3 file import.
 * It can be created empty and then updated later. that is why fields are optional.
 */
export type CreateS3LiveSyncInput = {
  bucket?: InputMaybe<Scalars["String"]["input"]>;
  credentials?: InputMaybe<S3LiveSyncCredentialsInput>;
  definition?: InputMaybe<S3LiveSyncDefinitionInput>;
  id: Scalars["ID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  pattern?: InputMaybe<Scalars["String"]["input"]>;
  project_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
  table_identifier?: InputMaybe<FileImportTableIdentifierInput>;
};

export type CreateSshTunnelConfigInput = {
  host?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  port?: InputMaybe<Scalars["Int"]["input"]>;
  projectId: Scalars["String"]["input"];
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateSshTunnelConfigResponse = {
  __typename?: "CreateSSHTunnelConfigResponse";
  sshTunnelConfig: SshTunnelConfig;
};

export type CreateSchemaInput = {
  columns: Array<SchemaColumnInput>;
  /**
   * Whether to execute the migration.
   * If you want to create the migration but not execute it, set this to false.
   * This is useful if you want to show the user the migration that will be executed without actually executing it.
   */
  exec?: InputMaybe<Scalars["Boolean"]["input"]>;
  partition_column?: InputMaybe<Scalars["String"]["input"]>;
  project_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
  table_identifier?: InputMaybe<FileImportTableIdentifierInput>;
};

export type CreateSchemaRegistryConfigInput = {
  confluentCloud: ConfluentCloudSchemaRegistryConfigInput;
  name: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
};

export type CreateSchemaRegistryConfigResponse = {
  __typename?: "CreateSchemaRegistryConfigResponse";
  schemaRegistryConfig: SchemaRegistryConfig;
};

export type CreateSchemaResponse = {
  __typename?: "CreateSchemaResponse";
  migration: Scalars["String"]["output"];
};

export type CreateServiceInput = {
  /**
   * Indicates the billing tags for this service
   * @deprecated Unused since static/dynamic postgres
   */
  billingTags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** enables the connection pooler in the service */
  enableConnectionPooler?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * enableStorageAutoscaling is deprecated and no longer supported
   * @deprecated Always true since 2023-06 and EBS launch
   */
  enableStorageAutoscaling?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Indicates if this service is used in a prod or dev environment */
  environmentTag?: InputMaybe<ServiceEnvironment>;
  /**
   * extensions is deprecated and no longer honored
   * @deprecated Ignored: extensions to pre-create are derived from the service addons server-side, caller-supplied names are never installed
   */
  extensions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** configure this service to be a fork of another one (requires a corresponding value in the type field) */
  forkConfig?: InputMaybe<ForkConfig>;
  /** @deprecated Use service plan / FREE instead */
  isFixed?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  /** Optional list of private link connection IDs to attach the service to. */
  privateLinkConnectionIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  /**
   * Optional ID of a private link connection to attach the service to.
   * @deprecated Use privateLinkConnectionIds instead
   */
  privateLinkEndpointConnectionId?: InputMaybe<Scalars["ID"]["input"]>;
  projectId: Scalars["ID"]["input"];
  /** The region that the service will be created in. Defaults to AWS us-east-1 if not specified. */
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  resourceConfig?: InputMaybe<ResourceConfig>;
  servicePlan?: InputMaybe<ServicePlan>;
  type: Type;
  /** Optional ID of a VPC to which the new instance should be attached. */
  vpcId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateServiceOutput = {
  __typename?: "CreateServiceOutput";
  initialPassword: Scalars["String"]["output"];
  service: Service;
};

export type CreateUiStateInput = {
  contents: Scalars["String"]["input"];
  key: Scalars["ID"]["input"];
  owner?: InputMaybe<OwnerInput>;
};

export type CreateUiStateResponse = {
  __typename?: "CreateUIStateResponse";
  ui_state: UiStateResource;
};

export type CreateUserInput = {
  email: Scalars["String"]["input"];
  inviteHash?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  passwordConfirm: Scalars["String"]["input"];
  recaptchaToken: Scalars["String"]["input"];
};

export type CreateVpcInput = {
  cidr: Scalars["String"]["input"];
  cloudProvider: CloudProvider;
  name: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
  regionCode: Scalars["String"]["input"];
};

/** Response for creating a verification payment method charge. */
export type CreatedCardVerificationChargeResponse = {
  __typename?: "CreatedCardVerificationChargeResponse";
  /** The client_secret from the PaymentIntent for the frontend to complete verification. */
  clientSecret: Scalars["String"]["output"];
  /** The PaymentIntent ID for tracking purposes. */
  paymentIntentId: Scalars["String"]["output"];
};

export type CrossRegionBackupStatusV2 = {
  __typename?: "CrossRegionBackupStatusV2";
  enabled: Scalars["Boolean"]["output"];
  regions: Array<BackupRegion>;
};

export type CrossRegionBackupsEnabled = {
  __typename?: "CrossRegionBackupsEnabled";
  enabled: Scalars["Boolean"]["output"];
  regions: Array<Scalars["String"]["output"]>;
};

export type CrossRegionBackupsStatusInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type CsvImportColumnInput = {
  name: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

export type CurrentActivity = {
  __typename?: "CurrentActivity";
  applicationName: Scalars["String"]["output"];
  isInternal: Scalars["Boolean"]["output"];
  pid: Scalars["Int"]["output"];
  query?: Maybe<Scalars["String"]["output"]>;
  queryStartedAt?: Maybe<Scalars["Time"]["output"]>;
  runningDurationUsecs?: Maybe<Scalars["Int"]["output"]>;
  state: Scalars["String"]["output"];
  username: Scalars["String"]["output"];
};

export type CurrentActivityAggregates = {
  __typename?: "CurrentActivityAggregates";
  connectionsCount: Scalars["Int"]["output"];
  maxConnectionsSetting: Scalars["Int"]["output"];
  maxUsableConnections: Scalars["Int"]["output"];
  reservedConnections: Scalars["Int"]["output"];
};

export type CurrentActivityItem = {
  __typename?: "CurrentActivityItem";
  item: CurrentActivity;
};

export type CurrentActivityItems = {
  __typename?: "CurrentActivityItems";
  aggregates: CurrentActivityAggregates;
  items: Array<CurrentActivityItem>;
};

export enum CurrentAuthMethod {
  EmailCredentials = "EMAIL_CREDENTIALS",
  Mfa = "MFA",
  Sso = "SSO",
}

export type DbAgent = {
  __typename?: "DBAgent";
  getChunkTuningStatus: ChunkTuningStatus;
  /** Whether chunk tuning covers the whole service, as set by toggleServiceChunkTuning. */
  getServiceChunkTuningStatus: ServiceChunkTuningStatus;
};

export type DbAgentGetChunkTuningStatusArgs = {
  hypertableId: Scalars["Int"]["input"];
};

export type DbCompressionStats = {
  __typename?: "DBCompressionStats";
  numCompressedContAggs: Scalars["Int"]["output"];
  numCompressedHypertables: Scalars["Int"]["output"];
  stats: CompressionStats;
};

export type DailyComposition = {
  __typename?: "DailyComposition";
  date: Scalars["Time"]["output"];
  products: Array<DailyCompositionProductCost>;
  total: Scalars["Float"]["output"];
};

export type DailyCompositionProductCost = {
  __typename?: "DailyCompositionProductCost";
  cost: Scalars["Float"]["output"];
  productId: Scalars["ID"]["output"];
  productName: Scalars["String"]["output"];
};

export type DataTieringSettings = {
  __typename?: "DataTieringSettings";
  enabled: Scalars["Boolean"]["output"];
};

export type DataTieringStats = {
  __typename?: "DataTieringStats";
  tieredKB: Scalars["Int"]["output"];
};

export type DataTieringStorageSummary = {
  __typename?: "DataTieringStorageSummary";
  estimatedEbsUsageCost: Scalars["Float"]["output"];
  estimatedEbsUsageInBytes: Scalars["Int"]["output"];
  serviceIds: Array<Scalars["String"]["output"]>;
  tieringUsageCost: Scalars["Float"]["output"];
  tieringUsageInBytes: Scalars["Int"]["output"];
};

export type DatadogMetricConfig = {
  __typename?: "DatadogMetricConfig";
  apiKey: Scalars["String"]["output"];
  site?: Maybe<Scalars["String"]["output"]>;
};

export type DatadogMetricConfigInput = {
  apiKey: Scalars["String"]["input"];
  site?: InputMaybe<Scalars["String"]["input"]>;
};

export type DeleteAllCustomerDataOutput = {
  __typename?: "DeleteAllCustomerDataOutput";
  /** Whether the user itself was queued for deletion. */
  userQueuedForDeletion: Scalars["Boolean"]["output"];
};

export type DeleteBillingEmailAddressInput = {
  billingAccountId: Scalars["ID"]["input"];
  billingEmailId: Scalars["ID"]["input"];
};

export type DeleteCompressionPolicyInput = {
  contAggName?: InputMaybe<Scalars["ID"]["input"]>;
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
  tableName?: InputMaybe<Scalars["ID"]["input"]>;
  tableSchema: Scalars["ID"]["input"];
};

export type DeleteConnectorInput = {
  connectorId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

export type DeleteConnectorResponse = {
  __typename?: "DeleteConnectorResponse";
  success: Scalars["Boolean"]["output"];
};

export type DeleteKafkaConnectorInput = {
  connectorId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

export type DeleteKafkaConnectorResponse = {
  __typename?: "DeleteKafkaConnectorResponse";
  /** Success confirmation for deleted Kafka connector */
  success: Scalars["Boolean"]["output"];
};

export type DeleteMfaMethodInput = {
  code: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
};

export type DeletePatRecordInput = {
  accessKey: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
};

export type DeletePeeringConnectionInput = {
  /** The ID of the peering connection. */
  id: Scalars["ID"]["input"];
  /** The project ID the VPC is associated with. */
  projectId: Scalars["ID"]["input"];
  /** The internal forge ID of the shell VPC that we are detaching the user's VPC from. */
  vpcId: Scalars["ID"]["input"];
};

export type DeletePrivateLinkConnectionInput = {
  connectionId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
};

export type DeleteProjectSecretInput = {
  name: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
};

export type DeleteS3LiveSyncInput = {
  id: Scalars["ID"]["input"];
  project_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
};

export type DeleteServiceInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type DeleteUiStateInput = {
  key: Scalars["ID"]["input"];
  owner?: InputMaybe<OwnerInput>;
};

export type DeleteVpcInput = {
  /** The project ID of the service. */
  projectId: Scalars["ID"]["input"];
  /** The internal forge ID of the shell VPC that we are attaching the service to. */
  vpcId: Scalars["ID"]["input"];
};

export enum DeployStatus {
  Configuring = "CONFIGURING",
  Deleted = "DELETED",
  Deleting = "DELETING",
  Optimizing = "OPTIMIZING",
  Paused = "PAUSED",
  Pausing = "PAUSING",
  Queued = "QUEUED",
  Ready = "READY",
  Resuming = "RESUMING",
  Unstable = "UNSTABLE",
  Upgrading = "UPGRADING",
}

export type DetachServiceFromGenericExporterInput = {
  /** The internal ID of the generic exporter to attach with. */
  exporterId: Scalars["String"]["input"];
  /** The project ID of the service. */
  projectId: Scalars["ID"]["input"];
  /** The ID of the service. */
  serviceId: Scalars["ID"]["input"];
};

export type DetachServiceFromMetricExporterInput = {
  /**
   * The internal ID of the metric exporter to detach.
   * @deprecated use exporterUuid
   */
  exporterId?: InputMaybe<Scalars["ID"]["input"]>;
  /** The UUID of the metric exporter to detach. */
  exporterUuid?: InputMaybe<Scalars["ID"]["input"]>;
  /** The project ID of the service. */
  projectId: Scalars["ID"]["input"];
  /** The ID of the service. */
  serviceId: Scalars["ID"]["input"];
};

export type DetachServiceFromPrivateLinkConnectionInput = {
  connectionIds: Array<Scalars["ID"]["input"]>;
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type DetachServiceFromVpcInput = {
  /** The project ID of the service. */
  projectId: Scalars["ID"]["input"];
  /** The ID of the service. */
  serviceId: Scalars["ID"]["input"];
  /** The internal forge ID of the shell VPC that we are detaching the service from. */
  vpcId: Scalars["ID"]["input"];
};

export type Dimension = SpaceDimension | TimeDimension;

export type DisableProjectInput = {
  projectId: Scalars["ID"]["input"];
};

export type DisableStaticResourcesInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

/** A measurement of the average iops/bandwidth used by an instance during a metrics bucket. */
export type DiskPerformanceMetricsDataPoint = {
  __typename?: "DiskPerformanceMetricsDataPoint";
  readBandwidth: Scalars["Float"]["output"];
  readIOPs: Scalars["Float"]["output"];
  time: Scalars["Time"]["output"];
  writeBandwidth: Scalars["Float"]["output"];
  writeIOPs: Scalars["Float"]["output"];
};

/** A record of the disk performance limits applied to a service during a metrics window. */
export type DiskPerformanceMetricsLimits = {
  __typename?: "DiskPerformanceMetricsLimits";
  bandwidthMBs: Scalars["Int"]["output"];
  iops: Scalars["Int"]["output"];
};

/** A window of time in which an instance's role and disk performance limits were constant, and it's io usage during that window. */
export type DiskPerformanceMetricsWindow = {
  __typename?: "DiskPerformanceMetricsWindow";
  data: Array<DiskPerformanceMetricsDataPoint>;
  limits: DiskPerformanceMetricsLimits;
  ordinal: Scalars["Int"]["output"];
  role: InstanceRole;
};

export type DismissRecommendationInput = {
  feedback?: InputMaybe<Scalars["String"]["input"]>;
  projectId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
  recommendationId: Scalars["ID"]["input"];
  recommendationType?: InputMaybe<RecommendationType>;
  serviceId: Scalars["ID"]["input"];
  undo?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DropTableFromPgSrcConnectorInput = {
  connectorId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  table: ConnectorTableIdentifierInput;
};

export type Endpoint = {
  __typename?: "Endpoint";
  /**
   * The hostname to use for VPC instance connections.
   * @deprecated service.Endpoints contains this field
   */
  host: Scalars["String"]["output"];
  /**
   * The port to use for VPC instance connections.
   * @deprecated service.Endpoints contains this field
   */
  port: Scalars["Int"]["output"];
  /** The project ID the Endpoint is associated with. */
  projectId: Scalars["ID"]["output"];
  /** The service ID the Endpoint is associated with. */
  serviceId: Scalars["ID"]["output"];
  /** The id of the VPC that the Endpoint is associated with. */
  vpcId: Scalars["ID"]["output"];
};

export type EndpointAddress = {
  __typename?: "EndpointAddress";
  /** The hostname to use for connections. */
  host: Scalars["String"]["output"];
  /** The port to use for connections. */
  port: Scalars["Int"]["output"];
};

export enum EndpointBindingType {
  Pooler = "pooler",
  Primary = "primary",
  Replica = "replica",
  Unspecified = "unspecified",
}

/**
 * Binds a database service to a Private Endpoint, providing private hostname and port for access.
 * Each binding represents an endpoint type (primary, replica, or pooler) for a service.
 */
export type EndpointServiceBinding = {
  __typename?: "EndpointServiceBinding";
  bindingType: EndpointBindingType;
  connectionId: Scalars["ID"]["output"];
  createdAt: Scalars["Time"]["output"];
  /** Private DNS hostname to connect to your service over Private Link. */
  hostname: Scalars["String"]["output"];
  port: Scalars["Int"]["output"];
  projectId: Scalars["ID"]["output"];
  serviceId: Scalars["ID"]["output"];
};

export enum EnforcementType {
  Mfa = "MFA",
  None = "NONE",
  Sso = "SSO",
}

export type EnhancedIopsRangeEntitlement = {
  __typename?: "EnhancedIOPSRangeEntitlement";
  enabled: Scalars["Boolean"]["output"];
  max_iops: Scalars["Int"]["output"];
  min_iops: Scalars["Int"]["output"];
};

export type EnhancedStorageEntitlement = {
  __typename?: "EnhancedStorageEntitlement";
  enabled: Scalars["Boolean"]["output"];
};

export type EntitlementDowngradeCheckInput = {
  downgradeTo: VirtualPlanType;
  projectID: Scalars["ID"]["input"];
};

export type EntitlementDowngradeResponse = {
  __typename?: "EntitlementDowngradeResponse";
  dependencies?: Maybe<Array<EntitlementKind>>;
};

export enum EntitlementKind {
  AddonIoBoost = "ADDON_IO_BOOST",
  /** EnhancedIOPSRangeEntitlement */
  EnhancedIopsRange = "ENHANCED_IOPS_RANGE",
  /** Enhanced Storage with EBS io2 */
  EnhancedStorage = "ENHANCED_STORAGE",
  Exporter = "EXPORTER",
  FixedServiceMaxInstances = "FIXED_SERVICE_MAX_INSTANCES",
  HaReplica = "HA_REPLICA",
  IpAllowList = "IP_ALLOW_LIST",
  ReadReplica = "READ_REPLICA",
  ServiceMaxCpu = "SERVICE_MAX_CPU",
  ServiceMaxInstances = "SERVICE_MAX_INSTANCES",
  ServiceMaxMemory = "SERVICE_MAX_MEMORY",
  TieredStorage = "TIERED_STORAGE",
  TransitGateway = "TRANSIT_GATEWAY",
  VpcMaxInstances = "VPC_MAX_INSTANCES",
}

export type EntitlementSpec = {
  __typename?: "EntitlementSpec";
  addon_io_boost: AddonIoBoostEntitlement;
  enhanced_iops: EnhancedIopsRangeEntitlement;
  enhanced_storage: EnhancedStorageEntitlement;
  exporter: ExporterEntitlement;
  ha_replica: HaReplicaEntitlement;
  insights: InsightsEntitlement;
  invoice_billing: InvoiceBillingEntitlement;
  ip_allow_list: IpAllowListEntitlement;
  pitr: PitrEntitlement;
  plan_type: VirtualPlanType;
  production_support: ProductionSupportEntitlement;
  read_replica: ReadReplicaEntitlement;
  saml: SamlEntitlement;
  services: ServiceEntitlement;
  support: SupportEntitlement;
  tiered_storage: TieredStorageEntitlement;
  tiger_lake: TigerLakeEntitlement;
  transit_gateway: TransitGatewayEntitlement;
  vpc: VpcAttachmentEntitlement;
};

export enum ExperimentGroup {
  A = "A",
  B = "B",
  Unknown = "UNKNOWN",
}

export type ExplainPlan = {
  __typename?: "ExplainPlan";
  plan: Scalars["String"]["output"];
  timestamp: Scalars["Time"]["output"];
};

export type Explorer = {
  __typename?: "Explorer";
  currentActivity: CurrentActivityItems;
  historicalConnections: Array<HistoricalConnections>;
  job: Job;
  jobs: JobItems;
  regionCode: Scalars["String"]["output"];
};

export type ExplorerCurrentActivityArgs = {
  serviceOrdinal?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ExplorerHistoricalConnectionsArgs = {
  bucketSeconds?: InputMaybe<Scalars["Int"]["input"]>;
  end?: InputMaybe<Scalars["Time"]["input"]>;
  serviceOrdinal?: InputMaybe<Scalars["Int"]["input"]>;
  start: Scalars["Time"]["input"];
};

export type ExplorerJobArgs = {
  jobId: Scalars["ID"]["input"];
};

export type ExplorerJobsArgs = {
  filters?: InputMaybe<JobsFilters>;
};

export type ExporterEntitlement = {
  __typename?: "ExporterEntitlement";
  enabled: Scalars["Boolean"]["output"];
};

/** ExtendedObjectMetadata includes an object's ID, the object type's metadata, and, if applicable, hyper object metadata. */
export type ExtendedObjectMetadata = {
  __typename?: "ExtendedObjectMetadata";
  hyperMetadata?: Maybe<HyperMetadata>;
  metadata: ObjectMetadata;
};

export type FieldInfo = {
  __typename?: "FieldInfo";
  fieldName: Scalars["String"]["output"];
  fieldType: Scalars["String"]["output"];
};

/**
 * The file import resource.
 * Deprecated, use FileImportV2 instead.
 */
export type FileImport = {
  __typename?: "FileImport";
  failure_reason: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  progress?: Maybe<OperationProgress>;
  source?: Maybe<FileImportSourceOutput>;
  state: ImportState;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type FileImportDefinition = {
  __typename?: "FileImportDefinition";
  csv?: Maybe<FileImportDefinitionCsv>;
  parquet?: Maybe<FileImportDefinitionParquet>;
  type: FileImportDefinitionType;
};

export type FileImportDefinitionCsv = {
  __typename?: "FileImportDefinitionCSV";
  /**
   * Automatically map columns by matching header names to table column names.
   * Requires skip_header to be true.
   * Mutually exclusive with column_names and column_mappings - specify only one of these options.
   */
  auto_column_mapping?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Column mappings from source file columns to destination table columns.
   * Requires skip_header to be true.
   * Mutually exclusive with column_names and auto_column_mapping - specify only one of these options.
   */
  column_mappings?: Maybe<Array<ColumnMapping>>;
  /**
   * The column names of the CSV file.
   * It must match the columns in the destination database.
   * If left empty, the columns will be inserted by their position.
   * Mutually exclusive with column_mappings and auto_column_mapping - specify only one of these options.
   */
  column_names?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The delimiter of the CSV file. */
  delimiter?: Maybe<Scalars["String"]["output"]>;
  /** Whether the file has a header. */
  skip_header?: Maybe<Scalars["Boolean"]["output"]>;
};

export type FileImportDefinitionCsvInput = {
  /**
   * Automatically map columns by matching header names to table column names.
   * Requires skip_header to be true.
   * Mutually exclusive with column_names and column_mappings - specify only one of these options.
   */
  auto_column_mapping?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Column mappings from source file columns to destination table columns.
   * Requires skip_header to be true.
   * Mutually exclusive with column_names and auto_column_mapping - specify only one of these options.
   */
  column_mappings?: InputMaybe<Array<ColumnMappingInput>>;
  /**
   * The column names of the CSV file.
   * It must match the columns in the destination database.
   * If left empty, the columns will be inserted by their position.
   * Mutually exclusive with column_mappings and auto_column_mapping - specify only one of these options.
   */
  column_names?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * The delimiter of the CSV file.
   * You almost never have to set this as it is a "," by default.
   */
  delimiter?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Whether the file has a header.
   * It is important to set this correctly, otherwise the first row may be skipped.
   * If in doubt, set it to false as it will fail if it has headers. but it will never skip the first row.
   * Required to be true when using column_mappings or auto_column_mapping.
   */
  skip_header?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type FileImportDefinitionInput = {
  csv?: InputMaybe<FileImportDefinitionCsvInput>;
  parquet?: InputMaybe<FileImportDefinitionParquetInput>;
  type: FileImportDefinitionType;
};

export type FileImportDefinitionParquet = {
  __typename?: "FileImportDefinitionParquet";
  /**
   * Automatically map columns by matching header names to table column names.
   * Mutually exclusive with column_mappings - specify only one of these options.
   */
  auto_column_mapping?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Column mappings from source file columns to destination table columns.
   * Mutually exclusive with auto_column_mapping - specify only one of these options.
   */
  column_mappings?: Maybe<Array<ColumnMapping>>;
};

export type FileImportDefinitionParquetInput = {
  /**
   * Automatically map columns by matching header names to table column names.
   * Mutually exclusive with column_mappings - specify only one of these options.
   */
  auto_column_mapping?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Column mappings from source file columns to destination table columns.
   * Mutually exclusive with auto_column_mapping - specify only one of these options.
   */
  column_mappings?: InputMaybe<Array<ColumnMappingInput>>;
};

export enum FileImportDefinitionType {
  Csv = "CSV",
  Parquet = "PARQUET",
}

/** Deprecated */
export type FileImportHttpSource = {
  url: Scalars["String"]["input"];
};

export type FileImportHttpSourceInput = {
  url: Scalars["String"]["input"];
};

export type FileImportHttpSourceOutput = {
  __typename?: "FileImportHttpSourceOutput";
  url: Scalars["String"]["output"];
};

export type FileImportInternalSourceInput = {
  id: Scalars["String"]["input"];
};

export type FileImportInternalSourceOutput = {
  __typename?: "FileImportInternalSourceOutput";
  key: Scalars["String"]["output"];
};

export type FileImportLabel = {
  __typename?: "FileImportLabel";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type FileImportLabelInput = {
  key: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

/** Deprecated */
export type FileImportS3Source = {
  bucket: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["String"]["input"]>;
  key: Scalars["String"]["input"];
  role_arn?: InputMaybe<Scalars["String"]["input"]>;
};

export type FileImportS3SourceInput = {
  bucket: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["String"]["input"]>;
  key: Scalars["String"]["input"];
  role_arn?: InputMaybe<Scalars["String"]["input"]>;
};

export type FileImportS3SourceOutput = {
  __typename?: "FileImportS3SourceOutput";
  bucket: Scalars["String"]["output"];
  /**
   * The id of the file import.
   * This field is not used and will be removed in the future.
   */
  id?: Maybe<Scalars["String"]["output"]>;
  key: Scalars["String"]["output"];
  roleARN?: Maybe<Scalars["String"]["output"]>;
};

/** Deprecated in favour of FileImportSourceInput */
export type FileImportSource = {
  http?: InputMaybe<FileImportHttpSource>;
  s3?: InputMaybe<FileImportS3Source>;
  type: FileImportSourceType;
};

export type FileImportSourceInput = {
  http?: InputMaybe<FileImportHttpSourceInput>;
  internal?: InputMaybe<FileImportInternalSourceInput>;
  s3?: InputMaybe<FileImportS3SourceInput>;
  type: FileImportSourceType;
};

export type FileImportSourceOutput =
  | FileImportHttpSourceOutput
  | FileImportInternalSourceOutput
  | FileImportS3SourceOutput;

export enum FileImportSourceType {
  Http = "HTTP",
  Internal = "INTERNAL",
  S3 = "S3",
}

export type FileImportState = {
  __typename?: "FileImportState";
  /**
   * The failure reason.
   * This is only set if the state is FAILURE.
   */
  failure_reason?: Maybe<Scalars["String"]["output"]>;
  progress?: Maybe<OperationProgress>;
  state: ImportState;
  timelines?: Maybe<Array<FileImportStateTimeline>>;
};

export type FileImportStateTimeline = {
  __typename?: "FileImportStateTimeline";
  /** Timestamp at which the state was entered */
  at: Scalars["String"]["output"];
  /**
   * Additional payload information about the state change.
   * For example, when the state is FAILURE, it contains the failure_reason.
   */
  payload?: Maybe<FileImportStateTimelinePayload>;
  state: Scalars["String"]["output"];
};

export type FileImportStateTimelinePayload = {
  __typename?: "FileImportStateTimelinePayload";
  failure_reason?: Maybe<Scalars["String"]["output"]>;
  retry_at?: Maybe<Scalars["String"]["output"]>;
};

export type FileImportTableIdentifierInput = {
  schema_name?: InputMaybe<Scalars["String"]["input"]>;
  table_name: Scalars["String"]["input"];
};

/** Name conflict with previous FileImport, it can be removed after cleanup */
export type FileImportV2 = {
  __typename?: "FileImportV2";
  created_at: Scalars["String"]["output"];
  definition: FileImportDefinition;
  id: Scalars["ID"]["output"];
  /**
   * The labels of the file import.
   * This are generic labels that can be used to filter the file import when using the listFileImport endpoint.
   */
  labels: Array<FileImportLabel>;
  project_id: Scalars["ID"]["output"];
  service_id: Scalars["ID"]["output"];
  /** Import settings for customizable behavior */
  settings?: Maybe<ImportSettings>;
  /** The size of the file in bytes. */
  size: Scalars["Int"]["output"];
  source: TypeFileImportSource;
  state: FileImportState;
  table_identifier: TableIdentifier;
  updated_at: Scalars["String"]["output"];
};

export type ForeignKey = {
  __typename?: "ForeignKey";
  keyCols: Scalars["String"]["output"];
  name: Scalars["ID"]["output"];
  refCols: Scalars["String"]["output"];
  refName: Scalars["String"]["output"];
  refSchema: Scalars["String"]["output"];
};

export type ForkConfig = {
  /** Strategy for creating the fork (defaults to UNSPECIFIED for PITR behavior) */
  forkStrategy?: InputMaybe<ForkStrategy>;
  /** Is this fork a standby service? */
  isStandby?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Project ID of the origin */
  projectID: Scalars["ID"]["input"];
  /** Service ID of the origin */
  serviceID: Scalars["ID"]["input"];
  /** Produce a fork of the parent at a given timestamp (PITR) */
  targetTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type ForkSpec = {
  __typename?: "ForkSpec";
  isStandby?: Maybe<Scalars["Boolean"]["output"]>;
  projectId: Scalars["ID"]["output"];
  serviceId: Scalars["ID"]["output"];
  targetTime?: Maybe<Scalars["Time"]["output"]>;
};

export enum ForkStrategy {
  LastSnapshot = "LAST_SNAPSHOT",
  Now = "NOW",
}

export type GeneratePresignedUrlInput = {
  /** The size of the file to upload. It has to match exactly with content-length header of the upload or it will be rejected. */
  content_length: Scalars["Int"]["input"];
  /** Any unique identifier for the file that will be used later to identify it */
  id: Scalars["String"]["input"];
  project_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
};

export type GeneratePresignedUrlResponse = {
  __typename?: "GeneratePresignedURLResponse";
  url: Scalars["String"]["output"];
};

/** A generic exporter */
export type GenericExporter = {
  __typename?: "GenericExporter";
  config: GenericExporterConfig;
  created: Scalars["Time"]["output"];
  dataType: GenericExporterDataType;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  projectId: Scalars["ID"]["output"];
  regionCode: Scalars["String"]["output"];
  type: GenericExporterType;
};

export type GenericExporterConfig = CloudWatchConfig;

/** The configuration for a generic exporter. Exactly one field must be set. */
export type GenericExporterConfigInput = {
  configCloudWatch?: InputMaybe<CloudWatchConfigInput>;
};

export enum GenericExporterDataType {
  Log = "LOG",
  Unspecified = "UNSPECIFIED",
}

export type GenericExporterIdInput = {
  exporterId: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
};

export enum GenericExporterType {
  Cloudwatch = "CLOUDWATCH",
  Unspecified = "UNSPECIFIED",
}

export type GetAllOrganizationsForUserResponse = {
  __typename?: "GetAllOrganizationsForUserResponse";
  organizations: Array<OrganizationProjects>;
};

export type GetAllServicesStorageThresholdEventsInput = {
  projectId: Scalars["ID"]["input"];
};

export type GetConnectorInput = {
  connectorId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

export type GetConnectorResponse = {
  __typename?: "GetConnectorResponse";
  connector: ConnectorDetails;
};

export type GetConnectorTargetTablesInput = {
  connectorId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

export type GetConnectorTargetTablesResponse = {
  __typename?: "GetConnectorTargetTablesResponse";
  icebergdst?: Maybe<IcebergDstConnectorTargetTables>;
  pgsrc?: Maybe<PgSrcConnectorTargetTables>;
};

export type GetConnectorsInput = {
  connectorType?: InputMaybe<ConnectorType>;
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

export type GetConnectorsResponse = {
  __typename?: "GetConnectorsResponse";
  connectors: Array<ConnectorDetails>;
};

/** Get the full info of a table in an instance */
export type GetContAggInfoInput = {
  contAggName: Scalars["ID"]["input"];
  contAggSchema: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

/** Get the continuous aggs in a user's instance */
export type GetContAggListInput = {
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

/** Get an instance's TimescaleDB overview */
export type GetDatabaseOverviewInput = {
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

export type GetDatabaseOverviewOutput = {
  __typename?: "GetDatabaseOverviewOutput";
  compressionV2?: Maybe<DbCompressionStats>;
  objectCounts: ObjectCounts;
  policyCounts?: Maybe<Array<PolicyCount>>;
};

export type GetFileImportInput = {
  id: Scalars["String"]["input"];
  project_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
};

export type GetFileImportResponse = {
  __typename?: "GetFileImportResponse";
  file_import: FileImportV2;
};

export type GetImportStateInput = {
  id: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type GetJwtForClientCredentialsInput = {
  accessKey: Scalars["String"]["input"];
  secretKey: Scalars["String"]["input"];
};

export type GetKafkaClustersInput = {
  projectId: Scalars["String"]["input"];
};

export type GetKafkaClustersResponse = {
  __typename?: "GetKafkaClustersResponse";
  clusters: Array<KafkaClusterConfig>;
};

export type GetKafkaSrcConnectorStatusInput = {
  connectorId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

export type GetKafkaSrcConnectorStatusResponse = {
  __typename?: "GetKafkaSrcConnectorStatusResponse";
  status: KafkaSrcConnectorStatus;
};

export type GetKafkaTopicSchemaMappingInput = {
  clusterId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  schemaFormat: Scalars["String"]["input"];
  schemaRegistryId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  tableName: Scalars["String"]["input"];
  tableSchema: Scalars["String"]["input"];
  topicName: Scalars["String"]["input"];
};

export type GetKafkaTopicSchemaMappingResponse = {
  __typename?: "GetKafkaTopicSchemaMappingResponse";
  mappedTableDetails: MappedTableDetails;
  topicDetails: TopicDetails;
};

export type GetKafkaTopicsFromClusterInput = {
  clusterId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
};

export type GetKafkaTopicsFromClusterResponse = {
  __typename?: "GetKafkaTopicsFromClusterResponse";
  topics: Array<KafkaTopic>;
};

/** Get a list of the largest objects in an instance. */
export type GetLargestObjectsInput = {
  /** The maximum number of objects to return. Default is 10. */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

export type GetLastServiceResourceMetricsInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  serviceOrdinal?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Get a list of objects' metadata in the database */
export type GetObjectsMetadataInput = {
  excludeContAggs?: InputMaybe<Scalars["Boolean"]["input"]>;
  excludeHypertables?: InputMaybe<Scalars["Boolean"]["input"]>;
  excludePGTables?: InputMaybe<Scalars["Boolean"]["input"]>;
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

export type GetOrganizationMembersInput = {
  organizationId: Scalars["ID"]["input"];
};

export type GetOrganizationMembersResponse = {
  __typename?: "GetOrganizationMembersResponse";
  members: Array<OrganizationMember>;
};

export type GetPgSrcConfigInput = {
  projectId: Scalars["String"]["input"];
  sourceId: Scalars["String"]["input"];
};

export type GetPgSrcConfigResponse = {
  __typename?: "GetPgSrcConfigResponse";
  sourceConfig: PgSrcConfig;
};

export type GetPgSrcConfigsInput = {
  projectId: Scalars["String"]["input"];
};

export type GetPgSrcConfigsResponse = {
  __typename?: "GetPgSrcConfigsResponse";
  sourceConfigs: Array<PgSrcConfig>;
};

export type GetPgSrcConnectorStatusInput = {
  connectorId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

export type GetPgSrcConnectorStatusResponse = {
  __typename?: "GetPgSrcConnectorStatusResponse";
  status: PgSrcConnectorStatus;
};

export type GetPgSrcConnectorTargetTablesInput = {
  connectorId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

export type GetPgSrcConnectorTargetTablesResponse = {
  __typename?: "GetPgSrcConnectorTargetTablesResponse";
  tables: Array<PgSrcConnectorTargetTable>;
};

export type GetPgSrcPublicationTablesInput = {
  projectId: Scalars["String"]["input"];
  publicationName: Scalars["String"]["input"];
  sourceId: Scalars["String"]["input"];
};

export type GetPgSrcPublicationTablesResponse = {
  __typename?: "GetPgSrcPublicationTablesResponse";
  tables: Array<PgSrcTable>;
};

export type GetPgSrcPublicationsInput = {
  projectId: Scalars["String"]["input"];
  sourceId: Scalars["String"]["input"];
};

export type GetPgSrcPublicationsResponse = {
  __typename?: "GetPgSrcPublicationsResponse";
  publications: Array<PgPublication>;
};

export type GetPgSrcSchemasInput = {
  projectId: Scalars["String"]["input"];
  sourceId: Scalars["String"]["input"];
};

export type GetPgSrcSchemasResponse = {
  __typename?: "GetPgSrcSchemasResponse";
  schemas: Array<Scalars["String"]["output"]>;
};

export type GetPgSrcTablesInput = {
  projectId: Scalars["String"]["input"];
  schemaName: Scalars["String"]["input"];
  sourceId: Scalars["String"]["input"];
};

export type GetPgSrcTablesResponse = {
  __typename?: "GetPgSrcTablesResponse";
  tables: Array<PgSrcTable>;
};

export type GetPopSqlIntegrationStatusInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

/** Get an instance's PG and timescaledb installed and available versions */
export type GetPostgresAndTimescaleDbVersionInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type GetPostgresAvailableExtensionsInput = {
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

/** Get the last known status for a major PostgreSQL Upgrade */
export type GetPostgresMajorVersionUpgradeStatusInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

/** Get postgres parameters for an instance. */
export type GetPostgresParametersInput = {
  /** ProjectID that the service belongs to. */
  projectId: Scalars["ID"]["input"];
  /** Service ID of the service in question. */
  serviceId: Scalars["ID"]["input"];
};

export type GetPrivateLinkServiceConnectionInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type GetProjectSecretsInput = {
  projectId: Scalars["ID"]["input"];
};

export type GetQueryDetailsInput = {
  projectId: Scalars["ID"]["input"];
  queryHash: Scalars["String"]["input"];
  serviceId: Scalars["ID"]["input"];
  serviceOrdinal: Scalars["Int"]["input"];
};

export type GetQueryDetailsResponse = {
  __typename?: "GetQueryDetailsResponse";
  queryDetails: QueryDetails;
};

export type GetQueryLatestExplainInput = {
  projectId: Scalars["ID"]["input"];
  queryHash: Scalars["String"]["input"];
  serviceId: Scalars["ID"]["input"];
  serviceRole: InstanceRole;
};

export type GetQueryMetricGraphsInput = {
  projectId: Scalars["ID"]["input"];
  queryHash: Scalars["String"]["input"];
  queryRange: QueryRange;
  serviceId: Scalars["ID"]["input"];
  serviceOrdinal: Scalars["Int"]["input"];
  serviceRole?: InputMaybe<InstanceRole>;
};

/** Defines all available options for requesting the list of query performance stats */
export type GetQueryStatsInput = {
  constraints?: InputMaybe<Array<QueryStatConstraint>>;
  limit?: Scalars["Int"]["input"];
  projectId: Scalars["ID"]["input"];
  queryRange: QueryRange;
  serviceId: Scalars["ID"]["input"];
  /** @deprecated prefer setting serviceRole */
  serviceOrdinal?: InputMaybe<Scalars["Int"]["input"]>;
  serviceRole?: InputMaybe<InstanceRole>;
  sortBy?: QueryStatSortFieldOption;
  sortOrder?: QueryStatSortOrderOption;
};

export type GetRecommendationsInput = {
  dismissed?: InputMaybe<Scalars["Boolean"]["input"]>;
  projectId: Scalars["ID"]["input"];
  recommendationType?: InputMaybe<RecommendationType>;
  serviceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type GetS3LiveSyncAuditInput = {
  pagination: PaginationInput;
  project_id: Scalars["ID"]["input"];
  s3_live_sync_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
};

export type GetS3LiveSyncAuditResponse = {
  __typename?: "GetS3LiveSyncAuditResponse";
  entries: Array<S3LiveSyncAudit>;
  page_info: PageInfo;
};

export type GetS3LiveSyncInput = {
  id: Scalars["ID"]["input"];
  project_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
};

export type GetS3LiveSyncRuntimeAuditInput = {
  pagination: PaginationInput;
  project_id: Scalars["ID"]["input"];
  s3_live_sync_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
};

export type GetS3LiveSyncRuntimeAuditResponse = {
  __typename?: "GetS3LiveSyncRuntimeAuditResponse";
  entries: Array<S3LiveSyncRuntimeAudit>;
  page_info: PageInfo;
};

export type GetS3LiveSyncStatisticsInput = {
  id: Scalars["ID"]["input"];
  project_id: Scalars["ID"]["input"];
  /** Filter S3 imports by key prefix (e.g., 'data/2024/'). */
  s3_key_prefix?: InputMaybe<Scalars["String"]["input"]>;
  service_id: Scalars["ID"]["input"];
};

export type GetS3LiveSyncStatisticsResponse = {
  __typename?: "GetS3LiveSyncStatisticsResponse";
  error?: Maybe<Scalars["String"]["output"]>;
  statistics: S3LiveSyncStatistics;
};

export type GetSshTunnelConfigInput = {
  projectId: Scalars["String"]["input"];
  sshTunnelId: Scalars["String"]["input"];
};

export type GetSshTunnelConfigResponse = {
  __typename?: "GetSSHTunnelConfigResponse";
  sshTunnelConfig: SshTunnelConfig;
};

export type GetSshTunnelConfigsInput = {
  projectId: Scalars["String"]["input"];
};

export type GetSshTunnelConfigsResponse = {
  __typename?: "GetSSHTunnelConfigsResponse";
  sshTunnelConfigs: Array<SshTunnelConfig>;
};

export type GetSchemaRegistriesInput = {
  projectId: Scalars["String"]["input"];
};

export type GetSchemaRegistriesResponse = {
  __typename?: "GetSchemaRegistriesResponse";
  schemaRegistries: Array<SchemaRegistryConfig>;
};

export type GetServiceDeploymentStatusInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type GetServiceInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type GetServiceLogsInput = {
  pageIndex?: InputMaybe<Scalars["Int"]["input"]>;
  projectId: Scalars["ID"]["input"];
  searchTags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  serviceId: Scalars["ID"]["input"];
  serviceOrdinal?: InputMaybe<Scalars["Int"]["input"]>;
  startTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type GetServiceMetricsInput = {
  /** Size of the time buckets we average the metrics over, expressed in seconds. */
  bucketSeconds: Scalars["Int"]["input"];
  /** End time of the window we want to get metrics for. */
  end: Scalars["Time"]["input"];
  /** Project ID of the service we want to get metrics for. */
  projectId: Scalars["ID"]["input"];
  /** Role of the pods we want to return metrics for. If this is missing, or unknown, all metrics will be returned. */
  role?: InputMaybe<InstanceRole>;
  /** Service ID of the service we want to get metrics for. */
  serviceId: Scalars["ID"]["input"];
  /** Start time of the window we want to get metrics for. */
  start: Scalars["Time"]["input"];
};

export type GetServiceResourceMetricsInput = {
  bucketSeconds: Scalars["Int"]["input"];
  end: Scalars["Time"]["input"];
  projectId: Scalars["ID"]["input"];
  role?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
  serviceOrdinal?: InputMaybe<Scalars["Int"]["input"]>;
  start: Scalars["Time"]["input"];
};

export type GetServiceStorageThresholdEventInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type GetSupportCasesInput = {
  /** Project ID to get cases for. */
  projectId: Scalars["ID"]["input"];
};

/** Get the full info of a table in an instance */
export type GetTableInfoInput = {
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
  tableName: Scalars["ID"]["input"];
  tableSchema: Scalars["ID"]["input"];
};

/** Get the tables in an instance */
export type GetTableListInput = {
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

/** Get an instance's TimescaleDB version */
export type GetTimescaleVersionInput = {
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

export type GetUiStateInput = {
  key: Scalars["ID"]["input"];
  owner?: InputMaybe<OwnerInput>;
  timeout_seconds?: InputMaybe<Scalars["Int"]["input"]>;
  version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GetUiStateResponse = {
  __typename?: "GetUIStateResponse";
  ui_state: UiStateResource;
};

export type GetVpcByNameInput = {
  /** The project ID of the vpc. */
  projectId: Scalars["ID"]["input"];
  /** The name of the shell VPC. */
  vpcName: Scalars["String"]["input"];
};

export type GetVirtualPlansResponse = {
  __typename?: "GetVirtualPlansResponse";
  plans: Array<VirtualPlan>;
};

export type GhostProjectStatus = {
  __typename?: "GhostProjectStatus";
  services: Array<GhostServiceStatus>;
  totalComputeMinutes: Scalars["Int"]["output"];
  totalStorageMiB: Scalars["Int"]["output"];
};

export type GhostServiceStatus = {
  __typename?: "GhostServiceStatus";
  computeMinutes: Scalars["Int"]["output"];
  disabled: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  storageMiB: Scalars["Int"]["output"];
};

/**
 * GraphDataPoint represents a data point in time for a graph.
 * It also holds a QueryStatMetrics with the aggregated metrics for that point in time.
 */
export type GraphDataPoint = {
  __typename?: "GraphDataPoint";
  bucket: Scalars["Time"]["output"];
  metrics: QueryStatMetrics;
  queryHash: Scalars["String"]["output"];
};

export type HaReplicaEntitlement = {
  __typename?: "HAReplicaEntitlement";
  enabled: Scalars["Boolean"]["output"];
  max_instances_per_service: Scalars["Int"]["output"];
  replication_modes: Array<HaReplicaReplicationMode>;
};

export enum HaReplicaReplicationMode {
  Async = "ASYNC",
  None = "NONE",
  Sync = "SYNC",
}

export type HasBackups = {
  __typename?: "HasBackups";
  hasBackups: Scalars["Boolean"]["output"];
};

export type HasBackupsInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type HistoricalConnections = {
  __typename?: "HistoricalConnections";
  connectionsCount: Scalars["Int"]["output"];
  maxUsableConnections: Scalars["Int"]["output"];
  time: Scalars["Time"]["output"];
};

export type HttpBasicAuth = {
  __typename?: "HttpBasicAuth";
  password: Scalars["String"]["output"];
  username: Scalars["String"]["output"];
};

export type HttpBasicAuthInput = {
  password: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
};

/** HyperMetadata is additional metadata associated with hyper objects like hypertables and continuous aggregates. */
export type HyperMetadata = {
  __typename?: "HyperMetadata";
  compression: Scalars["Boolean"]["output"];
  compressionStats?: Maybe<CompressionStats>;
  dimensions?: Maybe<Array<Dimension>>;
  hypertableId: Scalars["Int"]["output"];
  integerInterval: Scalars["Int"]["output"];
  numChunks: Scalars["Int"]["output"];
  /** @deprecated Use timeIntervalUsecs instead */
  timeInterval: Scalars["String"]["output"];
  timeIntervalUsecs: Scalars["Int"]["output"];
};

export type HypertableChangeChunkTimeIntervalMetadata = {
  __typename?: "HypertableChangeChunkTimeIntervalMetadata";
  currentIntervalSeconds: Scalars["Int"]["output"];
  recommendedIntervalSeconds: Scalars["Int"]["output"];
  schemaName: Scalars["String"]["output"];
  tableName: Scalars["String"]["output"];
};

export type HypertableDimension = {
  __typename?: "HypertableDimension";
  hash?: Maybe<HypertableHashDimension>;
  range?: Maybe<HypertableRangeDimension>;
};

export type HypertableDimensionInput = {
  hash?: InputMaybe<HypertableHashDimensionInput>;
  range?: InputMaybe<HypertableRangeDimensionInput>;
};

export type HypertableHashDimension = {
  __typename?: "HypertableHashDimension";
  columnName: Scalars["String"]["output"];
  numberPartitions: Scalars["Int"]["output"];
};

export type HypertableHashDimensionInput = {
  columnName: Scalars["String"]["input"];
  numberPartitions: Scalars["Int"]["input"];
};

export type HypertableRangeDimension = {
  __typename?: "HypertableRangeDimension";
  columnName: Scalars["String"]["output"];
  partitionInterval: Scalars["String"]["output"];
};

export type HypertableRangeDimensionInput = {
  columnName: Scalars["String"]["input"];
  partitionInterval: Scalars["String"]["input"];
};

export type HypertableSpec = {
  __typename?: "HypertableSpec";
  primaryDimension: HypertableRangeDimension;
  secondaryDimensions?: Maybe<Array<HypertableDimension>>;
};

export type IpAllowList = {
  __typename?: "IPAllowList";
  associatedServices?: Maybe<Array<Scalars["String"]["output"]>>;
  cidrBlocks: Array<Scalars["String"]["output"]>;
  created: Scalars["Time"]["output"];
  description: Scalars["String"]["output"];
  listId: Scalars["Int"]["output"];
};

export type IpAllowListEntitlement = {
  __typename?: "IPAllowListEntitlement";
  enabled: Scalars["Boolean"]["output"];
  max_cidr_blocks_count: Scalars["Int"]["output"];
  max_list_count: Scalars["Int"]["output"];
};

export type IcebergDstConnectorDetails = {
  __typename?: "IcebergDstConnectorDetails";
  catalogRest?: Maybe<CatalogRestDetails>;
  catalogS3Tables?: Maybe<CatalogS3TablesDetails>;
  id: Scalars["String"]["output"];
  status?: Maybe<IcebergDstConnectorDetailsStatus>;
};

export type IcebergDstConnectorDetailsStatus = {
  __typename?: "IcebergDstConnectorDetailsStatus";
  bytesRead?: Maybe<Scalars["String"]["output"]>;
  confirmedFlushLsn?: Maybe<Scalars["String"]["output"]>;
  lastCommittedTxnTime?: Maybe<Scalars["Time"]["output"]>;
  metricsUpdatedAt: Scalars["Time"]["output"];
  restartLsn?: Maybe<Scalars["String"]["output"]>;
  sourceWalLsn?: Maybe<Scalars["String"]["output"]>;
  throughput?: Maybe<Scalars["Float"]["output"]>;
  totalRecords?: Maybe<Scalars["String"]["output"]>;
};

export type IcebergDstConnectorTargetTable = {
  __typename?: "IcebergDstConnectorTargetTable";
  approximateRows?: Maybe<Scalars["String"]["output"]>;
  icebergSchema: Scalars["String"]["output"];
  icebergTable: Scalars["String"]["output"];
  lastError?: Maybe<Scalars["String"]["output"]>;
  rowsCopied?: Maybe<Scalars["String"]["output"]>;
  snapshotAttemptCount: Scalars["Int"]["output"];
  snapshotCompletedAt?: Maybe<Scalars["Time"]["output"]>;
  snapshotStartedAt?: Maybe<Scalars["Time"]["output"]>;
  state: IcebergDstConnectorTargetTableState;
  table: ConnectorTableIdentifier;
};

export enum IcebergDstConnectorTargetTableState {
  Copying = "copying",
  Failed = "failed",
  Pending = "pending",
  Synced = "synced",
  Warning = "warning",
}

export type IcebergDstConnectorTargetTables = {
  __typename?: "IcebergDstConnectorTargetTables";
  tables: Array<IcebergDstConnectorTargetTable>;
};

export type IcebergDstSpecInput = {
  catalogRest?: InputMaybe<CatalogRestInput>;
  catalogS3Tables?: InputMaybe<CatalogS3TablesInput>;
};

export type IcebergSync = {
  credentials: S3TablesRole;
  iceberg: S3TablesBucket;
};

export type IcebergSyncInfo = {
  __typename?: "IcebergSyncInfo";
  enabled: Scalars["Boolean"]["output"];
};

/** Import settings for customizable behavior during file imports */
export type ImportSettings = {
  __typename?: "ImportSettings";
  /** Handle conflicts by doing nothing (ignore conflicting rows). Defaults to false. */
  on_conflict_do_nothing?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Input for import settings */
export type ImportSettingsInput = {
  /** Handle conflicts by doing nothing (ignore conflicting rows). Defaults to false. */
  on_conflict_do_nothing?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum ImportState {
  /** The file import was canceled by the user. */
  Canceled = "CANCELED",
  /** The file import failed permanently. */
  Failure = "FAILURE",
  /** The file import is waiting in queue to be processed. */
  InQueue = "IN_QUEUE",
  /** The file import is paused and won't be processed until resumed. */
  Paused = "PAUSED",
  /** The file import is waiting to be retried after a transient failure. */
  PendingRetry = "PENDING_RETRY",
  /** The file import is currently being processed. */
  Running = "RUNNING",
  /** The file import completed successfully. */
  Success = "SUCCESS",
}

export type Index = {
  __typename?: "Index";
  definition: Scalars["String"]["output"];
  name: Scalars["ID"]["output"];
};

/** An Input version of the PeerVPC type. */
export type InputPeerVpc = {
  /** The account ID issues by the cloud provider to the user. */
  accountId: Scalars["ID"]["input"];
  /**
   * Deprecated. Use cidrBlocks.
   * @deprecated use cidrBlocks
   */
  cidr?: InputMaybe<Scalars["String"]["input"]>;
  /** The list of CIDR blocks of the peer VPC/TGW. If TGW, this field is mandatory. Otherwise, it's optional. */
  cidrBlocks?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** The ID of the user-provided VPC. */
  id: Scalars["ID"]["input"];
  /** The region that the user-provided VPC exists in. */
  regionCode: Scalars["String"]["input"];
};

export type InsightsEntitlement = {
  __typename?: "InsightsEntitlement";
  enabled: Scalars["Boolean"]["output"];
  max_hours: Scalars["Int"]["output"];
};

/** InstanceRole is used to request a particular role of a service. */
export enum InstanceRole {
  Primary = "PRIMARY",
  Replica = "REPLICA",
  Unknown = "UNKNOWN",
}

export type InviteProjectMemberInput = {
  email: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
  role?: InputMaybe<RbacRole>;
};

/** An invoice. */
export type Invoice = {
  __typename?: "Invoice";
  /** The billing account to which this record applies. */
  billingAccountId: Scalars["ID"]["output"];
  /** The date this record was generated in the system. */
  created: Scalars["Time"]["output"];
  /** It explicit identifies when the invoice comes from our own billing platform, or from Orb, which is the current 3rd party billing platform. */
  fromInternalBilling?: Maybe<Scalars["Boolean"]["output"]>;
  /** The ID of the `Invoice`. */
  id: Scalars["ID"]["output"];
  /** The time of the next scheduled payment attempt for this invoice, if any. */
  nextAttempt?: Maybe<Scalars["Time"]["output"]>;
  /** History of payment attempts made against this invoice. */
  paymentAttempts?: Maybe<Array<PaymentAttempt>>;
  /** This invoice's current state. */
  paymentState?: Maybe<Scalars["String"]["output"]>;
  /** This invoice's pdf Url (on orb) */
  pdfUrl?: Maybe<Scalars["String"]["output"]>;
  /** An exclusive timestamp of the end of this records billing period. */
  periodEnd?: Maybe<Scalars["Time"]["output"]>;
  /** An inclusive timestamp of the beginning of this records billing period. */
  periodStart?: Maybe<Scalars["Time"]["output"]>;
  /** The total amount charged for the invoice, in USD. */
  totalCharged?: Maybe<Scalars["Float"]["output"]>;
  /** The date of the last time this record was updated. */
  updated?: Maybe<Scalars["Time"]["output"]>;
};

export type InvoiceBillingEntitlement = {
  __typename?: "InvoiceBillingEntitlement";
  enabled: Scalars["Boolean"]["output"];
};

/** List of invoices with additional general info about invoices */
export type Invoices = {
  __typename?: "Invoices";
  /** The list of paid invoices matching eventual time filters */
  invoices: Array<Invoice>;
  /** Oldest available year (querying period_start) */
  oldestYear?: Maybe<Scalars["Int"]["output"]>;
  /** The list of all unpaid invoices, regardless of time filters */
  unpaidInvoices?: Maybe<Array<Invoice>>;
};

export type Invoicing = {
  __typename?: "Invoicing";
  billingAccountId: Scalars["Int"]["output"];
  netTermDays?: Maybe<Scalars["Int"]["output"]>;
  notes?: Maybe<Scalars["String"]["output"]>;
  paymentOrder?: Maybe<Scalars["String"]["output"]>;
  region?: Maybe<Scalars["String"]["output"]>;
};

export type Job = {
  __typename?: "Job";
  config?: Maybe<Scalars["String"]["output"]>;
  currentStart?: Maybe<Scalars["Time"]["output"]>;
  executions: Array<JobExecution>;
  id: Scalars["ID"]["output"];
  nextStart?: Maybe<Scalars["Time"]["output"]>;
  /** proc is the Postgres procedure that the job runs. */
  proc: ProcedureId;
  schedule: JobSchedule;
  stats: JobStats;
  status: JobStatus;
  /** target is the continuous aggregate or hypertable that this job affects, used for built-in jobs */
  target?: Maybe<ObjectId>;
  type: Scalars["String"]["output"];
};

export type JobExecutionsArgs = {
  end?: InputMaybe<Scalars["Time"]["input"]>;
  errorsOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  n?: InputMaybe<Scalars["Int"]["input"]>;
  start?: InputMaybe<Scalars["Time"]["input"]>;
};

export type JobStatsArgs = {
  end?: InputMaybe<Scalars["Time"]["input"]>;
  n?: InputMaybe<Scalars["Int"]["input"]>;
  start?: InputMaybe<Scalars["Time"]["input"]>;
};

export type JobExecution = {
  __typename?: "JobExecution";
  error?: Maybe<JobExecutionError>;
  finishTime: Scalars["Time"]["output"];
  startTime: Scalars["Time"]["output"];
  succeeded?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JobExecutionError = {
  __typename?: "JobExecutionError";
  errorMessage: Scalars["String"]["output"];
  sqlErrorCode: Scalars["String"]["output"];
};

export type JobFailedNTimesMetadata = {
  __typename?: "JobFailedNTimesMetadata";
  applicationName: Scalars["String"]["output"];
  lastSuccessfulFinish?: Maybe<Scalars["Time"]["output"]>;
  numFailures: Scalars["Int"]["output"];
  procName: Scalars["String"]["output"];
  procSchema: Scalars["String"]["output"];
};

export type JobItem = {
  __typename?: "JobItem";
  item: Job;
};

export type JobItems = {
  __typename?: "JobItems";
  items: Array<JobItem>;
};

export type JobRuntimeStats = {
  __typename?: "JobRuntimeStats";
  maxDurationUsecs: Scalars["Int"]["output"];
  medianDurationUsecs: Scalars["Int"]["output"];
  p95DurationUsecs: Scalars["Int"]["output"];
};

export type JobSchedule = {
  __typename?: "JobSchedule";
  active: Scalars["Boolean"]["output"];
  fixed: Scalars["Boolean"]["output"];
  initialStart?: Maybe<Scalars["Time"]["output"]>;
  intervalUsecs: Scalars["Int"]["output"];
  maxRetries: Scalars["Int"]["output"];
  maxRuntimeUsecs: Scalars["Int"]["output"];
  retryIntervalUsecs: Scalars["Int"]["output"];
};

export type JobStats = {
  __typename?: "JobStats";
  runtimes?: Maybe<JobRuntimeStats>;
  successPct?: Maybe<Scalars["Float"]["output"]>;
};

export enum JobStatus {
  Paused = "PAUSED",
  Running = "RUNNING",
  Upcoming = "UPCOMING",
}

export type JobsFilters = {
  end?: InputMaybe<Scalars["Time"]["input"]>;
  procNamePrefix?: InputMaybe<Scalars["String"]["input"]>;
  start?: InputMaybe<Scalars["Time"]["input"]>;
  statuses?: InputMaybe<Array<JobStatus>>;
  targetPrefix?: InputMaybe<Scalars["String"]["input"]>;
  types?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Error codes set in extensions.code when a joinProject mutation fails. */
export enum JoinProjectErrorCode {
  /** The project requires MFA and the session did not authenticate via MFA. */
  EnforcementMfaRequired = "ENFORCEMENT_MFA_REQUIRED",
  /** The project requires SSO and the session did not authenticate via SSO. */
  EnforcementSsoRequired = "ENFORCEMENT_SSO_REQUIRED",
  /** The invite has already been declined. */
  InviteDeclined = "INVITE_DECLINED",
  /** The invite has expired. */
  InviteExpired = "INVITE_EXPIRED",
  /** No pending invite was found for the supplied id/hash. */
  InviteNotFound = "INVITE_NOT_FOUND",
  /** An unexpected error occurred while joining the project. */
  Unknown = "UNKNOWN",
}

export type JoinProjectInput = {
  hash: Scalars["String"]["input"];
  inviteId: Scalars["ID"]["input"];
};

export type KafkaAuthentication = {
  __typename?: "KafkaAuthentication";
  awsAssumeRole?: Maybe<AwsAssumeRole>;
  sasl?: Maybe<SaslAuthentication>;
};

export type KafkaAuthenticationInput = {
  awsAssumeRole?: InputMaybe<AwsAssumeRoleInput>;
  sasl?: InputMaybe<SaslAuthenticationInput>;
};

export type KafkaClusterConfig = {
  __typename?: "KafkaClusterConfig";
  brokerUrls: Array<Scalars["String"]["output"]>;
  clusterId: Scalars["String"]["output"];
  created?: Maybe<Scalars["Time"]["output"]>;
  name: Scalars["String"]["output"];
  projectId: Scalars["String"]["output"];
  updated?: Maybe<Scalars["Time"]["output"]>;
};

export type KafkaConnectorDetails = {
  __typename?: "KafkaConnectorDetails";
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  kafkaClusterConfigId: Scalars["String"]["output"];
  kafkaTopic: Scalars["String"]["output"];
  schemaRegistryConfigId: Scalars["String"]["output"];
  tableName: Scalars["String"]["output"];
  tableSchema: Scalars["String"]["output"];
};

export type KafkaSpec = {
  clusterId: Scalars["String"]["input"];
  enabled: Scalars["Boolean"]["input"];
  kafkaTopic: Scalars["String"]["input"];
  schema: SchemaSpec;
  targetTable: TargetTableSpec;
};

export type KafkaSrcConnectorStatus = {
  __typename?: "KafkaSrcConnectorStatus";
  bytesIngestedTotal?: Maybe<Scalars["String"]["output"]>;
  consumerLagMessages?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["String"]["output"];
  lastMessageEventTimestamp?: Maybe<Scalars["Time"]["output"]>;
  lastMessageProcessedAt?: Maybe<Scalars["Time"]["output"]>;
  messagesProcessedTotal?: Maybe<Scalars["String"]["output"]>;
  operationalErrorCount?: Maybe<Scalars["Int"]["output"]>;
  ready?: Maybe<Scalars["Boolean"]["output"]>;
  recordErrorCount?: Maybe<Scalars["Int"]["output"]>;
  updated?: Maybe<Scalars["Time"]["output"]>;
};

export type KafkaTopic = {
  __typename?: "KafkaTopic";
  name: Scalars["String"]["output"];
  partitionCount: Scalars["Int"]["output"];
};

export type LastLoginSession = {
  __typename?: "LastLoginSession";
  authMethod: CurrentAuthMethod;
  timestamp: Scalars["Time"]["output"];
};

export type LinkMarketplaceAccountRequest = {
  projectId: Scalars["ID"]["input"];
};

export type LinkMarketplaceAccountResponse = {
  __typename?: "LinkMarketplaceAccountResponse";
  success: Scalars["Boolean"]["output"];
};

export type ListBackupsInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type ListBucketObjectsInput = {
  bucket: Scalars["String"]["input"];
  credentials: S3LiveSyncCredentialsInput;
  /**
   * The maximum number of items to return.
   * Maximum is 1000
   */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  pattern: Scalars["String"]["input"];
  project_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
  /**
   * The key to start the listing after.
   * If you want to fetch the next page, set this to the last key in the previous page.
   */
  start_after?: InputMaybe<Scalars["String"]["input"]>;
};

export type ListBucketObjectsResponse = {
  __typename?: "ListBucketObjectsResponse";
  objects: Array<BucketObject>;
};

export type ListFileImportInput = {
  /**
   * Deprecated: Use s3_key_prefix for better performance when filtering S3 files.
   * Filter by start time.
   * It is a timestamp in RFC3339 format.
   */
  from?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Filter by label key and value using k8s label selector syntax.
   * The labels are set when creating the file import.
   *
   * Example: Select files uploaded by S3LiveSync
   * `source=s3-live-sync,s3-live-sync-id=123`
   */
  label_selector?: InputMaybe<Scalars["String"]["input"]>;
  pagination: PaginationInput;
  project_id: Scalars["ID"]["input"];
  /**
   * Filter by required labels.
   * It is a simplification over the label_selector that will build a query using the label key and value.
   * Example: Select files uploaded by S3LiveSync
   * required_labels: [
   *     {key: "source", value: "s3-live-sync"},
   *     {key: "s3-live-sync-id", value: "123"}
   * ]
   * is equivalent to
   * label_selector: "source=s3-live-sync,s3-live-sync-id=123"
   */
  required_labels?: InputMaybe<Array<FileImportLabelInput>>;
  /**
   * Filter S3 imports by key prefix (e.g., 'data/2024/').
   * Only affects S3 source imports.
   */
  s3_key_prefix?: InputMaybe<Scalars["String"]["input"]>;
  service_id: Scalars["ID"]["input"];
  /**
   * Filter by source type for optimized ordering.
   * When set to "S3", enables lexicographical ordering by S3 key.
   * Supported values: "S3", "HTTP", "INTERNAL"
   */
  source_type?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Filter by states.
   * If empty, all states will be included.
   */
  states?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Deprecated: Use s3_key_prefix for better performance when filtering S3 files.
   * Filter by end time.
   * It is a timestamp in RFC3339 format.
   */
  to?: InputMaybe<Scalars["String"]["input"]>;
};

export type ListFileImportResponse = {
  __typename?: "ListFileImportResponse";
  file_imports: Array<FileImportV2>;
  page_info: PageInfo;
};

export type ListForkRegionsInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type ListForkRegionsResponse = {
  __typename?: "ListForkRegionsResponse";
  regions?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type ListPrivateLinkBindingsInput = {
  projectId: Scalars["ID"]["input"];
  serviceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ListPrivateLinkConnectionsInput = {
  projectId: Scalars["ID"]["input"];
  region?: InputMaybe<Scalars["String"]["input"]>;
};

export type ListS3LiveSyncInput = {
  project_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
};

export type LoginBasicAuth = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
};

export type LoginInput = {
  noJWT?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LoginMfa = {
  code: Scalars["String"]["input"];
  twoFactorId: Scalars["String"]["input"];
};

export type LoginMfaInput = {
  /** Details for initial request with email/password */
  basic?: InputMaybe<LoginBasicAuth>;
  /** Code and id for the second request when Mfa is enabled */
  mfa?: InputMaybe<LoginMfa>;
  /** Whether a JWT should be returned in the response body in addition to the cookie */
  noJWT?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LoginMfaRequired = {
  __typename?: "LoginMfaRequired";
  mfaMethods: Array<MfaMethod>;
  twoFactorId: Scalars["String"]["output"];
};

export type LoginMfaResponse = LoginMfaRequired | LoginSuccess;

export type LoginResponse = {
  __typename?: "LoginResponse";
  user: User;
  userToken: Scalars["String"]["output"];
};

export type LoginSuccess = {
  __typename?: "LoginSuccess";
  user: User;
  userToken?: Maybe<Scalars["String"]["output"]>;
};

export enum ManagedByIdpReason {
  IdpLogin = "IDP_LOGIN",
  MandatoryIdp = "MANDATORY_IDP",
}

export type MappedTableDetails = {
  __typename?: "MappedTableDetails";
  fields: Array<FieldInfo>;
  tableName: Scalars["String"]["output"];
  tableSchema: Scalars["String"]["output"];
};

/** Error codes set in extensions.code when a linkMarketplaceAccount mutation fails. */
export enum MarketplaceLinkErrorCode {
  /** The marketplace entitlement was not found. */
  EntitlementNotFound = "ENTITLEMENT_NOT_FOUND",
  /** The marketplace entitlement is not in a state that allows linking. */
  EntitlementNotLinkable = "ENTITLEMENT_NOT_LINKABLE",
  /** The marketplace account is already linked to another project. */
  MarketplaceAccountAlreadyLinked = "MARKETPLACE_ACCOUNT_ALREADY_LINKED",
  /** The project is already linked to a different marketplace account. */
  ProjectAlreadyLinkedDifferentAccount = "PROJECT_ALREADY_LINKED_DIFFERENT_ACCOUNT",
  /** The project is already linked to this marketplace account. */
  ProjectAlreadyLinkedSameAccount = "PROJECT_ALREADY_LINKED_SAME_ACCOUNT",
  /** An unexpected error occurred while linking the marketplace account. */
  Unknown = "UNKNOWN",
  /** The marketplace entitlement's partner is not supported. */
  UnsupportedPartner = "UNSUPPORTED_PARTNER",
}

/**
 * Aggregation function applied per output bucket. Omit to let the server pick
 * a default for the metric — usually `LAST`, but some metrics declare a
 * different one (see getMetricDetails.defaultAgg).
 *
 * `MIN`/`MAX` and `MIN_TOTAL`/`MAX_TOTAL` answer different questions for a
 * metric with labels (e.g. one series per database) when the request doesn't
 * group by them, so those series collapse into one:
 *   - `MIN`/`MAX`: the single most extreme value across every series, e.g. the
 *     longest-running transaction across all databases. Right when the metric
 *     is itself an extremum or a timestamp.
 *   - `MIN_TOTAL`/`MAX_TOTAL`: the extremum of the series added together
 *     first, e.g. the peak of total connections across all databases. Right
 *     when the combined total is the meaningful quantity.
 *
 * Not accepted on the following metrics — requests are rejected with
 * `INVALID_REQUEST`:
 *   - `timescale_cloud_system_cpu_total_millicores`
 *   - `timescale_cloud_system_cpu_usage_millicores`
 *   - `timescale_cloud_system_disk_io_read_bytes`
 *   - `timescale_cloud_system_disk_io_read_ops`
 *   - `timescale_cloud_system_disk_io_total_bytes`
 *   - `timescale_cloud_system_disk_io_total_ops`
 *   - `timescale_cloud_system_disk_io_write_bytes`
 *   - `timescale_cloud_system_disk_io_write_ops`
 *   - `timescale_cloud_system_disk_usage_bytes`
 *   - `timescale_cloud_system_memory_total_bytes`
 *   - `timescale_cloud_system_memory_usage_bytes`
 */
export enum MetricAggFn {
  Avg = "AVG",
  Count = "COUNT",
  Increase = "INCREASE",
  Last = "LAST",
  Max = "MAX",
  MaxTotal = "MAX_TOTAL",
  Min = "MIN",
  MinTotal = "MIN_TOTAL",
  P50 = "P50",
  P90 = "P90",
  P99 = "P99",
  Rate = "RATE",
  Sum = "SUM",
}

/**
 * A single time+value pair within a MetricSeries. Some producers (e.g.
 * metrics-store-backed and QPS series) gapfill: a bucket with no collected data
 * still gets a point, with value null, instead of being omitted.
 */
export type MetricDataPoint = {
  __typename?: "MetricDataPoint";
  time: Scalars["Time"]["output"];
  value?: Maybe<Scalars["Float"]["output"]>;
};

/**
 * Descriptive metadata for a metric series — what it is, not its data. Some
 * series don't have full metadata yet: type and defaultAgg may be null and
 * description/labels may be empty, but every field below is always present
 * in the response.
 */
export type MetricDetails = {
  __typename?: "MetricDetails";
  /** The aggregation function used by default when fn is omitted from a series query, or null if undocumented. */
  defaultAgg?: Maybe<MetricAggFn>;
  description: Scalars["String"]["output"];
  labels: Array<MetricLabelDetails>;
  name: Scalars["String"]["output"];
  /** The shape of this metric's data, or null if undocumented. */
  type?: Maybe<MetricType>;
};

/** A metric exporter */
export type MetricExporter = {
  __typename?: "MetricExporter";
  config: MetricExporterConfig;
  created: Scalars["Time"]["output"];
  enablePgMetrics?: Maybe<Scalars["Boolean"]["output"]>;
  exporterUuid: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  projectId: Scalars["ID"]["output"];
  regionCode: Scalars["String"]["output"];
  type: MetricExporterType;
};

export type MetricExporterConfig =
  | AzureMonitorMetricConfig
  | CloudWatchMetricConfig
  | DatadogMetricConfig
  | PrometheusMetricConfig;

/** The configuration for a metric exporter. Exactly one field must be set. */
export type MetricExporterConfigInput = {
  configAzureMonitor?: InputMaybe<AzureMonitorMetricConfigInput>;
  configCloudWatch?: InputMaybe<CloudWatchMetricConfigInput>;
  configDatadog?: InputMaybe<DatadogMetricConfigInput>;
  configPrometheus?: InputMaybe<PrometheusMetricConfigInput>;
};

export type MetricExporterIdInput = {
  exporterId?: InputMaybe<Scalars["ID"]["input"]>;
  exporterUuid?: InputMaybe<Scalars["String"]["input"]>;
  projectId: Scalars["ID"]["input"];
};

export enum MetricExporterType {
  Azuremonitor = "AZUREMONITOR",
  Cloudwatch = "CLOUDWATCH",
  Datadog = "DATADOG",
  Prometheus = "PROMETHEUS",
  Unknown = "UNKNOWN",
}

export type MetricLabel = {
  __typename?: "MetricLabel";
  name: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/** One label of a metric: either specific to it (e.g. datname on pg_stat_database_*) or added by the pipeline (region, role, ordinal). */
export type MetricLabelDetails = {
  __typename?: "MetricLabelDetails";
  /** What this label identifies, or empty if undocumented. */
  description: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type MetricLabelFilter = {
  key: Scalars["String"]["input"];
  matchType?: InputMaybe<MetricMatchType>;
  value: Scalars["String"]["input"];
};

export enum MetricMatchType {
  Equal = "EQUAL",
  NotEqual = "NOT_EQUAL",
}

export type MetricSeries = {
  __typename?: "MetricSeries";
  dataPoints: Array<MetricDataPoint>;
  labels: Array<MetricLabel>;
};

/**
 * The shape of a metric's underlying data.
 *
 * - `GAUGE`: a value that can go up or down (e.g. a current connection count).
 * - `COUNTER`: a value that only increases until it resets (e.g. total queries run).
 * - `HISTOGRAM`: a distribution of observed values grouped into ranges.
 * - `SUMMARY`: a distribution of observed values summarized by quantile.
 */
export enum MetricType {
  Counter = "COUNTER",
  Gauge = "GAUGE",
  Histogram = "HISTOGRAM",
  Summary = "SUMMARY",
}

/** MetricUnit defines which metrics units are available */
export enum MetricUnit {
  Average = "AVERAGE",
  Byte = "BYTE",
  Count = "COUNT",
  Microsecond = "MICROSECOND",
  Millisecond = "MILLISECOND",
  Nanosecond = "NANOSECOND",
  Percentage = "PERCENTAGE",
  RateBytesPerMicrosecond = "RATE_BYTES_PER_MICROSECOND",
  Second = "SECOND",
}

export type MetricValue = {
  __typename?: "MetricValue";
  unit: MetricUnit;
  value: Scalars["String"]["output"];
};

/** A record of an event that we wish to display on metrics graphs, such as switchovers or resizes. */
export type MetricsEvent = {
  __typename?: "MetricsEvent";
  ordinal?: Maybe<Scalars["Int"]["output"]>;
  time: Scalars["Time"]["output"];
  type: MetricsEventType;
};

/** The different types of metric events that we see. */
export enum MetricsEventType {
  ComputeResize = "COMPUTE_RESIZE",
  DiskPerformanceResize = "DISK_PERFORMANCE_RESIZE",
  Switchover = "SWITCHOVER",
}

export type MfaChallengeInput = {
  /** MFA code from authenticator */
  code: Scalars["String"]["input"];
  /** this should be sent during the password reset flow when there is no auth token available */
  resetToken?: InputMaybe<Scalars["String"]["input"]>;
  /** This string should be a random value which then need to be passed in when the returned trustToken is used */
  trustChallenge: Scalars["String"]["input"];
};

export type MfaChallengeResponse = {
  __typename?: "MfaChallengeResponse";
  trustToken: Scalars["String"]["output"];
};

export type MfaMethod = AuthenticatorMethod;

/** The root mutation object. */
export type Mutation = {
  __typename?: "Mutation";
  addCompressionPolicy: Scalars["Success"]["output"];
  /** Add an Mfa method, only authenticator is supported currently */
  addMfaMethod: AddMfaMethodResponse;
  /** Reply to an existing support case. */
  addSupportCaseReply: SupportCaseMessage;
  /** Approve a pending device authorization as the logged-in user. */
  approveDeviceAuthorization: Scalars["Success"]["output"];
  /** Attaches a service to a generic exporter. */
  attachServiceToGenericExporter: Scalars["Success"]["output"];
  /** Attaches a service to a metric exporter. */
  attachServiceToMetricExporter: Scalars["Success"]["output"];
  /** Attach a service to a private link connection */
  attachServiceToPrivateLinkConnection: Scalars["Success"]["output"];
  /** Attaches a service to a VPC. */
  attachServiceToVpc: Scalars["Success"]["output"];
  /** Create an association between an IP allow list and a service. */
  bindIPAllowList: Scalars["Success"]["output"];
  /** Cancels a query from currentActivity by PID */
  cancelCurrentQuery: Scalars["Success"]["output"];
  /** Cancel a pending payment deletion for the payment method on the target billing account. */
  cancelPendingPaymentDeletion: Scalars["Success"]["output"];
  /** Cancel Project invite */
  cancelProjectInvite: Scalars["Success"]["output"];
  /** Change a (logged in) user's password, given their current password. */
  changePassword: Scalars["String"]["output"];
  /** Charge an Orb invoice for the target `BillingAccount`. */
  chargeInvoice: Scalars["Success"]["output"];
  /** Claim an unclaimed private endpoint connection for a project */
  claimPrivateLinkConnection: PrivateEndpointConnection;
  /** Close an existing support case. */
  closeSupportCase: Scalars["Success"]["output"];
  /** Create or replace an IP allow list at the project level. */
  configureIPAllowList: ConfigureIpAllowListOutput;
  connectors: ConnectorsMutator;
  /** Create a new billing email. */
  createBillingEmailAddress: BillingEmailAddress;
  /**
   * Create a verification charge for a payment method.
   *
   * This creates a Stripe Payment Intent to verify a card by performing a small charge.
   * Returns the client_secret and payment_intent_id for the frontend to complete
   * the preauthorization process.
   */
  createCardVerificationCharge: CreatedCardVerificationChargeResponse;
  /** starts a file import given a source, definition and schema */
  createFileImport: CreateFileImportResponse;
  /** Create a new generic exporter. */
  createGenericExporter: GenericExporter;
  /** Create an iceberg sync for a service. */
  createIcebergSync: Scalars["Success"]["output"];
  /** Creates a kafka cluster configuration */
  createKafkaClusterConfig: CreateKafkaClusterConfigResponse;
  /** Create a Kafka connector */
  createKafkaConnector: CreateKafkaConnectorResponse;
  /** Create a new metric exporter. */
  createMetricExporter: MetricExporter;
  createOrganizationProject: CreateOrganizationProjectResponse;
  createPATRecord: PatRecord;
  /** Add a payment method for the target billing account. */
  createPaymentMethod: Scalars["String"]["output"];
  /** Create a new project. */
  createProject: Project;
  /** Creates a project secret. */
  createProjectSecret: Scalars["Success"]["output"];
  /** Creates an S3 live sync request resource. */
  createS3LiveSync: Scalars["Success"]["output"];
  /** creates the given schema in the backend */
  createSchema: CreateSchemaResponse;
  /** Create a schema registry configuration */
  createSchemaRegistryConfig: CreateSchemaRegistryConfigResponse;
  /** Create a new service. */
  createService: CreateServiceOutput;
  /**
   * Creates a support ticket
   *
   * As of 2023-07, support tickets have been modified to use salesforce API so this method is only used
   * for limit trial spend increase request
   */
  createSupportTicket: Scalars["Success"]["output"];
  createUIState: CreateUiStateResponse;
  /** Create a new user. */
  createUser: User;
  /** Creates a new shell VPC for users to peer with. */
  createVpc: Vpc;
  /** Decline Project invite */
  declineProjectInvite: Scalars["Success"]["output"];
  /**
   * Delete all data for a customer will:
   * - delete all projects the logged in customer is the owner of.
   * - leave all projects the customer is not the owner of.
   * - delete all PII associated with the customer.
   *
   * The process is asynchronous. Success indicates that the request has been accepted. Customer will be warned per email when the process is complete.
   */
  deleteAllCustomerData: DeleteAllCustomerDataOutput;
  /** Delete a billing email. */
  deleteBillingEmailAddress: Scalars["Success"]["output"];
  deleteCompressionPolicy: Scalars["Success"]["output"];
  /** Delete a generic exporter. */
  deleteGenericExporter: Scalars["Success"]["output"];
  /** Delete a metric exporter. */
  deleteMetricExporter: Scalars["Success"]["output"];
  /** Removes the Mfa method if there is one */
  deleteMfaMethod: Scalars["Success"]["output"];
  deletePATRecord: Scalars["Success"]["output"];
  /** Delete a payment method from the target `BillingAccount`. */
  deletePaymentMethod: PaymentMethod;
  /** Deletes a peering connection between a TGW/VPC and a shell VPC. */
  deletePeeringConnection: Scalars["Success"]["output"];
  /** Delete/reject a private endpoint connection */
  deletePrivateLinkConnection: Scalars["Success"]["output"];
  /** Deletes a project secret. */
  deleteProjectSecret: Scalars["Success"]["output"];
  /** removes an S3 live sync. */
  deleteS3LiveSync: Scalars["Success"]["output"];
  /** Delete a service. */
  deleteService: Service;
  deleteUIState: Scalars["Success"]["output"];
  /** Deletes a VPC provided that it has no attached services. */
  deleteVpc: Scalars["Success"]["output"];
  /** Detaches a service from a generic exporter. */
  detachServiceFromGenericExporter: Scalars["Success"]["output"];
  /** Detaches a service from a metric exporter. */
  detachServiceFromMetricExporter: Scalars["Success"]["output"];
  /** Detach a service from a private link connection */
  detachServiceFromPrivateLinkConnection: Scalars["Success"]["output"];
  /** Detaches a service from a VPC and places it back in the public internet. */
  detachServiceFromVpc: Scalars["Success"]["output"];
  /** Disable a project. */
  disableProject: Project;
  disableStaticResources: Scalars["Success"]["output"];
  /** Disable the authenticated user's account. */
  disableUser: User;
  /** Marks a single recommendation as dismissed in order to hide it */
  dismissRecommendation: Scalars["Success"]["output"];
  dismissRecommendationV2: Scalars["Success"]["output"];
  /** Generates a presigned URL to upload a single file up to 500MB. */
  generatePresignedURL: GeneratePresignedUrlResponse;
  /** Invite Project member */
  inviteProjectMember: Scalars["Success"]["output"];
  /** Join Project */
  joinProject: Scalars["ID"]["output"];
  /** Leave Project */
  leaveProject: Scalars["Success"]["output"];
  /** LinkMarketplaceAccountRequest takes a projectId, and links with the marketplace information stored into the cookie */
  linkMarketplaceAccount: LinkMarketplaceAccountResponse;
  /**
   * Begin a new file import operation. Currently supports csv and parquet file types"
   * @deprecated This endpoint has been removed. Use generatePresignedURL instead.
   * @deprecated This endpoint has been removed. Use generatePresignedURL instead.
   */
  newFileImport: FileImport;
  /** Opens up a peer request to link a VPC/TGW to a shell VPC. */
  openPeerRequest: PeeringConnectionId;
  /**
   * Starts processing the file. Accepts either ProcessCsvImportInput or ProcessParquetImportInput but not both
   * @deprecated This endpoint has been removed. Use createFileImport instead.
   * @deprecated This endpoint has been removed. Use createFileImport instead.
   */
  processFileImport: FileImport;
  /** Invalidates previous codes and returns 10 new recovery codes */
  regenerateRecoveryCodes: Array<Scalars["String"]["output"]>;
  renamePATRecord: Scalars["Success"]["output"];
  /** Rename a project. Only a project owner can do this */
  renameProject: Project;
  /** Rename a service. */
  renameService: Scalars["Success"]["output"];
  /** Renames the VPC provided. */
  renameVpc: Scalars["Success"]["output"];
  /** Begins an OAuth 2 Authorization Code Grant by requesting an authorization code */
  requestAuthorizationCode: AuthorizationCodeOutput;
  /** Resend the email invite to become a project member */
  resendInviteProjectMember: Scalars["Success"]["output"];
  /** Resends the initial verification email for a billing email. */
  resendVerifyBillingEmailAddress: Scalars["String"]["output"];
  /** Resends the initial verification email for a user. */
  resendVerifyEmail: Scalars["String"]["output"];
  /** Reset user's password based on the given password reset token. */
  resetPassword: Scalars["String"]["output"];
  /** Reset cluster, tsdb database, tsdbadmin user postgres parameters on an instance. */
  resetPostgresParameters: Scalars["Success"]["output"];
  /** Reset a service's password. */
  resetServicePassword: Scalars["String"]["output"];
  /** Resize an instance's CPU, RAM, and Storage. */
  resizeInstance: Scalars["Success"]["output"];
  /** Retries file imports for an S3 live sync that match the specified state and time range filters. */
  retryS3LiveSyncFileImports: RetryS3LiveSyncFileImportsResponse;
  /** Revoke all of the authenticated user's sessions except the current one. */
  revokeOtherSessions: Scalars["Success"]["output"];
  /** Revoke Project member */
  revokeProjectMember: Scalars["Success"]["output"];
  /**
   * Revoke a specific refresh token server-side. Intended for callers without
   * a session cookie (e.g. tiger-cli, which holds the refresh token locally).
   * Cookie-based callers should use `logout` instead.
   */
  revokeRefreshToken: Scalars["Success"]["output"];
  /** Revoke one of the authenticated user's sessions by its id. */
  revokeSession: Scalars["Success"]["output"];
  /**
   * Send a password reset token to the user bearing the given email address.
   *
   * The return value from this mutation is a simple success message from the API.
   */
  sendPasswordReset: Scalars["String"]["output"];
  /** Sends an email to the support team. */
  sendSupportEmail: Scalars["Success"]["output"];
  /** Set the address info for the target `BillingAccount`. */
  setAddressInfo: AddressDetails;
  setBackupsRetention: Scalars["Success"]["output"];
  setCompression: Scalars["Success"]["output"];
  /** @deprecated setCompressionHypertable is deprecated. Use setCompression which supports hypertables and caggs. */
  setCompressionHypertable: Scalars["Success"]["output"];
  setHypertableConf: Scalars["Success"]["output"];
  /** Set active window. */
  setMaintenanceWindow: Scalars["Success"]["output"];
  /** Sets postgres parameters. For example work_mem and array_nulls */
  setPostgresParameters: Array<ParamErrorMessages>;
  /** Update the primary payment method for the target `BillingAccount`. */
  setPrimaryPaymentMethod: Scalars["String"]["output"];
  /** Sets the authentication-enforcement policy on a project. Owner-only. */
  setProjectEnforcementType: Project;
  /** Adds or removes a replica. */
  setReplicaCount: Scalars["Success"]["output"];
  setServiceEnvironmentTag: Scalars["Success"]["output"];
  setVirtualPlanForProject: Scalars["Success"]["output"];
  /**
   * @deprecated Use updateFileImport with cancel request instead.
   * @deprecated Use updateFileImport with cancel request instead.
   */
  skipFileImport: Scalars["Success"]["output"];
  /** Sync connections from cloud providers */
  syncPrivateLinkConnections: Scalars["Success"]["output"];
  toggleChunkTuning: Scalars["Success"]["output"];
  /** Enable or disable the connection pooler on a service. */
  toggleConnectionPooler: Scalars["Success"]["output"];
  /** Enable or disable cross-region backups for a service. */
  toggleCrossRegionBackups: CrossRegionBackupsEnabled;
  toggleCrossRegionBackupsV2: Scalars["Boolean"]["output"];
  /** Enable or disable data tiering on a service. */
  toggleDataTiering: Scalars["Success"]["output"];
  /** Enable or disable the IOBoost on a service. */
  toggleIOBoost: Scalars["Success"]["output"];
  /** Enable or disable the PopSQL integration in a service. */
  togglePopSQLIntegration: Scalars["Success"]["output"];
  /** Toggle a service on or off */
  toggleService: Service;
  /** Turns chunk tuning on or off for every hypertable on the service, including ones created later. */
  toggleServiceChunkTuning: Scalars["Success"]["output"];
  transferOwnership: TransferOwnershipResponse;
  /** Transfer project ownership to another member of provided project. Errors if the caller is not the project's owner. */
  transferProjectOwnership: Scalars["Success"]["output"];
  /** Remove an association between an IP allow list and a service. */
  unbindIPAllowList: Scalars["Success"]["output"];
  /**
   * @deprecated Use updateFileImport with retry request instead.
   * @deprecated Use updateFileImport with retry request instead.
   */
  unskipFileImport: Scalars["Success"]["output"];
  /** Update a connector */
  updateConnector: UpdateConnectorResponse;
  /** updates a file import (supports cancel, retry, labels, and pause operations) */
  updateFileImport: UpdateFileImportResponse;
  /** Update a generic exporter's configuration. */
  updateGenericExporter: Scalars["Success"]["output"];
  /** Update a metric exporter's configuration. */
  updateMetricExporter: Scalars["Success"]["output"];
  updateOrganizationName: UpdateOrganizationNameResponse;
  /** Update the target `BillingAccount` with the given info. */
  updatePaymentMethod: PaymentMethod;
  /** Updates a peering connection's CIDR list. */
  updatePeeringConnectionCIDRs: Scalars["Success"]["output"];
  /** Update a private endpoint connection */
  updatePrivateLinkConnection: PrivateEndpointConnection;
  /** Updates a project secret. */
  updateProjectSecret: Scalars["Success"]["output"];
  /** Updates an S3 live sync in-place. */
  updateS3LiveSync: S3LiveSync;
  /** Set the tax ID for the target `BillingAccount`. */
  updateTaxID: Scalars["Success"]["output"];
  updateUIState: Scalars["Success"]["output"];
  /** Update the authenticated user's info. */
  updateUser: User;
  /** Update the role of a user in a project */
  updateUserRole: Scalars["Success"]["output"];
  /** Initiate a major PostgreSQL upgrade. */
  upgradePostgresMajorVersion: Scalars["Success"]["output"];
  /**
   * Validate the given address info.
   *
   * This endpoint will validate the given address, returning an array of addresses with the closest
   * match to the provided address.
   * @deprecated Geocoding API through taxjar, never actually used
   */
  validateAddress: Array<AddressInfo>;
  /** Validate Iceberg connector specification */
  validateConnectorSpecIceberg: ValidateConnectorSpecIcebergResponse;
  /** Verify new user billing email. */
  verifyBillingEmailAddress: Scalars["String"]["output"];
  /** Verify new user email. */
  verifyEmail: VerifyEmailOutput;
};

/** The root mutation object. */
export type MutationAddCompressionPolicyArgs = {
  data: AddCompressionPolicyInput;
};

/** The root mutation object. */
export type MutationAddMfaMethodArgs = {
  data: AddMfaMethodInput;
};

/** The root mutation object. */
export type MutationAddSupportCaseReplyArgs = {
  data: AddSupportCaseReplyInput;
};

/** The root mutation object. */
export type MutationApproveDeviceAuthorizationArgs = {
  userCode: Scalars["String"]["input"];
};

/** The root mutation object. */
export type MutationAttachServiceToGenericExporterArgs = {
  data: AttachServiceToGenericExporterInput;
};

/** The root mutation object. */
export type MutationAttachServiceToMetricExporterArgs = {
  data: AttachServiceToMetricExporterInput;
};

/** The root mutation object. */
export type MutationAttachServiceToPrivateLinkConnectionArgs = {
  data: AttachServiceToPrivateLinkConnectionInput;
};

/** The root mutation object. */
export type MutationAttachServiceToVpcArgs = {
  data: AttachServiceToVpcInput;
};

/** The root mutation object. */
export type MutationBindIpAllowListArgs = {
  data: BindIpAllowListInput;
};

/** The root mutation object. */
export type MutationCancelCurrentQueryArgs = {
  pid: Scalars["Int"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

/** The root mutation object. */
export type MutationCancelPendingPaymentDeletionArgs = {
  data: CancelPendingPaymentDeletionInput;
};

/** The root mutation object. */
export type MutationCancelProjectInviteArgs = {
  inviteId: Scalars["ID"]["input"];
  projectID: Scalars["String"]["input"];
};

/** The root mutation object. */
export type MutationChangePasswordArgs = {
  data: ChangePasswordInput;
};

/** The root mutation object. */
export type MutationChargeInvoiceArgs = {
  billingAccountId: Scalars["ID"]["input"];
  orbInvoiceId: Scalars["ID"]["input"];
};

/** The root mutation object. */
export type MutationClaimPrivateLinkConnectionArgs = {
  data: ClaimPrivateLinkConnectionInput;
};

/** The root mutation object. */
export type MutationCloseSupportCaseArgs = {
  data: CloseSupportCaseInput;
};

/** The root mutation object. */
export type MutationConfigureIpAllowListArgs = {
  data: ConfigureIpAllowListInput;
};

/** The root mutation object. */
export type MutationCreateBillingEmailAddressArgs = {
  data: CreateBillingEmailAddressInput;
};

/** The root mutation object. */
export type MutationCreateCardVerificationChargeArgs = {
  billingAccountId: Scalars["ID"]["input"];
};

/** The root mutation object. */
export type MutationCreateFileImportArgs = {
  data: CreateFileImportInput;
};

/** The root mutation object. */
export type MutationCreateGenericExporterArgs = {
  data: CreateGenericExporterInput;
};

/** The root mutation object. */
export type MutationCreateIcebergSyncArgs = {
  data: CreateIcebergSyncInput;
};

/** The root mutation object. */
export type MutationCreateKafkaClusterConfigArgs = {
  data: CreateKafkaClusterConfigInput;
};

/** The root mutation object. */
export type MutationCreateKafkaConnectorArgs = {
  data: CreateKafkaConnectorInput;
};

/** The root mutation object. */
export type MutationCreateMetricExporterArgs = {
  data: CreateMetricExporterInput;
};

/** The root mutation object. */
export type MutationCreateOrganizationProjectArgs = {
  data: CreateOrganizationProjectInput;
};

/** The root mutation object. */
export type MutationCreatePatRecordArgs = {
  createPATRecordInput: CreatePatRecordInput;
};

/** The root mutation object. */
export type MutationCreatePaymentMethodArgs = {
  billingAccountId: Scalars["ID"]["input"];
  isPrimary: Scalars["Boolean"]["input"];
};

/** The root mutation object. */
export type MutationCreateProjectArgs = {
  data: CreateProjectInput;
};

/** The root mutation object. */
export type MutationCreateProjectSecretArgs = {
  data: CreateProjectSecretInput;
};

/** The root mutation object. */
export type MutationCreateS3LiveSyncArgs = {
  data: CreateS3LiveSyncInput;
};

/** The root mutation object. */
export type MutationCreateSchemaArgs = {
  data: CreateSchemaInput;
};

/** The root mutation object. */
export type MutationCreateSchemaRegistryConfigArgs = {
  data: CreateSchemaRegistryConfigInput;
};

/** The root mutation object. */
export type MutationCreateServiceArgs = {
  data: CreateServiceInput;
};

/** The root mutation object. */
export type MutationCreateSupportTicketArgs = {
  data: SupportTicketInput;
};

/** The root mutation object. */
export type MutationCreateUiStateArgs = {
  input: CreateUiStateInput;
};

/** The root mutation object. */
export type MutationCreateUserArgs = {
  data: CreateUserInput;
};

/** The root mutation object. */
export type MutationCreateVpcArgs = {
  data: CreateVpcInput;
};

/** The root mutation object. */
export type MutationDeclineProjectInviteArgs = {
  inviteId: Scalars["ID"]["input"];
};

/** The root mutation object. */
export type MutationDeleteBillingEmailAddressArgs = {
  data: DeleteBillingEmailAddressInput;
};

/** The root mutation object. */
export type MutationDeleteCompressionPolicyArgs = {
  data: DeleteCompressionPolicyInput;
};

/** The root mutation object. */
export type MutationDeleteGenericExporterArgs = {
  data: GenericExporterIdInput;
};

/** The root mutation object. */
export type MutationDeleteMetricExporterArgs = {
  data: MetricExporterIdInput;
};

/** The root mutation object. */
export type MutationDeleteMfaMethodArgs = {
  data: DeleteMfaMethodInput;
};

/** The root mutation object. */
export type MutationDeletePatRecordArgs = {
  deletePATRecordInput: DeletePatRecordInput;
};

/** The root mutation object. */
export type MutationDeletePaymentMethodArgs = {
  billingAccountId: Scalars["ID"]["input"];
  paymentMethodId: Scalars["ID"]["input"];
};

/** The root mutation object. */
export type MutationDeletePeeringConnectionArgs = {
  data: DeletePeeringConnectionInput;
};

/** The root mutation object. */
export type MutationDeletePrivateLinkConnectionArgs = {
  data: DeletePrivateLinkConnectionInput;
};

/** The root mutation object. */
export type MutationDeleteProjectSecretArgs = {
  data: DeleteProjectSecretInput;
};

/** The root mutation object. */
export type MutationDeleteS3LiveSyncArgs = {
  data: DeleteS3LiveSyncInput;
};

/** The root mutation object. */
export type MutationDeleteServiceArgs = {
  data: DeleteServiceInput;
};

/** The root mutation object. */
export type MutationDeleteUiStateArgs = {
  input: DeleteUiStateInput;
};

/** The root mutation object. */
export type MutationDeleteVpcArgs = {
  data: DeleteVpcInput;
};

/** The root mutation object. */
export type MutationDetachServiceFromGenericExporterArgs = {
  data: DetachServiceFromGenericExporterInput;
};

/** The root mutation object. */
export type MutationDetachServiceFromMetricExporterArgs = {
  data: DetachServiceFromMetricExporterInput;
};

/** The root mutation object. */
export type MutationDetachServiceFromPrivateLinkConnectionArgs = {
  data: DetachServiceFromPrivateLinkConnectionInput;
};

/** The root mutation object. */
export type MutationDetachServiceFromVpcArgs = {
  data: DetachServiceFromVpcInput;
};

/** The root mutation object. */
export type MutationDisableProjectArgs = {
  data: DisableProjectInput;
};

/** The root mutation object. */
export type MutationDisableStaticResourcesArgs = {
  data: DisableStaticResourcesInput;
};

/** The root mutation object. */
export type MutationDismissRecommendationArgs = {
  data: SingleRecommendationInput;
};

/** The root mutation object. */
export type MutationDismissRecommendationV2Args = {
  data: DismissRecommendationInput;
};

/** The root mutation object. */
export type MutationGeneratePresignedUrlArgs = {
  data: GeneratePresignedUrlInput;
};

/** The root mutation object. */
export type MutationInviteProjectMemberArgs = {
  data: InviteProjectMemberInput;
};

/** The root mutation object. */
export type MutationJoinProjectArgs = {
  data: JoinProjectInput;
};

/** The root mutation object. */
export type MutationLeaveProjectArgs = {
  projectId: Scalars["ID"]["input"];
};

/** The root mutation object. */
export type MutationLinkMarketplaceAccountArgs = {
  data: LinkMarketplaceAccountRequest;
};

/** The root mutation object. */
export type MutationNewFileImportArgs = {
  data: NewFileImportInput;
};

/** The root mutation object. */
export type MutationOpenPeerRequestArgs = {
  data: OpenPeerRequestInput;
};

/** The root mutation object. */
export type MutationProcessFileImportArgs = {
  data: ProcessFileImportInput;
};

/** The root mutation object. */
export type MutationRegenerateRecoveryCodesArgs = {
  data: RegenerateRecoveryCodesInput;
};

/** The root mutation object. */
export type MutationRenamePatRecordArgs = {
  renamePATRecordInput: RenamePatRecordInput;
};

/** The root mutation object. */
export type MutationRenameProjectArgs = {
  data: RenameProjectInput;
};

/** The root mutation object. */
export type MutationRenameServiceArgs = {
  data: RenameServiceInput;
};

/** The root mutation object. */
export type MutationRenameVpcArgs = {
  data: RenameVpcInput;
};

/** The root mutation object. */
export type MutationRequestAuthorizationCodeArgs = {
  data: AuthorizationCodeInput;
};

/** The root mutation object. */
export type MutationResendInviteProjectMemberArgs = {
  inviteId: Scalars["ID"]["input"];
  projectID: Scalars["String"]["input"];
};

/** The root mutation object. */
export type MutationResendVerifyBillingEmailAddressArgs = {
  data: ResendVerifyBillingEmailAddressInput;
};

/** The root mutation object. */
export type MutationResendVerifyEmailArgs = {
  email: Scalars["String"]["input"];
};

/** The root mutation object. */
export type MutationResetPasswordArgs = {
  data: ResetPasswordInput;
};

/** The root mutation object. */
export type MutationResetPostgresParametersArgs = {
  data: ResetPostgresParametersInput;
};

/** The root mutation object. */
export type MutationResetServicePasswordArgs = {
  data: ResetServicePasswordInput;
};

/** The root mutation object. */
export type MutationResizeInstanceArgs = {
  data: ResizeInstanceInput;
};

/** The root mutation object. */
export type MutationRetryS3LiveSyncFileImportsArgs = {
  data: RetryS3LiveSyncFileImportsInput;
};

/** The root mutation object. */
export type MutationRevokeProjectMemberArgs = {
  data: RevokeProjectMemberInput;
};

/** The root mutation object. */
export type MutationRevokeRefreshTokenArgs = {
  refreshToken: Scalars["String"]["input"];
};

/** The root mutation object. */
export type MutationRevokeSessionArgs = {
  sid: Scalars["String"]["input"];
};

/** The root mutation object. */
export type MutationSendPasswordResetArgs = {
  email: Scalars["String"]["input"];
};

/** The root mutation object. */
export type MutationSendSupportEmailArgs = {
  data: SupportEmailInput;
};

/** The root mutation object. */
export type MutationSetAddressInfoArgs = {
  billingAccountId: Scalars["ID"]["input"];
  companyAddress: AddressInfoInput;
};

/** The root mutation object. */
export type MutationSetBackupsRetentionArgs = {
  data?: InputMaybe<SetBackupsRetentionInput>;
};

/** The root mutation object. */
export type MutationSetCompressionArgs = {
  data: SetCompressionInput;
};

/** The root mutation object. */
export type MutationSetCompressionHypertableArgs = {
  data: SetCompressionHypertableInput;
};

/** The root mutation object. */
export type MutationSetHypertableConfArgs = {
  data: SetHypertableConfInput;
};

/** The root mutation object. */
export type MutationSetMaintenanceWindowArgs = {
  data: SetMaintenanceWindowInput;
};

/** The root mutation object. */
export type MutationSetPostgresParametersArgs = {
  data: SetPostgresParametersInput;
};

/** The root mutation object. */
export type MutationSetPrimaryPaymentMethodArgs = {
  data: SetPrimaryPaymentMethodInput;
};

/** The root mutation object. */
export type MutationSetProjectEnforcementTypeArgs = {
  enforcementType: EnforcementType;
  projectId: Scalars["ID"]["input"];
};

/** The root mutation object. */
export type MutationSetReplicaCountArgs = {
  data: SetReplicaCountInput;
};

/** The root mutation object. */
export type MutationSetServiceEnvironmentTagArgs = {
  data: SetServiceEnvironmentTagInput;
};

/** The root mutation object. */
export type MutationSetVirtualPlanForProjectArgs = {
  data: SetVirtualPlanForProjectRequest;
};

/** The root mutation object. */
export type MutationSkipFileImportArgs = {
  data: SkipFileImportInput;
};

/** The root mutation object. */
export type MutationSyncPrivateLinkConnectionsArgs = {
  data: SyncPrivateLinkConnectionsInput;
};

/** The root mutation object. */
export type MutationToggleChunkTuningArgs = {
  enabled: Scalars["Boolean"]["input"];
  hypertableId: Scalars["Int"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

/** The root mutation object. */
export type MutationToggleConnectionPoolerArgs = {
  data: ToggleConnectionPoolerInput;
};

/** The root mutation object. */
export type MutationToggleCrossRegionBackupsArgs = {
  data: ToggleCrossRegionBackupsInput;
};

/** The root mutation object. */
export type MutationToggleCrossRegionBackupsV2Args = {
  data: ToggleCrossRegionBackupsV2Input;
};

/** The root mutation object. */
export type MutationToggleDataTieringArgs = {
  data: ToggleDataTieringInput;
};

/** The root mutation object. */
export type MutationToggleIoBoostArgs = {
  data: ToggleIoBoostInput;
};

/** The root mutation object. */
export type MutationTogglePopSqlIntegrationArgs = {
  data: TogglePopSqlIntegrationInput;
};

/** The root mutation object. */
export type MutationToggleServiceArgs = {
  data: ToggleServiceInput;
};

/** The root mutation object. */
export type MutationToggleServiceChunkTuningArgs = {
  enabled: Scalars["Boolean"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

/** The root mutation object. */
export type MutationTransferOwnershipArgs = {
  data: TransferOwnershipInput;
};

/** The root mutation object. */
export type MutationTransferProjectOwnershipArgs = {
  data: TransferProjectOwnershipInput;
};

/** The root mutation object. */
export type MutationUnbindIpAllowListArgs = {
  data: BindIpAllowListInput;
};

/** The root mutation object. */
export type MutationUnskipFileImportArgs = {
  data: UnskipFileImportInput;
};

/** The root mutation object. */
export type MutationUpdateConnectorArgs = {
  data: UpdateConnectorInput;
};

/** The root mutation object. */
export type MutationUpdateFileImportArgs = {
  data: UpdateFileImportInput;
};

/** The root mutation object. */
export type MutationUpdateGenericExporterArgs = {
  data: UpdateGenericExporterInput;
};

/** The root mutation object. */
export type MutationUpdateMetricExporterArgs = {
  data: UpdateMetricExporterInput;
};

/** The root mutation object. */
export type MutationUpdateOrganizationNameArgs = {
  data: UpdateOrganizationNameInput;
};

/** The root mutation object. */
export type MutationUpdatePaymentMethodArgs = {
  addressInfo?: InputMaybe<AddressInfoInput>;
  billingAccountId: Scalars["ID"]["input"];
  cardExp: CardExpInput;
  paymentMethodId: Scalars["ID"]["input"];
};

/** The root mutation object. */
export type MutationUpdatePeeringConnectionCidRsArgs = {
  data: UpdatePeeringConnectionCidRsInput;
};

/** The root mutation object. */
export type MutationUpdatePrivateLinkConnectionArgs = {
  data: UpdatePrivateLinkConnectionInput;
};

/** The root mutation object. */
export type MutationUpdateProjectSecretArgs = {
  data: UpdateProjectSecretInput;
};

/** The root mutation object. */
export type MutationUpdateS3LiveSyncArgs = {
  data: UpdateS3LiveSyncInput;
};

/** The root mutation object. */
export type MutationUpdateTaxIdArgs = {
  data: UpdateTaxIdInput;
};

/** The root mutation object. */
export type MutationUpdateUiStateArgs = {
  input: UpdateUiStateInput;
};

/** The root mutation object. */
export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
};

/** The root mutation object. */
export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};

/** The root mutation object. */
export type MutationUpgradePostgresMajorVersionArgs = {
  data: UpgradePostgresMajorVersionInput;
};

/** The root mutation object. */
export type MutationValidateAddressArgs = {
  address: AddressInfoInput;
};

/** The root mutation object. */
export type MutationValidateConnectorSpecIcebergArgs = {
  data: ValidateConnectorSpecIcebergInput;
};

/** The root mutation object. */
export type MutationVerifyBillingEmailAddressArgs = {
  data: VerifyBillingEmailAddressInput;
};

/** The root mutation object. */
export type MutationVerifyEmailArgs = {
  data: VerifyEmailInput;
};

export type NewFileImportInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type NextMaintenance = {
  __typename?: "NextMaintenance";
  /** The end of the next maintenance run */
  end: Scalars["Time"]["output"];
  /** Indicates if a disruptive maintenance event is expected */
  isMaintenanceScheduled: Scalars["Boolean"]["output"];
  /** The beginning of the next maintenance run */
  start: Scalars["Time"]["output"];
};

export type NextMaintenanceInput = {
  /** ProjectID that the service belongs to. */
  projectId: Scalars["ID"]["input"];
  /** Service ID of the service. */
  serviceId: Scalars["ID"]["input"];
};

export type NumericParameter = {
  __typename?: "NumericParameter";
  current_value: Scalars["Float"]["output"];
  info: ParameterInfo;
  max_allowed_value?: Maybe<Scalars["Float"]["output"]>;
  min_allowed_value?: Maybe<Scalars["Float"]["output"]>;
  unit: ParameterUnit;
};

export type ObjectCounts = {
  __typename?: "ObjectCounts";
  contAggs: Scalars["Int"]["output"];
  hypertables: Scalars["Int"]["output"];
  pgTables: Scalars["Int"]["output"];
  policies: Scalars["Int"]["output"];
  realtimeContAggs: Scalars["Int"]["output"];
};

export type ObjectId = ContAggId | TableId;

/** ObjectMetadata is used to represent metadata from either a table (regular or hyper) or a continuous aggregate. */
export type ObjectMetadata = ContAggMetadata | TableMetadata;

export type ObjectSizeId = ContAggId | TableId;

export type ObjectSizeInfo = {
  __typename?: "ObjectSizeInfo";
  approxRowCount: Scalars["Int"]["output"];
  id: ObjectSizeId;
  size: Scalars["Int"]["output"];
};

/** The input type for opening a peer request. */
export type OpenPeerRequestInput = {
  /** The cloud provider that the VPCs are hosted on. */
  cloudProvider: CloudProvider;
  /** The internal table ID of the VPC row. */
  forgeVpcId: Scalars["ID"]["input"];
  /** The VPC/TGW that the user wants to peer with Forge. */
  peerVpc: InputPeerVpc;
  /** The project ID the VPC is associated with. */
  projectId: Scalars["ID"]["input"];
};

export type OperationProgress = {
  __typename?: "OperationProgress";
  current: Scalars["Int"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type OrbCostInput = {
  billingAccountId?: InputMaybe<Scalars["ID"]["input"]>;
  projectId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OrderByColumn = {
  __typename?: "OrderByColumn";
  descending: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  nullsFirst: Scalars["Boolean"]["output"];
};

/** An organization member. */
export type OrganizationMember = {
  __typename?: "OrganizationMember";
  /** Date the user joined the organization */
  joined: Scalars["Time"]["output"];
  /** The organization id */
  organizationId: Scalars["ID"]["output"];
  /** The organization role. */
  role: OrganizationRbacRole;
  /** The user of the `OrganizationMember`. */
  user: OrganizationUser;
  /** The member user id */
  userId: Scalars["ID"]["output"];
};

export type OrganizationProjects = {
  __typename?: "OrganizationProjects";
  organization?: Maybe<BillingAccount>;
  projects: Array<Project>;
};

export enum OrganizationRbacRole {
  /** The admin role for the organization, which can manage billing and users */
  Admin = "ADMIN",
  Finance = "FINANCE",
  /** The owner role for the organization, which should be unique */
  Owner = "OWNER",
  Unspecified = "UNSPECIFIED",
  Viewer = "VIEWER",
}

export type OrganizationUser = {
  __typename?: "OrganizationUser";
  /** The user of the `OrganizationMember`. Created to hold information about users projects */
  user: User;
};

export type Owner = {
  __typename?: "Owner";
  project_id?: Maybe<Scalars["String"]["output"]>;
  type: OwnerType;
};

export type OwnerInput = {
  project_id?: InputMaybe<Scalars["String"]["input"]>;
  type: OwnerType;
};

export enum OwnerType {
  Project = "project",
  User = "user",
}

export type PatRecord = {
  __typename?: "PATRecord";
  clientCredentials: ClientCredentials;
  created: Scalars["Time"]["output"];
  /** The user who issued the PAT record */
  issuingUser: User;
  issuingUserId: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  /** The project this PAT record belongs to */
  project: Project;
  projectId: Scalars["ID"]["output"];
};

export type PitrEntitlement = {
  __typename?: "PITREntitlement";
  enabled: Scalars["Boolean"]["output"];
  max_days: Scalars["Int"]["output"];
};

/** Pagination information */
export type PageInfo = {
  __typename?: "PageInfo";
  /** The cursor to fetch the next page. */
  end_cursor?: Maybe<Scalars["String"]["output"]>;
  /** Whether there is a next page. */
  has_next_page: Scalars["Boolean"]["output"];
  /** Whether there is a previous page. */
  has_previous_page: Scalars["Boolean"]["output"];
  /** The cursor to fetch the previous page. */
  start_cursor?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Pagination input
 * Be aware that first and last are mutually exclusive.
 * First can be used with after to fetch a forward page.
 * Last can be used with before to fetch a backward page.
 *
 * if before or after are not provided. The first page is returned instead.
 */
export type PaginationInput = {
  /** The cursor to fetch the next page. */
  after?: InputMaybe<Scalars["String"]["input"]>;
  /** The cursor to fetch the previous page. */
  before?: InputMaybe<Scalars["String"]["input"]>;
  /** The number of items to fetch. */
  first?: InputMaybe<Scalars["Int"]["input"]>;
  /** The number of items to fetch. */
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ParamErrorMessages = {
  __typename?: "ParamErrorMessages";
  /** Error message. */
  errorMessage: Scalars["String"]["output"];
  /** Parameter to update. */
  name: Scalars["String"]["output"];
};

export type ParameterInfo = {
  __typename?: "ParameterInfo";
  description: Scalars["String"]["output"];
  is_pending_restart: Scalars["Boolean"]["output"];
  is_tune_overridable: Scalars["Boolean"]["output"];
  is_user_editable: Scalars["Boolean"]["output"];
  is_user_modified: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  requires_restart: Scalars["Boolean"]["output"];
  ui_priority: Scalars["Int"]["output"];
};

/**
 * ParameterUnit defines the Postgres parameter mapping for us to use when reading or setting parameters.
 * Units are applied to numeric parameters, for example work_mem could be 10 KB
 * Valid memory units are B (bytes), kB (kilobytes), MB (megabytes), GB (gigabytes), and TB (terabytes).
 * Valid time units are us (microseconds), ms (milliseconds), s (seconds), min (minutes), h (hours), and d (days).
 */
export enum ParameterUnit {
  Bytes = "BYTES",
  Days = "DAYS",
  Gigabytes = "GIGABYTES",
  Hours = "HOURS",
  Kilobytes = "KILOBYTES",
  Megabytes = "MEGABYTES",
  Microseconds = "MICROSECONDS",
  Milliseconds = "MILLISECONDS",
  Minutes = "MINUTES",
  Seconds = "SECONDS",
  Terabytes = "TERABYTES",
  Undefined = "UNDEFINED",
}

export enum PasswordType {
  Invalid = "INVALID",
  Md5 = "MD5",
  Scram = "SCRAM",
}

/** An attempt to charge a payment method for an invoice. */
export type PaymentAttempt = {
  __typename?: "PaymentAttempt";
  /** The failure reason, if this attempt did not succeed. */
  failureReason: Scalars["String"]["output"];
  /** Whether this attempt succeeded. */
  success: Scalars["Boolean"]["output"];
  /** The time this attempt was made. */
  time: Scalars["Time"]["output"];
};

/** A payment method. */
export type PaymentMethod = {
  __typename?: "PaymentMethod";
  /** The address info for this `PaymentMethod`. */
  addressInfo?: Maybe<AddressInfo>;
  /** The card information for this `PaymentMethod`. */
  cardInfo?: Maybe<CardInfo>;
  /** The ID of the `PaymentMethod`. */
  id: Scalars["ID"]["output"];
  /** Whether the `PaymentMethod` is the primary. */
  isPrimary?: Maybe<Scalars["Boolean"]["output"]>;
  /** The type of this `PaymentMethod`. */
  type: PaymentMethodType;
};

export type PaymentMethodInfo = {
  __typename?: "PaymentMethodInfo";
  /** All payment methods currently configured on this billing account. */
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  /** Type of the primary payment method. */
  primaryType: PaymentMethodType;
};

export enum PaymentMethodType {
  AwsMarketplace = "AWS_MARKETPLACE",
  AzureMarketplace = "AZURE_MARKETPLACE",
  Card = "CARD",
  Crypto = "CRYPTO",
  Invoicing = "INVOICING",
  None = "NONE",
  Unknown = "UNKNOWN",
}

/** The VPC that the user wants to peer with (i.e. their personal VPC, *not* the shell). */
export type PeerVpc = {
  __typename?: "PeerVPC";
  /** The account ID issues by the cloud provider to the user. */
  accountId: Scalars["ID"]["output"];
  /**
   * Deprecated. Use cidrBlocks.
   * @deprecated use cidrBlocks
   */
  cidr: Scalars["String"]["output"];
  /** The list of the user's VPC/TGW CIDR blocks. */
  cidrBlocks?: Maybe<Array<Scalars["String"]["output"]>>;
  /** The ID of the user-provided VPC. */
  id: Scalars["ID"]["output"];
  /** The region that the user-provided VPC exists in. */
  regionCode: Scalars["String"]["output"];
};

/** Model of the peering connection between a user's VPC and an allocated shell VPC. */
export type PeeringConnection = {
  __typename?: "PeeringConnection";
  /** The accepter provisioned ID of the Peering Connection as given by the cloud provider. */
  accepterProvisionedId?: Maybe<Scalars["ID"]["output"]>;
  /** Indicates an error with the peering connection. */
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  /** The ID of the peering connection. Currently nullable, soon will be required. */
  id?: Maybe<Scalars["ID"]["output"]>;
  /** The user-provided VPC that the connection points to. */
  peerVpc: PeerVpc;
  /** The provisioned ID of the Peering Connection as given by the cloud provider. */
  provisionedId?: Maybe<Scalars["ID"]["output"]>;
  /** The current status of the PeeringConnection. */
  status: PeeringConnectionStatus;
  /** The ID of the shell VPC this connection points to (i.e. the Id property of a VPC object). */
  vpcId: Scalars["ID"]["output"];
};

export type PeeringConnectionId = {
  __typename?: "PeeringConnectionID";
  /** The ID of the peering connection. */
  id: Scalars["ID"]["output"];
};

/** Enum that represents the status of a PeeringConnection. */
export enum PeeringConnectionStatus {
  Active = "ACTIVE",
  Approved = "APPROVED",
  Deleting = "DELETING",
  Disabled = "DISABLED",
  Invalid = "INVALID",
  Pending = "PENDING",
  Timeout = "TIMEOUT",
  Unknown = "UNKNOWN",
}

export type PerQueryGraphDataPoint = {
  __typename?: "PerQueryGraphDataPoint";
  dataPoints: Array<GraphDataPoint>;
  queryHash: Scalars["String"]["output"];
};

export type PgPublication = {
  __typename?: "PgPublication";
  publicationName: Scalars["String"]["output"];
};

export type PgSrcConfig = {
  __typename?: "PgSrcConfig";
  connectionString: Scalars["String"]["output"];
  createdAt: Scalars["Time"]["output"];
  name: Scalars["String"]["output"];
  projectId: Scalars["String"]["output"];
  sourceId: Scalars["String"]["output"];
  sshTunnelId?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["Time"]["output"];
};

export type PgSrcConfigUpdateConnectionStringInput = {
  value: Scalars["String"]["input"];
};

export type PgSrcConfigUpdateNameInput = {
  value: Scalars["String"]["input"];
};

export type PgSrcConfigUpdateSshTunnelIdInput = {
  value: Scalars["String"]["input"];
};

export type PgSrcConfigUpdatesInput = {
  connectionString?: InputMaybe<PgSrcConfigUpdateConnectionStringInput>;
  name?: InputMaybe<PgSrcConfigUpdateNameInput>;
  sshTunnelId?: InputMaybe<PgSrcConfigUpdateSshTunnelIdInput>;
};

export type PgSrcConnectorDetails = {
  __typename?: "PgSrcConnectorDetails";
  createdAt: Scalars["Time"]["output"];
  enabled: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  publicationNames?: Maybe<Array<Scalars["String"]["output"]>>;
  sourceConfigId: Scalars["String"]["output"];
  status?: Maybe<PgSrcConnectorDetailsStatus>;
  tableSyncWorkers?: Maybe<Scalars["Int"]["output"]>;
};

export type PgSrcConnectorDetailsStatus = {
  __typename?: "PgSrcConnectorDetailsStatus";
  appliedOperationsCount: Scalars["Float"]["output"];
  lastReplicatedLsn: Scalars["Float"]["output"];
  lastReplicatedLsnStr: Scalars["String"]["output"];
  lastReplicatedTxnTime: Scalars["Time"]["output"];
  metricsUpdatedAt?: Maybe<Scalars["Time"]["output"]>;
  ready: Scalars["Boolean"]["output"];
  sourceFlushLsn: Scalars["Float"]["output"];
  sourceFlushLsnStr: Scalars["String"]["output"];
};

export type PgSrcConnectorStatus = {
  __typename?: "PgSrcConnectorStatus";
  appliedOperationsCount: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  lastReplicatedLsn: Scalars["Float"]["output"];
  lastReplicatedLsnStr: Scalars["String"]["output"];
  lastReplicatedTxnTime: Scalars["Time"]["output"];
  metricsUpdatedAt: Scalars["Time"]["output"];
  ready: Scalars["Boolean"]["output"];
  sourceFlushLsn: Scalars["Float"]["output"];
  sourceFlushLsnStr: Scalars["String"]["output"];
};

export type PgSrcConnectorTargetTable = {
  __typename?: "PgSrcConnectorTargetTable";
  approximateRows: Scalars["Float"]["output"];
  approximateSize: Scalars["Float"]["output"];
  bytesCopied: Scalars["Float"]["output"];
  lastError?: Maybe<Scalars["String"]["output"]>;
  rowsCopied: Scalars["Float"]["output"];
  state: Scalars["String"]["output"];
  table: ConnectorTableSpec;
};

export type PgSrcConnectorTargetTables = {
  __typename?: "PgSrcConnectorTargetTables";
  tables: Array<PgSrcConnectorTargetTable>;
};

export type PgSrcSpecInput = {
  sourceConfigId: Scalars["String"]["input"];
};

export type PgSrcTable = {
  __typename?: "PgSrcTable";
  approximateRows: Scalars["Float"]["output"];
  approximateSize: Scalars["Float"]["output"];
  columns: Array<ConnectorTableColumn>;
  hypertableSpec?: Maybe<HypertableSpec>;
  table: ConnectorTableIdentifier;
};

/** A billing plan for Timescale. */
export type Plan = {
  __typename?: "Plan";
  /** Amount of memory/RAM in GB. */
  IOPS?: Maybe<Scalars["Int"]["output"]>;
  cloudProvider: CloudProvider;
  /** Amount of memory/RAM in GB. */
  memoryGB?: Maybe<Scalars["Int"]["output"]>;
  /** Amount of CPU in thousandths; take this number over 1000 to get a decimal in whole CPUs. */
  milliCPU?: Maybe<Scalars["Int"]["output"]>;
  /** CPU limit in thousandths. A value of 0 means limits is equal to requested amount. */
  milliCPULimit?: Maybe<Scalars["Int"]["output"]>;
  /** The cost of this plan. */
  price: Scalars["Float"]["output"];
  /** The product which this plan is associated with. */
  productId: Scalars["ID"]["output"];
  /** The region of the plan. */
  regionCode: Scalars["String"]["output"];
  /**
   * Amount of storage in GB.
   * @deprecated deprecated
   */
  storageGB?: Maybe<Scalars["Int"]["output"]>;
  /** workerCount is the number of workers included in this plan. Used by the connectors pricing to represent the number of parallel workers. */
  workerCount?: Maybe<Scalars["Int"]["output"]>;
};

export type Policy = {
  __typename?: "Policy";
  fullInfo: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  interval: Scalars["String"]["output"];
  target: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type PolicyCount = {
  __typename?: "PolicyCount";
  count: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
};

export type PostgresAndTimescaleVersions = {
  __typename?: "PostgresAndTimescaleVersions";
  hasBackupInfo: Scalars["Boolean"]["output"];
  postgresVersion: VersionInfo;
  timescaleDBVersion: VersionInfo;
};

export type PostgresExtension = {
  __typename?: "PostgresExtension";
  comment: Scalars["String"]["output"];
  defaultVersion: Scalars["String"]["output"];
  installedVersion?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
};

export enum PostgresMajorVersionUpgradeStage {
  Error = "ERROR",
  Finished = "FINISHED",
  Initiated = "INITIATED",
  Uninitiated = "UNINITIATED",
  Unknown = "UNKNOWN",
  Verifying = "VERIFYING",
}

/** A status of a major PostgreSQL Upgrade. */
export type PostgresMajorVersionUpgradeStatus = {
  __typename?: "PostgresMajorVersionUpgradeStatus";
  /** The error message of a failed major PostgreSQL upgrade */
  error?: Maybe<Scalars["String"]["output"]>;
  /** The last known stage of the major PostgreSQL upgrade */
  stage: PostgresMajorVersionUpgradeStage;
};

export type PostgresParameters = {
  __typename?: "PostgresParameters";
  numeric_parameters: Array<NumericParameter>;
  string_parameters: Array<StringParameter>;
};

export type PreviewSource = {
  __typename?: "PreviewSource";
  definition: FileImportDefinition;
  source: TypeFileImportSource;
};

export type PreviewSourceInput = {
  definition: FileImportDefinitionInput;
  /**
   *    The project id.
   *    If not provided, the assume role call will not have external id.
   * TODO: DAT-430 make project_id and service_id required
   */
  project_id?: InputMaybe<Scalars["ID"]["input"]>;
  /**
   *    The service id.
   *    If not provided, the assume role call will not have external id.
   * TODO: DAT-430 make project_id and service_id required
   */
  service_id?: InputMaybe<Scalars["ID"]["input"]>;
  source: FileImportSourceInput;
};

export type PreviewSourceResponse = {
  __typename?: "PreviewSourceResponse";
  bytes?: Maybe<Scalars["Int"]["output"]>;
  columns: Array<ColumnPreview>;
  /**
   * Whether the file has a header.
   * This is not always reliable and is up to the end user to determine if this is correct.
   */
  has_header: Scalars["Boolean"]["output"];
};

/**
 * A Private Endpoint connection from your cloud account.
 * Created when you set up a Private Endpoint targeting our Private Link Service.
 */
export type PrivateEndpointConnection = {
  __typename?: "PrivateEndpointConnection";
  /** Service endpoints (primary, replica, pooler) exposed through this connection. */
  bindings: Array<EndpointServiceBinding>;
  cloudProvider: PrivateLinkCloudProvider;
  /** Unique identifier for this connection. Use this when calling attachServiceToPrivateLinkConnection/detachServiceFromPrivateLinkConnection. */
  connectionId: Scalars["ID"]["output"];
  createdAt: Scalars["Time"]["output"];
  ipAddress?: Maybe<Scalars["String"]["output"]>;
  /** Cloud provider-assigned identifier for the Private Endpoint connection. */
  linkIdentifier: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  principalId: Scalars["String"]["output"];
  /** Provider-specific connection identifier (Azure connection name or AWS VPC Endpoint ID). */
  providerConnectionId: Scalars["String"]["output"];
  region: Scalars["String"]["output"];
  state: ConnectionState;
  updatedAt?: Maybe<Scalars["Time"]["output"]>;
};

/** A region where Private Link is available. */
export type PrivateLinkAvailableRegion = {
  __typename?: "PrivateLinkAvailableRegion";
  cloudProvider: PrivateLinkCloudProvider;
  region: Scalars["String"]["output"];
  /** Provider-specific service identifier (Azure alias or AWS VPC Endpoint Service name). */
  serviceName: Scalars["String"]["output"];
};

export enum PrivateLinkCloudProvider {
  Aws = "aws",
  Azure = "azure",
}

/** Result of getPrivateLinkServiceConnections, including connections and default endpoints. */
export type PrivateLinkServiceConnectionsResult = {
  __typename?: "PrivateLinkServiceConnectionsResult";
  connections: Array<PrivateEndpointConnection>;
  /** Default endpoints for this service over Private Link (common hostname + port per binding type). */
  endpoints?: Maybe<ServiceEndpoints>;
};

export type ProcedureId = {
  __typename?: "ProcedureID";
  name: Scalars["String"]["output"];
  schema: Scalars["String"]["output"];
};

export type ProcessCsvImportInput = {
  columns: Array<CsvImportColumnInput>;
  delimiter: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
  schema_name: Scalars["String"]["input"];
  serviceId: Scalars["ID"]["input"];
  skip_header: Scalars["Boolean"]["input"];
  table_name: Scalars["String"]["input"];
  time_column: Scalars["String"]["input"];
};

export type ProcessFileImportInput = {
  csv?: InputMaybe<ProcessCsvImportInput>;
  parquet?: InputMaybe<ProcessParquetImportInput>;
  source?: InputMaybe<FileImportSource>;
};

export type ProcessParquetImportInput = {
  columns: Array<CsvImportColumnInput>;
  id: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
  schema_name: Scalars["String"]["input"];
  serviceId: Scalars["ID"]["input"];
  table_name: Scalars["String"]["input"];
  time_column: Scalars["String"]["input"];
};

/** A billing product of Timescale. */
export type Product = {
  __typename?: "Product";
  /**
   * A description of the product.
   * @deprecated unused
   */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Product ID, as it appears in Stripe as well. */
  id: Scalars["ID"]["output"];
  /** A display name for the product. */
  name: Scalars["String"]["output"];
  /** All plans associated with this product. */
  plans: Array<Plan>;
};

/** All cost information for a specific billing account for a specific product. */
export type ProductCostInfo = {
  __typename?: "ProductCostInfo";
  /** The cost-to-date for the current billing period, minus any trials or credits. */
  costToDate: Scalars["Float"]["output"];
  /** The cost-to-date for the current billing period. */
  costToDateGross: Scalars["Float"]["output"];
  /** The estimated total cost for the current billing period, minus any trials or credits. */
  estimatedTotalCost: Scalars["Float"]["output"];
  /** The estimated total cost for the current billing period. */
  estimatedTotalCostGross: Scalars["Float"]["output"];
  /** The id of the product we have informatiion for */
  productID: Scalars["ID"]["output"];
  /** The product name */
  productName?: Maybe<Scalars["String"]["output"]>;
};

export type ProductionSupportEntitlement = {
  __typename?: "ProductionSupportEntitlement";
  enabled: Scalars["Boolean"]["output"];
};

export type Project = {
  __typename?: "Project";
  billingAccount?: Maybe<BillingAccount>;
  created?: Maybe<Scalars["Time"]["output"]>;
  enforcementType: EnforcementType;
  /** Entitlement spec shows the set of features, and limits a given project has. */
  entitlementSpec?: Maybe<EntitlementSpec>;
  id: Scalars["ID"]["output"];
  isOwner: Scalars["Boolean"]["output"];
  /** It holds the current role the logged has in the project */
  loggedUserRole: UserProjectRbacRole;
  maxVPCs: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  projectPlan: ProjectPlan;
  queuedForDeletion?: Maybe<Scalars["Time"]["output"]>;
};

export type ProjectDeletionRequestInput = {
  projectId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
};

/** A project invitation. */
export type ProjectInvite = {
  __typename?: "ProjectInvite";
  /** The date this invite has been activated. */
  activated?: Maybe<Scalars["Time"]["output"]>;
  /** The date this invite has been created. */
  created: Scalars["Time"]["output"];
  /** The date this invite has been declined. */
  declined?: Maybe<Scalars["Time"]["output"]>;
  /** The date this invite has been deleted. */
  deleted?: Maybe<Scalars["Time"]["output"]>;
  /** The invited email. */
  email: Scalars["String"]["output"];
  /** The invite unique hash */
  hash?: Maybe<Scalars["String"]["output"]>;
  /** The invite ID */
  id: Scalars["ID"]["output"];
  /** The user that sent the invitation. */
  inviter?: Maybe<User>;
  /** The project the invitation is about. */
  project: Project;
  /** The project RBAC role for the user */
  rbacRole: RbacRole;
  /** The project role. */
  role: Role;
  /** The user ID */
  userId: Scalars["ID"]["output"];
};

/** A project member. */
export type ProjectMember = {
  __typename?: "ProjectMember";
  /** Whether the member has ever logged in via SSO */
  hasSSO: Scalars["Boolean"]["output"];
  /** Date the user joined the project */
  joined: Scalars["Time"]["output"];
  /** The member's most recent login session */
  lastLoginSession?: Maybe<LastLoginSession>;
  /** The project id */
  projectId: Scalars["ID"]["output"];
  /** The project RBAC role for the current logged user */
  rbacRole: RbacRole;
  /** The project role. */
  role: Role;
  /** The user of the `ProjectMember`. */
  user: User;
  /** The member user id */
  userId: Scalars["ID"]["output"];
};

export enum ProjectPlan {
  Ghost = "GHOST",
  TigerCloud = "TIGER_CLOUD",
}

export type PrometheusMetricConfig = {
  __typename?: "PrometheusMetricConfig";
  endpoint?: Maybe<Scalars["String"]["output"]>;
  password?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<Scalars["String"]["output"]>;
};

export type PrometheusMetricConfigInput = {
  password?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["String"]["input"]>;
};

/** Queries-per-second breakdown for a single time bucket. */
export type QpsMetricsDataPoint = {
  __typename?: "QPSMetricsDataPoint";
  all: Scalars["Float"]["output"];
  /** @deprecated we decided not to expose this */
  other: Scalars["Float"]["output"];
  reads: Scalars["Float"]["output"];
  time: Scalars["Time"]["output"];
  writes: Scalars["Float"]["output"];
};

/** A window of QPS data for a single instance with constant role. */
export type QpsMetricsWindow = {
  __typename?: "QPSMetricsWindow";
  data: Array<QpsMetricsDataPoint>;
  ordinal: Scalars["Int"]["output"];
  role: InstanceRole;
};

/** The root Query object of this API. */
export type Query = {
  __typename?: "Query";
  GetContAggListV2: ContAggListResponse;
  activityLog: ActivityLogItems;
  backupsRetentionStatus: BackupsRetentionStatusResponse;
  /** Day-by-day cost breakdown from Orb data for a billing account. */
  billingTimeline: BillingTimeline;
  connectors?: Maybe<ConnectorsQuerier>;
  /** Is cross-region backups enabled. */
  crossRegionBackupsStatus: CrossRegionBackupsEnabled;
  /** Is cross-region backups enabled with the list of regions. */
  crossRegionBackupsStatusV2?: Maybe<CrossRegionBackupStatusV2>;
  dbagent: DbAgent;
  downgradeCheck: EntitlementDowngradeResponse;
  explorer: Explorer;
  /** Get all generic exporters for this project. */
  getAllGenericExporters: Array<GenericExporter>;
  /** Get all metric exporters for this project. */
  getAllMetricExporters: Array<MetricExporter>;
  getAllNextMaintenance: Array<ServiceNextMaintenance>;
  getAllOrganizationsForUser: GetAllOrganizationsForUserResponse;
  /** Get all projects which the authenticated user has access to. */
  getAllProjects: Array<Project>;
  /** Get all services which the authenticated user has access to for the project specified by ID. */
  getAllServices: Array<Service>;
  /** Get latest storage threshold event for every service in the project */
  getAllServicesStorageThresholdEvents: Array<ServiceStorageThresholdEvent>;
  /** Get a list of VPCs for a user's project. */
  getAllVpcs: Array<Vpc>;
  /** Get billing emails for the target billing account */
  getBillingEmailAddresses: Array<BillingEmailAddress>;
  /** Get the list of catalog table identifiers in a user's instance */
  getCatalogTableList: Array<TableId>;
  getCompressionRecommendationsForOrderBy: CompressionRecommendationsForOrderBy;
  getCompressionRecommendationsForSegmentBy: CompressionRecommendationsForSegmentBy;
  /** Get a specific connector by ID */
  getConnector: GetConnectorResponse;
  /** Get all connectors for a project */
  getConnectors: GetConnectorsResponse;
  getContAggInfo: ContAggInfo;
  getContAggList: Array<ContAggId>;
  /** Get the hourly cost of data tiering vs. EBS */
  getCostedProjectDataTieringUsageDistribution: Array<DataTieringStorageSummary>;
  /** Current billing period cost for a billing account or project. */
  getCurrentCost: BillingAccountCostInfo;
  /**
   * Get information about the currently authenticated PAT.
   *
   * This query can only be called when authenticated with a PAT token.
   * It returns an error if called with a user token.
   */
  getCurrentPATRecord: PatRecord;
  getDataTieringSummary?: Maybe<Array<Maybe<TieringUsage>>>;
  getDatabaseOverview: GetDatabaseOverviewOutput;
  /** Returns a single file import. */
  getFileImport: GetFileImportResponse;
  /** Get one generic exporter. */
  getGenericExporter: GenericExporter;
  /** Get the status of a ghost project, including storage and compute used. */
  getGhostProjectStatus: GhostProjectStatus;
  /** Get IP allow lists for a project. */
  getIPAllowLists: Array<IpAllowList>;
  /**
   * Get the file-import information
   * It is deprecated, use getFileImport instead
   */
  getImportState: FileImport;
  /** Get corporate invoicing info for a project */
  getInvoicing?: Maybe<Invoicing>;
  /** Get JWT for CC */
  getJWTForClientCredentials: Scalars["String"]["output"];
  /** Get status for Kafka connector */
  getKafkaSrcConnectorStatus: GetKafkaSrcConnectorStatusResponse;
  /** Get schema mapping for a Kafka topic */
  getKafkaTopicSchemaMapping: GetKafkaTopicSchemaMappingResponse;
  /** Get topics from a Kafka cluster */
  getKafkaTopicsFromCluster: GetKafkaTopicsFromClusterResponse;
  getLargestObjects: Array<ObjectSizeInfo>;
  /** Get the last resource usage of a service. */
  getLastServiceResourceMetrics: Array<ResourceMetrics>;
  /** Get one metric exporter. */
  getMetricExporter: MetricExporter;
  /** Estimated cost for the remainder of the current billing period. */
  getMonthRemainderEstimate: Scalars["Float"]["output"];
  /** Get the next maintenance run of the instance */
  getNextMaintenance: NextMaintenance;
  getObjectsMetadata: Array<ExtendedObjectMetadata>;
  /** Get Invoices for the target billing account, for optionnally provided year (querying for period_start) */
  getOrbInvoices: Invoices;
  getOrganizationMembers: GetOrganizationMembersResponse;
  /** Get all PAT records for the specified project */
  getPATRecords: Array<Maybe<PatRecord>>;
  /** Get all payment methods for the target billing account. */
  getPaymentMethods: Array<PaymentMethod>;
  /** Get pending payment method deletion for the target billing account. */
  getPendingPaymentDeletion?: Maybe<PaymentMethod>;
  /** Get the current status from the PopSQL integration of a service. */
  getPopSQLIntegrationStatus: Status;
  /** Get version information for an instance */
  getPostgresAndTimescaleDBVersion: PostgresAndTimescaleVersions;
  /** Get the list of available extensions for the specified instance */
  getPostgresAvailableExtensions: Array<PostgresExtension>;
  /** Get the last known status for a major PostgreSQL upgrade */
  getPostgresMajorVersionUpgradeStatus: PostgresMajorVersionUpgradeStatus;
  /** Get the currently configured postgres parameters for an instance. */
  getPostgresParameters: PostgresParameters;
  /** Get the connections, bindings, and default endpoints for a specific service */
  getPrivateLinkServiceConnections: PrivateLinkServiceConnectionsResult;
  /**
   * Get the project specified by ID.
   *
   * Permissions are checked based on the authenticated user's ID.
   */
  getProject: Project;
  /** Get pending project invites for a project */
  getProjectInvites: Array<ProjectInvite>;
  /** Get pending project invites for user */
  getProjectInvitesForUser: Array<ProjectInvite>;
  /** Get list of project members for a project */
  getProjectMembers: Array<ProjectMember>;
  /** Get all project secrets. */
  getProjectSecrets: Array<Secret>;
  /** getQueryDetails returns the normalized query for a given query hash */
  getQueryDetails: GetQueryDetailsResponse;
  /** getQueryLatestExplain returns the latest explain plan for a given query hash */
  getQueryLatestExplain?: Maybe<ExplainPlan>;
  /** getQueryMetricGraphs returns 5 minutes data points for a given query hash over time */
  getQueryMetricGraphs: QueryMetricGraphResponse;
  /** Get query stats for a given instance */
  getQueryStatsAndMetadata: QueryStatResponse;
  /** Lists all recommendations for a project and service */
  getRecommendations: Array<Recommendation>;
  /** Get recovery progress for replication-based services */
  getRecoveryProgress: Array<RecoveryProgress>;
  /**  Get the recovery time windows (earliest and latest timestamp) for PITR. Multiple windows can be returned */
  getRecoveryWindows: Array<RecoveryWindow>;
  /** Returns a single S3 live sync available for a service. */
  getS3LiveSync: S3LiveSync;
  /** Returns a list of audit entries for a S3 live sync */
  getS3LiveSyncAudit: GetS3LiveSyncAuditResponse;
  /** Returns runtime/billing audit entries for a S3 live sync */
  getS3LiveSyncRuntimeAudit: GetS3LiveSyncRuntimeAuditResponse;
  /** Returns statistics for a S3 live sync */
  getS3LiveSyncStatistics: GetS3LiveSyncStatisticsResponse;
  /**
   * Get the service specified by ID.
   *
   * Permissions are checked based on the authenticated user's ID.
   */
  getService: Service;
  /** Get the history of a service's configuration. */
  getServiceConfigHistory: ServiceConfigHistory;
  /** Get the current deployment status of a service. */
  getServiceDeploymentStatus: DeployStatus;
  /**
   * Get a payload of logs from the target service.
   *
   * This call will pull the most recent payload of logs from the current 24hr window, returning
   * a maximum of 500 log entries.
   */
  getServiceLogs: Array<Scalars["String"]["output"]>;
  /**
   * Get the resource usage of a service over time.
   *
   * This call will combine the metrics with the pod ordinals, roles and the pod limits and group the
   * metrics into windows for each distinct set of ordinal/role/limits.
   */
  getServiceMetrics: ServiceMetrics;
  /** Get the resource usage of a service over time. */
  getServiceResourceMetrics: Array<ResourceMetrics>;
  /** Get service-scoped latest storage threshold event if any */
  getServiceStorageThresholdEvent?: Maybe<ServiceStorageThresholdEvent>;
  /** Get support cases for a project from the last 3 months. */
  getSupportCases: Array<SupportCase>;
  getTableInfo: Table;
  /** Get the list of table identifiers in a user's instance */
  getTableList: Array<TableId>;
  /** Get the version of TimescaleDB in a user's instance */
  getTimescaleVersion: Scalars["TimescaleVersion"]["output"];
  getUIState: GetUiStateResponse;
  /**
   * Get details on the logged in user.
   *
   * This field will use the JWT associated with the call to determine the user to look-up.
   */
  getUser: User;
  getVirtualPlans: GetVirtualPlansResponse;
  /** Get a VPC by ID. This will verify the authenticated user has access to said vpc before returning. */
  getVpc: Vpc;
  /** Get a VPC by ID. This will verify the authenticated user has access to said vpc before returning. */
  getVpcByName: Vpc;
  /** Is service has backups. */
  hasBackups: HasBackups;
  /** Returns whether iceberg sync is enabled for a service. */
  icebergSyncInfo: IcebergSyncInfo;
  /** Get a list of existing backups for a service. */
  listBackups: BackupList;
  /**
   * Returns a list of objects in a bucket
   * This is just a wrapper over ListObjectsV2 with our custom filtering based on patterns.
   */
  listBucketObjects: ListBucketObjectsResponse;
  /** Returns a list of file imports */
  listFileImport: ListFileImportResponse;
  listForkRegions: ListForkRegionsResponse;
  /** List available regions for private link */
  listPrivateLinkAvailableRegions: Array<PrivateLinkAvailableRegion>;
  /** List all service bindings for a project, optionally filtered by service */
  listPrivateLinkBindings: Array<EndpointServiceBinding>;
  /** List all private endpoint connections for a project */
  listPrivateLinkConnections: Array<PrivateEndpointConnection>;
  /** Returns a list of the S3 live syncs available for a service. */
  listS3LiveSync?: Maybe<Array<S3LiveSync>>;
  /**
   * Login to Timescale with potential Mfa step up.
   *
   * This can return an MfaRequired object which requires the user to call the endpoint again with
   * a code from the users Mfa device. The returned twoFactorId should be passed back again with
   * a valid code, the email/password does not need to be passed in again.
   */
  loginMfa: LoginMfaResponse;
  /**
   * Logout of Timescale.
   *
   * This serves to remove the HTTPonly cookies set by login
   */
  logout: Scalars["Success"]["output"];
  /**
   * Perform a MFA challenge returning a trust token to use with later API calls.
   *
   * This is required for actions that require step up authentication such as changing password
   * We leverage the trustToken and trustChallenge provided in https://fusionauth.io/docs/v1/tech/apis/two-factor
   *
   * This endpoint supports a password reset token in place of a standard auth token
   * passed in via the auth header as a bearer token "Bearer <Token>"
   */
  mfaChallenge: MfaChallengeResponse;
  /** All products and their associated plans available in Orb. */
  orbAllProducts: Array<TierWithProducts>;
  /** Products and their associated plans available in Orb for given project. */
  orbProducts: Array<Product>;
  /**
   * Given a source, it will attempt to return a schema for it
   * This enpoint is intended to guess the schema of a file. The information returned is not guaranteed to be correct.
   * After user confirms the schema, the endpoint createSchema is used to create the schema in the backend
   */
  previewSource: PreviewSourceResponse;
  /** Returns log aggregates and related data for the target service. */
  serviceLogs: ServiceLogs;
  /** The authenticated user's active sessions. */
  userSessions: Array<UserSession>;
  /** Validate the given password reset token to ensure it can be used. */
  validateResetToken: Scalars["String"]["output"];
  /** Validate the given password reset token to ensure it can be used. */
  validateResetTokenMfa: ValidateResetTokenMfaResponse;
};

/** The root Query object of this API. */
export type QueryGetContAggListV2Args = {
  data: GetContAggListInput;
};

/** The root Query object of this API. */
export type QueryActivityLogArgs = {
  end?: InputMaybe<Scalars["Time"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  projectId: Scalars["String"]["input"];
  serviceId?: InputMaybe<Scalars["String"]["input"]>;
  start?: InputMaybe<Scalars["Time"]["input"]>;
};

/** The root Query object of this API. */
export type QueryBackupsRetentionStatusArgs = {
  data?: InputMaybe<BackupsRetentionStatusInput>;
};

/** The root Query object of this API. */
export type QueryBillingTimelineArgs = {
  billingAccountId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryCrossRegionBackupsStatusArgs = {
  data: CrossRegionBackupsStatusInput;
};

/** The root Query object of this API. */
export type QueryCrossRegionBackupsStatusV2Args = {
  data: CrossRegionBackupsStatusInput;
};

/** The root Query object of this API. */
export type QueryDbagentArgs = {
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

/** The root Query object of this API. */
export type QueryDowngradeCheckArgs = {
  data: EntitlementDowngradeCheckInput;
};

/** The root Query object of this API. */
export type QueryExplorerArgs = {
  projectId: Scalars["String"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["String"]["input"];
};

/** The root Query object of this API. */
export type QueryGetAllGenericExportersArgs = {
  projectId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetAllMetricExportersArgs = {
  projectId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetAllNextMaintenanceArgs = {
  projectId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetAllServicesArgs = {
  projectId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetAllServicesStorageThresholdEventsArgs = {
  data: GetAllServicesStorageThresholdEventsInput;
};

/** The root Query object of this API. */
export type QueryGetAllVpcsArgs = {
  projectId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetBillingEmailAddressesArgs = {
  billingAccountId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetCatalogTableListArgs = {
  data: GetTableListInput;
};

/** The root Query object of this API. */
export type QueryGetCompressionRecommendationsForOrderByArgs = {
  data: CompressionRecommendationsForOrderByInput;
};

/** The root Query object of this API. */
export type QueryGetCompressionRecommendationsForSegmentByArgs = {
  data: CompressionRecommendationsForSegmentByInput;
};

/** The root Query object of this API. */
export type QueryGetConnectorArgs = {
  data: GetConnectorInput;
};

/** The root Query object of this API. */
export type QueryGetConnectorsArgs = {
  data: GetConnectorsInput;
};

/** The root Query object of this API. */
export type QueryGetContAggInfoArgs = {
  data: GetContAggInfoInput;
};

/** The root Query object of this API. */
export type QueryGetContAggListArgs = {
  data: GetContAggListInput;
};

/** The root Query object of this API. */
export type QueryGetCostedProjectDataTieringUsageDistributionArgs = {
  projectID: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetCurrentCostArgs = {
  data: OrbCostInput;
};

/** The root Query object of this API. */
export type QueryGetDataTieringSummaryArgs = {
  projectId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetDatabaseOverviewArgs = {
  data: GetDatabaseOverviewInput;
};

/** The root Query object of this API. */
export type QueryGetFileImportArgs = {
  data: GetFileImportInput;
};

/** The root Query object of this API. */
export type QueryGetGenericExporterArgs = {
  data: GenericExporterIdInput;
};

/** The root Query object of this API. */
export type QueryGetGhostProjectStatusArgs = {
  projectID: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetIpAllowListsArgs = {
  projectID: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetImportStateArgs = {
  data: GetImportStateInput;
};

/** The root Query object of this API. */
export type QueryGetInvoicingArgs = {
  billingAccountId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetJwtForClientCredentialsArgs = {
  data: GetJwtForClientCredentialsInput;
};

/** The root Query object of this API. */
export type QueryGetKafkaSrcConnectorStatusArgs = {
  data: GetKafkaSrcConnectorStatusInput;
};

/** The root Query object of this API. */
export type QueryGetKafkaTopicSchemaMappingArgs = {
  data: GetKafkaTopicSchemaMappingInput;
};

/** The root Query object of this API. */
export type QueryGetKafkaTopicsFromClusterArgs = {
  data: GetKafkaTopicsFromClusterInput;
};

/** The root Query object of this API. */
export type QueryGetLargestObjectsArgs = {
  data: GetLargestObjectsInput;
};

/** The root Query object of this API. */
export type QueryGetLastServiceResourceMetricsArgs = {
  data: GetLastServiceResourceMetricsInput;
};

/** The root Query object of this API. */
export type QueryGetMetricExporterArgs = {
  data: MetricExporterIdInput;
};

/** The root Query object of this API. */
export type QueryGetMonthRemainderEstimateArgs = {
  data: OrbCostInput;
};

/** The root Query object of this API. */
export type QueryGetNextMaintenanceArgs = {
  data: NextMaintenanceInput;
};

/** The root Query object of this API. */
export type QueryGetObjectsMetadataArgs = {
  data: GetObjectsMetadataInput;
};

/** The root Query object of this API. */
export type QueryGetOrbInvoicesArgs = {
  billingAccountId: Scalars["ID"]["input"];
  year?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root Query object of this API. */
export type QueryGetOrganizationMembersArgs = {
  data: GetOrganizationMembersInput;
};

/** The root Query object of this API. */
export type QueryGetPatRecordsArgs = {
  projectID: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetPaymentMethodsArgs = {
  billingAccountId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetPendingPaymentDeletionArgs = {
  billingAccountId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetPopSqlIntegrationStatusArgs = {
  data: GetPopSqlIntegrationStatusInput;
};

/** The root Query object of this API. */
export type QueryGetPostgresAndTimescaleDbVersionArgs = {
  data: GetPostgresAndTimescaleDbVersionInput;
};

/** The root Query object of this API. */
export type QueryGetPostgresAvailableExtensionsArgs = {
  data: GetPostgresAvailableExtensionsInput;
};

/** The root Query object of this API. */
export type QueryGetPostgresMajorVersionUpgradeStatusArgs = {
  data: GetPostgresMajorVersionUpgradeStatusInput;
};

/** The root Query object of this API. */
export type QueryGetPostgresParametersArgs = {
  data: GetPostgresParametersInput;
};

/** The root Query object of this API. */
export type QueryGetPrivateLinkServiceConnectionsArgs = {
  data: GetPrivateLinkServiceConnectionInput;
};

/** The root Query object of this API. */
export type QueryGetProjectArgs = {
  id: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetProjectInvitesArgs = {
  projectId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetProjectMembersArgs = {
  projectId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetProjectSecretsArgs = {
  data: GetProjectSecretsInput;
};

/** The root Query object of this API. */
export type QueryGetQueryDetailsArgs = {
  data: GetQueryDetailsInput;
};

/** The root Query object of this API. */
export type QueryGetQueryLatestExplainArgs = {
  data: GetQueryLatestExplainInput;
};

/** The root Query object of this API. */
export type QueryGetQueryMetricGraphsArgs = {
  data: GetQueryMetricGraphsInput;
};

/** The root Query object of this API. */
export type QueryGetQueryStatsAndMetadataArgs = {
  data: GetQueryStatsInput;
};

/** The root Query object of this API. */
export type QueryGetRecommendationsArgs = {
  data: GetRecommendationsInput;
};

/** The root Query object of this API. */
export type QueryGetRecoveryProgressArgs = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetRecoveryWindowsArgs = {
  data: RecoveryWindowsInput;
};

/** The root Query object of this API. */
export type QueryGetS3LiveSyncArgs = {
  data: GetS3LiveSyncInput;
};

/** The root Query object of this API. */
export type QueryGetS3LiveSyncAuditArgs = {
  data: GetS3LiveSyncAuditInput;
};

/** The root Query object of this API. */
export type QueryGetS3LiveSyncRuntimeAuditArgs = {
  data: GetS3LiveSyncRuntimeAuditInput;
};

/** The root Query object of this API. */
export type QueryGetS3LiveSyncStatisticsArgs = {
  data: GetS3LiveSyncStatisticsInput;
};

/** The root Query object of this API. */
export type QueryGetServiceArgs = {
  data: GetServiceInput;
};

/** The root Query object of this API. */
export type QueryGetServiceConfigHistoryArgs = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  serviceOrdinal?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The root Query object of this API. */
export type QueryGetServiceDeploymentStatusArgs = {
  data: GetServiceDeploymentStatusInput;
};

/** The root Query object of this API. */
export type QueryGetServiceLogsArgs = {
  data: GetServiceLogsInput;
};

/** The root Query object of this API. */
export type QueryGetServiceMetricsArgs = {
  data: GetServiceMetricsInput;
};

/** The root Query object of this API. */
export type QueryGetServiceResourceMetricsArgs = {
  data: GetServiceResourceMetricsInput;
};

/** The root Query object of this API. */
export type QueryGetServiceStorageThresholdEventArgs = {
  data: GetServiceStorageThresholdEventInput;
};

/** The root Query object of this API. */
export type QueryGetSupportCasesArgs = {
  data: GetSupportCasesInput;
};

/** The root Query object of this API. */
export type QueryGetTableInfoArgs = {
  data: GetTableInfoInput;
};

/** The root Query object of this API. */
export type QueryGetTableListArgs = {
  data: GetTableListInput;
};

/** The root Query object of this API. */
export type QueryGetTimescaleVersionArgs = {
  data: GetTimescaleVersionInput;
};

/** The root Query object of this API. */
export type QueryGetUiStateArgs = {
  input: GetUiStateInput;
};

/** The root Query object of this API. */
export type QueryGetVpcArgs = {
  projectId?: InputMaybe<Scalars["ID"]["input"]>;
  vpcId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryGetVpcByNameArgs = {
  data: GetVpcByNameInput;
};

/** The root Query object of this API. */
export type QueryHasBackupsArgs = {
  data: HasBackupsInput;
};

/** The root Query object of this API. */
export type QueryIcebergSyncInfoArgs = {
  data: GetServiceInput;
};

/** The root Query object of this API. */
export type QueryListBackupsArgs = {
  data: ListBackupsInput;
};

/** The root Query object of this API. */
export type QueryListBucketObjectsArgs = {
  data: ListBucketObjectsInput;
};

/** The root Query object of this API. */
export type QueryListFileImportArgs = {
  data: ListFileImportInput;
};

/** The root Query object of this API. */
export type QueryListForkRegionsArgs = {
  data: ListForkRegionsInput;
};

/** The root Query object of this API. */
export type QueryListPrivateLinkBindingsArgs = {
  data: ListPrivateLinkBindingsInput;
};

/** The root Query object of this API. */
export type QueryListPrivateLinkConnectionsArgs = {
  data: ListPrivateLinkConnectionsInput;
};

/** The root Query object of this API. */
export type QueryListS3LiveSyncArgs = {
  data: ListS3LiveSyncInput;
};

/** The root Query object of this API. */
export type QueryLoginMfaArgs = {
  data: LoginMfaInput;
};

/** The root Query object of this API. */
export type QueryMfaChallengeArgs = {
  data: MfaChallengeInput;
};

/** The root Query object of this API. */
export type QueryOrbProductsArgs = {
  experimentGroup?: InputMaybe<ExperimentGroup>;
  projectId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryPreviewSourceArgs = {
  data: PreviewSourceInput;
};

/** The root Query object of this API. */
export type QueryServiceLogsArgs = {
  filters?: InputMaybe<ServiceLogsFilters>;
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

/** The root Query object of this API. */
export type QueryValidateResetTokenArgs = {
  token: Scalars["String"]["input"];
};

/** The root Query object of this API. */
export type QueryValidateResetTokenMfaArgs = {
  token: Scalars["String"]["input"];
};

export type QueryDetails = {
  __typename?: "QueryDetails";
  normalizedQuery: Scalars["String"]["output"];
};

export type QueryMetricGraphResponse = {
  __typename?: "QueryMetricGraphResponse";
  dataPoints: Array<GraphDataPoint>;
  total: Scalars["Int"]["output"];
};

/** Query Range is used to provide a range to get query stats from. */
export type QueryRange = {
  from: Scalars["Time"]["input"];
  to: Scalars["Time"]["input"];
};

/**
 * The QueryStat is the response received for a request to list queries.
 * Each QueryStat represents a single query row, which consists of a fingerprint (identifier),
 * the raw query string, and a collection of aggregated metrics.
 */
export type QueryStat = {
  __typename?: "QueryStat";
  hasExplainPlan: Scalars["Boolean"]["output"];
  metrics: QueryStatMetrics;
  query: Scalars["String"]["output"];
  queryHash: Scalars["String"]["output"];
  userName: Scalars["String"]["output"];
};

export type QueryStatConstraint = {
  field: QueryStatConstraintFieldOption;
  search?: InputMaybe<Scalars["String"]["input"]>;
  threshold?: InputMaybe<Scalars["Float"]["input"]>;
};

export enum QueryStatConstraintFieldOption {
  ExecutionsGreaterThan = "EXECUTIONS_GREATER_THAN",
  ExecutionsLessThan = "EXECUTIONS_LESS_THAN",
  FindByQueryPart = "FIND_BY_QUERY_PART",
  FindByUser = "FIND_BY_USER",
  HasAggregates = "HAS_AGGREGATES",
  HasCompression = "HAS_COMPRESSION",
  HasHypertables = "HAS_HYPERTABLES",
  MaxTimeGreaterThan = "MAX_TIME_GREATER_THAN",
  OnlyDeleteQueries = "ONLY_DELETE_QUERIES",
  OnlyInsertQueries = "ONLY_INSERT_QUERIES",
  OnlySelectQueries = "ONLY_SELECT_QUERIES",
  OnlyUpdateQueries = "ONLY_UPDATE_QUERIES",
  OnlyUserQueries = "ONLY_USER_QUERIES",
  ShowBackgroundQueries = "SHOW_BACKGROUND_QUERIES",
}

/**
 * QueryStatMetrics is the single shared type for all query performance metrics.
 * It is used in two places:
 *
 * - QueryStat.metrics — a snapshot of aggregated metrics for one query over the
 *   requested time window, returned by getQueryStatsAndMetadata.
 * - GraphDataPoint.metrics — the same metric set but for a single 5-minute time
 *   bucket, returned by getQueryMetricGraphs.
 *
 * Because the graph endpoint lets callers select only the fields they need (via
 * the MetricOption enum on the request), fields that were not requested will be
 * null in GraphDataPoint responses. All fields are always populated in
 * QueryStat responses.
 *
 * All MetricValue fields carry both a string value and a MetricUnit so clients
 * can convert to the display scale of their choice.
 *
 * Execution time (p50Time, p95Time, p99Time, p05Time, totalTime) and plan time
 * (p50PlanTime, p95PlanTime) are in microseconds.
 *
 * Shared-buffer metrics (medianMemory, p95Memory, medianBytesRead,
 * p95BytesRead) are derived from pg_stat_statements block counters multiplied by
 * the page size (8192 bytes), and are measured in bytes. cacheHitRatio is a 0–100
 * percentage. cacheMemoryRate and bytesReadRate are rates in bytes per microsecond.
 *
 * Hardware resource metrics (p50CpuTimeUser, p95CpuTimeUser, p50CpuTimeSys,
 * p95CpuTimeSys, p50MemAllocatedBytes, p95MemAllocatedBytes, p50FsBytesRead,
 * p95FsBytesRead, p50FsBytesWritten, p95FsBytesWritten) are collected via OS
 * resource usage (getrusage). CPU fields are in microseconds; memory and
 * filesystem I/O fields are in bytes. These fields are null for services running
 * agent versions that predate hardware metrics collection.
 */
export type QueryStatMetrics = {
  __typename?: "QueryStatMetrics";
  bytesReadRate?: Maybe<MetricValue>;
  cacheHitRatio?: Maybe<MetricValue>;
  cacheMemoryRate?: Maybe<MetricValue>;
  caggsCount?: Maybe<MetricValue>;
  compressionCount?: Maybe<MetricValue>;
  executions?: Maybe<MetricValue>;
  hypertablesCount?: Maybe<MetricValue>;
  medianBytesRead?: Maybe<MetricValue>;
  medianChunkAccessed?: Maybe<MetricValue>;
  medianMemory?: Maybe<MetricValue>;
  medianRows?: Maybe<MetricValue>;
  p05Time?: Maybe<MetricValue>;
  p50CpuTimeSys?: Maybe<MetricValue>;
  p50CpuTimeUser?: Maybe<MetricValue>;
  p50FsBytesRead?: Maybe<MetricValue>;
  p50FsBytesWritten?: Maybe<MetricValue>;
  p50MemAllocatedBytes?: Maybe<MetricValue>;
  p50PlanTime?: Maybe<MetricValue>;
  p50Time?: Maybe<MetricValue>;
  p95BytesRead?: Maybe<MetricValue>;
  p95CpuTimeSys?: Maybe<MetricValue>;
  p95CpuTimeUser?: Maybe<MetricValue>;
  p95FsBytesRead?: Maybe<MetricValue>;
  p95FsBytesWritten?: Maybe<MetricValue>;
  p95MemAllocatedBytes?: Maybe<MetricValue>;
  p95Memory?: Maybe<MetricValue>;
  p95PlanTime?: Maybe<MetricValue>;
  p95Time?: Maybe<MetricValue>;
  p99Time?: Maybe<MetricValue>;
  plans?: Maybe<MetricValue>;
  rows?: Maybe<MetricValue>;
  totalTime?: Maybe<MetricValue>;
};

export enum QueryStatRange {
  Custom = "CUSTOM",
  TwentyFourHours = "TWENTY_FOUR_HOURS",
}

/**
 * The QueryStatResponse is a wrapper for the list of query stats.
 * It's used to send alongside the stats others helpful information.
 */
export type QueryStatResponse = {
  __typename?: "QueryStatResponse";
  queriesDataPoints: Array<PerQueryGraphDataPoint>;
  stats: Array<Maybe<QueryStat>>;
  statsAsOf?: Maybe<Scalars["Time"]["output"]>;
};

export enum QueryStatSortFieldOption {
  CacheHitRatio = "CACHE_HIT_RATIO",
  CaggsCount = "CAGGS_COUNT",
  CompressionCount = "COMPRESSION_COUNT",
  Executions = "EXECUTIONS",
  HypertablesCount = "HYPERTABLES_COUNT",
  MedianBytesRead = "MEDIAN_BYTES_READ",
  MedianChunksAccessed = "MEDIAN_CHUNKS_ACCESSED",
  MedianMemory = "MEDIAN_MEMORY",
  MedianRows = "MEDIAN_ROWS",
  P05Time = "P05_TIME",
  P50CpuTimeSys = "P50_CPU_TIME_SYS",
  P50CpuTimeUser = "P50_CPU_TIME_USER",
  P50FsBytesRead = "P50_FS_BYTES_READ",
  P50FsBytesWritten = "P50_FS_BYTES_WRITTEN",
  P50MemAllocatedBytes = "P50_MEM_ALLOCATED_BYTES",
  P50PlanTime = "P50_PLAN_TIME",
  P50Time = "P50_TIME",
  P95BytesRead = "P95_BYTES_READ",
  P95CpuTimeSys = "P95_CPU_TIME_SYS",
  P95CpuTimeUser = "P95_CPU_TIME_USER",
  P95FsBytesRead = "P95_FS_BYTES_READ",
  P95FsBytesWritten = "P95_FS_BYTES_WRITTEN",
  P95Memory = "P95_MEMORY",
  P95MemAllocatedBytes = "P95_MEM_ALLOCATED_BYTES",
  P95PlanTime = "P95_PLAN_TIME",
  P95Time = "P95_TIME",
  P99Time = "P99_TIME",
  Rows = "ROWS",
  TotalTime = "TOTAL_TIME",
}

export enum QueryStatSortOrderOption {
  Asc = "ASC",
  Desc = "DESC",
}

export type RbacAccountPermission = {
  __typename?: "RBACAccountPermission";
  ACCOUNT_MEMBERS_UPDATE: Scalars["Boolean"]["output"];
  ACCOUNT_OWNER_UPDATE: Scalars["Boolean"]["output"];
  ACCOUNT_READ: Scalars["Boolean"]["output"];
  ACCOUNT_UPDATE: Scalars["Boolean"]["output"];
};

export type RbacPermissions = {
  __typename?: "RBACPermissions";
  /** Account is the billing account. An account can have multiple projects, but a project can only have one account */
  account?: Maybe<RbacAccountPermission>;
  /** Project is a resource, and behind it are permissions */
  project: RbacProjectPermission;
};

export type RbacProjectPermission = {
  __typename?: "RBACProjectPermission";
  PROJECT_BILLING_UPDATE: Scalars["Boolean"]["output"];
  PROJECT_MEMBERS_UPDATE: Scalars["Boolean"]["output"];
  PROJECT_OWNER_UPDATE: Scalars["Boolean"]["output"];
  /**
   * Each ID inside the list represents a project the user has permission to
   * @deprecated Use `PROJECT_READ` instead.
   */
  PROJECT_PERMISSION_READ?: Maybe<Array<Scalars["ID"]["output"]>>;
  /** @deprecated Use `PROJECT_UPDATE` instead. */
  PROJECT_PERMISSION_UPDATE?: Maybe<Array<Scalars["ID"]["output"]>>;
  PROJECT_PLAN_CHANGE: Scalars["Boolean"]["output"];
  PROJECT_READ: Scalars["Boolean"]["output"];
  PROJECT_UPDATE: Scalars["Boolean"]["output"];
};

export enum RbacProjectPermissionOptions {
  ProjectBillingUpdate = "PROJECT_BILLING_UPDATE",
  ProjectMembersUpdate = "PROJECT_MEMBERS_UPDATE",
  ProjectOwnerUpdate = "PROJECT_OWNER_UPDATE",
  /** @deprecated Use `PROJECT_READ` instead. */
  ProjectPermissionRead = "PROJECT_PERMISSION_READ",
  /** @deprecated Use `PROJECT_UPDATE` instead. */
  ProjectPermissionUpdate = "PROJECT_PERMISSION_UPDATE",
  ProjectPlanChange = "PROJECT_PLAN_CHANGE",
  ProjectRead = "PROJECT_READ",
  ProjectUpdate = "PROJECT_UPDATE",
}

/** Represents each available role for a user, considering the built-in roles */
export enum RbacRole {
  Admin = "ADMIN",
  /** The developer role, which less restricted than viewer, but more than admin. */
  Developer = "DEVELOPER",
  /** Each project must have a single onwer */
  Owner = "OWNER",
  Unspecified = "UNSPECIFIED",
  /** The read-only viewer role for users. */
  Viewer = "VIEWER",
}

export type ReadReplicaEntitlement = {
  __typename?: "ReadReplicaEntitlement";
  enabled: Scalars["Boolean"]["output"];
};

export type Recommendation = {
  __typename?: "Recommendation";
  actionText?: Maybe<Scalars["String"]["output"]>;
  category?: Maybe<Scalars["String"]["output"]>;
  created: Scalars["Time"]["output"];
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
  metadata?: Maybe<RecommendationMetadata>;
  projectId: Scalars["ID"]["output"];
  resourceId?: Maybe<Scalars["ID"]["output"]>;
  serviceId: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  type: RecommendationType;
  updated: Scalars["Time"]["output"];
};

export type RecommendationMetadata =
  | HypertableChangeChunkTimeIntervalMetadata
  | JobFailedNTimesMetadata;

export enum RecommendationType {
  AddData = "ADD_DATA",
  AddHaReplica = "ADD_HA_REPLICA",
  AddReadReplica = "ADD_READ_REPLICA",
  CheckInsights = "CHECK_INSIGHTS",
  CompressData = "COMPRESS_DATA",
  ConnectToService = "CONNECT_TO_SERVICE",
  CreateContinuousAggregate = "CREATE_CONTINUOUS_AGGREGATE",
  CreateHypertable = "CREATE_HYPERTABLE",
  HypertableChangeChunkTimeInterval = "HYPERTABLE_CHANGE_CHUNK_TIME_INTERVAL",
  JobFailedNTimes = "JOB_FAILED_N_TIMES",
  QueryHypertable = "QUERY_HYPERTABLE",
  QueryService = "QUERY_SERVICE",
  S3LiveSyncError = "S3_LIVE_SYNC_ERROR",
}

export enum RecoveryMethod {
  Basebackup = "BASEBACKUP",
  Snapshot = "SNAPSHOT",
  Unknown = "UNKNOWN",
}

export type RecoveryProgress = {
  __typename?: "RecoveryProgress";
  lag: Scalars["Int"]["output"];
  ordinal: Scalars["Int"]["output"];
  recorded: Scalars["Time"]["output"];
};

export type RecoveryWindow = {
  __typename?: "RecoveryWindow";
  endTime: Scalars["Time"]["output"];
  method: RecoveryMethod;
  startTime: Scalars["Time"]["output"];
};

export type RecoveryWindowsInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type RegenerateRecoveryCodesInput = {
  code: Scalars["String"]["input"];
};

export type RenamePatRecordInput = {
  accessKey: Scalars["String"]["input"];
  newName: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
};

export type RenameProjectInput = {
  name: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
};

export type RenameServiceInput = {
  newName: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

/** The input type for renaming a vpc. */
export type RenameVpcInput = {
  /** The internal table ID of the VPC row. */
  forgeVpcId: Scalars["ID"]["input"];
  /** The new VPC name. */
  newName: Scalars["String"]["input"];
  /** The project ID the VPC is associated with. */
  projectId: Scalars["ID"]["input"];
};

export type ResendVerifyBillingEmailAddressInput = {
  billingAccountId: Scalars["ID"]["input"];
  billingEmailId: Scalars["ID"]["input"];
};

export type ResetPasswordInput = {
  password: Scalars["String"]["input"];
  passwordConfirm: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
  /** Required if there are MFA methods active for the user  */
  trustChallenge?: InputMaybe<Scalars["String"]["input"]>;
  trustToken?: InputMaybe<Scalars["String"]["input"]>;
};

/** Reset postgres parameters for an instance. */
export type ResetPostgresParametersInput = {
  /** ProjectID that the service belongs to. */
  projectId: Scalars["ID"]["input"];
  /** Service ID of the service in question. */
  serviceId: Scalars["ID"]["input"];
};

export type ResetServicePasswordInput = {
  password?: InputMaybe<Scalars["String"]["input"]>;
  passwordType: PasswordType;
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

/** Resize instance input. */
export type ResizeInstanceInput = {
  /** Desired configuration changes. */
  config: ResourceConfig;
  /** Project ID that the service belongs to. */
  projectId: Scalars["ID"]["input"];
  /** Service ID of the service in question. */
  serviceId: Scalars["ID"]["input"];
};

export type Resource = {
  __typename?: "Resource";
  id: Scalars["ID"]["output"];
  serviceId: Scalars["ID"]["output"];
  spec: ResourceSpec;
  type: Scalars["String"]["output"];
};

export type ResourceConfig = {
  allReplicasAreSync?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** iopsForEnhancedStorage is the specific IOPS we want when migrating to enhanced storage */
  iopsForEnhancedStorage?: InputMaybe<Scalars["Int"]["input"]>;
  memoryGB: Scalars["Int"]["input"];
  milliCPU: Scalars["Int"]["input"];
  milliCPULimit?: InputMaybe<Scalars["Int"]["input"]>;
  replicaCount?: InputMaybe<Scalars["Int"]["input"]>;
  storageGB?: InputMaybe<Scalars["Int"]["input"]>;
  synchronousReplicaCount?: InputMaybe<Scalars["Int"]["input"]>;
  /** volumeType to migrate to. No migration will be performed if it is empty */
  volumeType?: InputMaybe<Scalars["String"]["input"]>;
};

/** A measurement of an instance's CPU, RAM & storage usage, and the IOPs and Bandwidth consumption of it's volume at a specific point in time. */
export type ResourceMetrics = {
  __typename?: "ResourceMetrics";
  Time: Scalars["Time"]["output"];
  memoryMB?: Maybe<Scalars["Int"]["output"]>;
  milliCPU?: Maybe<Scalars["Int"]["output"]>;
  milliCPULimit?: Maybe<Scalars["Int"]["output"]>;
  readBandwidth?: Maybe<Scalars["Float"]["output"]>;
  readIOPs?: Maybe<Scalars["Float"]["output"]>;
  /**
   * Size of the base data directory, temp files included. Only the latest sample
   * carries the storage breakdown: populated on getLastServiceResourceMetrics and
   * Service.metrics, always null on getServiceResourceMetrics.
   */
  storageBaseMB?: Maybe<Scalars["Int"]["output"]>;
  storageMB?: Maybe<Scalars["Int"]["output"]>;
  /** Size of temp files (a subset of storageBaseMB). Latest sample only, see storageBaseMB. */
  storageTmpMB?: Maybe<Scalars["Int"]["output"]>;
  /** Size of pg_wal. Latest sample only, see storageBaseMB. */
  storageWalMB?: Maybe<Scalars["Int"]["output"]>;
  writeBandwidth?: Maybe<Scalars["Float"]["output"]>;
  writeIOPs?: Maybe<Scalars["Float"]["output"]>;
};

export type ResourceNode = {
  __typename?: "ResourceNode";
  memoryGB: Scalars["Int"]["output"];
  milliCPU: Scalars["Int"]["output"];
  milliCPULimit?: Maybe<Scalars["Int"]["output"]>;
  replicaCount: Scalars["Int"]["output"];
  storageGB?: Maybe<Scalars["Int"]["output"]>;
  syncReplicaCount: Scalars["Int"]["output"];
};

export type ResourceSpec = ResourceNode;

export type RetryS3LiveSyncFileImportsInput = {
  /**
   * Deprecated: Use s3_key_prefix for better performance when filtering S3 files.
   * The start date to filter file imports.
   * It is a timestamp in RFC3339 format.
   * If this value is omitted, it will retry from the beginning of time.
   */
  from?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  project_id: Scalars["ID"]["input"];
  /** Filter S3 imports by key prefix (e.g., 'data/2024/'). */
  s3_key_prefix?: InputMaybe<Scalars["String"]["input"]>;
  service_id: Scalars["ID"]["input"];
  /**
   * The states to retry. Only FAILURE and CANCELED are allowed.
   * If empty, defaults to both FAILURE and CANCELED.
   */
  states?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * Deprecated: Use s3_key_prefix for better performance when filtering S3 files.
   * The end date to filter file imports.
   * It is a timestamp in RFC3339 format.
   * If this value is omitted, it will retry until current time.
   */
  to?: InputMaybe<Scalars["String"]["input"]>;
};

export type RetryS3LiveSyncFileImportsResponse = {
  __typename?: "RetryS3LiveSyncFileImportsResponse";
  /** The number of file imports that were retried. */
  count: Scalars["Int"]["output"];
};

export type RevokeProjectMemberInput = {
  projectId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export enum Role {
  Admin = "ADMIN",
  Manager = "MANAGER",
  User = "USER",
  Viewer = "VIEWER",
}

/** Represents a S3 Live Sync source for live sync request */
export type S3LiveSync = {
  __typename?: "S3LiveSync";
  bucket: Scalars["String"]["output"];
  created_at: Scalars["String"]["output"];
  credentials?: Maybe<S3LiveSyncCredentials>;
  definition?: Maybe<S3LiveSyncDefinition>;
  enabled: Scalars["Boolean"]["output"];
  /**
   * The frequency of the live sync.
   * It is a cron expression.
   */
  frequency?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /**
   * The last error of the live sync.
   * Is set if something went wrong with the reconciliation.
   */
  last_error?: Maybe<Scalars["String"]["output"]>;
  /**
   * The last imported object of the live sync.
   * Next tick will continue from this object.
   * It can be updated to skip or replay the import.
   */
  last_imported_object?: Maybe<Scalars["String"]["output"]>;
  /**
   * The name of the live sync.
   * It is just a human readable name not used for any other purpose.
   */
  name?: Maybe<Scalars["String"]["output"]>;
  /**
   * The next tick of the live sync.
   * It can be used to schedule the next sync.
   * by default it will be set when frequency is set.
   */
  next_tick?: Maybe<Scalars["String"]["output"]>;
  pattern: Scalars["String"]["output"];
  project_id: Scalars["ID"]["output"];
  service_id: Scalars["ID"]["output"];
  /** Settings for customizable behavior that are propagated to file imports */
  settings?: Maybe<ImportSettings>;
  table_identifier?: Maybe<TableIdentifier>;
  updated_at: Scalars["String"]["output"];
};

export type S3LiveSyncAudit = {
  __typename?: "S3LiveSyncAudit";
  at: Scalars["String"]["output"];
  bucket: Scalars["String"]["output"];
  created_at: Scalars["String"]["output"];
  credentials: S3LiveSyncCredentials;
  definition: S3LiveSyncDefinition;
  enabled: Scalars["Boolean"]["output"];
  frequency: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  last_error?: Maybe<Scalars["String"]["output"]>;
  last_imported_object: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  next_tick: Scalars["String"]["output"];
  objects: Array<S3LiveSyncAuditObjects>;
  pattern: Scalars["String"]["output"];
  project_id: Scalars["ID"]["output"];
  service_id: Scalars["ID"]["output"];
  table_identifier: TableIdentifier;
  updated_at: Scalars["String"]["output"];
};

export type S3LiveSyncAuditObjects = {
  __typename?: "S3LiveSyncAuditObjects";
  bytes: Scalars["Int"]["output"];
  key: Scalars["String"]["output"];
};

export type S3LiveSyncCredentials = {
  __typename?: "S3LiveSyncCredentials";
  role?: Maybe<S3LiveSyncRequestCredentialsRole>;
  type: S3LiveSyncCredentialsType;
};

export type S3LiveSyncCredentialsInput = {
  role?: InputMaybe<S3LiveSyncCredentialsRole>;
  type: S3LiveSyncCredentialsType;
};

export type S3LiveSyncCredentialsRole = {
  arn: Scalars["String"]["input"];
};

export enum S3LiveSyncCredentialsType {
  Public = "Public",
  RoleArn = "RoleARN",
}

export type S3LiveSyncDefinition = {
  __typename?: "S3LiveSyncDefinition";
  csv?: Maybe<S3LiveSyncRequestDefinitionCsv>;
  parquet?: Maybe<S3LiveSyncRequestDefinitionParquet>;
  type: S3LiveSyncDefinitionType;
};

export type S3LiveSyncDefinitionCsv = {
  /**
   * Automatically map columns by matching header names to table column names.
   * Requires skip_header to be true.
   * Mutually exclusive with column_names and column_mappings - specify only one of these options.
   */
  auto_column_mapping?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Column mappings from source file columns to destination table columns.
   * Requires skip_header to be true.
   * Mutually exclusive with column_names and auto_column_mapping - specify only one of these options.
   */
  column_mappings?: InputMaybe<Array<ColumnMappingInput>>;
  /**
   * The names of the columns in the CSV file.
   * It must match the columns in the destination database.
   * If left empty, the columns will be inserted by their position.
   * Mutually exclusive with column_mappings and auto_column_mapping - specify only one of these options.
   */
  column_names?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /**
   * The delimiter of the CSV file.
   * You almost never have to set this as it is a "," by default.
   */
  delimiter?: InputMaybe<Scalars["String"]["input"]>;
  /** Whether the CSV file has a header. */
  skip_header?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type S3LiveSyncDefinitionInput = {
  csv?: InputMaybe<S3LiveSyncDefinitionCsv>;
  parquet?: InputMaybe<S3LiveSyncDefinitionParquet>;
  type: S3LiveSyncDefinitionType;
};

export type S3LiveSyncDefinitionParquet = {
  /**
   * Automatically map columns by matching header names to table column names.
   * Mutually exclusive with column_mappings - specify only one of these options.
   */
  auto_column_mapping?: InputMaybe<Scalars["Boolean"]["input"]>;
  /**
   * Column mappings from source file columns to destination table columns.
   * Mutually exclusive with auto_column_mapping - specify only one of these options.
   */
  column_mappings?: InputMaybe<Array<ColumnMappingInput>>;
};

export enum S3LiveSyncDefinitionType {
  Csv = "CSV",
  Parquet = "PARQUET",
}

export type S3LiveSyncRequestCredentialsRole = {
  __typename?: "S3LiveSyncRequestCredentialsRole";
  arn: Scalars["String"]["output"];
};

export type S3LiveSyncRequestDefinitionCsv = {
  __typename?: "S3LiveSyncRequestDefinitionCSV";
  /** Automatically map columns by matching header names to table column names. */
  auto_column_mapping?: Maybe<Scalars["Boolean"]["output"]>;
  /** Column mappings from source file columns to destination table columns. */
  column_mappings?: Maybe<Array<ColumnMapping>>;
  /**
   * The names of the columns in the CSV file.
   * It must match the columns in the destination database.
   */
  column_names?: Maybe<Array<Scalars["String"]["output"]>>;
  /**
   * The delimiter of the CSV file.
   * You almost never have to set this as it is a "," by default.
   */
  delimiter?: Maybe<Scalars["String"]["output"]>;
  /** Whether the CSV file has a header. */
  skip_header?: Maybe<Scalars["Boolean"]["output"]>;
};

export type S3LiveSyncRequestDefinitionParquet = {
  __typename?: "S3LiveSyncRequestDefinitionParquet";
  /** Automatically map columns by matching header names to table column names. */
  auto_column_mapping?: Maybe<Scalars["Boolean"]["output"]>;
  /** Column mappings from source file columns to destination table columns. */
  column_mappings?: Maybe<Array<ColumnMapping>>;
};

export type S3LiveSyncRuntimeAudit = {
  __typename?: "S3LiveSyncRuntimeAudit";
  /** When this record was created */
  created_at: Scalars["String"]["output"];
  /** End of the billing period. Null if period is currently running */
  period_end?: Maybe<Scalars["String"]["output"]>;
  /** Start of the billing period */
  period_start: Scalars["String"]["output"];
  /** The S3 live sync ID */
  s3_live_sync_id: Scalars["ID"]["output"];
};

export type S3LiveSyncStatistics = {
  __typename?: "S3LiveSyncStatistics";
  /**
   * Count of operations grouped by state.
   * All possible states are included with 0 count if no operations exist in that state.
   */
  state_counts: Array<StateCount>;
  /** The total number of objects that failed to import. */
  total_failed_objects: Scalars["Int"]["output"];
  /** The total number of objects imported successfully. */
  total_objects: Scalars["Int"]["output"];
  /** The total size of the file in bytes imported successfully. */
  total_size_bytes: Scalars["Int"]["output"];
};

export type S3LiveSyncUpdateRequest = {
  bucket?: InputMaybe<S3LiveSyncUpdateRequestBucket>;
  credentials?: InputMaybe<S3LiveSyncUpdateRequestCredentials>;
  definition?: InputMaybe<S3LiveSyncUpdateRequestDefinition>;
  enabled?: InputMaybe<S3LiveSyncUpdateRequestEnabled>;
  frequency?: InputMaybe<S3LiveSyncUpdateRequestFrequency>;
  last_imported_object?: InputMaybe<S3LiveSyncUpdateRequestLastImportedObject>;
  name?: InputMaybe<S3LiveSyncUpdateRequestName>;
  next_tick?: InputMaybe<S3LiveSyncUpdateRequestNextTick>;
  pattern?: InputMaybe<S3LiveSyncUpdateRequestPattern>;
  settings?: InputMaybe<S3LiveSyncUpdateRequestSettings>;
  table_identifier?: InputMaybe<S3LiveSyncUpdateRequestTableIdentifier>;
  type: S3LiveSyncUpdateRequestType;
};

export type S3LiveSyncUpdateRequestBucket = {
  value: Scalars["String"]["input"];
};

export type S3LiveSyncUpdateRequestCredentials = {
  value: S3LiveSyncCredentialsInput;
};

export type S3LiveSyncUpdateRequestDefinition = {
  value: S3LiveSyncDefinitionInput;
};

export type S3LiveSyncUpdateRequestEnabled = {
  value: Scalars["Boolean"]["input"];
};

export type S3LiveSyncUpdateRequestFrequency = {
  value: Scalars["String"]["input"];
};

export type S3LiveSyncUpdateRequestLastImportedObject = {
  value: Scalars["String"]["input"];
};

export type S3LiveSyncUpdateRequestName = {
  value: Scalars["String"]["input"];
};

export type S3LiveSyncUpdateRequestNextTick = {
  value: Scalars["String"]["input"];
};

export type S3LiveSyncUpdateRequestPattern = {
  value: Scalars["String"]["input"];
};

export type S3LiveSyncUpdateRequestSettings = {
  value?: InputMaybe<ImportSettingsInput>;
};

export type S3LiveSyncUpdateRequestTableIdentifier = {
  value: FileImportTableIdentifierInput;
};

export enum S3LiveSyncUpdateRequestType {
  Bucket = "bucket",
  Credentials = "credentials",
  Definition = "definition",
  Enabled = "enabled",
  Frequency = "frequency",
  LastImportedObject = "last_imported_object",
  Name = "name",
  NextTick = "next_tick",
  Pattern = "pattern",
  Settings = "settings",
  TableIdentifier = "table_identifier",
}

export type S3TableDstConnectorDetails = {
  __typename?: "S3TableDstConnectorDetails";
  enabled: Scalars["Boolean"]["output"];
  iamRoleArn: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  s3TableBucketArn: Scalars["String"]["output"];
};

export type S3TableDstSpecInput = {
  iamRoleArn: Scalars["String"]["input"];
  s3TableBucketArn: Scalars["String"]["input"];
};

export type S3TablesBucket = {
  bucketArn: Scalars["String"]["input"];
};

export type S3TablesRole = {
  roleArn: Scalars["String"]["input"];
};

export type SamlEntitlement = {
  __typename?: "SAMLEntitlement";
  enabled: Scalars["Boolean"]["output"];
};

export type SshTunnelConfig = {
  __typename?: "SSHTunnelConfig";
  createdAt: Scalars["Time"]["output"];
  host?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  port?: Maybe<Scalars["Int"]["output"]>;
  projectId: Scalars["String"]["output"];
  publicKey: Scalars["String"]["output"];
  sshTunnelId: Scalars["String"]["output"];
  updatedAt: Scalars["Time"]["output"];
  username?: Maybe<Scalars["String"]["output"]>;
};

/** SAML configuration status for the user's email domain */
export type SamlConfig = {
  __typename?: "SamlConfig";
  /** Whether the user's email domain has a SAML IdP configured */
  enabled: Scalars["Boolean"]["output"];
  /** Whether that SAML config is mandatory */
  mandatory: Scalars["Boolean"]["output"];
};

export type SaslAuthentication = {
  __typename?: "SaslAuthentication";
  accessKey: Scalars["String"]["output"];
  hashAlgorithm: Scalars["String"]["output"];
  secretAccessKey: Scalars["String"]["output"];
};

export type SaslAuthenticationInput = {
  accessKey: Scalars["String"]["input"];
  hashAlgorithm: Scalars["String"]["input"];
  secretAccessKey: Scalars["String"]["input"];
};

export type SchemaColumnInput = {
  name: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

export type SchemaDefinition = {
  __typename?: "SchemaDefinition";
  definition: Scalars["String"]["output"];
  schemaId: Scalars["Int"]["output"];
};

export type SchemaRegistryConfig = {
  __typename?: "SchemaRegistryConfig";
  /**
   * Optional Confluent Cloud schema registry configuration.
   * Example: This field is empty when used in return value of createSchemaRegistryConfig()
   */
  confluentCloud?: Maybe<ConfluentCloudSchemaRegistryConfig>;
  created?: Maybe<Scalars["Time"]["output"]>;
  name: Scalars["String"]["output"];
  projectId: Scalars["String"]["output"];
  schemaRegistryId: Scalars["String"]["output"];
  updated?: Maybe<Scalars["Time"]["output"]>;
};

export type SchemaSpec = {
  schemaId?: InputMaybe<Scalars["String"]["input"]>;
  /** Schema spec can be either a schema ID or a schema definition. */
  schemaRegistryId?: InputMaybe<Scalars["String"]["input"]>;
};

export type Secret = {
  __typename?: "Secret";
  created: Scalars["Time"]["output"];
  metadata: Array<SecretMetadataItem>;
  name: Scalars["String"]["output"];
  projectId: Scalars["ID"]["output"];
  updated?: Maybe<Scalars["Time"]["output"]>;
  value: Scalars["String"]["output"];
};

export type SecretMetadataItem = {
  __typename?: "SecretMetadataItem";
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type SecretMetadataItemInput = {
  key: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
};

/** Service is only a return value */
export type Service = {
  __typename?: "Service";
  autoscaleSettings?: Maybe<AutoscaleSettings>;
  created: Scalars["Time"]["output"];
  dataTieringSettings?: Maybe<DataTieringSettings>;
  /** service endpoints for the service */
  endpoints?: Maybe<ServiceEndpoints>;
  forkedFromId?: Maybe<ForkSpec>;
  id: Scalars["ID"]["output"];
  installedExtensions?: Maybe<Array<PostgresExtension>>;
  iops?: Maybe<Scalars["Int"]["output"]>;
  isReadOnly: Scalars["Boolean"]["output"];
  /** metadata contains service metadata e.g. environment (dev/prod) */
  metadata: ServiceMetadata;
  metrics?: Maybe<ResourceMetrics>;
  name: Scalars["String"]["output"];
  /** primaryOrdinal is the service ordinal that is currently serving as the master/primary in the pool. */
  primaryOrdinal?: Maybe<Scalars["Int"]["output"]>;
  privateLinkConnectionIds: Array<Scalars["ID"]["output"]>;
  /** @deprecated Use privateLinkConnectionIds instead */
  privateLinkEndpointConnectionId?: Maybe<Scalars["ID"]["output"]>;
  projectId: Scalars["ID"]["output"];
  regionCode: Scalars["String"]["output"];
  /** replicaOrdinals are the service ordinal(s) that are serving the replica endpoint pool. */
  replicaOrdinals?: Maybe<Array<Scalars["Int"]["output"]>>;
  /** replicaStatus is the deploy status of the replica endpoint */
  replicaStatus?: Maybe<DeployStatus>;
  resources: Array<Resource>;
  servicePlan: ServicePlan;
  spec: ServiceSpec;
  status: DeployStatus;
  /** standard or enhanced */
  storageType?: Maybe<StorageType>;
  /** syncReplicaOrdinals are the service ordinal(s) that are serving the sync replica endpoint */
  syncReplicaOrdinals?: Maybe<Array<Scalars["Int"]["output"]>>;
  type: Type;
  versions?: Maybe<PostgresAndTimescaleVersions>;
  vpcEndpoint?: Maybe<Endpoint>;
  vpcId?: Maybe<Scalars["ID"]["output"]>;
};

export type ServiceChunkTuningStatus = {
  __typename?: "ServiceChunkTuningStatus";
  /**
   * Whether chunk tuning covers every hypertable on the service, including ones
   * created later, except those turned off individually. False when tuning is
   * off, or on only for hypertables turned on individually; use
   * getChunkTuningStatus for a single hypertable.
   */
  enabled: Scalars["Boolean"]["output"];
};

/** A record of a service's CPU & RAM configuration. */
export type ServiceComputeConfig = {
  __typename?: "ServiceComputeConfig";
  created: Scalars["Time"]["output"];
  memoryGB: Scalars["Int"]["output"];
  milliCPU: Scalars["Int"]["output"];
  milliCPULimit?: Maybe<Scalars["Int"]["output"]>;
};

/** A record of a service's compute & storage configuration history. */
export type ServiceConfigHistory = {
  __typename?: "ServiceConfigHistory";
  /** If a service's storage can be modified (change of IOPS, throughput, volume type or size). */
  ServiceStorageReadyToBeModified: Scalars["Boolean"]["output"];
  compute: Array<ServiceComputeConfig>;
  storage: Array<ServiceStorageConfig>;
};

/** All cost information for a specific billing account for a specific service. */
export type ServiceCostInfo = {
  __typename?: "ServiceCostInfo";
  /**
   * The cost-to-date for the current billing period, minus any trials or credits.
   * @deprecated use costToDateGross
   */
  costToDate?: Maybe<Scalars["Float"]["output"]>;
  /** The cost-to-date for the current billing period. */
  costToDateGross: Scalars["Float"]["output"];
  /** The breakdown on the per-product usage */
  productCostInfos: Array<ProductCostInfo>;
  /** The id of the service we have information for */
  serviceID: Scalars["ID"]["output"];
};

/** Represents the service endpoints */
export type ServiceEndpoints = {
  __typename?: "ServiceEndpoints";
  pooler: EndpointAddress;
  primary: EndpointAddress;
  replica: EndpointAddress;
};

export type ServiceEntitlement = {
  __typename?: "ServiceEntitlement";
  enabled: Scalars["Boolean"]["output"];
  max_bandwidth_mb: Scalars["Int"]["output"];
  max_cpu: Scalars["Int"]["output"];
  max_cpu_milli: Scalars["Int"]["output"];
  max_fixed_instances: Scalars["Int"]["output"];
  max_instances: Scalars["Int"]["output"];
  max_iops: Scalars["Int"]["output"];
  max_memory: Scalars["Int"]["output"];
  max_memory_gb: Scalars["Int"]["output"];
  max_storage_gb: Scalars["Int"]["output"];
  min_bandwidth_mb: Scalars["Int"]["output"];
  min_iops: Scalars["Int"]["output"];
  unlimited: Scalars["Boolean"]["output"];
};

export enum ServiceEnvironment {
  Dev = "DEV",
  Prod = "PROD",
}

export type ServiceLog = {
  __typename?: "ServiceLog";
  /** Structured (JSON log) fields requested through items(fields), sorted by key. Empty if none. */
  fields: Array<ServiceLogFieldValue>;
  /** Log line text. */
  message: Scalars["String"]["output"];
  /** Severity level as returned by Elasticsearch (e.g. ERROR, WARNING, LOG, FATAL, DETAIL). */
  severity: Scalars["String"]["output"];
  timestamp: Scalars["Time"]["output"];
};

/** A filter on one log field. */
export type ServiceLogFieldFilter = {
  /** Field name (e.g. user, state_code, query_id). */
  key: Scalars["String"]["input"];
  /** Value to match, as a string. */
  value: Scalars["String"]["input"];
};

export type ServiceLogFieldValue = {
  __typename?: "ServiceLogFieldValue";
  /** JSON log field name (e.g. user, application_name, state_code). */
  key: Scalars["String"]["output"];
  /** Field value rendered as a string. */
  value: Scalars["String"]["output"];
};

export type ServiceLogs = {
  __typename?: "ServiceLogs";
  aggregates: ServiceLogsAggregates;
  /**
   * Cursor-paginated log entries in reverse chronological order.
   * Pass pageInfo.lastCursor from a prior response as cursor to load the next page.
   * limit is required and capped at 1000. fields selects the structured (JSON log)
   * fields to return on each entry, by name; omit it to get none.
   */
  items: ServiceLogsItems;
};

export type ServiceLogsItemsArgs = {
  cursor?: InputMaybe<Scalars["ID"]["input"]>;
  fields?: InputMaybe<Array<Scalars["String"]["input"]>>;
  limit: Scalars["Int"]["input"];
};

export type ServiceLogsAggregates = {
  __typename?: "ServiceLogsAggregates";
  /**
   * Returns total per-severity counts and time-bucketed data points for the log
   * search window. bucketInterval is the width of each time bucket in seconds;
   * defaults to 86400 (1 day) when omitted.
   */
  countsBySeverity: ServiceLogsSeverityAggregates;
};

export type ServiceLogsAggregatesCountsBySeverityArgs = {
  bucketIntervalSeconds?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Shared filter parameters for log queries. */
export type ServiceLogsFilters = {
  /**
   * Upper bound timestamp for the log search window (closest to now).
   * Results are returned in descending order starting here.
   */
  endTime?: InputMaybe<Scalars["Time"]["input"]>;
  /**
   * Filters on log fields; all must match. Most fields match exactly; the text
   * fields (message, detail, hint, context, statement, internal_query) match the
   * value as a phrase. Services whose log entries have no fields return an error.
   */
  fieldFilters?: InputMaybe<Array<ServiceLogFieldFilter>>;
  role?: InputMaybe<InstanceRole>;
  searchTags?: InputMaybe<Array<Scalars["String"]["input"]>>;
  serviceOrdinal?: InputMaybe<Scalars["Int"]["input"]>;
  /** Filter results to only the listed severity levels (e.g. "ERROR", "WARNING"). Empty means no filter. */
  severities?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Lower bound timestamp for the log search window. */
  startTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type ServiceLogsItem = {
  __typename?: "ServiceLogsItem";
  /** Opaque pagination cursor for this log entry. */
  cursor: Scalars["ID"]["output"];
  item: ServiceLog;
};

export type ServiceLogsItems = {
  __typename?: "ServiceLogsItems";
  items: Array<ServiceLogsItem>;
  pageInfo: ServiceLogsPageInfo;
};

export type ServiceLogsPageInfo = {
  __typename?: "ServiceLogsPageInfo";
  /** True when older log entries exist beyond this page. */
  hasNextPage: Scalars["Boolean"]["output"];
  /** Cursor of the last item on this page. Pass as cursor on the next items() call. */
  lastCursor?: Maybe<Scalars["ID"]["output"]>;
};

export type ServiceLogsSeverityAggregates = {
  __typename?: "ServiceLogsSeverityAggregates";
  /** Per-severity counts broken down by time bucket. Empty buckets are omitted. */
  dataPoints: Array<ServiceLogsSeverityDataPoint>;
  /** Total count per severity level across the full filter window, for legend display. */
  totals: Array<ServiceLogsSeverityCount>;
};

export type ServiceLogsSeverityCount = {
  __typename?: "ServiceLogsSeverityCount";
  count: Scalars["Int"]["output"];
  severity: Scalars["String"]["output"];
};

export type ServiceLogsSeverityDataPoint = {
  __typename?: "ServiceLogsSeverityDataPoint";
  bucket: Scalars["Time"]["output"];
  counts: Array<ServiceLogsSeverityCount>;
};

export type ServiceMetadata = {
  __typename?: "ServiceMetadata";
  environment: ServiceEnvironment;
  isAI: Scalars["Boolean"]["output"];
};

export type ServiceMetrics = {
  __typename?: "ServiceMetrics";
  compute: Array<Maybe<ComputeMetricsWindow>>;
  diskPerformance: Array<Maybe<DiskPerformanceMetricsWindow>>;
  events: Array<Maybe<MetricsEvent>>;
  /** Returns the list of available metric names. */
  getAvailableMetrics: Array<Scalars["String"]["output"]>;
  /**
   * Returns descriptive details about a named metric: what it measures, its
   * type, default aggregation, and its labels — the ones specific to the metric
   * plus the region/role/ordinal labels the pipeline adds (pgbouncer metrics
   * only carry region). Errors, same as getSeries, if name doesn't exist or is
   * hidden in this environment — use getAvailableMetrics to discover valid names.
   */
  getMetricDetails: MetricDetails;
  /**
   * Returns time-series data for a named metric over the parent's time window,
   * as one MetricSeries per group.
   *
   * For metrics served by the Metrics Store (every name from getAvailableMetrics
   * except the `timescale_cloud_system_*` resource metrics), filters are label
   * matchers on any label of the metric (see getMetricDetails), ANDed together,
   * with matchType EQUAL or NOT_EQUAL. A "role" filter (case-insensitive:
   * PRIMARY or REPLICA) or the parent input's role restricts the role; without
   * either, all roles are returned. Without groupBy, all matching label sets
   * collapse into a single series.
   *
   * The `timescale_cloud_system_*` resource metrics come from the legacy
   * resource pipeline instead: data is grouped by (ordinal, role), only the
   * "role" filter is interpreted (other keys are silently ignored), role
   * defaults to PRIMARY, and fn and groupBy are rejected — see MetricAggFn.
   *
   * fn selects the per-bucket aggregation function — see MetricAggFn for the
   * metrics that do not accept it. Omit to use the metric's default aggregation
   * (defaultAgg in getMetricDetails), which is LAST when none is declared.
   *
   * groupBy lists label keys to break the result into one series per distinct
   * value combination; omit (or pass empty) to collapse all matching label
   * sets into a single series. Rejected with `INVALID_REQUEST` on the same
   * metrics that reject fn — see MetricAggFn.
   *
   * Bucket width comes from the parent ServiceMetrics input (bucketSeconds).
   */
  getSeries: Array<MetricSeries>;
  queriesPerSecond: Array<Maybe<QpsMetricsWindow>>;
  storage: Array<Maybe<StorageMetricsWindow>>;
};

export type ServiceMetricsGetMetricDetailsArgs = {
  name: Scalars["String"]["input"];
};

export type ServiceMetricsGetSeriesArgs = {
  filters?: InputMaybe<Array<MetricLabelFilter>>;
  fn?: InputMaybe<MetricAggFn>;
  groupBy?: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: Scalars["String"]["input"];
};

export type ServiceNextMaintenance = {
  __typename?: "ServiceNextMaintenance";
  maintenance: NextMaintenance;
  serviceId: Scalars["ID"]["output"];
};

export enum ServicePlan {
  Fluid = "FLUID",
  Free = "FREE",
  Ghost = "GHOST",
  Paid = "PAID",
  Unknown = "UNKNOWN",
}

export type ServiceSpec = TimescaleDbServiceSpec;

/** A record of a service's storage configuration. */
export type ServiceStorageConfig = {
  __typename?: "ServiceStorageConfig";
  bandwidthMBs: Scalars["Int"]["output"];
  created: Scalars["Time"]["output"];
  iops: Scalars["Int"]["output"];
  storageGB: Scalars["Int"]["output"];
  volumeType: Scalars["String"]["output"];
};

export type ServiceStorageThresholdEvent = {
  __typename?: "ServiceStorageThresholdEvent";
  createdAt: Scalars["Time"]["output"];
  expiresAt: Scalars["Time"]["output"];
  projectId: Scalars["ID"]["output"];
  serviceId: Scalars["ID"]["output"];
  storageThresholdPct: Scalars["Float"]["output"];
  storageUsedPct: Scalars["Float"]["output"];
};

export type SetBackupsRetentionInput = {
  projectId: Scalars["ID"]["input"];
  retCount: Scalars["Int"]["input"];
  retType: Scalars["String"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type SetCompressionHypertableInput = {
  config: CompressionConfig;
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
  tableName: Scalars["ID"]["input"];
  tableSchema: Scalars["ID"]["input"];
};

export type SetCompressionInput = {
  config: CompressionConfig;
  contAggName?: InputMaybe<Scalars["ID"]["input"]>;
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  schema: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  tableName?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SetHypertableConfInput = {
  chunkSizeIntervalDuration?: InputMaybe<Scalars["String"]["input"]>;
  projectId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  schema: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  tableName: Scalars["ID"]["input"];
};

export type SetMaintenanceWindowInput = {
  /** How long we're allowed to run maintenance */
  durationInSeconds: Scalars["Int"]["input"];
  /** ProjectID that the service. */
  projectId: Scalars["ID"]["input"];
  /** Service ID of the service. */
  serviceId: Scalars["ID"]["input"];
  /** Time to run maintenance, we'll run maintenance every week at the day/time defined */
  start: Scalars["Time"]["input"];
};

export type SetNumericParameter = {
  /** Parameter to update. */
  name: Scalars["String"]["input"];
  /** Unit of the value. */
  unit: ParameterUnit;
  /** Updated value for the parameter. */
  value: Scalars["Float"]["input"];
};

/** Set postgres numeric parameters for an instance. */
export type SetPostgresParametersInput = {
  /** Numeric parameters to configure. */
  numericParameters?: InputMaybe<Array<SetNumericParameter>>;
  /** ProjectID that the service belongs to. */
  projectId: Scalars["ID"]["input"];
  /** Service ID of the service in question. */
  serviceId: Scalars["ID"]["input"];
  /** String parameters to configure. */
  stringParameters?: InputMaybe<Array<SetStringParameter>>;
};

export type SetPrimaryPaymentMethodInput = {
  billingAccountId: Scalars["ID"]["input"];
  paymentMethodId: Scalars["ID"]["input"];
};

/** Sets the replica count for a single node instance */
export type SetReplicaCountInput = {
  allReplicasAreSync?: InputMaybe<Scalars["Boolean"]["input"]>;
  projectId: Scalars["ID"]["input"];
  replicaCount: Scalars["Int"]["input"];
  serviceId: Scalars["ID"]["input"];
  synchronousReplicaCount?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SetServiceEnvironmentTagInput = {
  /** The env value to tag the DB instance with */
  environment: ServiceEnvironment;
  /** ProjectID that the service belongs to. */
  projectId: Scalars["ID"]["input"];
  /** Service ID of the service. */
  serviceId: Scalars["ID"]["input"];
};

export type SetStringParameter = {
  /** Parameter to update. */
  name: Scalars["String"]["input"];
  /** Updated value for the parameter. */
  value: Scalars["String"]["input"];
};

export type SetVirtualPlanForProjectRequest = {
  projectId: Scalars["ID"]["input"];
  trialPackage?: InputMaybe<TrialPackage>;
  virtualPlanKind: VirtualPlanType;
};

export type SingleRecommendationInput = {
  projectId: Scalars["ID"]["input"];
  recommendationId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type SkipFileImportInput = {
  id: Scalars["ID"]["input"];
  project_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
};

export type SpaceDimension = {
  __typename?: "SpaceDimension";
  columnName: Scalars["String"]["output"];
  numPartitions: Scalars["Int"]["output"];
};

export type SpecIcebergInput = {
  /** ARN of the IAM role which federates access for this service to send data to the corresponding S3Table bucket */
  iamRoleArn: Scalars["String"]["input"];
  /** ARN of the S3Table bucket in the caller's AWS account */
  s3TableBucketArn: Scalars["String"]["input"];
};

export type StateCount = {
  __typename?: "StateCount";
  /** The count of operations in this state */
  count: Scalars["Int"]["output"];
  /** The state name (e.g., SUCCESS, FAILURE, IN_QUEUE, etc.) */
  state: Scalars["String"]["output"];
};

export enum Status {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

/** A measurement of the average storage used by an instance during a metrics bucket. */
export type StorageMetricsDataPoint = {
  __typename?: "StorageMetricsDataPoint";
  storageMiB: Scalars["Int"]["output"];
  time: Scalars["Time"]["output"];
};

/** A window of time in which an instance's role was constant, and it's storage usage during that window. */
export type StorageMetricsWindow = {
  __typename?: "StorageMetricsWindow";
  data: Array<StorageMetricsDataPoint>;
  ordinal: Scalars["Int"]["output"];
  role: InstanceRole;
};

export enum StorageState {
  Applied = "APPLIED",
  InitialApplied = "INITIAL_APPLIED",
  Pending = "PENDING",
  Queued = "QUEUED",
  Unknown = "UNKNOWN",
}

export enum StorageType {
  Enhanced = "ENHANCED",
  Standard = "STANDARD",
  Unknown = "UNKNOWN",
}

export type StringParameter = {
  __typename?: "StringParameter";
  allowed_values: Array<Scalars["String"]["output"]>;
  current_value: Scalars["String"]["output"];
  info: ParameterInfo;
};

/** Sub-category of a BILLING case. Only meaningful when caseType=BILLING; drives the derived Salesforce Type. */
export enum SupportBillingCategory {
  /** Account management requests (plan, ownership, account details). */
  AccountManagement = "ACCOUNT_MANAGEMENT",
  /** Questions about invoices, payments, or charges. */
  InvoicesAndPayment = "INVOICES_AND_PAYMENT",
}

export type SupportCase = {
  __typename?: "SupportCase";
  /** Human-readable case number. */
  caseNumber: Scalars["String"]["output"];
  /** When the case was created. */
  createdDate: Scalars["Time"]["output"];
  /**
   * Deprecated. Always null — the case body is now the first entry in `messages`. Retained temporarily so pre-rollout frontend queries keep parsing; remove in a follow-up once the frontend stops selecting it.
   * @deprecated Read the first entry of `messages` instead.
   */
  description?: Maybe<Scalars["String"]["output"]>;
  /** Salesforce Case ID. */
  id: Scalars["ID"]["output"];
  /** Impact description from the Salesforce picklist. */
  impact?: Maybe<Scalars["String"]["output"]>;
  /** Whether the case is closed. */
  isClosed: Scalars["Boolean"]["output"];
  /** Whether production services are affected. */
  isProduction?: Maybe<Scalars["Boolean"]["output"]>;
  /** Email thread messages, oldest first. The first message carries the case body. */
  messages: Array<SupportCaseMessage>;
  /** Subject line of the case. */
  subject: Scalars["String"]["output"];
  /** The email address of the case submitter. */
  suppliedEmail?: Maybe<Scalars["String"]["output"]>;
};

export type SupportCaseAttachment = {
  __typename?: "SupportCaseAttachment";
  /** Salesforce ContentDocument ID. Populated for attachments returned by getSupportCases; left empty on freshly-uploaded attachments in mutation responses since the upload path does not resolve it. */
  contentDocumentId: Scalars["String"]["output"];
  /** File size in bytes. */
  contentSize: Scalars["Int"]["output"];
  /** File extension (e.g. png, csv). */
  fileExtension?: Maybe<Scalars["String"]["output"]>;
  /** File title. */
  title: Scalars["String"]["output"];
  /** URL to fetch the attachment binary via the proxy endpoint. */
  url: Scalars["String"]["output"];
};

export type SupportCaseMessage = {
  __typename?: "SupportCaseMessage";
  /** File attachments and inline images. Deduplicated across messages — each file appears only on the first message that references it. */
  attachments: Array<SupportCaseAttachment>;
  /** Sender display name. */
  fromName?: Maybe<Scalars["String"]["output"]>;
  /**
   * Sanitized HTML version of the message body, scoped for a chat-style UI.
   * Only populated on outbound messages (incoming=false); inbound replies
   * expose textBody only because client-side quote markers can't be stripped
   * reliably. The allowlist covers links (with rel/target safety attributes),
   * lists, paragraphs, basic emphasis, and code blocks. Inline images,
   * styles, colors, fonts, classes, scripts, and frames are stripped —
   * inline images are surfaced through `attachments` instead. Null when
   * the source had no HTML part or sanitization reduced it to nothing;
   * fall back to textBody in that case.
   */
  htmlBody?: Maybe<Scalars["String"]["output"]>;
  /** Whether this is an inbound message (from customer) or outbound (from support). */
  incoming: Scalars["Boolean"]["output"];
  /** When the message was sent. */
  messageDate: Scalars["Time"]["output"];
  /** Message body as plain text. Always present when the source message had content; use as the fallback when htmlBody is null. */
  textBody?: Maybe<Scalars["String"]["output"]>;
};

/** High-level category the user picked in the structured intake flow. Drives validation and the derived Salesforce Type/Impact. */
export enum SupportCaseType {
  Billing = "BILLING",
  TechnicalAdvice = "TECHNICAL_ADVICE",
  TechnicalIssue = "TECHNICAL_ISSUE",
}

export type SupportEmailInput = {
  /** Email destinations. If empty, uses `support@tigerdata.com`. */
  destinations?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** User's email. */
  email: Scalars["String"]["input"];
  /** Message as supplied by the user. */
  formBody: Scalars["String"]["input"];
  /** User's name. */
  name: Scalars["String"]["input"];
  /** Project ID that the service belongs to. */
  projectId: Scalars["ID"]["input"];
  /** Service ID of the service in question. */
  serviceId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Subject as supplied by the user. */
  subject: Scalars["String"]["input"];
  /** User's ID. */
  userId: Scalars["ID"]["input"];
};

export type SupportEntitlement = {
  __typename?: "SupportEntitlement";
  email_support: Scalars["Boolean"]["output"];
  production_support: Scalars["Boolean"]["output"];
  solution_architect_support: Scalars["Boolean"]["output"];
};

/** User's report of how much of the service still works. Only meaningful for TECHNICAL_ISSUE cases where stillHappening != NO. */
export enum SupportServiceCapability {
  Fine = "FINE",
  None = "NONE",
  Partial = "PARTIAL",
}

/** Service related information useful for support */
export type SupportServiceInfoInput = {
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

/** User's answer to 'is this still happening?'. Only meaningful for TECHNICAL_ISSUE cases. */
export enum SupportStillHappening {
  Intermittent = "INTERMITTENT",
  No = "NO",
  Yes = "YES",
}

export type SupportTicketInput = {
  /** Optional file attachments (max 10, 25 MiB each). */
  attachments?: InputMaybe<Array<Scalars["Upload"]["input"]>>;
  /** Billing sub-category. Optional for backward compatibility: when unset on a BILLING case, the case is filed as a generic Billing case. Ignored for other case types. */
  billingCategory?: InputMaybe<SupportBillingCategory>;
  /** Structured case category. When set, switches the mutation to the new validation + derivation flow. When unset, legacy isProduction+impact behavior applies. */
  caseType?: InputMaybe<SupportCaseType>;
  /** Message as supplied by the user. */
  description: Scalars["String"]["input"];
  /** User's email. */
  email: Scalars["String"]["input"];
  /** Impact one-liner description. Required for legacy clients; derived server-side when caseType is set. */
  impact?: InputMaybe<Scalars["String"]["input"]>;
  /** Production service(s) are affected. Required for legacy clients and for new-flow TECHNICAL_ISSUE cases; ignored for BILLING/TECHNICAL_ADVICE. */
  isProduction?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** User's name. */
  name: Scalars["String"]["input"];
  /** Project ID that the ticket relates to. */
  projectId: Scalars["ID"]["input"];
  /** How much of the service is currently working. Required when caseType=TECHNICAL_ISSUE and stillHappening != NO. */
  reportedServiceCapability?: InputMaybe<SupportServiceCapability>;
  /** Any services relates to. */
  services?: InputMaybe<Array<SupportServiceInfoInput>>;
  /** Whether the issue is still occurring. Required when caseType=TECHNICAL_ISSUE. */
  stillHappening?: InputMaybe<SupportStillHappening>;
  /** Subject as supplied by the user. */
  subject: Scalars["String"]["input"];
  /** User's ID. */
  userId: Scalars["ID"]["input"];
};

export type SyncPrivateLinkConnectionsInput = {
  projectId: Scalars["ID"]["input"];
};

export type Table = {
  __typename?: "Table";
  chunks: Array<Chunk>;
  contAggs: Array<ContAgg>;
  foreignKeys: Array<ForeignKey>;
  hyperMetadata?: Maybe<HyperMetadata>;
  indexes: Array<Index>;
  metadata: TableMetadata;
  policies: Array<Policy>;
  schema: Array<Column>;
};

/** TableID represents an identifier for a table in a user's TimescaleDB instance. */
export type TableId = {
  __typename?: "TableID";
  isHypertable: Scalars["Boolean"]["output"];
  name: Scalars["ID"]["output"];
  schema: Scalars["ID"]["output"];
};

export type TableIdentifier = {
  __typename?: "TableIdentifier";
  schema_name?: Maybe<Scalars["String"]["output"]>;
  table_name: Scalars["String"]["output"];
};

export type TableMetadata = {
  __typename?: "TableMetadata";
  approxRowCount: Scalars["Int"]["output"];
  id: TableId;
  owner: Scalars["String"]["output"];
  size: Scalars["Int"]["output"];
};

/** Deprecated: Use ConnectorTableSpecInput instead. */
export type TargetTableSpec = {
  primaryDimensionChunkInterval?: InputMaybe<Scalars["String"]["input"]>;
  primaryDimensionColumnName?: InputMaybe<Scalars["String"]["input"]>;
  tableName: Scalars["String"]["input"];
  tableSchema: Scalars["String"]["input"];
};

export type TierWithProducts = {
  __typename?: "TierWithProducts";
  id: Scalars["ID"]["output"];
  products: Array<Product>;
};

export type TieredStorageEntitlement = {
  __typename?: "TieredStorageEntitlement";
  enabled: Scalars["Boolean"]["output"];
};

export type TieringUsage = {
  __typename?: "TieringUsage";
  serviceIds?: Maybe<Array<Scalars["ID"]["output"]>>;
  tieredBytes: Scalars["Int"]["output"];
};

export type TigerLakeEntitlement = {
  __typename?: "TigerLakeEntitlement";
  enabled: Scalars["Boolean"]["output"];
};

export type TimeDimension = {
  __typename?: "TimeDimension";
  columnName: Scalars["String"]["output"];
  integerInterval?: Maybe<Scalars["Int"]["output"]>;
  timeInterval?: Maybe<Scalars["String"]["output"]>;
};

export type TimescaleDbServiceSpec = {
  __typename?: "TimescaleDBServiceSpec";
  IOBoostEnabled: Scalars["Boolean"]["output"];
  connectionPoolerEnabled: Scalars["Boolean"]["output"];
  defaultDBName: Scalars["String"]["output"];
  exporterID?: Maybe<Scalars["ID"]["output"]>;
  exporterSidecarEnabled: Scalars["Boolean"]["output"];
  genericExporterID?: Maybe<Scalars["ID"]["output"]>;
  /** @deprecated service.Endpoints contains this field */
  hostname: Scalars["String"]["output"];
  isFixed: Scalars["Boolean"]["output"];
  metricExporterUuid?: Maybe<Scalars["ID"]["output"]>;
  /** @deprecated service.Endpoints contains this field */
  poolerHostName?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated service.Endpoints contains this field */
  poolerPort?: Maybe<Scalars["Int"]["output"]>;
  popSQLIntegrationEnabled: Scalars["Boolean"]["output"];
  /** @deprecated service.Endpoints contains this field */
  port: Scalars["Int"]["output"];
  /** @deprecated service.Endpoints contains this field */
  replicaHostName?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated service.Endpoints contains this field */
  replicaPort?: Maybe<Scalars["Int"]["output"]>;
  status: Status;
  username: Scalars["String"]["output"];
};

export type ToggleConnectionPoolerInput = {
  /** Enable or disable connection pooler. */
  enable: Scalars["Boolean"]["input"];
  /** ProjectID that the service belongs to. */
  projectId: Scalars["ID"]["input"];
  /** Service ID of the service. */
  serviceId: Scalars["ID"]["input"];
};

export type ToggleCrossRegionBackupsInput = {
  projectId: Scalars["ID"]["input"];
  regions: Array<Scalars["String"]["input"]>;
  serviceId: Scalars["ID"]["input"];
};

export type ToggleCrossRegionBackupsV2Input = {
  enable: Scalars["Boolean"]["input"];
  projectID: Scalars["ID"]["input"];
  region: Scalars["String"]["input"];
  serviceID: Scalars["ID"]["input"];
};

export type ToggleDataTieringInput = {
  /** Enable or disable data tiering. */
  enable: Scalars["Boolean"]["input"];
  /** ProjectID that the service belongs to. */
  projectId: Scalars["ID"]["input"];
  /** Service ID of the service. */
  serviceId: Scalars["ID"]["input"];
};

export type ToggleIoBoostInput = {
  /** Enable or disable IOBoost. */
  enable: Scalars["Boolean"]["input"];
  /** ProjectID that the service belongs to. */
  projectId: Scalars["ID"]["input"];
  /** Service ID of the service. */
  serviceId: Scalars["ID"]["input"];
  /** standard or enhanced */
  storageType?: InputMaybe<StorageType>;
};

export type TogglePopSqlIntegrationInput = {
  /** Enable or disable PopSQL integration. */
  enable: Scalars["Boolean"]["input"];
  /** ProjectID that the service belongs to. */
  projectId: Scalars["ID"]["input"];
  /** Service ID of the service. */
  serviceId: Scalars["ID"]["input"];
};

export type ToggleServiceInput = {
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  status: Status;
};

export type TopicDetails = {
  __typename?: "TopicDetails";
  fields: Array<FieldInfo>;
  schemaDefinition: SchemaDefinition;
  schemaFormat: Scalars["String"]["output"];
  topicName: Scalars["String"]["output"];
};

export type TransferOwnershipInput = {
  mfaCode: Scalars["String"]["input"];
  newOwnerUserId: Scalars["ID"]["input"];
  organizationId: Scalars["ID"]["input"];
  password: Scalars["String"]["input"];
};

export type TransferOwnershipResponse = {
  __typename?: "TransferOwnershipResponse";
  success: Scalars["Boolean"]["output"];
};

export type TransferProjectOwnershipInput = {
  mfaCode: Scalars["String"]["input"];
  newOwnerId: Scalars["ID"]["input"];
  password: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
};

export type TransitGatewayEntitlement = {
  __typename?: "TransitGatewayEntitlement";
  enabled: Scalars["Boolean"]["output"];
};

export enum TrialPackage {
  Trial_30Days_500Credits = "TRIAL_30_DAYS_500_CREDITS",
  Trial_30Days_1000Credits = "TRIAL_30_DAYS_1000_CREDITS",
  TrialUnspecified = "TRIAL_UNSPECIFIED",
}

export enum TrialStatus {
  Current = "CURRENT",
  Unknown = "UNKNOWN",
  Unused = "UNUSED",
  Used = "USED",
}

export enum TrialType {
  Duration = "DURATION",
  Unknown = "UNKNOWN",
  Usage = "USAGE",
}

export type TrialUsage = {
  __typename?: "TrialUsage";
  endDate?: Maybe<Scalars["Time"]["output"]>;
  remainingUSD?: Maybe<Scalars["Float"]["output"]>;
};

export enum Type {
  Branch = "BRANCH",
  /** @deprecated Grafana service type is deprecated and will be removed in future releases */
  Grafana = "GRAFANA",
  Postgres = "POSTGRES",
  Timescaledb = "TIMESCALEDB",
  /** @deprecated Vector service type is deprecated and will be removed in future releases */
  Vector = "VECTOR",
}

export type TypeFileImportHttpSource = {
  __typename?: "TypeFileImportHTTPSource";
  url: Scalars["String"]["output"];
};

export type TypeFileImportInternalSource = {
  __typename?: "TypeFileImportInternalSource";
  id: Scalars["String"]["output"];
};

/** Has Type prefix because of conflict with previous input FileImportS3Source */
export type TypeFileImportS3Source = {
  __typename?: "TypeFileImportS3Source";
  bucket: Scalars["String"]["output"];
  /**
   * The id of the file import.
   * This field is not used and will be removed in the future.
   */
  id?: Maybe<Scalars["String"]["output"]>;
  key: Scalars["String"]["output"];
  role_arn?: Maybe<Scalars["String"]["output"]>;
};

/** Has Type prefix because of conflict with previous input FileImportSource */
export type TypeFileImportSource = {
  __typename?: "TypeFileImportSource";
  http?: Maybe<TypeFileImportHttpSource>;
  internal?: Maybe<TypeFileImportInternalSource>;
  s3?: Maybe<TypeFileImportS3Source>;
  type: FileImportSourceType;
};

export type UiStateResource = {
  __typename?: "UIStateResource";
  contents: Scalars["String"]["output"];
  version: Scalars["Int"]["output"];
};

export type UnskipFileImportInput = {
  id: Scalars["ID"]["input"];
  project_id: Scalars["ID"]["input"];
  service_id: Scalars["ID"]["input"];
};

export type UpdateAdditionalHeadersInput = {
  headers?: InputMaybe<Scalars["KeyValuePairs"]["input"]>;
};

export type UpdateCatalogRestInput = {
  /** Omitted = unchanged. Present with empty/omitted headers removes all stored headers. Present with headers replaces the full set. */
  additionalHeaders?: InputMaybe<UpdateAdditionalHeadersInput>;
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  /** Write-only. Omitted keeps the existing stored secret; set to rotate to a new value. */
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  /** Explicit OAuth2 token endpoint. When omitted, derived as <uri>/v1/oauth/tokens. */
  oauth2ServerUri?: InputMaybe<Scalars["String"]["input"]>;
  scope?: InputMaybe<Scalars["String"]["input"]>;
  vendedCredentials?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateCatalogS3TablesInput = {
  /** New IAM role ARN. Omitted leaves it unchanged. */
  iamRoleArn?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateConnectorDisplayNameInput = {
  value: Scalars["String"]["input"];
};

export type UpdateConnectorEnabledInput = {
  value: Scalars["Boolean"]["input"];
};

export type UpdateConnectorInput = {
  connectorId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  requests: Array<UpdateConnectorRequestInput>;
  serviceId: Scalars["String"]["input"];
};

export type UpdateConnectorPgSrcInput = {
  addTables?: InputMaybe<Array<ConnectorTableSpecInput>>;
  dropTables?: InputMaybe<Array<ConnectorTableIdentifierInput>>;
  publicationName?: InputMaybe<Scalars["String"]["input"]>;
  sourceConfigId?: InputMaybe<Scalars["String"]["input"]>;
  tableSyncWorkers?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdateConnectorRequestInput = {
  displayName?: InputMaybe<UpdateConnectorDisplayNameInput>;
  enabled?: InputMaybe<UpdateConnectorEnabledInput>;
  pgsrc?: InputMaybe<UpdateConnectorPgSrcInput>;
  type: Scalars["String"]["input"];
};

export type UpdateConnectorResponse = {
  __typename?: "UpdateConnectorResponse";
  connector: ConnectorDetails;
};

export type UpdateConnectorV2Input = {
  connectorId: Scalars["String"]["input"];
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  icebergdst?: InputMaybe<UpdateIcebergDstSpecInput>;
  pgsrc?: InputMaybe<UpdatePgSrcSpecInput>;
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

export type UpdateConnectorV2Response = {
  __typename?: "UpdateConnectorV2Response";
  connector: ConnectorDetails;
};

export type UpdateFileImportInput = {
  id: Scalars["ID"]["input"];
  project_id: Scalars["ID"]["input"];
  requests: Array<UpdateFileImportRequests>;
  service_id: Scalars["ID"]["input"];
};

export type UpdateFileImportRequestCancel = {
  reason: Scalars["String"]["input"];
};

export type UpdateFileImportRequestLabels = {
  labels: Array<FileImportLabelInput>;
};

export enum UpdateFileImportRequestType {
  Cancel = "cancel",
  Labels = "labels",
  Retry = "retry",
}

export type UpdateFileImportRequests = {
  cancel?: InputMaybe<UpdateFileImportRequestCancel>;
  labels?: InputMaybe<UpdateFileImportRequestLabels>;
  type: UpdateFileImportRequestType;
};

export type UpdateFileImportResponse = {
  __typename?: "UpdateFileImportResponse";
  error?: Maybe<Scalars["String"]["output"]>;
};

export type UpdateGenericExporterInput = {
  config: GenericExporterConfigInput;
  exporterId: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
};

/**
 * Patch spec for an Iceberg destination connector. Set exactly one catalog block, matching the
 * connector's stored catalog type. Catalog identity (S3 bucketArn; REST uri/warehouse) and the
 * catalog type are immutable and are intentionally absent.
 */
export type UpdateIcebergDstSpecInput = {
  catalogRest?: InputMaybe<UpdateCatalogRestInput>;
  catalogS3Tables?: InputMaybe<UpdateCatalogS3TablesInput>;
};

export type UpdateMetricExporterInput = {
  config: MetricExporterConfigInput;
  enablePgMetrics?: InputMaybe<Scalars["Boolean"]["input"]>;
  exporterId?: InputMaybe<Scalars["ID"]["input"]>;
  exporterUuid?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
};

export type UpdateOrganizationNameInput = {
  name: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
};

export type UpdateOrganizationNameResponse = {
  __typename?: "UpdateOrganizationNameResponse";
  new_name: Scalars["String"]["output"];
};

/** The input type for updating the peering connection's CIDRs. */
export type UpdatePeeringConnectionCidRsInput = {
  /** The new list of CIDR blocks of the peer VPC/TGW. The list can not be empty. */
  cidrBlocks: Array<Scalars["String"]["input"]>;
  /** The internal table ID of the VPC row. */
  forgeVpcId: Scalars["ID"]["input"];
  /** The ID of the peering connection. */
  id: Scalars["ID"]["input"];
  /** The project ID the VPC is associated with. */
  projectId: Scalars["ID"]["input"];
};

export type UpdatePgSrcConfigInput = {
  connectionString?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectId: Scalars["String"]["input"];
  sourceId: Scalars["String"]["input"];
  sshTunnelId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePgSrcConfigResponse = {
  __typename?: "UpdatePgSrcConfigResponse";
  sourceConfig: PgSrcConfig;
};

export type UpdatePgSrcSpecInput = {
  addTables?: InputMaybe<Array<ConnectorTableSpecInput>>;
  dropTables?: InputMaybe<Array<ConnectorTableIdentifierInput>>;
  sourceConfigId?: InputMaybe<Scalars["String"]["input"]>;
  tableSyncWorkers?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UpdatePrivateLinkConnectionInput = {
  connectionId: Scalars["ID"]["input"];
  ipAddress?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  projectId: Scalars["ID"]["input"];
};

export type UpdateProjectSecretInput = {
  metadata?: InputMaybe<Array<SecretMetadataItemInput>>;
  name: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
  value: Scalars["String"]["input"];
};

export type UpdateS3LiveSyncInput = {
  id: Scalars["ID"]["input"];
  project_id: Scalars["ID"]["input"];
  /**
   * The requests to update the live sync.
   * All operations will be executed in the order they are provided.
   * If one operation fails, all the operations will be rolled back.
   */
  requests: Array<S3LiveSyncUpdateRequest>;
  service_id: Scalars["ID"]["input"];
};

export type UpdateSshTunnelConfigInput = {
  host?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  port?: InputMaybe<Scalars["Int"]["input"]>;
  projectId: Scalars["String"]["input"];
  sshTunnelId: Scalars["String"]["input"];
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateSshTunnelConfigResponse = {
  __typename?: "UpdateSSHTunnelConfigResponse";
  sshTunnelConfig: SshTunnelConfig;
};

export type UpdateTaxIdInput = {
  billingAccountId: Scalars["ID"]["input"];
  country: Scalars["String"]["input"];
  taxType?: InputMaybe<Scalars["String"]["input"]>;
  value: Scalars["String"]["input"];
};

export type UpdateUiStateInput = {
  contents: Scalars["String"]["input"];
  key: Scalars["ID"]["input"];
  owner?: InputMaybe<OwnerInput>;
  version: Scalars["Int"]["input"];
};

export type UpdateUserInput = {
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  uiState?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateUserRoleInput = {
  projectId: Scalars["String"]["input"];
  role: RbacRole;
  userId: Scalars["ID"]["input"];
};

/** Initiate a major PostgreSQL Upgrade */
export type UpgradePostgresMajorVersionInput = {
  /** The major version to upgrade PostgreSQL to. */
  postgresVersion: Scalars["Int"]["input"];
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
};

export type User = {
  __typename?: "User";
  created?: Maybe<Scalars["Time"]["output"]>;
  /** How the user authenticated; null when unknown */
  currentAuthMethod?: Maybe<CurrentAuthMethod>;
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** The user's most recent login session */
  lastLoginSession?: Maybe<LastLoginSession>;
  /** If functionality for username/password users should be hidden */
  managedByIdp: Scalars["Boolean"]["output"];
  /** Why managedByIdp is true */
  managedByIdpReason?: Maybe<ManagedByIdpReason>;
  mfaMethods?: Maybe<Array<MfaMethod>>;
  name: Scalars["String"]["output"];
  /** User origin */
  origin?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  /** Whether the user is queued for deletion */
  queuedForDeletion: Scalars["Boolean"]["output"];
  /** SAML configuration status for the user's email domain */
  samlConfig?: Maybe<SamlConfig>;
  /** JSON string that models the UI State of the persona. */
  uiState?: Maybe<Scalars["String"]["output"]>;
};

export type UserPersona = {
  __typename?: "UserPersona";
  /** JSON string that models the UI State of the persona. */
  uiState: Scalars["String"]["output"];
  /** The ID of the user. */
  user_id: Scalars["ID"]["output"];
};

export type UserProjectRbacRole = {
  __typename?: "UserProjectRBACRole";
  permissions: RbacPermissions;
  role: RbacRole;
};

/** An active session for the authenticated user. */
export type UserSession = {
  __typename?: "UserSession";
  city: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  created?: Maybe<Scalars["Time"]["output"]>;
  deviceName: Scalars["String"]["output"];
  /** WEB or CLI; empty when the session has no recorded metadata. */
  deviceType: Scalars["String"]["output"];
  ipAddress: Scalars["String"]["output"];
  /** Whether this is the caller's current session. */
  isCurrent: Scalars["Boolean"]["output"];
  lastUsed?: Maybe<Scalars["Time"]["output"]>;
  sid: Scalars["String"]["output"];
};

/** The shell VPC that we allocate for peering, *not* the user's personal VPC. */
export type Vpc = {
  __typename?: "VPC";
  /** The CIDR block of the VPC. */
  cidr: Scalars["String"]["output"];
  /** The cloud provider that the VPC is hosted on. */
  cloudProvider: CloudProvider;
  /** Time at which the shell VPC is allocated on the cloud provider. */
  created?: Maybe<Scalars["Time"]["output"]>;
  /** Indicates an error with the VPC. */
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  /** The internal table ID of the VPC row. */
  id: Scalars["ID"]["output"];
  /** The name of the shell VPC. */
  name: Scalars["String"]["output"];
  /** Any peering connections associated with the shell VPC. */
  peeringConnections: Array<PeeringConnection>;
  /** The project ID the VPC is associated with. */
  projectId: Scalars["ID"]["output"];
  /** The provisioned ID of the VPC as given by the cloud provider. */
  provisionedId: Scalars["ID"]["output"];
  /** The region that the VPC is allocated in. */
  regionCode: Scalars["String"]["output"];
  /** The current status of the VPC. */
  status: VpcStatus;
  /** Most recent time that the user has updated a property of the VPC. */
  updated?: Maybe<Scalars["Time"]["output"]>;
};

export type VpcAttachmentEntitlement = {
  __typename?: "VPCAttachmentEntitlement";
  attachment_type: VpcAttachmentType;
  enabled: Scalars["Boolean"]["output"];
  max_instances: Scalars["Int"]["output"];
};

export enum VpcAttachmentType {
  Multi = "MULTI",
  None = "NONE",
  Single = "SINGLE",
}

/** Enum that represents the status of a VPC. */
export enum VpcStatus {
  Created = "CREATED",
  Creating = "CREATING",
  Deleted = "DELETED",
  Deleting = "DELETING",
  Error = "ERROR",
  Unknown = "UNKNOWN",
}

export type ValidateConfigResponse = {
  __typename?: "ValidateConfigResponse";
  errors: Array<Scalars["String"]["output"]>;
  valid: Scalars["Boolean"]["output"];
  warnings: Array<Scalars["String"]["output"]>;
};

export type ValidateConnectorConfigPgSrcInput = {
  connectionString: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  sshTunnelId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ValidateConnectorSpecIcebergInput = {
  iceberg: SpecIcebergInput;
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
};

export type ValidateConnectorSpecIcebergResponse = {
  __typename?: "ValidateConnectorSpecIcebergResponse";
  valid: Scalars["Boolean"]["output"];
  validationMessage: Scalars["String"]["output"];
};

export type ValidateIcebergDstInput = {
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  spec: IcebergDstSpecInput;
};

export type ValidateResetTokenMfaResponse = {
  __typename?: "ValidateResetTokenMfaResponse";
  message: Scalars["String"]["output"];
  mfaMethods: Array<MfaMethod>;
};

export type VerifyBillingEmailAddressInput = {
  billingEmailId: Scalars["ID"]["input"];
  hash: Scalars["String"]["input"];
};

export type VerifyEmailInput = {
  email: Scalars["String"]["input"];
  hash: Scalars["String"]["input"];
};

export type VerifyEmailOutput = {
  __typename?: "VerifyEmailOutput";
  status: Scalars["String"]["output"];
  user?: Maybe<User>;
  userID: Scalars["ID"]["output"];
  userToken?: Maybe<Scalars["String"]["output"]>;
};

export type VerifySshTunnelConfigInput = {
  projectId: Scalars["String"]["input"];
  sshTunnelId: Scalars["String"]["input"];
};

export type VerifySshTunnelConfigResponse = {
  __typename?: "VerifySSHTunnelConfigResponse";
  message: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type VersionInfo = {
  __typename?: "VersionInfo";
  available: Array<Scalars["String"]["output"]>;
  installed: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  scheduledUpgrade?: Maybe<Scalars["Time"]["output"]>;
};

export type VirtualPlan = {
  __typename?: "VirtualPlan";
  kind: VirtualPlanType;
};

export enum VirtualPlanType {
  AwaitingPlan = "AWAITING_PLAN",
  Enterprise = "ENTERPRISE",
  Free = "FREE",
  Ghost = "GHOST",
  Performance = "PERFORMANCE",
  Scale = "SCALE",
  Unspecified = "UNSPECIFIED",
}

export type CreateProjectMutationVariables = Exact<{
  name: Scalars["String"]["input"];
}>;

export type CreateProjectMutation = {
  __typename?: "Mutation";
  createProject: { __typename?: "Project"; id: string; name: string };
};

export type JoinProjectMutationVariables = Exact<{
  inviteId: Scalars["ID"]["input"];
  hash: Scalars["String"]["input"];
}>;

export type JoinProjectMutation = {
  __typename?: "Mutation";
  joinProject: string;
};

export type DeclineProjectInviteMutationVariables = Exact<{
  inviteId: Scalars["ID"]["input"];
}>;

export type DeclineProjectInviteMutation = {
  __typename?: "Mutation";
  declineProjectInvite: any;
};

export type LeaveProjectMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type LeaveProjectMutation = {
  __typename?: "Mutation";
  leaveProject: any;
};

export type CancelProjectInviteMutationVariables = Exact<{
  inviteId: Scalars["ID"]["input"];
  projectId: Scalars["String"]["input"];
}>;

export type CancelProjectInviteMutation = {
  __typename?: "Mutation";
  cancelProjectInvite: any;
};

export type RevokeProjectMemberMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
}>;

export type RevokeProjectMemberMutation = {
  __typename?: "Mutation";
  revokeProjectMember: any;
};

export type InviteProjectMemberMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  email: Scalars["String"]["input"];
  role?: InputMaybe<RbacRole>;
}>;

export type InviteProjectMemberMutation = {
  __typename?: "Mutation";
  inviteProjectMember: any;
};

export type ResendInviteProjectMemberMutationVariables = Exact<{
  inviteId: Scalars["ID"]["input"];
  projectId: Scalars["String"]["input"];
}>;

export type ResendInviteProjectMemberMutation = {
  __typename?: "Mutation";
  resendInviteProjectMember: any;
};

export type CreateServiceMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  type: Type;
  resourceConfig?: InputMaybe<ResourceConfig>;
  vpcId?: InputMaybe<Scalars["ID"]["input"]>;
  privateLinkConnectionIds?: InputMaybe<
    Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
  >;
  enableConnectionPooler?: InputMaybe<Scalars["Boolean"]["input"]>;
  regionCode: Scalars["String"]["input"];
  forkConfig?: InputMaybe<ForkConfig>;
  environmentTag?: InputMaybe<ServiceEnvironment>;
  isFixed?: InputMaybe<Scalars["Boolean"]["input"]>;
  servicePlan?: InputMaybe<ServicePlan>;
}>;

export type CreateServiceMutation = {
  __typename?: "Mutation";
  createService: {
    __typename?: "CreateServiceOutput";
    initialPassword: string;
    service: {
      __typename?: "Service";
      name: string;
      id: string;
      projectId: string;
      servicePlan: ServicePlan;
      type: Type;
      isReadOnly: boolean;
      regionCode: string;
      status: DeployStatus;
      vpcId?: string | null;
      primaryOrdinal?: number | null;
      replicaOrdinals?: Array<number> | null;
      replicaStatus?: DeployStatus | null;
      created: any;
      endpoints?: {
        __typename?: "ServiceEndpoints";
        primary: { __typename?: "EndpointAddress"; host: string; port: number };
      } | null;
      spec: {
        __typename?: "TimescaleDBServiceSpec";
        hostname: string;
        username: string;
        port: number;
        defaultDBName: string;
        connectionPoolerEnabled: boolean;
        IOBoostEnabled: boolean;
        poolerHostName?: string | null;
        poolerPort?: number | null;
        isFixed: boolean;
      };
      resources: Array<{
        __typename?: "Resource";
        id: string;
        spec: {
          __typename?: "ResourceNode";
          milliCPU: number;
          memoryGB: number;
          storageGB?: number | null;
          replicaCount: number;
          syncReplicaCount: number;
        };
      }>;
      vpcEndpoint?: {
        __typename?: "Endpoint";
        projectId: string;
        serviceId: string;
        vpcId: string;
        host: string;
        port: number;
      } | null;
      metrics?: {
        __typename?: "ResourceMetrics";
        memoryMB?: number | null;
        storageMB?: number | null;
        milliCPU?: number | null;
      } | null;
      forkedFromId?: {
        __typename?: "ForkSpec";
        serviceId: string;
        projectId: string;
      } | null;
    };
  };
};

export type DisableStaticResourcesMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
}>;

export type DisableStaticResourcesMutation = {
  __typename?: "Mutation";
  disableStaticResources: any;
};

export type ToggleCrossRegionBackupsMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  region: Scalars["String"]["input"];
  enable: Scalars["Boolean"]["input"];
}>;

export type ToggleCrossRegionBackupsMutation = {
  __typename?: "Mutation";
  toggleCrossRegionBackupsV2: boolean;
};

export type SetBackupsRetentionMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  retType: Scalars["String"]["input"];
  retCount: Scalars["Int"]["input"];
}>;

export type SetBackupsRetentionMutation = {
  __typename?: "Mutation";
  setBackupsRetention: any;
};

export type SetProjectEnforcementTypeMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  enforcementType: EnforcementType;
}>;

export type SetProjectEnforcementTypeMutation = {
  __typename?: "Mutation";
  setProjectEnforcementType: {
    __typename?: "Project";
    id: string;
    enforcementType: EnforcementType;
  };
};

export type CreateServiceForkMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  type: Type;
  resourceConfig?: InputMaybe<ResourceConfig>;
  vpcId?: InputMaybe<Scalars["ID"]["input"]>;
  privateLinkConnectionIds?: InputMaybe<
    Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]
  >;
  enableConnectionPooler?: InputMaybe<Scalars["Boolean"]["input"]>;
  regionCode: Scalars["String"]["input"];
  forkConfig: ForkConfig;
  environmentTag?: InputMaybe<ServiceEnvironment>;
  isFixed?: InputMaybe<Scalars["Boolean"]["input"]>;
  servicePlan?: InputMaybe<ServicePlan>;
}>;

export type CreateServiceForkMutation = {
  __typename?: "Mutation";
  createService: {
    __typename?: "CreateServiceOutput";
    initialPassword: string;
    service: {
      __typename?: "Service";
      name: string;
      id: string;
      projectId: string;
      type: Type;
      isReadOnly: boolean;
      regionCode: string;
      status: DeployStatus;
      vpcId?: string | null;
      created: any;
      spec: {
        __typename?: "TimescaleDBServiceSpec";
        hostname: string;
        username: string;
        port: number;
        defaultDBName: string;
        connectionPoolerEnabled: boolean;
        IOBoostEnabled: boolean;
        poolerHostName?: string | null;
        poolerPort?: number | null;
        isFixed: boolean;
      };
      resources: Array<{
        __typename?: "Resource";
        id: string;
        spec: {
          __typename?: "ResourceNode";
          milliCPU: number;
          memoryGB: number;
          storageGB?: number | null;
          replicaCount: number;
        };
      }>;
      vpcEndpoint?: {
        __typename?: "Endpoint";
        projectId: string;
        serviceId: string;
        vpcId: string;
        host: string;
        port: number;
      } | null;
      metrics?: {
        __typename?: "ResourceMetrics";
        memoryMB?: number | null;
        storageMB?: number | null;
        milliCPU?: number | null;
      } | null;
      forkedFromId?: {
        __typename?: "ForkSpec";
        serviceId: string;
        projectId: string;
        isStandby?: boolean | null;
      } | null;
    };
  };
};

export type SetReplicaCountMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  replicaCount: Scalars["Int"]["input"];
  synchronousReplicaCount?: InputMaybe<Scalars["Int"]["input"]>;
  allReplicasAreSync?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type SetReplicaCountMutation = {
  __typename?: "Mutation";
  setReplicaCount: any;
};

export type UpgradePostgresMajorVersionMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  postgresVersion: Scalars["Int"]["input"];
}>;

export type UpgradePostgresMajorVersionMutation = {
  __typename?: "Mutation";
  upgradePostgresMajorVersion: any;
};

export type CreateUserMutationVariables = Exact<{
  name: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  passwordConfirm: Scalars["String"]["input"];
  recaptchaToken: Scalars["String"]["input"];
  inviteHash?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreateUserMutation = {
  __typename?: "Mutation";
  createUser: {
    __typename?: "User";
    name: string;
    email: string;
    id: string;
    created?: any | null;
  };
};

export type SetServiceEnvironmentTagMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  environment: ServiceEnvironment;
}>;

export type SetServiceEnvironmentTagMutation = {
  __typename?: "Mutation";
  setServiceEnvironmentTag: any;
};

export type CreatePaymentMethodMutationVariables = Exact<{
  billingAccountId: Scalars["ID"]["input"];
  isPrimary: Scalars["Boolean"]["input"];
}>;

export type CreatePaymentMethodMutation = {
  __typename?: "Mutation";
  createPaymentMethod: string;
};

export type CreateCardVerificationChargeMutationVariables = Exact<{
  billingAccountId: Scalars["ID"]["input"];
}>;

export type CreateCardVerificationChargeMutation = {
  __typename?: "Mutation";
  createCardVerificationCharge: {
    __typename?: "CreatedCardVerificationChargeResponse";
    clientSecret: string;
  };
};

export type UpdatePaymentMethodMutationVariables = Exact<{
  billingAccountId: Scalars["ID"]["input"];
  paymentMethodId: Scalars["ID"]["input"];
  addressInfo?: InputMaybe<AddressInfoInput>;
  cardExp: CardExpInput;
}>;

export type UpdatePaymentMethodMutation = {
  __typename?: "Mutation";
  updatePaymentMethod: {
    __typename?: "PaymentMethod";
    id: string;
    isPrimary?: boolean | null;
    cardInfo?: { __typename?: "CardInfo"; last4: string } | null;
    addressInfo?: {
      __typename?: "AddressInfo";
      city: string;
      state: string;
      country: string;
      line1: string;
      line2: string;
      postalCode: string;
    } | null;
  };
};

export type DeletePaymentMethodMutationVariables = Exact<{
  billingAccountId: Scalars["ID"]["input"];
  paymentMethodId: Scalars["ID"]["input"];
}>;

export type DeletePaymentMethodMutation = {
  __typename?: "Mutation";
  deletePaymentMethod: { __typename?: "PaymentMethod"; id: string };
};

export type SetPrimaryPaymentMethodMutationVariables = Exact<{
  billingAccountId: Scalars["ID"]["input"];
  paymentMethodId: Scalars["ID"]["input"];
}>;

export type SetPrimaryPaymentMethodMutation = {
  __typename?: "Mutation";
  setPrimaryPaymentMethod: string;
};

export type CreateBillingEmailAddressMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  billingAccountId: Scalars["ID"]["input"];
}>;

export type CreateBillingEmailAddressMutation = {
  __typename?: "Mutation";
  createBillingEmailAddress: {
    __typename?: "BillingEmailAddress";
    id: string;
    email: string;
    billingAccountId: string;
    created: any;
    activated?: any | null;
  };
};

export type DeleteBillingEmailAddressMutationVariables = Exact<{
  billingEmailId: Scalars["ID"]["input"];
  billingAccountId: Scalars["ID"]["input"];
}>;

export type DeleteBillingEmailAddressMutation = {
  __typename?: "Mutation";
  deleteBillingEmailAddress: any;
};

export type VerifyBillingEmailAddressMutationVariables = Exact<{
  billingEmailId: Scalars["ID"]["input"];
  hash: Scalars["String"]["input"];
}>;

export type VerifyBillingEmailAddressMutation = {
  __typename?: "Mutation";
  verifyBillingEmailAddress: string;
};

export type ResendVerifyBillingEmailAddressMutationVariables = Exact<{
  billingEmailId: Scalars["ID"]["input"];
  billingAccountId: Scalars["ID"]["input"];
}>;

export type ResendVerifyBillingEmailAddressMutation = {
  __typename?: "Mutation";
  resendVerifyBillingEmailAddress: string;
};

export type CancelPendingPaymentDeletionMutationVariables = Exact<{
  billingAccountId: Scalars["ID"]["input"];
  paymentMethodId: Scalars["ID"]["input"];
}>;

export type CancelPendingPaymentDeletionMutation = {
  __typename?: "Mutation";
  cancelPendingPaymentDeletion: any;
};

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars["String"]["input"];
  newPassword: Scalars["String"]["input"];
  newPasswordConfirm: Scalars["String"]["input"];
  trustChallenge?: InputMaybe<Scalars["String"]["input"]>;
  trustToken?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ChangePasswordMutation = {
  __typename?: "Mutation";
  changePassword: string;
};

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars["String"]["input"];
  passwordConfirm: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
  trustChallenge?: InputMaybe<Scalars["String"]["input"]>;
  trustToken?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ResetPasswordMutation = {
  __typename?: "Mutation";
  resetPassword: string;
};

export type ResetServicePasswordMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  password: Scalars["String"]["input"];
  passwordType: PasswordType;
}>;

export type ResetServicePasswordMutation = {
  __typename?: "Mutation";
  resetServicePassword: string;
};

export type SendPasswordResetMutationVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type SendPasswordResetMutation = {
  __typename?: "Mutation";
  sendPasswordReset: string;
};

export type UpdateUserMutationVariables = Exact<{
  name?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  uiState?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateUserMutation = {
  __typename?: "Mutation";
  updateUser: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    created?: any | null;
    origin?: string | null;
    uiState?: string | null;
    managedByIdp: boolean;
    managedByIdpReason?: ManagedByIdpReason | null;
  };
};

export type VerifyEmailMutationVariables = Exact<{
  email: Scalars["String"]["input"];
  hash: Scalars["String"]["input"];
}>;

export type VerifyEmailMutation = {
  __typename?: "Mutation";
  verifyEmail: {
    __typename?: "VerifyEmailOutput";
    status: string;
    userID: string;
    userToken?: string | null;
    user?: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      created?: any | null;
      managedByIdp: boolean;
    } | null;
  };
};

export type ResendVerifyEmailMutationVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type ResendVerifyEmailMutation = {
  __typename?: "Mutation";
  resendVerifyEmail: string;
};

export type DeleteServiceMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
}>;

export type DeleteServiceMutation = {
  __typename?: "Mutation";
  deleteService: { __typename?: "Service"; id: string; name: string };
};

export type ToggleServiceMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  status: Status;
}>;

export type ToggleServiceMutation = {
  __typename?: "Mutation";
  toggleService: {
    __typename?: "Service";
    id: string;
    name: string;
    spec: { __typename?: "TimescaleDBServiceSpec"; status: Status };
  };
};

export type TogglePopSqlIntegrationMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  enable: Scalars["Boolean"]["input"];
}>;

export type TogglePopSqlIntegrationMutation = {
  __typename?: "Mutation";
  togglePopSQLIntegration: any;
};

export type ResizeInstanceMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  config: ResourceConfig;
}>;

export type ResizeInstanceMutation = {
  __typename?: "Mutation";
  resizeInstance: any;
};

export type SetAddressInfoMutationVariables = Exact<{
  billingAccountId: Scalars["ID"]["input"];
  companyAddress: AddressInfoInput;
}>;

export type SetAddressInfoMutation = {
  __typename?: "Mutation";
  setAddressInfo: {
    __typename?: "AddressDetails";
    companyAddress?: {
      __typename?: "AddressInfo";
      companyName?: string | null;
      line1: string;
      line2: string;
      city: string;
      state: string;
      country: string;
      postalCode: string;
    } | null;
  };
};

export type SetPostgresParametersMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  numericParameters?: InputMaybe<
    Array<SetNumericParameter> | SetNumericParameter
  >;
  stringParameters?: InputMaybe<Array<SetStringParameter> | SetStringParameter>;
}>;

export type SetPostgresParametersMutation = {
  __typename?: "Mutation";
  setPostgresParameters: Array<{
    __typename?: "ParamErrorMessages";
    name: string;
    errorMessage: string;
  }>;
};

export type ResetPostgresParametersMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
}>;

export type ResetPostgresParametersMutation = {
  __typename?: "Mutation";
  resetPostgresParameters: any;
};

export type ChangeMaintenanceWindowMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  start: Scalars["Time"]["input"];
  durationInSeconds: Scalars["Int"]["input"];
}>;

export type ChangeMaintenanceWindowMutation = {
  __typename?: "Mutation";
  setMaintenanceWindow: any;
};

export type CreateVpcMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  cidr: Scalars["String"]["input"];
  cloudProvider: CloudProvider;
  name: Scalars["String"]["input"];
  regionCode: Scalars["String"]["input"];
}>;

export type CreateVpcMutation = {
  __typename?: "Mutation";
  createVpc: { __typename?: "VPC"; id: string };
};

export type ConfigureIpAllowListMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  cidrBlocks?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
  description: Scalars["String"]["input"];
  listId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type ConfigureIpAllowListMutation = {
  __typename?: "Mutation";
  configureIPAllowList: {
    __typename?: "ConfigureIPAllowListOutput";
    listId: number;
  };
};

export type BindIpAllowListMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  listId: Scalars["Int"]["input"];
}>;

export type BindIpAllowListMutation = {
  __typename?: "Mutation";
  bindIPAllowList: any;
};

export type UnbindIpAllowListMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  listId: Scalars["Int"]["input"];
}>;

export type UnbindIpAllowListMutation = {
  __typename?: "Mutation";
  unbindIPAllowList: any;
};

export type RenameVpcMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  forgeVpcId: Scalars["ID"]["input"];
  newName: Scalars["String"]["input"];
}>;

export type RenameVpcMutation = { __typename?: "Mutation"; renameVpc: any };

export type RenameServiceMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  newName: Scalars["String"]["input"];
}>;

export type RenameServiceMutation = {
  __typename?: "Mutation";
  renameService: any;
};

export type RenameProjectMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
}>;

export type RenameProjectMutation = {
  __typename?: "Mutation";
  renameProject: { __typename?: "Project"; id: string; name: string };
};

export type DisableProjectMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type DisableProjectMutation = {
  __typename?: "Mutation";
  disableProject: { __typename?: "Project"; id: string; name: string };
};

export type OpenPeerRequestMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  forgeVpcId: Scalars["ID"]["input"];
  cloudProvider: CloudProvider;
  peerVpc: InputPeerVpc;
}>;

export type OpenPeerRequestMutation = {
  __typename?: "Mutation";
  openPeerRequest: { __typename?: "PeeringConnectionID"; id: string };
};

export type UpdatePeeringConnectionCidRsMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  forgeVpcId: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
  cidrBlocks: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type UpdatePeeringConnectionCidRsMutation = {
  __typename?: "Mutation";
  updatePeeringConnectionCIDRs: any;
};

export type DeletePeeringConnectionMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  vpcId: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
}>;

export type DeletePeeringConnectionMutation = {
  __typename?: "Mutation";
  deletePeeringConnection: any;
};

export type AttachServiceToVpcMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  vpcId: Scalars["ID"]["input"];
}>;

export type AttachServiceToVpcMutation = {
  __typename?: "Mutation";
  attachServiceToVpc: any;
};

export type DetachServiceFromVpcMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  vpcId: Scalars["ID"]["input"];
}>;

export type DetachServiceFromVpcMutation = {
  __typename?: "Mutation";
  detachServiceFromVpc: any;
};

export type DeleteVpcMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  vpcId: Scalars["ID"]["input"];
}>;

export type DeleteVpcMutation = { __typename?: "Mutation"; deleteVpc: any };

export type CreateMetricExporterMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  config: MetricExporterConfigInput;
  regionCode: Scalars["String"]["input"];
  enablePgMetrics?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateMetricExporterMutation = {
  __typename?: "Mutation";
  createMetricExporter: {
    __typename?: "MetricExporter";
    id: string;
    exporterUuid: string;
    projectId: string;
    created: any;
    name: string;
    type: MetricExporterType;
    enablePgMetrics?: boolean | null;
    config:
      | { __typename?: "AzureMonitorMetricConfig"; connectionString: string }
      | {
          __typename?: "CloudWatchMetricConfig";
          logGroupName: string;
          logStreamName: string;
          namespace: string;
          awsRegion: string;
          awsRoleArn?: string | null;
        }
      | {
          __typename?: "DatadogMetricConfig";
          apiKey: string;
          site?: string | null;
        }
      | {
          __typename?: "PrometheusMetricConfig";
          user?: string | null;
          password?: string | null;
        };
  };
};

export type UpdateMetricExporterMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  config: MetricExporterConfigInput;
  exporterUuid?: InputMaybe<Scalars["String"]["input"]>;
  enablePgMetrics?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateMetricExporterMutation = {
  __typename?: "Mutation";
  updateMetricExporter: any;
};

export type DeleteMetricExporterMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  exporterUuid?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type DeleteMetricExporterMutation = {
  __typename?: "Mutation";
  deleteMetricExporter: any;
};

export type AttachServiceToMetricExporterMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  exporterUuid?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type AttachServiceToMetricExporterMutation = {
  __typename?: "Mutation";
  attachServiceToMetricExporter: any;
};

export type DetachServiceFromMetricExporterMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  exporterUuid?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type DetachServiceFromMetricExporterMutation = {
  __typename?: "Mutation";
  detachServiceFromMetricExporter: any;
};

export type CreateGenericExporterMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  region: Scalars["String"]["input"];
  type: GenericExporterType;
  dataType: GenericExporterDataType;
  config: GenericExporterConfigInput;
}>;

export type CreateGenericExporterMutation = {
  __typename?: "Mutation";
  createGenericExporter: {
    __typename?: "GenericExporter";
    id: string;
    projectId: string;
    regionCode: string;
    created: any;
    name: string;
    type: GenericExporterType;
  };
};

export type UpdateGenericExporterMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  exporterId: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  config: GenericExporterConfigInput;
}>;

export type UpdateGenericExporterMutation = {
  __typename?: "Mutation";
  updateGenericExporter: any;
};

export type DeleteGenericExporterMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  exporterId: Scalars["String"]["input"];
}>;

export type DeleteGenericExporterMutation = {
  __typename?: "Mutation";
  deleteGenericExporter: any;
};

export type AttachServiceToGenericExporterMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  exporterId: Scalars["String"]["input"];
}>;

export type AttachServiceToGenericExporterMutation = {
  __typename?: "Mutation";
  attachServiceToGenericExporter: any;
};

export type DetachServiceFromGenericExporterMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  exporterId: Scalars["String"]["input"];
}>;

export type DetachServiceFromGenericExporterMutation = {
  __typename?: "Mutation";
  detachServiceFromGenericExporter: any;
};

export type SetCompressionHypertableMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  regionCode: Scalars["String"]["input"];
  config: CompressionConfig;
  tableSchema: Scalars["ID"]["input"];
  tableName: Scalars["ID"]["input"];
}>;

export type SetCompressionHypertableMutation = {
  __typename?: "Mutation";
  setCompressionHypertable: any;
};

export type SetCompressionMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  regionCode: Scalars["String"]["input"];
  config: CompressionConfig;
  schema: Scalars["ID"]["input"];
  tableName?: InputMaybe<Scalars["ID"]["input"]>;
  contAggName?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type SetCompressionMutation = {
  __typename?: "Mutation";
  setCompression: any;
};

export type AddCompressionPolicyMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  regionCode: Scalars["String"]["input"];
  tableSchema: Scalars["ID"]["input"];
  tableName?: InputMaybe<Scalars["ID"]["input"]>;
  contAggName?: InputMaybe<Scalars["ID"]["input"]>;
  olderThan: Scalars["String"]["input"];
}>;

export type AddCompressionPolicyMutation = {
  __typename?: "Mutation";
  addCompressionPolicy: any;
};

export type DeleteCompressionPolicyMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  regionCode: Scalars["String"]["input"];
  tableSchema: Scalars["ID"]["input"];
  tableName: Scalars["ID"]["input"];
}>;

export type DeleteCompressionPolicyMutation = {
  __typename?: "Mutation";
  deleteCompressionPolicy: any;
};

export type AddMfaMethodMutationVariables = Exact<{
  code: Scalars["String"]["input"];
  secret: Scalars["String"]["input"];
}>;

export type AddMfaMethodMutation = {
  __typename?: "Mutation";
  addMfaMethod: {
    __typename?: "AddMfaMethodResponse";
    recoveryCodes?: Array<string> | null;
    method: { __typename?: "AuthenticatorMethod"; id: string };
  };
};

export type DeleteMfaMethodMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  code: Scalars["String"]["input"];
}>;

export type DeleteMfaMethodMutation = {
  __typename?: "Mutation";
  deleteMfaMethod: any;
};

export type RegenerateRecoveryCodesMutationVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type RegenerateRecoveryCodesMutation = {
  __typename?: "Mutation";
  regenerateRecoveryCodes: Array<string>;
};

export type CreateSupportTicketMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  services?: InputMaybe<
    Array<SupportServiceInfoInput> | SupportServiceInfoInput
  >;
  subject: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
  caseType?: InputMaybe<SupportCaseType>;
  billingCategory?: InputMaybe<SupportBillingCategory>;
  stillHappening?: InputMaybe<SupportStillHappening>;
  reportedServiceCapability?: InputMaybe<SupportServiceCapability>;
  isProduction?: InputMaybe<Scalars["Boolean"]["input"]>;
  impact?: InputMaybe<Scalars["String"]["input"]>;
  attachments?: InputMaybe<
    Array<Scalars["Upload"]["input"]> | Scalars["Upload"]["input"]
  >;
}>;

export type CreateSupportTicketMutation = {
  __typename?: "Mutation";
  createSupportTicket: any;
};

export type AddSupportCaseReplyMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  body: Scalars["String"]["input"];
  attachments?: InputMaybe<
    Array<Scalars["Upload"]["input"]> | Scalars["Upload"]["input"]
  >;
}>;

export type AddSupportCaseReplyMutation = {
  __typename?: "Mutation";
  addSupportCaseReply: {
    __typename?: "SupportCaseMessage";
    fromName?: string | null;
    incoming: boolean;
    textBody?: string | null;
    messageDate: any;
    attachments: Array<{
      __typename?: "SupportCaseAttachment";
      contentDocumentId: string;
      title: string;
      fileExtension?: string | null;
      contentSize: number;
      url: string;
    }>;
  };
};

export type CloseSupportCaseMutationVariables = Exact<{
  caseId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  body?: InputMaybe<Scalars["String"]["input"]>;
  attachments?: InputMaybe<
    Array<Scalars["Upload"]["input"]> | Scalars["Upload"]["input"]
  >;
}>;

export type CloseSupportCaseMutation = {
  __typename?: "Mutation";
  closeSupportCase: any;
};

export type ToggleDataTieringInputMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  enable: Scalars["Boolean"]["input"];
}>;

export type ToggleDataTieringInputMutation = {
  __typename?: "Mutation";
  toggleDataTiering: any;
};

export type CreatePatRecordMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
}>;

export type CreatePatRecordMutation = {
  __typename?: "Mutation";
  createPATRecord: {
    __typename?: "PATRecord";
    name: string;
    projectId: string;
    created: any;
    clientCredentials: {
      __typename?: "ClientCredentials";
      accessKey: string;
      secretKey?: string | null;
    };
  };
};

export type DeletePatRecordMutationVariables = Exact<{
  accessKey: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
}>;

export type DeletePatRecordMutation = {
  __typename?: "Mutation";
  deletePATRecord: any;
};

export type RenamePatRecordMutationVariables = Exact<{
  accessKey: Scalars["String"]["input"];
  newName: Scalars["String"]["input"];
  projectId: Scalars["ID"]["input"];
}>;

export type RenamePatRecordMutation = {
  __typename?: "Mutation";
  renamePATRecord: any;
};

export type ToggleConnectionPoolerMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  enable: Scalars["Boolean"]["input"];
}>;

export type ToggleConnectionPoolerMutation = {
  __typename?: "Mutation";
  toggleConnectionPooler: any;
};

export type ToggleIoBoostMutationVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  enable: Scalars["Boolean"]["input"];
  storageType: StorageType;
}>;

export type ToggleIoBoostMutation = {
  __typename?: "Mutation";
  toggleIOBoost: any;
};

export type TransferProjectOwnershipMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  newOwnerId: Scalars["ID"]["input"];
  mfaCode: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
}>;

export type TransferProjectOwnershipMutation = {
  __typename?: "Mutation";
  transferProjectOwnership: any;
};

export type CreateConnectorMutationVariables = Exact<{
  data: CreateConnectorInput;
}>;

export type CreateConnectorMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    createConnector: { __typename?: "CreateConnectorResponse"; id: string };
  };
};

export type UpdateConnectorV2MutationVariables = Exact<{
  data: UpdateConnectorV2Input;
}>;

export type UpdateConnectorV2Mutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    updateConnectorV2: {
      __typename?: "UpdateConnectorV2Response";
      connector: { __typename?: "ConnectorDetails"; displayName: string };
    };
  };
};

export type CreateSshTunnelConfigMutationVariables = Exact<{
  data: CreateSshTunnelConfigInput;
}>;

export type CreateSshTunnelConfigMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    createSSHTunnelConfig: {
      __typename?: "CreateSSHTunnelConfigResponse";
      sshTunnelConfig: {
        __typename?: "SSHTunnelConfig";
        sshTunnelId: string;
        projectId: string;
        name: string;
        publicKey: string;
        username?: string | null;
        host?: string | null;
        port?: number | null;
        createdAt: any;
        updatedAt: any;
      };
    };
  };
};

export type UpdateSshTunnelConfigMutationVariables = Exact<{
  data: UpdateSshTunnelConfigInput;
}>;

export type UpdateSshTunnelConfigMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    updateSSHTunnelConfig: {
      __typename?: "UpdateSSHTunnelConfigResponse";
      sshTunnelConfig: {
        __typename?: "SSHTunnelConfig";
        sshTunnelId: string;
        projectId: string;
        name: string;
        publicKey: string;
        username?: string | null;
        host?: string | null;
        port?: number | null;
        createdAt: any;
        updatedAt: any;
      };
    };
  };
};

export type CreatePgSrcConfigMutationVariables = Exact<{
  data: CreatePgSrcConfigInput;
}>;

export type CreatePgSrcConfigMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    createPgSrcConfig: {
      __typename?: "CreatePgSrcConfigResponse";
      sourceConfig: { __typename?: "PgSrcConfig"; sourceId: string };
    };
  };
};

export type UpdatePgSrcConfigMutationVariables = Exact<{
  data: UpdatePgSrcConfigInput;
}>;

export type UpdatePgSrcConfigMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    updatePgSrcConfig: {
      __typename?: "UpdatePgSrcConfigResponse";
      sourceConfig: { __typename?: "PgSrcConfig"; sourceId: string };
    };
  };
};

export type CreateKafkaClusterConfigMutationVariables = Exact<{
  data: CreateKafkaClusterConfigInput;
}>;

export type CreateKafkaClusterConfigMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    createKafkaClusterConfig: {
      __typename?: "CreateKafkaClusterConfigResponse";
      clusterConfig: {
        __typename?: "KafkaClusterConfig";
        clusterId: string;
        projectId: string;
        name: string;
        created?: any | null;
        updated?: any | null;
      };
    };
  };
};

export type CreateSchemaRegistryConfigMutationVariables = Exact<{
  data: CreateSchemaRegistryConfigInput;
}>;

export type CreateSchemaRegistryConfigMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    createSchemaRegistryConfig: {
      __typename?: "CreateSchemaRegistryConfigResponse";
      schemaRegistryConfig: {
        __typename?: "SchemaRegistryConfig";
        schemaRegistryId: string;
      };
    };
  };
};

export type CreateKafkaConnectorMutationVariables = Exact<{
  data: CreateKafkaConnectorInput;
}>;

export type CreateKafkaConnectorMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    createKafkaConnector: {
      __typename?: "CreateKafkaConnectorResponse";
      id: string;
    };
  };
};

export type UpdateConnectorMutationVariables = Exact<{
  data: UpdateConnectorInput;
}>;

export type UpdateConnectorMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    updateConnector: {
      __typename?: "UpdateConnectorResponse";
      connector: { __typename?: "ConnectorDetails"; displayName: string };
    };
  };
};

export type CreateS3LiveSyncMutationVariables = Exact<{
  data: CreateS3LiveSyncInput;
}>;

export type CreateS3LiveSyncMutation = {
  __typename?: "Mutation";
  connectors: { __typename?: "ConnectorsMutator"; createS3LiveSync: any };
};

export type UpdateS3LiveSyncMutationVariables = Exact<{
  data: UpdateS3LiveSyncInput;
}>;

export type UpdateS3LiveSyncMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    updateS3LiveSync: {
      __typename?: "S3LiveSync";
      id: string;
      name?: string | null;
      pattern: string;
      created_at: string;
      updated_at: string;
      enabled: boolean;
      bucket: string;
      last_imported_object?: string | null;
      frequency?: string | null;
      credentials?: {
        __typename?: "S3LiveSyncCredentials";
        type: S3LiveSyncCredentialsType;
        role?: {
          __typename?: "S3LiveSyncRequestCredentialsRole";
          arn: string;
        } | null;
      } | null;
      settings?: {
        __typename?: "ImportSettings";
        on_conflict_do_nothing?: boolean | null;
      } | null;
      definition?: {
        __typename?: "S3LiveSyncDefinition";
        type: S3LiveSyncDefinitionType;
        csv?: {
          __typename?: "S3LiveSyncRequestDefinitionCSV";
          column_names?: Array<string> | null;
          delimiter?: string | null;
          skip_header?: boolean | null;
        } | null;
      } | null;
      table_identifier?: {
        __typename?: "TableIdentifier";
        table_name: string;
        schema_name?: string | null;
      } | null;
    };
  };
};

export type DeleteS3LiveSyncMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
}>;

export type DeleteS3LiveSyncMutation = {
  __typename?: "Mutation";
  connectors: { __typename?: "ConnectorsMutator"; deleteS3LiveSync: any };
};

export type DeleteConnectorMutationVariables = Exact<{
  data: DeleteConnectorInput;
}>;

export type DeleteConnectorMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    deleteConnector: {
      __typename?: "DeleteConnectorResponse";
      success: boolean;
    };
  };
};

export type RetryS3LiveSyncFileImportsMutationVariables = Exact<{
  data: RetryS3LiveSyncFileImportsInput;
}>;

export type RetryS3LiveSyncFileImportsMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    retryS3LiveSyncFileImports: {
      __typename?: "RetryS3LiveSyncFileImportsResponse";
      count: number;
    };
  };
};

export type UpdateKafkaConnectorMutationVariables = Exact<{
  data: UpdateConnectorInput;
}>;

export type UpdateKafkaConnectorMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    updateConnector: {
      __typename?: "UpdateConnectorResponse";
      connector: { __typename?: "ConnectorDetails"; displayName: string };
    };
  };
};

export type ValidateIcebergDstMutationVariables = Exact<{
  data: ValidateIcebergDstInput;
}>;

export type ValidateIcebergDstMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    validateConnectorSpecIcebergDst: {
      __typename?: "ValidateConnectorSpecIcebergResponse";
      valid: boolean;
      validationMessage: string;
    };
  };
};

export type ValidateConnectorConfigPgSrcMutationVariables = Exact<{
  data: ValidateConnectorConfigPgSrcInput;
}>;

export type ValidateConnectorConfigPgSrcMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    validateConnectorConfigPgSrc: {
      __typename?: "ValidateConfigResponse";
      valid: boolean;
      errors: Array<string>;
      warnings: Array<string>;
    };
  };
};

export type SetVirtualPlanForProjectMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  virtualPlanKind: VirtualPlanType;
  trialPackage?: InputMaybe<TrialPackage>;
}>;

export type SetVirtualPlanForProjectMutation = {
  __typename?: "Mutation";
  setVirtualPlanForProject: any;
};

export type SetHypertableConfMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  schema: Scalars["ID"]["input"];
  tableName: Scalars["ID"]["input"];
  chunkSizeIntervalDuration: Scalars["String"]["input"];
}>;

export type SetHypertableConfMutation = {
  __typename?: "Mutation";
  setHypertableConf: any;
};

export type SetHypertableConfAndToggleChunkTuningMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  schema: Scalars["ID"]["input"];
  tableName: Scalars["ID"]["input"];
  chunkSizeIntervalDuration: Scalars["String"]["input"];
  tuningProjectId: Scalars["String"]["input"];
  tuningServiceId: Scalars["String"]["input"];
  hypertableId: Scalars["Int"]["input"];
  enabled: Scalars["Boolean"]["input"];
}>;

export type SetHypertableConfAndToggleChunkTuningMutation = {
  __typename?: "Mutation";
  setHypertableConf: any;
  toggleChunkTuning: any;
};

export type DismissRecommendationMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  recommendationId: Scalars["ID"]["input"];
}>;

export type DismissRecommendationMutation = {
  __typename?: "Mutation";
  dismissRecommendation: any;
};

export type LinkMarketplaceAccountMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type LinkMarketplaceAccountMutation = {
  __typename?: "Mutation";
  linkMarketplaceAccount: {
    __typename?: "LinkMarketplaceAccountResponse";
    success: boolean;
  };
};

export type GeneratePresignedUrlMutationVariables = Exact<{
  data: GeneratePresignedUrlInput;
}>;

export type GeneratePresignedUrlMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    generatePresignedURL: {
      __typename?: "GeneratePresignedURLResponse";
      url: string;
    };
  };
};

export type CreateSchemaMutationVariables = Exact<{
  data: CreateSchemaInput;
}>;

export type CreateSchemaMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    createSchema: { __typename?: "CreateSchemaResponse"; migration: string };
  };
};

export type CreateFileImportMutationVariables = Exact<{
  data: CreateFileImportInput;
}>;

export type CreateFileImportMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    createFileImport: {
      __typename?: "CreateFileImportResponse";
      error?: string | null;
    };
  };
};

export type UpdateFileImportMutationVariables = Exact<{
  data: UpdateFileImportInput;
}>;

export type UpdateFileImportMutation = {
  __typename?: "Mutation";
  connectors: {
    __typename?: "ConnectorsMutator";
    updateFileImport: {
      __typename?: "UpdateFileImportResponse";
      error?: string | null;
    };
  };
};

export type CancelCurrentQueryMutationVariables = Exact<{
  serviceId: Scalars["String"]["input"];
  projectId: Scalars["String"]["input"];
  pid: Scalars["Int"]["input"];
}>;

export type CancelCurrentQueryMutation = {
  __typename?: "Mutation";
  cancelCurrentQuery: any;
};

export type UpdateUserRoleMutationVariables = Exact<{
  role: RbacRole;
  projectId: Scalars["String"]["input"];
  userId: Scalars["ID"]["input"];
}>;

export type UpdateUserRoleMutation = {
  __typename?: "Mutation";
  updateUserRole: any;
};

export type RequestAuthorizationCodeMutationVariables = Exact<{
  data: AuthorizationCodeInput;
}>;

export type RequestAuthorizationCodeMutation = {
  __typename?: "Mutation";
  requestAuthorizationCode: {
    __typename?: "AuthorizationCodeOutput";
    code: string;
  };
};

export type ApproveDeviceAuthorizationMutationVariables = Exact<{
  userCode: Scalars["String"]["input"];
}>;

export type ApproveDeviceAuthorizationMutation = {
  __typename?: "Mutation";
  approveDeviceAuthorization: any;
};

export type ToggleChunkTuningMutationVariables = Exact<{
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  hypertableId: Scalars["Int"]["input"];
  enabled: Scalars["Boolean"]["input"];
}>;

export type ToggleChunkTuningMutation = {
  __typename?: "Mutation";
  toggleChunkTuning: any;
};

export type UpdatePrivateLinkConnectionMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  connectionId: Scalars["ID"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  ipAddress?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdatePrivateLinkConnectionMutation = {
  __typename?: "Mutation";
  updatePrivateLinkConnection: {
    __typename?: "PrivateEndpointConnection";
    connectionId: string;
    principalId: string;
    cloudProvider: PrivateLinkCloudProvider;
    linkIdentifier: string;
    state: ConnectionState;
    ipAddress?: string | null;
    name: string;
    providerConnectionId: string;
    region: string;
    bindings: Array<{
      __typename?: "EndpointServiceBinding";
      projectId: string;
      serviceId: string;
      connectionId: string;
      bindingType: EndpointBindingType;
      port: number;
      hostname: string;
    }>;
  };
};

export type ClaimPrivateLinkConnectionMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  claimIdentifier: Scalars["String"]["input"];
}>;

export type ClaimPrivateLinkConnectionMutation = {
  __typename?: "Mutation";
  claimPrivateLinkConnection: {
    __typename?: "PrivateEndpointConnection";
    connectionId: string;
    principalId: string;
    cloudProvider: PrivateLinkCloudProvider;
    linkIdentifier: string;
    state: ConnectionState;
    ipAddress?: string | null;
    name: string;
    providerConnectionId: string;
    region: string;
    bindings: Array<{
      __typename?: "EndpointServiceBinding";
      projectId: string;
      serviceId: string;
      connectionId: string;
      bindingType: EndpointBindingType;
      port: number;
      hostname: string;
    }>;
  };
};

export type DeletePrivateLinkConnectionMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  connectionId: Scalars["ID"]["input"];
}>;

export type DeletePrivateLinkConnectionMutation = {
  __typename?: "Mutation";
  deletePrivateLinkConnection: any;
};

export type AttachServiceToPrivateLinkMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  connectionIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type AttachServiceToPrivateLinkMutation = {
  __typename?: "Mutation";
  attachServiceToPrivateLinkConnection: any;
};

export type DetachServiceFromPrivateLinkMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  connectionIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type DetachServiceFromPrivateLinkMutation = {
  __typename?: "Mutation";
  detachServiceFromPrivateLinkConnection: any;
};

export type SyncPrivateLinkConnectionsMutationVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type SyncPrivateLinkConnectionsMutation = {
  __typename?: "Mutation";
  syncPrivateLinkConnections: any;
};

export type RevokeSessionMutationVariables = Exact<{
  sid: Scalars["String"]["input"];
}>;

export type RevokeSessionMutation = {
  __typename?: "Mutation";
  revokeSession: any;
};

export type RevokeOtherSessionsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RevokeOtherSessionsMutation = {
  __typename?: "Mutation";
  revokeOtherSessions: any;
};

export type DeleteAllCustomerDataMutationVariables = Exact<{
  [key: string]: never;
}>;

export type DeleteAllCustomerDataMutation = {
  __typename?: "Mutation";
  deleteAllCustomerData: {
    __typename?: "DeleteAllCustomerDataOutput";
    userQueuedForDeletion: boolean;
  };
};

export type BillingAccountCostInfoFragmentFragment = {
  __typename?: "BillingAccountCostInfo";
  costToDate: number;
  costToDateGross: number;
  billingPeriodStart: any;
  billingPeriodEnd: any;
  productCostInfos: Array<{
    __typename?: "ProductCostInfo";
    productID: string;
    productName?: string | null;
    costToDate: number;
    costToDateGross: number;
  }>;
  serviceCostInfos: Array<{
    __typename?: "ServiceCostInfo";
    serviceID: string;
    costToDateGross: number;
  }>;
};

export type ProjectFragmentFragment = {
  __typename?: "Project";
  id: string;
  name: string;
  maxVPCs: number;
  created?: any | null;
  isOwner: boolean;
  enforcementType: EnforcementType;
  queuedForDeletion?: any | null;
  loggedUserRole: {
    __typename?: "UserProjectRBACRole";
    role: RbacRole;
    permissions: {
      __typename?: "RBACPermissions";
      project: {
        __typename?: "RBACProjectPermission";
        PROJECT_READ: boolean;
        PROJECT_UPDATE: boolean;
        PROJECT_BILLING_UPDATE: boolean;
        PROJECT_MEMBERS_UPDATE: boolean;
        PROJECT_OWNER_UPDATE: boolean;
        PROJECT_PLAN_CHANGE: boolean;
      };
    };
  };
  billingAccount?: {
    __typename?: "BillingAccount";
    id: string;
    created: any;
    name: string;
    isUsingInvoicing: boolean;
    trialEndDate: any;
    trialStatus: TrialStatus;
    trialType: TrialType;
    permission: {
      __typename?: "BillingPermission";
      billingAccountId: string;
      created: any;
      userId: string;
      role: BillingRole;
    };
    allPermissions: Array<{
      __typename?: "BillingPermission";
      userId: string;
      billingAccountId: string;
      created: any;
      role: BillingRole;
    }>;
    trialUsage?: {
      __typename?: "TrialUsage";
      endDate?: any | null;
      remainingUSD?: number | null;
    } | null;
    paymentMethods: Array<{
      __typename?: "PaymentMethod";
      id: string;
      isPrimary?: boolean | null;
      cardInfo?: {
        __typename?: "CardInfo";
        brand: string;
        last4: string;
        expMonth: number;
        expYear: number;
      } | null;
      addressInfo?: {
        __typename?: "AddressInfo";
        city: string;
        state: string;
        country: string;
        line1: string;
        line2: string;
        postalCode: string;
      } | null;
    }>;
    addressDetails: {
      __typename?: "AddressDetails";
      companyAddress?: {
        __typename?: "AddressInfo";
        companyName?: string | null;
        line1: string;
        line2: string;
        city: string;
        state: string;
        country: string;
        postalCode: string;
      } | null;
    };
  } | null;
  entitlementSpec?: {
    __typename?: "EntitlementSpec";
    plan_type: VirtualPlanType;
    exporter: { __typename?: "ExporterEntitlement"; enabled: boolean };
    ha_replica: {
      __typename?: "HAReplicaEntitlement";
      enabled: boolean;
      max_instances_per_service: number;
    };
    insights: {
      __typename?: "InsightsEntitlement";
      enabled: boolean;
      max_hours: number;
    };
    invoice_billing: {
      __typename?: "InvoiceBillingEntitlement";
      enabled: boolean;
    };
    pitr: {
      __typename?: "PITREntitlement";
      enabled: boolean;
      max_days: number;
    };
    support: {
      __typename?: "SupportEntitlement";
      email_support: boolean;
      solution_architect_support: boolean;
      production_support: boolean;
    };
    read_replica: { __typename?: "ReadReplicaEntitlement"; enabled: boolean };
    saml: { __typename?: "SAMLEntitlement"; enabled: boolean };
    services: {
      __typename?: "ServiceEntitlement";
      enabled: boolean;
      max_bandwidth_mb: number;
      max_cpu: number;
      max_cpu_milli: number;
      max_instances: number;
      max_fixed_instances: number;
      max_iops: number;
      max_memory: number;
      max_memory_gb: number;
      max_storage_gb: number;
      min_bandwidth_mb: number;
      min_iops: number;
      unlimited: boolean;
    };
    tiered_storage: {
      __typename?: "TieredStorageEntitlement";
      enabled: boolean;
    };
    tiger_lake: { __typename?: "TigerLakeEntitlement"; enabled: boolean };
    vpc: {
      __typename?: "VPCAttachmentEntitlement";
      attachment_type: VpcAttachmentType;
      enabled: boolean;
      max_instances: number;
    };
    ip_allow_list: {
      __typename?: "IPAllowListEntitlement";
      enabled: boolean;
      max_list_count: number;
      max_cidr_blocks_count: number;
    };
    transit_gateway: {
      __typename?: "TransitGatewayEntitlement";
      enabled: boolean;
    };
    enhanced_iops: {
      __typename?: "EnhancedIOPSRangeEntitlement";
      enabled: boolean;
      min_iops: number;
      max_iops: number;
    };
    enhanced_storage: {
      __typename?: "EnhancedStorageEntitlement";
      enabled: boolean;
    };
  } | null;
};

export type ServiceFragmentBaseFragment = {
  __typename?: "Service";
  name: string;
  id: string;
  projectId: string;
  type: Type;
  servicePlan: ServicePlan;
  isReadOnly: boolean;
  created: any;
  regionCode: string;
  storageType?: StorageType | null;
  iops?: number | null;
  status: DeployStatus;
  vpcId?: string | null;
  privateLinkConnectionIds: Array<string>;
  primaryOrdinal?: number | null;
  replicaOrdinals?: Array<number> | null;
  replicaStatus?: DeployStatus | null;
  versions?: {
    __typename?: "PostgresAndTimescaleVersions";
    hasBackupInfo: boolean;
    postgresVersion: {
      __typename?: "VersionInfo";
      name: string;
      installed: string;
      available: Array<string>;
    };
    timescaleDBVersion: {
      __typename?: "VersionInfo";
      name: string;
      installed: string;
      available: Array<string>;
    };
  } | null;
  endpoints?: {
    __typename?: "ServiceEndpoints";
    primary: { __typename?: "EndpointAddress"; host: string; port: number };
    replica: { __typename?: "EndpointAddress"; host: string; port: number };
    pooler: { __typename?: "EndpointAddress"; host: string; port: number };
  } | null;
  spec: {
    __typename?: "TimescaleDBServiceSpec";
    hostname: string;
    username: string;
    port: number;
    defaultDBName: string;
    replicaHostName?: string | null;
    replicaPort?: number | null;
    exporterID?: string | null;
    genericExporterID?: string | null;
    exporterSidecarEnabled: boolean;
    connectionPoolerEnabled: boolean;
    IOBoostEnabled: boolean;
    poolerPort?: number | null;
    poolerHostName?: string | null;
    popSQLIntegrationEnabled: boolean;
    isFixed: boolean;
    status: Status;
  };
  resources: Array<{
    __typename?: "Resource";
    id: string;
    serviceId: string;
    type: string;
    spec: {
      __typename?: "ResourceNode";
      milliCPU: number;
      memoryGB: number;
      storageGB?: number | null;
      replicaCount: number;
      syncReplicaCount: number;
    };
  }>;
  vpcEndpoint?: {
    __typename?: "Endpoint";
    projectId: string;
    serviceId: string;
    vpcId: string;
    host: string;
    port: number;
  } | null;
  metadata: {
    __typename?: "ServiceMetadata";
    environment: ServiceEnvironment;
    isAI: boolean;
  };
  dataTieringSettings?: {
    __typename?: "DataTieringSettings";
    enabled: boolean;
  } | null;
  forkedFromId?: {
    __typename?: "ForkSpec";
    serviceId: string;
    projectId: string;
    isStandby?: boolean | null;
    targetTime?: any | null;
  } | null;
};

export type ServiceMetricsFragmentFragment = {
  __typename?: "Service";
  metrics?: {
    __typename?: "ResourceMetrics";
    Time: any;
    memoryMB?: number | null;
    storageMB?: number | null;
    storageBaseMB?: number | null;
    storageWalMB?: number | null;
    storageTmpMB?: number | null;
    milliCPU?: number | null;
  } | null;
};

export type ServiceFragmentFragment = {
  __typename?: "Service";
  name: string;
  id: string;
  projectId: string;
  type: Type;
  servicePlan: ServicePlan;
  isReadOnly: boolean;
  created: any;
  regionCode: string;
  storageType?: StorageType | null;
  iops?: number | null;
  status: DeployStatus;
  vpcId?: string | null;
  privateLinkConnectionIds: Array<string>;
  primaryOrdinal?: number | null;
  replicaOrdinals?: Array<number> | null;
  replicaStatus?: DeployStatus | null;
  versions?: {
    __typename?: "PostgresAndTimescaleVersions";
    hasBackupInfo: boolean;
    postgresVersion: {
      __typename?: "VersionInfo";
      name: string;
      installed: string;
      available: Array<string>;
    };
    timescaleDBVersion: {
      __typename?: "VersionInfo";
      name: string;
      installed: string;
      available: Array<string>;
    };
  } | null;
  endpoints?: {
    __typename?: "ServiceEndpoints";
    primary: { __typename?: "EndpointAddress"; host: string; port: number };
    replica: { __typename?: "EndpointAddress"; host: string; port: number };
    pooler: { __typename?: "EndpointAddress"; host: string; port: number };
  } | null;
  spec: {
    __typename?: "TimescaleDBServiceSpec";
    hostname: string;
    username: string;
    port: number;
    defaultDBName: string;
    replicaHostName?: string | null;
    replicaPort?: number | null;
    exporterID?: string | null;
    genericExporterID?: string | null;
    exporterSidecarEnabled: boolean;
    connectionPoolerEnabled: boolean;
    IOBoostEnabled: boolean;
    poolerPort?: number | null;
    poolerHostName?: string | null;
    popSQLIntegrationEnabled: boolean;
    isFixed: boolean;
    status: Status;
  };
  resources: Array<{
    __typename?: "Resource";
    id: string;
    serviceId: string;
    type: string;
    spec: {
      __typename?: "ResourceNode";
      milliCPU: number;
      memoryGB: number;
      storageGB?: number | null;
      replicaCount: number;
      syncReplicaCount: number;
    };
  }>;
  vpcEndpoint?: {
    __typename?: "Endpoint";
    projectId: string;
    serviceId: string;
    vpcId: string;
    host: string;
    port: number;
  } | null;
  metadata: {
    __typename?: "ServiceMetadata";
    environment: ServiceEnvironment;
    isAI: boolean;
  };
  dataTieringSettings?: {
    __typename?: "DataTieringSettings";
    enabled: boolean;
  } | null;
  forkedFromId?: {
    __typename?: "ForkSpec";
    serviceId: string;
    projectId: string;
    isStandby?: boolean | null;
    targetTime?: any | null;
  } | null;
  metrics?: {
    __typename?: "ResourceMetrics";
    Time: any;
    memoryMB?: number | null;
    storageMB?: number | null;
    storageBaseMB?: number | null;
    storageWalMB?: number | null;
    storageTmpMB?: number | null;
    milliCPU?: number | null;
  } | null;
};

export type GetProjectQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetProjectQuery = {
  __typename?: "Query";
  getProject: {
    __typename?: "Project";
    id: string;
    name: string;
    maxVPCs: number;
    created?: any | null;
    isOwner: boolean;
    enforcementType: EnforcementType;
    queuedForDeletion?: any | null;
    loggedUserRole: {
      __typename?: "UserProjectRBACRole";
      role: RbacRole;
      permissions: {
        __typename?: "RBACPermissions";
        project: {
          __typename?: "RBACProjectPermission";
          PROJECT_READ: boolean;
          PROJECT_UPDATE: boolean;
          PROJECT_BILLING_UPDATE: boolean;
          PROJECT_MEMBERS_UPDATE: boolean;
          PROJECT_OWNER_UPDATE: boolean;
          PROJECT_PLAN_CHANGE: boolean;
        };
      };
    };
    billingAccount?: {
      __typename?: "BillingAccount";
      id: string;
      created: any;
      name: string;
      isUsingInvoicing: boolean;
      trialEndDate: any;
      trialStatus: TrialStatus;
      trialType: TrialType;
      permission: {
        __typename?: "BillingPermission";
        billingAccountId: string;
        created: any;
        userId: string;
        role: BillingRole;
      };
      allPermissions: Array<{
        __typename?: "BillingPermission";
        userId: string;
        billingAccountId: string;
        created: any;
        role: BillingRole;
      }>;
      trialUsage?: {
        __typename?: "TrialUsage";
        endDate?: any | null;
        remainingUSD?: number | null;
      } | null;
      paymentMethods: Array<{
        __typename?: "PaymentMethod";
        id: string;
        isPrimary?: boolean | null;
        cardInfo?: {
          __typename?: "CardInfo";
          brand: string;
          last4: string;
          expMonth: number;
          expYear: number;
        } | null;
        addressInfo?: {
          __typename?: "AddressInfo";
          city: string;
          state: string;
          country: string;
          line1: string;
          line2: string;
          postalCode: string;
        } | null;
      }>;
      addressDetails: {
        __typename?: "AddressDetails";
        companyAddress?: {
          __typename?: "AddressInfo";
          companyName?: string | null;
          line1: string;
          line2: string;
          city: string;
          state: string;
          country: string;
          postalCode: string;
        } | null;
      };
    } | null;
    entitlementSpec?: {
      __typename?: "EntitlementSpec";
      plan_type: VirtualPlanType;
      exporter: { __typename?: "ExporterEntitlement"; enabled: boolean };
      ha_replica: {
        __typename?: "HAReplicaEntitlement";
        enabled: boolean;
        max_instances_per_service: number;
      };
      insights: {
        __typename?: "InsightsEntitlement";
        enabled: boolean;
        max_hours: number;
      };
      invoice_billing: {
        __typename?: "InvoiceBillingEntitlement";
        enabled: boolean;
      };
      pitr: {
        __typename?: "PITREntitlement";
        enabled: boolean;
        max_days: number;
      };
      support: {
        __typename?: "SupportEntitlement";
        email_support: boolean;
        solution_architect_support: boolean;
        production_support: boolean;
      };
      read_replica: { __typename?: "ReadReplicaEntitlement"; enabled: boolean };
      saml: { __typename?: "SAMLEntitlement"; enabled: boolean };
      services: {
        __typename?: "ServiceEntitlement";
        enabled: boolean;
        max_bandwidth_mb: number;
        max_cpu: number;
        max_cpu_milli: number;
        max_instances: number;
        max_fixed_instances: number;
        max_iops: number;
        max_memory: number;
        max_memory_gb: number;
        max_storage_gb: number;
        min_bandwidth_mb: number;
        min_iops: number;
        unlimited: boolean;
      };
      tiered_storage: {
        __typename?: "TieredStorageEntitlement";
        enabled: boolean;
      };
      tiger_lake: { __typename?: "TigerLakeEntitlement"; enabled: boolean };
      vpc: {
        __typename?: "VPCAttachmentEntitlement";
        attachment_type: VpcAttachmentType;
        enabled: boolean;
        max_instances: number;
      };
      ip_allow_list: {
        __typename?: "IPAllowListEntitlement";
        enabled: boolean;
        max_list_count: number;
        max_cidr_blocks_count: number;
      };
      transit_gateway: {
        __typename?: "TransitGatewayEntitlement";
        enabled: boolean;
      };
      enhanced_iops: {
        __typename?: "EnhancedIOPSRangeEntitlement";
        enabled: boolean;
        min_iops: number;
        max_iops: number;
      };
      enhanced_storage: {
        __typename?: "EnhancedStorageEntitlement";
        enabled: boolean;
      };
    } | null;
  };
};

export type GetUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserQuery = {
  __typename?: "Query";
  getUser: {
    __typename?: "User";
    id: string;
    name: string;
    email: string;
    phone?: string | null;
    created?: any | null;
    managedByIdp: boolean;
    origin?: string | null;
    uiState?: string | null;
    currentAuthMethod?: CurrentAuthMethod | null;
    queuedForDeletion: boolean;
    mfaMethods?: Array<{
      __typename?: "AuthenticatorMethod";
      id: string;
    }> | null;
  };
};

export type GetAllProjectsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllProjectsQuery = {
  __typename?: "Query";
  getAllProjects: Array<{
    __typename?: "Project";
    id: string;
    name: string;
    isOwner: boolean;
    enforcementType: EnforcementType;
    queuedForDeletion?: any | null;
    billingAccount?: { __typename?: "BillingAccount"; id: string } | null;
    entitlementSpec?: {
      __typename?: "EntitlementSpec";
      plan_type: VirtualPlanType;
    } | null;
    loggedUserRole: { __typename?: "UserProjectRBACRole"; role: RbacRole };
  }>;
};

export type GetBillingAccountCorporateInvoicingQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetBillingAccountCorporateInvoicingQuery = {
  __typename?: "Query";
  getProject: {
    __typename?: "Project";
    id: string;
    billingAccount?: {
      __typename?: "BillingAccount";
      id: string;
      isUsingInvoicing: boolean;
      trialEndDate: any;
      trialStatus: TrialStatus;
      trialType: TrialType;
      paymentMethodInfo: {
        __typename?: "PaymentMethodInfo";
        primaryType: PaymentMethodType;
      };
      paymentMethods: Array<{
        __typename?: "PaymentMethod";
        id: string;
        isPrimary?: boolean | null;
        cardInfo?: {
          __typename?: "CardInfo";
          brand: string;
          last4: string;
          expMonth: number;
          expYear: number;
        } | null;
        addressInfo?: {
          __typename?: "AddressInfo";
          city: string;
          state: string;
          country: string;
          line1: string;
          line2: string;
          postalCode: string;
        } | null;
      }>;
      addressDetails: {
        __typename?: "AddressDetails";
        companyAddress?: {
          __typename?: "AddressInfo";
          companyName?: string | null;
          line1: string;
          line2: string;
          city: string;
          state: string;
          country: string;
          postalCode: string;
        } | null;
      };
      trialUsage?: {
        __typename?: "TrialUsage";
        endDate?: any | null;
        remainingUSD?: number | null;
      } | null;
    } | null;
    entitlementSpec?: {
      __typename?: "EntitlementSpec";
      plan_type: VirtualPlanType;
    } | null;
  };
};

export type GetBillingEmailAddressesQueryVariables = Exact<{
  billingAccountId: Scalars["ID"]["input"];
}>;

export type GetBillingEmailAddressesQuery = {
  __typename?: "Query";
  getBillingEmailAddresses: Array<{
    __typename?: "BillingEmailAddress";
    id: string;
    email: string;
    billingAccountId: string;
    created: any;
    activated?: any | null;
  }>;
};

export type InvoiceFragmentFragment = {
  __typename?: "Invoice";
  id: string;
  created: any;
  updated?: any | null;
  billingAccountId: string;
  totalCharged?: number | null;
  paymentState?: string | null;
  pdfUrl?: string | null;
  fromInternalBilling?: boolean | null;
};

export type GetOrbInvoicesQueryVariables = Exact<{
  billingAccountId: Scalars["ID"]["input"];
  year?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetOrbInvoicesQuery = {
  __typename?: "Query";
  getOrbInvoices: {
    __typename?: "Invoices";
    invoices: Array<{
      __typename?: "Invoice";
      id: string;
      created: any;
      updated?: any | null;
      billingAccountId: string;
      totalCharged?: number | null;
      paymentState?: string | null;
      pdfUrl?: string | null;
      fromInternalBilling?: boolean | null;
    }>;
    unpaidInvoices?: Array<{
      __typename?: "Invoice";
      id: string;
      created: any;
      updated?: any | null;
      billingAccountId: string;
      totalCharged?: number | null;
      paymentState?: string | null;
      pdfUrl?: string | null;
      fromInternalBilling?: boolean | null;
    }> | null;
  };
};

export type GetPaymentMethodsQueryVariables = Exact<{
  billingAccountId: Scalars["ID"]["input"];
}>;

export type GetPaymentMethodsQuery = {
  __typename?: "Query";
  getPaymentMethods: Array<{
    __typename?: "PaymentMethod";
    id: string;
    isPrimary?: boolean | null;
    type: PaymentMethodType;
    cardInfo?: {
      __typename?: "CardInfo";
      brand: string;
      last4: string;
      expMonth: number;
      expYear: number;
    } | null;
    addressInfo?: {
      __typename?: "AddressInfo";
      city: string;
      state: string;
      country: string;
      line1: string;
      line2: string;
      postalCode: string;
    } | null;
  }>;
};

export type GetServiceQueryVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
}>;

export type GetServiceQuery = {
  __typename?: "Query";
  getService: {
    __typename?: "Service";
    name: string;
    id: string;
    projectId: string;
    type: Type;
    servicePlan: ServicePlan;
    isReadOnly: boolean;
    created: any;
    regionCode: string;
    storageType?: StorageType | null;
    iops?: number | null;
    status: DeployStatus;
    vpcId?: string | null;
    privateLinkConnectionIds: Array<string>;
    primaryOrdinal?: number | null;
    replicaOrdinals?: Array<number> | null;
    replicaStatus?: DeployStatus | null;
    versions?: {
      __typename?: "PostgresAndTimescaleVersions";
      hasBackupInfo: boolean;
      postgresVersion: {
        __typename?: "VersionInfo";
        name: string;
        installed: string;
        available: Array<string>;
      };
      timescaleDBVersion: {
        __typename?: "VersionInfo";
        name: string;
        installed: string;
        available: Array<string>;
      };
    } | null;
    endpoints?: {
      __typename?: "ServiceEndpoints";
      primary: { __typename?: "EndpointAddress"; host: string; port: number };
      replica: { __typename?: "EndpointAddress"; host: string; port: number };
      pooler: { __typename?: "EndpointAddress"; host: string; port: number };
    } | null;
    spec: {
      __typename?: "TimescaleDBServiceSpec";
      hostname: string;
      username: string;
      port: number;
      defaultDBName: string;
      replicaHostName?: string | null;
      replicaPort?: number | null;
      exporterID?: string | null;
      genericExporterID?: string | null;
      exporterSidecarEnabled: boolean;
      connectionPoolerEnabled: boolean;
      IOBoostEnabled: boolean;
      poolerPort?: number | null;
      poolerHostName?: string | null;
      popSQLIntegrationEnabled: boolean;
      isFixed: boolean;
      status: Status;
    };
    resources: Array<{
      __typename?: "Resource";
      id: string;
      serviceId: string;
      type: string;
      spec: {
        __typename?: "ResourceNode";
        milliCPU: number;
        memoryGB: number;
        storageGB?: number | null;
        replicaCount: number;
        syncReplicaCount: number;
      };
    }>;
    vpcEndpoint?: {
      __typename?: "Endpoint";
      projectId: string;
      serviceId: string;
      vpcId: string;
      host: string;
      port: number;
    } | null;
    metadata: {
      __typename?: "ServiceMetadata";
      environment: ServiceEnvironment;
      isAI: boolean;
    };
    dataTieringSettings?: {
      __typename?: "DataTieringSettings";
      enabled: boolean;
    } | null;
    forkedFromId?: {
      __typename?: "ForkSpec";
      serviceId: string;
      projectId: string;
      isStandby?: boolean | null;
      targetTime?: any | null;
    } | null;
    metrics?: {
      __typename?: "ResourceMetrics";
      Time: any;
      memoryMB?: number | null;
      storageMB?: number | null;
      storageBaseMB?: number | null;
      storageWalMB?: number | null;
      storageTmpMB?: number | null;
      milliCPU?: number | null;
    } | null;
  };
};

export type GetServiceResourcesAndStatusQueryVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
}>;

export type GetServiceResourcesAndStatusQuery = {
  __typename?: "Query";
  getService: {
    __typename?: "Service";
    id: string;
    name: string;
    status: DeployStatus;
    resources: Array<{
      __typename?: "Resource";
      spec: {
        __typename?: "ResourceNode";
        storageGB?: number | null;
        milliCPU: number;
        memoryGB: number;
        replicaCount: number;
        syncReplicaCount: number;
      };
    }>;
  };
};

export type GetServiceResizeInfoQueryVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
}>;

export type GetServiceResizeInfoQuery = {
  __typename?: "Query";
  getService: {
    __typename?: "Service";
    id: string;
    name: string;
    status: DeployStatus;
    resources: Array<{
      __typename?: "Resource";
      id: string;
      type: string;
      serviceId: string;
      spec: {
        __typename?: "ResourceNode";
        storageGB?: number | null;
        milliCPU: number;
        memoryGB: number;
        replicaCount: number;
        syncReplicaCount: number;
      };
    }>;
  };
};

export type ServiceMetricsBaseFieldsFragment = {
  __typename?: "ServiceMetrics";
  compute: Array<{
    __typename?: "ComputeMetricsWindow";
    ordinal: number;
    role: InstanceRole;
    limits: {
      __typename?: "ComputeMetricsLimits";
      milliCPU: number;
      memoryMiB: number;
    };
    data: Array<{
      __typename?: "ComputeMetricsDataPoint";
      time: any;
      milliCPU: number;
      memoryMiB: number;
    }>;
  } | null>;
  storage: Array<{
    __typename?: "StorageMetricsWindow";
    ordinal: number;
    role: InstanceRole;
    data: Array<{
      __typename?: "StorageMetricsDataPoint";
      time: any;
      storageMiB: number;
    }>;
  } | null>;
  diskPerformance: Array<{
    __typename?: "DiskPerformanceMetricsWindow";
    ordinal: number;
    role: InstanceRole;
    limits: {
      __typename?: "DiskPerformanceMetricsLimits";
      iops: number;
      bandwidthMBs: number;
    };
    data: Array<{
      __typename?: "DiskPerformanceMetricsDataPoint";
      time: any;
      readIOPs: number;
      writeIOPs: number;
      readBandwidth: number;
      writeBandwidth: number;
    }>;
  } | null>;
};

export type GetServiceMetricsQueryVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  start: Scalars["Time"]["input"];
  end: Scalars["Time"]["input"];
  bucketSeconds: Scalars["Int"]["input"];
  role?: InputMaybe<InstanceRole>;
}>;

export type GetServiceMetricsQuery = {
  __typename?: "Query";
  getServiceMetrics: {
    __typename?: "ServiceMetrics";
    events: Array<{
      __typename?: "MetricsEvent";
      time: any;
      type: MetricsEventType;
      ordinal?: number | null;
    } | null>;
    compute: Array<{
      __typename?: "ComputeMetricsWindow";
      ordinal: number;
      role: InstanceRole;
      limits: {
        __typename?: "ComputeMetricsLimits";
        milliCPU: number;
        memoryMiB: number;
      };
      data: Array<{
        __typename?: "ComputeMetricsDataPoint";
        time: any;
        milliCPU: number;
        memoryMiB: number;
      }>;
    } | null>;
    storage: Array<{
      __typename?: "StorageMetricsWindow";
      ordinal: number;
      role: InstanceRole;
      data: Array<{
        __typename?: "StorageMetricsDataPoint";
        time: any;
        storageMiB: number;
      }>;
    } | null>;
    diskPerformance: Array<{
      __typename?: "DiskPerformanceMetricsWindow";
      ordinal: number;
      role: InstanceRole;
      limits: {
        __typename?: "DiskPerformanceMetricsLimits";
        iops: number;
        bandwidthMBs: number;
      };
      data: Array<{
        __typename?: "DiskPerformanceMetricsDataPoint";
        time: any;
        readIOPs: number;
        writeIOPs: number;
        readBandwidth: number;
        writeBandwidth: number;
      }>;
    } | null>;
  };
};

export type GetServiceMetricsQpsQueryVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  start: Scalars["Time"]["input"];
  end: Scalars["Time"]["input"];
  bucketSeconds: Scalars["Int"]["input"];
  role?: InputMaybe<InstanceRole>;
}>;

export type GetServiceMetricsQpsQuery = {
  __typename?: "Query";
  getServiceMetrics: {
    __typename?: "ServiceMetrics";
    queriesPerSecond: Array<{
      __typename?: "QPSMetricsWindow";
      ordinal: number;
      role: InstanceRole;
      data: Array<{
        __typename?: "QPSMetricsDataPoint";
        time: any;
        reads: number;
        writes: number;
        all: number;
      }>;
    } | null>;
  };
};

export type GetPopSqlIntegrationStatusQueryVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
}>;

export type GetPopSqlIntegrationStatusQuery = {
  __typename?: "Query";
  getPopSQLIntegrationStatus: Status;
};

export type GetAllServicesQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetAllServicesQuery = {
  __typename?: "Query";
  getAllServices: Array<{
    __typename?: "Service";
    name: string;
    id: string;
    projectId: string;
    type: Type;
    servicePlan: ServicePlan;
    isReadOnly: boolean;
    created: any;
    regionCode: string;
    storageType?: StorageType | null;
    iops?: number | null;
    status: DeployStatus;
    vpcId?: string | null;
    privateLinkConnectionIds: Array<string>;
    primaryOrdinal?: number | null;
    replicaOrdinals?: Array<number> | null;
    replicaStatus?: DeployStatus | null;
    versions?: {
      __typename?: "PostgresAndTimescaleVersions";
      hasBackupInfo: boolean;
      postgresVersion: {
        __typename?: "VersionInfo";
        name: string;
        installed: string;
        available: Array<string>;
      };
      timescaleDBVersion: {
        __typename?: "VersionInfo";
        name: string;
        installed: string;
        available: Array<string>;
      };
    } | null;
    endpoints?: {
      __typename?: "ServiceEndpoints";
      primary: { __typename?: "EndpointAddress"; host: string; port: number };
      replica: { __typename?: "EndpointAddress"; host: string; port: number };
      pooler: { __typename?: "EndpointAddress"; host: string; port: number };
    } | null;
    spec: {
      __typename?: "TimescaleDBServiceSpec";
      hostname: string;
      username: string;
      port: number;
      defaultDBName: string;
      replicaHostName?: string | null;
      replicaPort?: number | null;
      exporterID?: string | null;
      genericExporterID?: string | null;
      exporterSidecarEnabled: boolean;
      connectionPoolerEnabled: boolean;
      IOBoostEnabled: boolean;
      poolerPort?: number | null;
      poolerHostName?: string | null;
      popSQLIntegrationEnabled: boolean;
      isFixed: boolean;
      status: Status;
    };
    resources: Array<{
      __typename?: "Resource";
      id: string;
      serviceId: string;
      type: string;
      spec: {
        __typename?: "ResourceNode";
        milliCPU: number;
        memoryGB: number;
        storageGB?: number | null;
        replicaCount: number;
        syncReplicaCount: number;
      };
    }>;
    vpcEndpoint?: {
      __typename?: "Endpoint";
      projectId: string;
      serviceId: string;
      vpcId: string;
      host: string;
      port: number;
    } | null;
    metadata: {
      __typename?: "ServiceMetadata";
      environment: ServiceEnvironment;
      isAI: boolean;
    };
    dataTieringSettings?: {
      __typename?: "DataTieringSettings";
      enabled: boolean;
    } | null;
    forkedFromId?: {
      __typename?: "ForkSpec";
      serviceId: string;
      projectId: string;
      isStandby?: boolean | null;
      targetTime?: any | null;
    } | null;
    metrics?: {
      __typename?: "ResourceMetrics";
      Time: any;
      memoryMB?: number | null;
      storageMB?: number | null;
      storageBaseMB?: number | null;
      storageWalMB?: number | null;
      storageTmpMB?: number | null;
      milliCPU?: number | null;
    } | null;
  }>;
};

export type GetServiceLogsQueryVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  serviceOrdinal?: InputMaybe<Scalars["Int"]["input"]>;
  pageIndex?: InputMaybe<Scalars["Int"]["input"]>;
  startTime: Scalars["Time"]["input"];
  searchTags?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;

export type GetServiceLogsQuery = {
  __typename?: "Query";
  getServiceLogs: Array<string>;
};

export type ServiceLogsPageQueryVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  filters?: InputMaybe<ServiceLogsFilters>;
  cursor?: InputMaybe<Scalars["ID"]["input"]>;
  limit: Scalars["Int"]["input"];
  bucketIntervalSeconds?: InputMaybe<Scalars["Int"]["input"]>;
  fields?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type ServiceLogsPageQuery = {
  __typename?: "Query";
  serviceLogs: {
    __typename?: "ServiceLogs";
    aggregates: {
      __typename?: "ServiceLogsAggregates";
      countsBySeverity: {
        __typename?: "ServiceLogsSeverityAggregates";
        totals: Array<{
          __typename?: "ServiceLogsSeverityCount";
          severity: string;
          count: number;
        }>;
        dataPoints: Array<{
          __typename?: "ServiceLogsSeverityDataPoint";
          bucket: any;
          counts: Array<{
            __typename?: "ServiceLogsSeverityCount";
            severity: string;
            count: number;
          }>;
        }>;
      };
    };
    items: {
      __typename?: "ServiceLogsItems";
      items: Array<{
        __typename?: "ServiceLogsItem";
        cursor: string;
        item: {
          __typename?: "ServiceLog";
          timestamp: any;
          message: string;
          severity: string;
          fields: Array<{
            __typename?: "ServiceLogFieldValue";
            key: string;
            value: string;
          }>;
        };
      }>;
      pageInfo: {
        __typename?: "ServiceLogsPageInfo";
        lastCursor?: string | null;
        hasNextPage: boolean;
      };
    };
  };
};

export type LoginMfaQueryVariables = Exact<{
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
}>;

export type LoginMfaQuery = {
  __typename?: "Query";
  loginMfa:
    | {
        __typename?: "LoginMfaRequired";
        twoFactorId: string;
        mfaMethods: Array<{ __typename?: "AuthenticatorMethod"; id: string }>;
      }
    | {
        __typename?: "LoginSuccess";
        user: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
          phone?: string | null;
          created?: any | null;
        };
      };
};

export type LoginMfaChallengeQueryVariables = Exact<{
  code: Scalars["String"]["input"];
  twoFactorId: Scalars["String"]["input"];
}>;

export type LoginMfaChallengeQuery = {
  __typename?: "Query";
  loginMfa:
    | { __typename?: "LoginMfaRequired" }
    | {
        __typename?: "LoginSuccess";
        user: {
          __typename?: "User";
          id: string;
          name: string;
          email: string;
          phone?: string | null;
          created?: any | null;
        };
      };
};

export type MfaChallengeQueryVariables = Exact<{
  code: Scalars["String"]["input"];
  trustChallenge: Scalars["String"]["input"];
  resetToken?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type MfaChallengeQuery = {
  __typename?: "Query";
  mfaChallenge: { __typename?: "MfaChallengeResponse"; trustToken: string };
};

export type LogoutQueryVariables = Exact<{ [key: string]: never }>;

export type LogoutQuery = { __typename?: "Query"; logout: any };

export type GetOrbProductsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  experimentGroup?: InputMaybe<ExperimentGroup>;
}>;

export type GetOrbProductsQuery = {
  __typename?: "Query";
  orbProducts: Array<{
    __typename?: "Product";
    id: string;
    name: string;
    plans: Array<{
      __typename?: "Plan";
      productId: string;
      IOPS?: number | null;
      price: number;
      milliCPU?: number | null;
      memoryGB?: number | null;
      storageGB?: number | null;
      regionCode: string;
      cloudProvider: CloudProvider;
    }>;
  }>;
};

export type GetOrbAllProductsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrbAllProductsQuery = {
  __typename?: "Query";
  orbAllProducts: Array<{
    __typename?: "TierWithProducts";
    id: string;
    products: Array<{
      __typename?: "Product";
      id: string;
      name: string;
      plans: Array<{
        __typename?: "Plan";
        productId: string;
        IOPS?: number | null;
        price: number;
        milliCPU?: number | null;
        memoryGB?: number | null;
        storageGB?: number | null;
        regionCode: string;
        cloudProvider: CloudProvider;
      }>;
    }>;
  }>;
};

export type GetServiceConfigHistoryQueryVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
  serviceOrdinal?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetServiceConfigHistoryQuery = {
  __typename?: "Query";
  getServiceConfigHistory: {
    __typename?: "ServiceConfigHistory";
    ServiceStorageReadyToBeModified: boolean;
    compute: Array<{
      __typename?: "ServiceComputeConfig";
      memoryGB: number;
      milliCPU: number;
      created: any;
    }>;
    storage: Array<{
      __typename?: "ServiceStorageConfig";
      storageGB: number;
      volumeType: string;
      iops: number;
      bandwidthMBs: number;
      created: any;
    }>;
  };
};

export type ValidateResetTokenMfaQueryVariables = Exact<{
  token: Scalars["String"]["input"];
}>;

export type ValidateResetTokenMfaQuery = {
  __typename?: "Query";
  validateResetTokenMfa: {
    __typename?: "ValidateResetTokenMfaResponse";
    message: string;
    mfaMethods: Array<{ __typename?: "AuthenticatorMethod"; id: string }>;
  };
};

export type GetPostgresParametersQueryVariables = Exact<{
  serviceId: Scalars["ID"]["input"];
  projectId: Scalars["ID"]["input"];
}>;

export type GetPostgresParametersQuery = {
  __typename?: "Query";
  getPostgresParameters: {
    __typename?: "PostgresParameters";
    string_parameters: Array<{
      __typename?: "StringParameter";
      current_value: string;
      allowed_values: Array<string>;
      info: {
        __typename?: "ParameterInfo";
        name: string;
        description: string;
        is_user_editable: boolean;
        requires_restart: boolean;
        is_tune_overridable: boolean;
        ui_priority: number;
        is_pending_restart: boolean;
        is_user_modified: boolean;
      };
    }>;
    numeric_parameters: Array<{
      __typename?: "NumericParameter";
      unit: ParameterUnit;
      current_value: number;
      max_allowed_value?: number | null;
      min_allowed_value?: number | null;
      info: {
        __typename?: "ParameterInfo";
        name: string;
        description: string;
        is_user_editable: boolean;
        requires_restart: boolean;
        is_tune_overridable: boolean;
        ui_priority: number;
        is_pending_restart: boolean;
        is_user_modified: boolean;
      };
    }>;
  };
};

export type GetAllNextMaintenanceQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetAllNextMaintenanceQuery = {
  __typename?: "Query";
  getAllNextMaintenance: Array<{
    __typename?: "ServiceNextMaintenance";
    serviceId: string;
    maintenance: {
      __typename?: "NextMaintenance";
      start: any;
      end: any;
      isMaintenanceScheduled: boolean;
    };
  }>;
};

export type GetServiceTablesQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetServiceTablesQuery = {
  __typename?: "Query";
  getTableList: Array<{
    __typename?: "TableID";
    name: string;
    isHypertable: boolean;
    schema: string;
  }>;
};

export type GetServiceCatalogTablesQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetServiceCatalogTablesQuery = {
  __typename?: "Query";
  getCatalogTableList: Array<{
    __typename?: "TableID";
    name: string;
    isHypertable: boolean;
    schema: string;
  }>;
};

export type GetServiceContinuousAggregatesQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetServiceContinuousAggregatesQuery = {
  __typename?: "Query";
  getContAggList: Array<{
    __typename?: "ContAggID";
    name: string;
    schema: string;
  }>;
};

export type GetServiceLargestObjectsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetServiceLargestObjectsQuery = {
  __typename?: "Query";
  getLargestObjects: Array<{
    __typename?: "ObjectSizeInfo";
    size: number;
    objectId:
      | { __typename: "ContAggID"; name: string; schema: string }
      | {
          __typename: "TableID";
          isHypertable: boolean;
          schema: string;
          name: string;
        };
  }>;
};

export type GetServiceGeneralInformationQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetServiceGeneralInformationQuery = {
  __typename?: "Query";
  getDatabaseOverview: {
    __typename?: "GetDatabaseOverviewOutput";
    info: {
      __typename?: "ObjectCounts";
      pgTables: number;
      hypertables: number;
      contAggs: number;
      realtimeContAggs: number;
      policies: number;
    };
    compressionV2?: {
      __typename?: "DBCompressionStats";
      numCompressedHypertables: number;
      numCompressedContAggs: number;
      stats: {
        __typename?: "CompressionStats";
        precompressed: number;
        compressed: number;
        uncompressed: number;
        diskSize: number;
        originalSize: number;
        savings: number;
      };
    } | null;
    policyCounts?: Array<{
      __typename?: "PolicyCount";
      name: string;
      count: number;
    }> | null;
  };
};

export type HyperMetadataFragmentFragment = {
  __typename?: "HyperMetadata";
  hypertableId: number;
  numChunks: number;
  compression: boolean;
  timeInterval: string;
  timeIntervalUsecs: number;
  integerInterval: number;
  compressionStats?: {
    __typename?: "CompressionStats";
    precompressed: number;
    compressed: number;
    uncompressed: number;
    diskSize: number;
    originalSize: number;
    savings: number;
  } | null;
  dimensions?: Array<
    | {
        __typename?: "SpaceDimension";
        columnName: string;
        numPartitions: number;
      }
    | {
        __typename?: "TimeDimension";
        columnName: string;
        timeInterval?: string | null;
        integerInterval?: number | null;
      }
  > | null;
};

export type GetTableInfoQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  tableSchema: Scalars["ID"]["input"];
  tableName: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetTableInfoQuery = {
  __typename?: "Query";
  getTableInfo: {
    __typename?: "Table";
    metadata: {
      __typename?: "TableMetadata";
      size: number;
      approxRowCount: number;
      owner: string;
      id: {
        __typename?: "TableID";
        schema: string;
        name: string;
        isHypertable: boolean;
      };
    };
    hyperMetadata?: {
      __typename?: "HyperMetadata";
      hypertableId: number;
      numChunks: number;
      compression: boolean;
      timeInterval: string;
      timeIntervalUsecs: number;
      integerInterval: number;
      compressionStats?: {
        __typename?: "CompressionStats";
        precompressed: number;
        compressed: number;
        uncompressed: number;
        diskSize: number;
        originalSize: number;
        savings: number;
      } | null;
      dimensions?: Array<
        | {
            __typename?: "SpaceDimension";
            columnName: string;
            numPartitions: number;
          }
        | {
            __typename?: "TimeDimension";
            columnName: string;
            timeInterval?: string | null;
            integerInterval?: number | null;
          }
      > | null;
    } | null;
    schema: Array<{
      __typename?: "Column";
      name: string;
      type: string;
      default: string;
      nullable: boolean;
    }>;
    indexes: Array<{ __typename?: "Index"; name: string; definition: string }>;
    chunks: Array<{
      __typename?: "Chunk";
      name: string;
      size: number;
      startTime: string;
      endTime: string;
      rangeStart?: string | null;
      rangeEnd?: string | null;
      isCompressed: boolean;
      compressedSize: number;
      precompressedSize: number;
      uncompressedSize: number;
      indexSize: number;
    }>;
    contAggs: Array<{
      __typename?: "ContAgg";
      name: string;
      schema: string;
      materializedOnly: boolean;
      definition: string;
    }>;
    foreignKeys: Array<{
      __typename?: "ForeignKey";
      name: string;
      keyCols: string;
      refSchema: string;
      refName: string;
      refCols: string;
    }>;
    policies: Array<{
      __typename?: "Policy";
      id: number;
      type: string;
      target: string;
      interval: string;
      fullInfo: string;
    }>;
  };
};

export type GetServiceCaggInfoQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  contAggSchema: Scalars["ID"]["input"];
  contAggName: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetServiceCaggInfoQuery = {
  __typename?: "Query";
  getContAggInfo: {
    __typename?: "ContAggInfo";
    definition: string;
    metadata: {
      __typename?: "ContAggMetadata";
      size: number;
      approxRowCount: number;
      owner: string;
      materializedOnly: boolean;
      lastRefresh: string;
      nextRefresh: string;
      id: { __typename?: "ContAggID"; schema: string; name: string };
      parentID:
        | { __typename?: "ContAggID"; schema: string; name: string }
        | { __typename?: "TableID"; schema: string; name: string };
    };
    hyperMetadata: {
      __typename?: "HyperMetadata";
      hypertableId: number;
      numChunks: number;
      compression: boolean;
      timeInterval: string;
      timeIntervalUsecs: number;
      integerInterval: number;
      compressionStats?: {
        __typename?: "CompressionStats";
        precompressed: number;
        compressed: number;
        uncompressed: number;
        diskSize: number;
        originalSize: number;
        savings: number;
      } | null;
      dimensions?: Array<
        | {
            __typename?: "SpaceDimension";
            columnName: string;
            numPartitions: number;
          }
        | {
            __typename?: "TimeDimension";
            columnName: string;
            timeInterval?: string | null;
            integerInterval?: number | null;
          }
      > | null;
    };
    schema: Array<{
      __typename?: "Column";
      name: string;
      type: string;
      default: string;
      nullable: boolean;
      constraints: Array<string>;
    }>;
    indexes: Array<{ __typename?: "Index"; name: string; definition: string }>;
    policies: Array<{
      __typename?: "Policy";
      id: number;
      type: string;
      target: string;
      interval: string;
      fullInfo: string;
    }>;
    refreshPolicies: Array<{
      __typename?: "ContAggRefreshPolicy";
      startOffset: string;
      endOffset: string;
      interval: string;
    }>;
    chunks: Array<{
      __typename?: "Chunk";
      name: string;
      size: number;
      startTime: string;
      endTime: string;
      rangeStart?: string | null;
      rangeEnd?: string | null;
      isCompressed: boolean;
      compressedSize: number;
      precompressedSize: number;
      uncompressedSize: number;
      indexSize: number;
    }>;
  };
};

export type GetAllVpcsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetAllVpcsQuery = {
  __typename?: "Query";
  getAllVpcs: Array<{
    __typename?: "VPC";
    id: string;
    projectId: string;
    provisionedId: string;
    cidr: string;
    cloudProvider: CloudProvider;
    name: string;
    created?: any | null;
    updated?: any | null;
    errorMessage?: string | null;
    status: VpcStatus;
    regionCode: string;
    peeringConnections: Array<{
      __typename?: "PeeringConnection";
      id?: string | null;
      vpcId: string;
      errorMessage?: string | null;
      status: PeeringConnectionStatus;
      peerVpc: {
        __typename?: "PeerVPC";
        id: string;
        accountId: string;
        regionCode: string;
        cidr: string;
        cidrBlocks?: Array<string> | null;
      };
    }>;
  }>;
};

export type GetAllIpAllowListQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetAllIpAllowListQuery = {
  __typename?: "Query";
  getIPAllowLists: Array<{
    __typename?: "IPAllowList";
    listId: number;
    description: string;
    cidrBlocks: Array<string>;
    associatedServices?: Array<string> | null;
    created: any;
  }>;
};

export type GetProjectMembersQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetProjectMembersQuery = {
  __typename?: "Query";
  getProjectMembers: Array<{
    __typename?: "ProjectMember";
    projectId: string;
    userId: string;
    hasSSO: boolean;
    joined: any;
    role: Role;
    rbacRole: RbacRole;
    user: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
      created?: any | null;
      mfaMethods?: Array<{
        __typename?: "AuthenticatorMethod";
        id: string;
      }> | null;
      lastLoginSession?: {
        __typename?: "LastLoginSession";
        timestamp: any;
        authMethod: CurrentAuthMethod;
      } | null;
    };
  }>;
};

export type GetProjectInvitesQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetProjectInvitesQuery = {
  __typename?: "Query";
  getProjectInvites: Array<{
    __typename?: "ProjectInvite";
    id: string;
    email: string;
    role: Role;
    created: any;
    declined?: any | null;
    rbacRole: RbacRole;
    project: { __typename?: "Project"; id: string; name: string };
  }>;
};

export type GetProjectInvitesForUserQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetProjectInvitesForUserQuery = {
  __typename?: "Query";
  getProjectInvitesForUser: Array<{
    __typename?: "ProjectInvite";
    id: string;
    email: string;
    role: Role;
    created: any;
    declined?: any | null;
    hash?: string | null;
    rbacRole: RbacRole;
    project: { __typename?: "Project"; id: string; name: string };
    inviter?: {
      __typename?: "User";
      id: string;
      name: string;
      email: string;
      phone?: string | null;
    } | null;
  }>;
};

export type GetPendingPaymentDeletionQueryVariables = Exact<{
  billingAccountId: Scalars["ID"]["input"];
}>;

export type GetPendingPaymentDeletionQuery = {
  __typename?: "Query";
  getPendingPaymentDeletion?: {
    __typename?: "PaymentMethod";
    id: string;
  } | null;
};

export type GetPostgresAndTimescaleDbVersionQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
}>;

export type GetPostgresAndTimescaleDbVersionQuery = {
  __typename?: "Query";
  getPostgresAndTimescaleDBVersion: {
    __typename?: "PostgresAndTimescaleVersions";
    hasBackupInfo: boolean;
    postgresVersion: {
      __typename?: "VersionInfo";
      name: string;
      installed: string;
      available: Array<string>;
    };
    timescaleDBVersion: {
      __typename?: "VersionInfo";
      name: string;
      installed: string;
      available: Array<string>;
      scheduledUpgrade?: any | null;
    };
  };
};

export type GetAllMetricExportersQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetAllMetricExportersQuery = {
  __typename?: "Query";
  getAllMetricExporters: Array<{
    __typename?: "MetricExporter";
    id: string;
    exporterUuid: string;
    projectId: string;
    created: any;
    name: string;
    type: MetricExporterType;
    regionCode: string;
    enablePgMetrics?: boolean | null;
    config:
      | { __typename?: "AzureMonitorMetricConfig"; connectionString: string }
      | {
          __typename?: "CloudWatchMetricConfig";
          logGroupName: string;
          logStreamName: string;
          namespace: string;
          awsRegion: string;
          awsRoleArn?: string | null;
          awsAccessKey: string;
          awsSecretKey: string;
        }
      | {
          __typename?: "DatadogMetricConfig";
          apiKey: string;
          site?: string | null;
        }
      | {
          __typename?: "PrometheusMetricConfig";
          user?: string | null;
          password?: string | null;
        };
  }>;
};

export type GetAllGenericExportersQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetAllGenericExportersQuery = {
  __typename?: "Query";
  getAllGenericExporters: Array<{
    __typename?: "GenericExporter";
    id: string;
    projectId: string;
    created: any;
    name: string;
    type: GenericExporterType;
    regionCode: string;
    config: {
      __typename?: "CloudWatchConfig";
      logGroupName: string;
      logStreamName: string;
      awsRegion: string;
      awsRoleArn?: string | null;
      awsAccessKey: string;
      awsSecretKey: string;
    };
  }>;
};

export type GetPostgresMajorVersionUpgradeStatusQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
}>;

export type GetPostgresMajorVersionUpgradeStatusQuery = {
  __typename?: "Query";
  getPostgresMajorVersionUpgradeStatus: {
    __typename?: "PostgresMajorVersionUpgradeStatus";
    stage: PostgresMajorVersionUpgradeStage;
    error?: string | null;
  };
};

export type GetPatRecordsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetPatRecordsQuery = {
  __typename?: "Query";
  getPATRecords: Array<{
    __typename?: "PATRecord";
    name: string;
    projectId: string;
    created: any;
    issuingUserId: string;
    clientCredentials: {
      __typename?: "ClientCredentials";
      accessKey: string;
      secretKey?: string | null;
    };
  } | null>;
};

export type GetPostgresAvailableExtensionsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetPostgresAvailableExtensionsQuery = {
  __typename?: "Query";
  getPostgresAvailableExtensions: Array<{
    __typename?: "PostgresExtension";
    name: string;
    defaultVersion: string;
    installedVersion?: string | null;
    comment: string;
  }>;
};

export type GetDataTieringSummaryQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetDataTieringSummaryQuery = {
  __typename?: "Query";
  getDataTieringSummary?: Array<{
    __typename?: "TieringUsage";
    serviceIds?: Array<string> | null;
    tieredBytes: number;
  } | null> | null;
};

export type GetCostedProjectDataTieringUsageDistributionQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetCostedProjectDataTieringUsageDistributionQuery = {
  __typename?: "Query";
  getCostedProjectDataTieringUsageDistribution: Array<{
    __typename?: "DataTieringStorageSummary";
    serviceIds: Array<string>;
    tieringUsageInBytes: number;
    tieringUsageCost: number;
    estimatedEbsUsageInBytes: number;
    estimatedEbsUsageCost: number;
  }>;
};

export type GetRecoveryWindowsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
}>;

export type GetRecoveryWindowsQuery = {
  __typename?: "Query";
  getRecoveryWindows: Array<{
    __typename?: "RecoveryWindow";
    method: RecoveryMethod;
    startTime: any;
    endTime: any;
  }>;
};

export type MetricValueFragment = {
  __typename?: "MetricValue";
  value: string;
  unit: MetricUnit;
};

export type GetQueryStatsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  serviceRole?: InputMaybe<InstanceRole>;
  limit: Scalars["Int"]["input"];
  sortBy: QueryStatSortFieldOption;
  sortOrder: QueryStatSortOrderOption;
  constraints?: InputMaybe<Array<QueryStatConstraint> | QueryStatConstraint>;
  queryRange: QueryRange;
}>;

export type GetQueryStatsQuery = {
  __typename?: "Query";
  getQueryStatsAndMetadata: {
    __typename?: "QueryStatResponse";
    statsAsOf?: any | null;
    stats: Array<{
      __typename?: "QueryStat";
      queryHash: string;
      query: string;
      userName: string;
      hasExplainPlan: boolean;
      metrics: {
        __typename?: "QueryStatMetrics";
        executions?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        rows?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50Time?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95Time?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        totalTime?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        hypertablesCount?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        compressionCount?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50CpuTimeUser?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95CpuTimeUser?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50CpuTimeSys?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95CpuTimeSys?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50MemAllocatedBytes?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95MemAllocatedBytes?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50FsBytesRead?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95FsBytesRead?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50FsBytesWritten?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95FsBytesWritten?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
      };
    } | null>;
    queriesDataPoints: Array<{
      __typename?: "PerQueryGraphDataPoint";
      queryHash: string;
      dataPoints: Array<{
        __typename?: "GraphDataPoint";
        bucket: any;
        metrics: {
          __typename?: "QueryStatMetrics";
          p50Time?: {
            __typename?: "MetricValue";
            value: string;
            unit: MetricUnit;
          } | null;
          p95Time?: {
            __typename?: "MetricValue";
            value: string;
            unit: MetricUnit;
          } | null;
        };
      }>;
    }>;
  };
};

export type GraphMetricValueFragment = {
  __typename?: "MetricValue";
  value: string;
  unit: MetricUnit;
};

export type GraphMetricsFragment = {
  __typename?: "QueryStatMetrics";
  executions?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  plans?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  rows?: { __typename?: "MetricValue"; value: string; unit: MetricUnit } | null;
  p50Time?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  p95Time?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  cacheHitRatio?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  cacheMemoryRate?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  bytesReadRate?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  p50CpuTimeUser?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  p95CpuTimeUser?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  p50CpuTimeSys?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  p95CpuTimeSys?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  p50MemAllocatedBytes?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  p95MemAllocatedBytes?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  p50FsBytesRead?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  p95FsBytesRead?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  p50FsBytesWritten?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
  p95FsBytesWritten?: {
    __typename?: "MetricValue";
    value: string;
    unit: MetricUnit;
  } | null;
};

export type GetQueryMetricGraphsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  serviceOrdinal: Scalars["Int"]["input"];
  queryRange: QueryRange;
  queryHash: Scalars["String"]["input"];
}>;

export type GetQueryMetricGraphsQuery = {
  __typename?: "Query";
  getQueryMetricGraphs: {
    __typename?: "QueryMetricGraphResponse";
    total: number;
    dataPoints: Array<{
      __typename?: "GraphDataPoint";
      bucket: any;
      queryHash: string;
      metrics: {
        __typename?: "QueryStatMetrics";
        executions?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        plans?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        rows?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50Time?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95Time?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        cacheHitRatio?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        cacheMemoryRate?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        bytesReadRate?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50CpuTimeUser?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95CpuTimeUser?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50CpuTimeSys?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95CpuTimeSys?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50MemAllocatedBytes?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95MemAllocatedBytes?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50FsBytesRead?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95FsBytesRead?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50FsBytesWritten?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95FsBytesWritten?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
      };
    }>;
  };
};

export type GetQueryDetailsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  serviceOrdinal: Scalars["Int"]["input"];
  queryHash: Scalars["String"]["input"];
}>;

export type GetQueryDetailsQuery = {
  __typename?: "Query";
  getQueryDetails: {
    __typename?: "GetQueryDetailsResponse";
    queryDetails: { __typename?: "QueryDetails"; normalizedQuery: string };
  };
};

export type GetQueryLatestExplainQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  serviceRole: InstanceRole;
  queryHash: Scalars["String"]["input"];
}>;

export type GetQueryLatestExplainQuery = {
  __typename?: "Query";
  getQueryLatestExplain?: {
    __typename?: "ExplainPlan";
    plan: string;
    timestamp: any;
  } | null;
};

export type GetQueryMetricsDetailsAndExplainQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  serviceOrdinal: Scalars["Int"]["input"];
  queryRange: QueryRange;
  queryHash: Scalars["String"]["input"];
  serviceRole: InstanceRole;
}>;

export type GetQueryMetricsDetailsAndExplainQuery = {
  __typename?: "Query";
  getQueryMetricGraphs: {
    __typename?: "QueryMetricGraphResponse";
    total: number;
    dataPoints: Array<{
      __typename?: "GraphDataPoint";
      bucket: any;
      queryHash: string;
      metrics: {
        __typename?: "QueryStatMetrics";
        executions?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        plans?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        rows?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50Time?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95Time?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        cacheHitRatio?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        cacheMemoryRate?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        bytesReadRate?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50CpuTimeUser?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95CpuTimeUser?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50CpuTimeSys?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95CpuTimeSys?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50MemAllocatedBytes?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95MemAllocatedBytes?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50FsBytesRead?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95FsBytesRead?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p50FsBytesWritten?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
        p95FsBytesWritten?: {
          __typename?: "MetricValue";
          value: string;
          unit: MetricUnit;
        } | null;
      };
    }>;
  };
  getQueryDetails: {
    __typename?: "GetQueryDetailsResponse";
    queryDetails: { __typename?: "QueryDetails"; normalizedQuery: string };
  };
  getQueryLatestExplain?: {
    __typename?: "ExplainPlan";
    plan: string;
    timestamp: any;
  } | null;
};

export type GetConnectionDetailsQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
}>;

export type GetConnectionDetailsQuery = {
  __typename?: "Query";
  explorer: {
    __typename?: "Explorer";
    currentActivity: {
      __typename?: "CurrentActivityItems";
      items: Array<{
        __typename?: "CurrentActivityItem";
        item: {
          __typename?: "CurrentActivity";
          pid: number;
          applicationName: string;
          isInternal: boolean;
          username: string;
          state: string;
          query?: string | null;
          queryStartedAt?: any | null;
          runningDurationUsecs?: number | null;
        };
      }>;
      aggregates: {
        __typename?: "CurrentActivityAggregates";
        connectionsCount: number;
        maxUsableConnections: number;
        maxConnectionsSetting: number;
        reservedConnections: number;
      };
    };
  };
};

export type GetConnectionDetailsAggregatesQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
}>;

export type GetConnectionDetailsAggregatesQuery = {
  __typename?: "Query";
  explorer: {
    __typename?: "Explorer";
    currentActivity: {
      __typename?: "CurrentActivityItems";
      aggregates: {
        __typename?: "CurrentActivityAggregates";
        connectionsCount: number;
        maxUsableConnections: number;
        maxConnectionsSetting: number;
        reservedConnections: number;
      };
    };
  };
};

export type GetHistoricalConnectionsQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  start: Scalars["Time"]["input"];
}>;

export type GetHistoricalConnectionsQuery = {
  __typename?: "Query";
  explorer: {
    __typename?: "Explorer";
    historicalConnections: Array<{
      __typename?: "HistoricalConnections";
      time: any;
      maxUsableConnections: number;
      connectionsCount: number;
    }>;
  };
};

export type GetHistoricalConnectionsNewQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  start: Scalars["Time"]["input"];
  end: Scalars["Time"]["input"];
  bucketSeconds: Scalars["Int"]["input"];
  filters?: InputMaybe<Array<MetricLabelFilter> | MetricLabelFilter>;
  connectionsCountFilters?: InputMaybe<
    Array<MetricLabelFilter> | MetricLabelFilter
  >;
}>;

export type GetHistoricalConnectionsNewQuery = {
  __typename?: "Query";
  getServiceMetrics: {
    __typename?: "ServiceMetrics";
    connectionsCount: Array<{
      __typename?: "MetricSeries";
      dataPoints: Array<{
        __typename?: "MetricDataPoint";
        time: any;
        value?: number | null;
      }>;
    }>;
    maxConnections: Array<{
      __typename?: "MetricSeries";
      dataPoints: Array<{
        __typename?: "MetricDataPoint";
        time: any;
        value?: number | null;
      }>;
    }>;
    reservedConnections: Array<{
      __typename?: "MetricSeries";
      dataPoints: Array<{
        __typename?: "MetricDataPoint";
        time: any;
        value?: number | null;
      }>;
    }>;
    superuserReservedConnections: Array<{
      __typename?: "MetricSeries";
      dataPoints: Array<{
        __typename?: "MetricDataPoint";
        time: any;
        value?: number | null;
      }>;
    }>;
  };
};

export type GetJobListQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<JobsFilters>;
  executionsLimit?: InputMaybe<Scalars["Int"]["input"]>;
  executionsStart?: InputMaybe<Scalars["Time"]["input"]>;
  executionsEnd?: InputMaybe<Scalars["Time"]["input"]>;
}>;

export type GetJobListQuery = {
  __typename?: "Query";
  explorer: {
    __typename?: "Explorer";
    jobs: {
      __typename?: "JobItems";
      items: Array<{
        __typename?: "JobItem";
        item: {
          __typename?: "Job";
          id: string;
          type: string;
          currentStart?: any | null;
          nextStart?: any | null;
          status: JobStatus;
          executions: Array<{
            __typename?: "JobExecution";
            startTime: any;
            finishTime: any;
            succeeded?: boolean | null;
          }>;
          proc: { __typename?: "ProcedureID"; name: string; schema: string };
          target?:
            | { __typename?: "ContAggID"; name: string; schema: string }
            | {
                __typename?: "TableID";
                isHypertable: boolean;
                schema: string;
                name: string;
              }
            | null;
        };
      }>;
    };
  };
};

export type GetJobByIdQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  jobId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetJobByIdQuery = {
  __typename?: "Query";
  explorer: {
    __typename?: "Explorer";
    job: {
      __typename?: "Job";
      id: string;
      config?: string | null;
      status: JobStatus;
      type: string;
      currentStart?: any | null;
      nextStart?: any | null;
      stats: {
        __typename?: "JobStats";
        successPct?: number | null;
        runtimes?: {
          __typename?: "JobRuntimeStats";
          medianDurationUsecs: number;
          p95DurationUsecs: number;
          maxDurationUsecs: number;
        } | null;
      };
      executions: Array<{
        __typename?: "JobExecution";
        startTime: any;
        finishTime: any;
        succeeded?: boolean | null;
        error?: {
          __typename?: "JobExecutionError";
          errorMessage: string;
          sqlErrorCode: string;
        } | null;
      }>;
      schedule: {
        __typename?: "JobSchedule";
        active: boolean;
        fixed: boolean;
        initialStart?: any | null;
        intervalUsecs: number;
        maxRetries: number;
        maxRuntimeUsecs: number;
        retryIntervalUsecs: number;
      };
      proc: { __typename?: "ProcedureID"; name: string; schema: string };
      target?:
        | { __typename?: "ContAggID"; name: string; schema: string }
        | {
            __typename?: "TableID";
            isHypertable: boolean;
            schema: string;
            name: string;
          }
        | null;
    };
  };
};

export type GetObjectsMetadataQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  excludePGTables?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetObjectsMetadataQuery = {
  __typename?: "Query";
  getObjectsMetadata: Array<{
    __typename?: "ExtendedObjectMetadata";
    metadata:
      | {
          __typename: "ContAggMetadata";
          approxRowCount: number;
          owner: string;
          size: number;
          parentID:
            | { __typename?: "ContAggID"; schema: string; name: string }
            | { __typename?: "TableID"; schema: string; name: string };
          id: { __typename?: "ContAggID"; name: string; schema: string };
        }
      | {
          __typename: "TableMetadata";
          approxRowCount: number;
          owner: string;
          size: number;
          id: {
            __typename?: "TableID";
            name: string;
            schema: string;
            isHypertable: boolean;
          };
        };
    hyperMetadata?: {
      __typename?: "HyperMetadata";
      hypertableId: number;
      numChunks: number;
      timeInterval: string;
      timeIntervalUsecs: number;
      compressionStats?: {
        __typename?: "CompressionStats";
        savings: number;
        compressed: number;
        uncompressed: number;
      } | null;
    } | null;
  }>;
};

export type GetCompressionRecommendationsForSegmentByQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  schema: Scalars["ID"]["input"];
  tableName?: InputMaybe<Scalars["ID"]["input"]>;
  contAggName?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetCompressionRecommendationsForSegmentByQuery = {
  __typename?: "Query";
  getCompressionRecommendationsForSegmentBy: {
    __typename?: "CompressionRecommendationsForSegmentBy";
    availableSegmentByColumns: Array<string>;
    recommendedSegmentByColumns: Array<string>;
  };
};

export type GetCompressionRecommendationsForOrderByQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  regionCode?: InputMaybe<Scalars["String"]["input"]>;
  schema: Scalars["ID"]["input"];
  tableName?: InputMaybe<Scalars["ID"]["input"]>;
  contAggName?: InputMaybe<Scalars["ID"]["input"]>;
  segmentByColumns:
    | Array<Scalars["String"]["input"]>
    | Scalars["String"]["input"];
}>;

export type GetCompressionRecommendationsForOrderByQuery = {
  __typename?: "Query";
  getCompressionRecommendationsForOrderBy: {
    __typename?: "CompressionRecommendationsForOrderBy";
    availableOrderByColumns: Array<string>;
    recommendedOrderByColumns: Array<{
      __typename?: "OrderByColumn";
      name: string;
      descending: boolean;
      nullsFirst: boolean;
    }>;
  };
};

export type GetFileImportQueryVariables = Exact<{
  data: GetFileImportInput;
}>;

export type GetFileImportQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getFileImport: {
      __typename?: "GetFileImportResponse";
      file_import: {
        __typename?: "FileImportV2";
        id: string;
        size: number;
        source: {
          __typename?: "TypeFileImportSource";
          type: FileImportSourceType;
          s3?: {
            __typename?: "TypeFileImportS3Source";
            id?: string | null;
            key: string;
            bucket: string;
            role_arn?: string | null;
          } | null;
          http?: {
            __typename?: "TypeFileImportHTTPSource";
            url: string;
          } | null;
          internal?: {
            __typename?: "TypeFileImportInternalSource";
            id: string;
          } | null;
        };
        state: {
          __typename?: "FileImportState";
          state: ImportState;
          failure_reason?: string | null;
          progress?: {
            __typename?: "OperationProgress";
            current: number;
            total?: number | null;
            message?: string | null;
          } | null;
          timelines?: Array<{
            __typename?: "FileImportStateTimeline";
            at: string;
            state: string;
            payload?: {
              __typename?: "FileImportStateTimelinePayload";
              failure_reason?: string | null;
            } | null;
          }> | null;
        };
      };
    };
  } | null;
};

export type PreviewSourceQueryVariables = Exact<{
  data: PreviewSourceInput;
}>;

export type PreviewSourceQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    previewSource: {
      __typename?: "PreviewSourceResponse";
      has_header: boolean;
      bytes?: number | null;
      columns: Array<{
        __typename?: "ColumnPreview";
        name: string;
        type: string;
        content: string;
      }>;
    };
  } | null;
};

export type ListBucketObjectsQueryVariables = Exact<{
  data: ListBucketObjectsInput;
}>;

export type ListBucketObjectsQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    listBucketObjects: {
      __typename?: "ListBucketObjectsResponse";
      objects: Array<{
        __typename?: "BucketObject";
        key: string;
        bytes: number;
      }>;
    };
  } | null;
};

export type ListS3LiveSyncQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
}>;

export type ListS3LiveSyncQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    listS3LiveSync?: Array<{
      __typename?: "S3LiveSync";
      id: string;
      name?: string | null;
      pattern: string;
      created_at: string;
      updated_at: string;
      enabled: boolean;
      bucket: string;
      next_tick?: string | null;
      frequency?: string | null;
      last_error?: string | null;
      credentials?: {
        __typename?: "S3LiveSyncCredentials";
        type: S3LiveSyncCredentialsType;
        role?: {
          __typename?: "S3LiveSyncRequestCredentialsRole";
          arn: string;
        } | null;
      } | null;
      definition?: {
        __typename?: "S3LiveSyncDefinition";
        type: S3LiveSyncDefinitionType;
      } | null;
      table_identifier?: {
        __typename?: "TableIdentifier";
        table_name: string;
        schema_name?: string | null;
      } | null;
    }> | null;
  } | null;
};

export type GetS3LiveSyncQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
}>;

export type GetS3LiveSyncQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getS3LiveSync: {
      __typename?: "S3LiveSync";
      id: string;
      name?: string | null;
      pattern: string;
      last_imported_object?: string | null;
      created_at: string;
      updated_at: string;
      enabled: boolean;
      bucket: string;
      next_tick?: string | null;
      frequency?: string | null;
      last_error?: string | null;
      credentials?: {
        __typename?: "S3LiveSyncCredentials";
        type: S3LiveSyncCredentialsType;
        role?: {
          __typename?: "S3LiveSyncRequestCredentialsRole";
          arn: string;
        } | null;
      } | null;
      settings?: {
        __typename?: "ImportSettings";
        on_conflict_do_nothing?: boolean | null;
      } | null;
      definition?: {
        __typename?: "S3LiveSyncDefinition";
        type: S3LiveSyncDefinitionType;
        csv?: {
          __typename?: "S3LiveSyncRequestDefinitionCSV";
          auto_column_mapping?: boolean | null;
          column_names?: Array<string> | null;
          delimiter?: string | null;
          skip_header?: boolean | null;
          column_mappings?: Array<{
            __typename?: "ColumnMapping";
            source: string;
            destination: string;
          }> | null;
        } | null;
        parquet?: {
          __typename?: "S3LiveSyncRequestDefinitionParquet";
          auto_column_mapping?: boolean | null;
          column_mappings?: Array<{
            __typename?: "ColumnMapping";
            source: string;
            destination: string;
          }> | null;
        } | null;
      } | null;
      table_identifier?: {
        __typename?: "TableIdentifier";
        table_name: string;
        schema_name?: string | null;
      } | null;
    };
  } | null;
};

export type ListFileImportQueryVariables = Exact<{
  data: ListFileImportInput;
}>;

export type ListFileImportQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    listFileImport: {
      __typename?: "ListFileImportResponse";
      file_imports: Array<{
        __typename?: "FileImportV2";
        id: string;
        created_at: string;
        size: number;
        source: {
          __typename?: "TypeFileImportSource";
          type: FileImportSourceType;
          s3?: { __typename?: "TypeFileImportS3Source"; key: string } | null;
        };
        definition: {
          __typename?: "FileImportDefinition";
          type: FileImportDefinitionType;
        };
        table_identifier: {
          __typename?: "TableIdentifier";
          table_name: string;
          schema_name?: string | null;
        };
        state: {
          __typename?: "FileImportState";
          state: ImportState;
          failure_reason?: string | null;
          progress?: {
            __typename?: "OperationProgress";
            current: number;
            message?: string | null;
            total?: number | null;
          } | null;
        };
      }>;
      page_info: {
        __typename?: "PageInfo";
        end_cursor?: string | null;
        has_next_page: boolean;
      };
    };
  } | null;
};

export type GetS3LiveSyncAuditQueryVariables = Exact<{
  data: GetS3LiveSyncAuditInput;
}>;

export type GetS3LiveSyncAuditQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getS3LiveSyncAudit: {
      __typename?: "GetS3LiveSyncAuditResponse";
      entries: Array<{ __typename?: "S3LiveSyncAudit"; at: string }>;
    };
  } | null;
};

export type GetS3LiveSyncStatisticsQueryVariables = Exact<{
  data: GetS3LiveSyncStatisticsInput;
}>;

export type GetS3LiveSyncStatisticsQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getS3LiveSyncStatistics: {
      __typename?: "GetS3LiveSyncStatisticsResponse";
      statistics: {
        __typename?: "S3LiveSyncStatistics";
        total_size_bytes: number;
        total_failed_objects: number;
        state_counts: Array<{
          __typename?: "StateCount";
          state: string;
          count: number;
        }>;
      };
    };
  } | null;
};

export type GetConnectorsQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  connectorType: ConnectorType;
}>;

export type GetConnectorsQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getConnectors: {
      __typename?: "GetConnectorsResponse";
      connectors: Array<{
        __typename?: "ConnectorDetails";
        displayName: string;
        created: any;
        state: ConnectorState;
        stateMessage: string;
        kafkasrc?: {
          __typename?: "KafkaConnectorDetails";
          id: string;
          enabled: boolean;
        } | null;
        icebergdst?: {
          __typename?: "IcebergDstConnectorDetails";
          id: string;
          catalogS3Tables?: {
            __typename?: "CatalogS3TablesDetails";
            bucketArn: string;
            iamRoleArn: string;
          } | null;
          catalogRest?: {
            __typename?: "CatalogRestDetails";
            uri: string;
            warehouse: string;
            clientId: string;
            scope: string;
            oauth2ServerUri?: string | null;
            vendedCredentials: boolean;
            additionalHeaders?: any | null;
          } | null;
          status?: {
            __typename?: "IcebergDstConnectorDetailsStatus";
            lastCommittedTxnTime?: any | null;
            metricsUpdatedAt: any;
            throughput?: number | null;
            totalRecords?: string | null;
            bytesRead?: string | null;
            confirmedFlushLsn?: string | null;
            restartLsn?: string | null;
            sourceWalLsn?: string | null;
          } | null;
        } | null;
        pgsrc?: {
          __typename?: "PgSrcConnectorDetails";
          id: string;
          enabled: boolean;
          status?: {
            __typename?: "PgSrcConnectorDetailsStatus";
            lastReplicatedTxnTime: any;
          } | null;
        } | null;
      }>;
    };
  } | null;
};

export type GetSourceConnectorsQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  s3ProjectId: Scalars["ID"]["input"];
  s3ServiceId: Scalars["ID"]["input"];
}>;

export type GetSourceConnectorsQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    s3Connectors?: Array<{
      __typename?: "S3LiveSync";
      id: string;
      name?: string | null;
      pattern: string;
      created_at: string;
      updated_at: string;
      enabled: boolean;
      bucket: string;
      next_tick?: string | null;
      frequency?: string | null;
      last_error?: string | null;
      credentials?: {
        __typename?: "S3LiveSyncCredentials";
        type: S3LiveSyncCredentialsType;
        role?: {
          __typename?: "S3LiveSyncRequestCredentialsRole";
          arn: string;
        } | null;
      } | null;
      definition?: {
        __typename?: "S3LiveSyncDefinition";
        type: S3LiveSyncDefinitionType;
      } | null;
      table_identifier?: {
        __typename?: "TableIdentifier";
        table_name: string;
        schema_name?: string | null;
      } | null;
    }> | null;
    kafkaConnectors: {
      __typename?: "GetConnectorsResponse";
      connectors: Array<{
        __typename?: "ConnectorDetails";
        displayName: string;
        created: any;
        state: ConnectorState;
        stateMessage: string;
        kafkasrc?: {
          __typename?: "KafkaConnectorDetails";
          id: string;
          enabled: boolean;
        } | null;
      }>;
    };
    postgresConnectors: {
      __typename?: "GetConnectorsResponse";
      connectors: Array<{
        __typename?: "ConnectorDetails";
        displayName: string;
        created: any;
        state: ConnectorState;
        stateMessage: string;
        pgsrc?: {
          __typename?: "PgSrcConnectorDetails";
          id: string;
          enabled: boolean;
          status?: {
            __typename?: "PgSrcConnectorDetailsStatus";
            lastReplicatedTxnTime: any;
          } | null;
        } | null;
      }>;
    };
  } | null;
};

export type GetConnectorQueryVariables = Exact<{
  data: GetConnectorInput;
}>;

export type GetConnectorQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getConnector: {
      __typename?: "GetConnectorResponse";
      connector: {
        __typename?: "ConnectorDetails";
        displayName: string;
        created: any;
        state: ConnectorState;
        stateMessage: string;
        kafkasrc?: {
          __typename?: "KafkaConnectorDetails";
          id: string;
          kafkaClusterConfigId: string;
          schemaRegistryConfigId: string;
          kafkaTopic: string;
          tableSchema: string;
          tableName: string;
          enabled: boolean;
        } | null;
        s3tabledst?: {
          __typename?: "S3TableDstConnectorDetails";
          id: string;
          enabled: boolean;
        } | null;
        pgsrc?: {
          __typename?: "PgSrcConnectorDetails";
          id: string;
          sourceConfigId: string;
          enabled: boolean;
          tableSyncWorkers?: number | null;
          publicationNames?: Array<string> | null;
          createdAt: any;
          status?: {
            __typename?: "PgSrcConnectorDetailsStatus";
            lastReplicatedTxnTime: any;
            lastReplicatedLsn: number;
            lastReplicatedLsnStr: string;
            sourceFlushLsn: number;
            sourceFlushLsnStr: string;
            appliedOperationsCount: number;
            metricsUpdatedAt?: any | null;
            ready: boolean;
          } | null;
        } | null;
      };
    };
  } | null;
};

export type GetKafkaTopicsFromClusterQueryVariables = Exact<{
  data: GetKafkaTopicsFromClusterInput;
}>;

export type GetKafkaTopicsFromClusterQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getKafkaTopicsFromCluster: {
      __typename?: "GetKafkaTopicsFromClusterResponse";
      topics: Array<{ __typename?: "KafkaTopic"; name: string }>;
    };
  } | null;
};

export type GetKafkaTopicSchemaMappingQueryVariables = Exact<{
  data: GetKafkaTopicSchemaMappingInput;
}>;

export type GetKafkaTopicSchemaMappingQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getKafkaTopicSchemaMapping: {
      __typename?: "GetKafkaTopicSchemaMappingResponse";
      topicDetails: {
        __typename?: "TopicDetails";
        topicName: string;
        schemaFormat: string;
        fields: Array<{
          __typename?: "FieldInfo";
          fieldName: string;
          fieldType: string;
        }>;
        schemaDefinition: {
          __typename?: "SchemaDefinition";
          schemaId: number;
          definition: string;
        };
      };
      mappedTableDetails: {
        __typename?: "MappedTableDetails";
        tableSchema: string;
        tableName: string;
        fields: Array<{
          __typename?: "FieldInfo";
          fieldName: string;
          fieldType: string;
        }>;
      };
    };
  } | null;
};

export type GetKafkaSrcConnectorStatusQueryVariables = Exact<{
  data: GetKafkaSrcConnectorStatusInput;
}>;

export type GetKafkaSrcConnectorStatusQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getKafkaSrcConnectorStatus: {
      __typename?: "GetKafkaSrcConnectorStatusResponse";
      status: {
        __typename?: "KafkaSrcConnectorStatus";
        id: string;
        messagesProcessedTotal?: string | null;
        bytesIngestedTotal?: string | null;
        consumerLagMessages?: number | null;
        recordErrorCount?: number | null;
        operationalErrorCount?: number | null;
        lastMessageProcessedAt?: any | null;
        lastMessageEventTimestamp?: any | null;
        updated?: any | null;
        ready?: boolean | null;
      };
    };
  } | null;
};

export type GetPgSrcPublicationsQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  sourceId: Scalars["String"]["input"];
}>;

export type GetPgSrcPublicationsQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getPgSrcPublications: {
      __typename?: "GetPgSrcPublicationsResponse";
      publications: Array<{
        __typename?: "PgPublication";
        publicationName: string;
      }>;
    };
  } | null;
};

export type GetPgSrcPublicationTablesQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  sourceId: Scalars["String"]["input"];
  publicationName: Scalars["String"]["input"];
}>;

export type GetPgSrcPublicationTablesQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getPgSrcPublicationTables: {
      __typename?: "GetPgSrcPublicationTablesResponse";
      tables: Array<{
        __typename?: "PgSrcTable";
        table: {
          __typename?: "ConnectorTableIdentifier";
          schemaName: string;
          tableName: string;
        };
      }>;
    };
  } | null;
};

export type GetPgSrcSchemasQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  sourceId: Scalars["String"]["input"];
}>;

export type GetPgSrcSchemasQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getPgSrcSchemas: {
      __typename?: "GetPgSrcSchemasResponse";
      schemas: Array<string>;
    };
  } | null;
};

export type GetPgSrcTablesQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  schemaName: Scalars["String"]["input"];
  sourceId: Scalars["String"]["input"];
}>;

export type GetPgSrcTablesQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getPgSrcTables: {
      __typename?: "GetPgSrcTablesResponse";
      tables: Array<{
        __typename?: "PgSrcTable";
        approximateRows: number;
        approximateSize: number;
        table: {
          __typename?: "ConnectorTableIdentifier";
          schemaName: string;
          tableName: string;
        };
        columns: Array<{
          __typename?: "ConnectorTableColumn";
          name: string;
          type: string;
        }>;
        hypertableSpec?: {
          __typename?: "HypertableSpec";
          primaryDimension: {
            __typename?: "HypertableRangeDimension";
            columnName: string;
            partitionInterval: string;
          };
        } | null;
      }>;
    };
  } | null;
};

export type GetPgSrcTargetTablesQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  connectorId: Scalars["String"]["input"];
}>;

export type GetPgSrcTargetTablesQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getPgSrcConnectorTargetTables: {
      __typename?: "GetPgSrcConnectorTargetTablesResponse";
      tables: Array<{
        __typename?: "PgSrcConnectorTargetTable";
        state: string;
        rowsCopied: number;
        bytesCopied: number;
        approximateRows: number;
        approximateSize: number;
        lastError?: string | null;
        table: {
          __typename?: "ConnectorTableSpec";
          table: {
            __typename?: "ConnectorTableIdentifier";
            schemaName: string;
            tableName: string;
          };
          tableMapping?: {
            __typename?: "ConnectorTableIdentifier";
            schemaName: string;
            tableName: string;
          } | null;
          hypertableSpec?: {
            __typename?: "HypertableSpec";
            primaryDimension: {
              __typename?: "HypertableRangeDimension";
              columnName: string;
              partitionInterval: string;
            };
          } | null;
        };
      }>;
    };
  } | null;
};

export type GetConnectorTargetTablesQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  connectorId: Scalars["String"]["input"];
}>;

export type GetConnectorTargetTablesQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getConnectorTargetTables: {
      __typename?: "GetConnectorTargetTablesResponse";
      icebergdst?: {
        __typename?: "IcebergDstConnectorTargetTables";
        tables: Array<{
          __typename?: "IcebergDstConnectorTargetTable";
          state: IcebergDstConnectorTargetTableState;
          lastError?: string | null;
          snapshotStartedAt?: any | null;
          snapshotCompletedAt?: any | null;
          snapshotAttemptCount: number;
          icebergSchema: string;
          icebergTable: string;
          rowsCopied?: string | null;
          approximateRows?: string | null;
          table: {
            __typename?: "ConnectorTableIdentifier";
            schemaName: string;
            tableName: string;
          };
        }>;
      } | null;
    };
  } | null;
};

export type GetSshTunnelConfigQueryVariables = Exact<{
  data: GetSshTunnelConfigInput;
}>;

export type GetSshTunnelConfigQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getSSHTunnelConfig: {
      __typename?: "GetSSHTunnelConfigResponse";
      sshTunnelConfig: {
        __typename?: "SSHTunnelConfig";
        sshTunnelId: string;
        name: string;
        host?: string | null;
        port?: number | null;
        username?: string | null;
        publicKey: string;
        projectId: string;
        createdAt: any;
        updatedAt: any;
      };
    };
  } | null;
};

export type GetSshTunnelConfigsQueryVariables = Exact<{
  data: GetSshTunnelConfigsInput;
}>;

export type GetSshTunnelConfigsQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getSSHTunnelConfigs: {
      __typename?: "GetSSHTunnelConfigsResponse";
      sshTunnelConfigs: Array<{
        __typename?: "SSHTunnelConfig";
        sshTunnelId: string;
        name: string;
        host?: string | null;
        port?: number | null;
        username?: string | null;
        publicKey: string;
        projectId: string;
        createdAt: any;
        updatedAt: any;
      }>;
    };
  } | null;
};

export type VerifySshTunnelConfigQueryVariables = Exact<{
  data: VerifySshTunnelConfigInput;
}>;

export type VerifySshTunnelConfigQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    verifySSHTunnelConfig: {
      __typename?: "VerifySSHTunnelConfigResponse";
      success: boolean;
    };
  } | null;
};

export type GetPgSrcConfigQueryVariables = Exact<{
  data: GetPgSrcConfigInput;
}>;

export type GetPgSrcConfigQuery = {
  __typename?: "Query";
  connectors?: {
    __typename?: "ConnectorsQuerier";
    getPgSrcConfig: {
      __typename?: "GetPgSrcConfigResponse";
      sourceConfig: {
        __typename?: "PgSrcConfig";
        sourceId: string;
        projectId: string;
        name: string;
        sshTunnelId?: string | null;
        connectionString: string;
        createdAt: any;
        updatedAt: any;
      };
    };
  } | null;
};

export type GetVirtualPlansQueryVariables = Exact<{ [key: string]: never }>;

export type GetVirtualPlansQuery = {
  __typename?: "Query";
  getVirtualPlans: {
    __typename?: "GetVirtualPlansResponse";
    plans: Array<{ __typename?: "VirtualPlan"; kind: VirtualPlanType }>;
  };
};

export type GetPlanDowngradeCheckQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  downgradeTo: VirtualPlanType;
}>;

export type GetPlanDowngradeCheckQuery = {
  __typename?: "Query";
  downgradeCheck: {
    __typename?: "EntitlementDowngradeResponse";
    dependencies?: Array<EntitlementKind> | null;
  };
};

export type GetCurrentCostQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars["ID"]["input"]>;
  billingAccountId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetCurrentCostQuery = {
  __typename?: "Query";
  getCurrentCost: {
    __typename?: "BillingAccountCostInfo";
    costToDate: number;
    costToDateGross: number;
    billingPeriodStart: any;
    billingPeriodEnd: any;
    serviceCostInfos: Array<{
      __typename?: "ServiceCostInfo";
      serviceID: string;
      costToDateGross: number;
      productCostInfos: Array<{
        __typename?: "ProductCostInfo";
        productID: string;
        productName?: string | null;
        costToDate: number;
      }>;
    }>;
    productCostInfos: Array<{
      __typename?: "ProductCostInfo";
      productID: string;
      productName?: string | null;
      costToDate: number;
      costToDateGross: number;
    }>;
  };
};

export type GetMonthRemainderEstimateQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars["ID"]["input"]>;
  billingAccountId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetMonthRemainderEstimateQuery = {
  __typename?: "Query";
  getMonthRemainderEstimate: number;
};

export type GetRecoveryProgressQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
}>;

export type GetRecoveryProgressQuery = {
  __typename?: "Query";
  getRecoveryProgress: Array<{
    __typename?: "RecoveryProgress";
    recorded: any;
    ordinal: number;
    lag: number;
  }>;
};

export type GetRecommendationsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type GetRecommendationsQuery = {
  __typename?: "Query";
  getRecommendations: Array<{
    __typename?: "Recommendation";
    id: string;
    projectId: string;
    serviceId: string;
    resourceId?: string | null;
    message: string;
    created: any;
    updated: any;
    type: RecommendationType;
    actionText?: string | null;
    category?: string | null;
    title?: string | null;
    metadata?:
      | {
          __typename?: "HypertableChangeChunkTimeIntervalMetadata";
          tableName: string;
          schemaName: string;
          recommendedIntervalSeconds: number;
        }
      | { __typename?: "JobFailedNTimesMetadata" }
      | null;
  }>;
};

export type GetActivityLogQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  serviceId?: InputMaybe<Scalars["String"]["input"]>;
  start?: InputMaybe<Scalars["Time"]["input"]>;
  end?: InputMaybe<Scalars["Time"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type GetActivityLogQuery = {
  __typename?: "Query";
  activityLog: {
    __typename?: "ActivityLogItems";
    items: Array<{
      __typename?: "ActivityLogItem";
      item: {
        __typename?: "ActivityLog";
        id: string;
        timestamp: any;
        eventType: string;
        serviceId: string;
        description: string;
        user?: { __typename?: "User"; name: string; email: string } | null;
      };
    }>;
  };
};

export type GetChunkTuningStatusQueryVariables = Exact<{
  projectId: Scalars["String"]["input"];
  serviceId: Scalars["String"]["input"];
  hypertableId: Scalars["Int"]["input"];
}>;

export type GetChunkTuningStatusQuery = {
  __typename?: "Query";
  dbagent: {
    __typename?: "DBAgent";
    getChunkTuningStatus: {
      __typename?: "ChunkTuningStatus";
      enabled: boolean;
      recommendedInterval: number;
      preTunerInterval?: number | null;
    };
  };
};

export type ListPrivateLinksAuthorizationsConnectionsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type ListPrivateLinksAuthorizationsConnectionsQuery = {
  __typename?: "Query";
  connections: Array<{
    __typename?: "PrivateEndpointConnection";
    connectionId: string;
    principalId: string;
    cloudProvider: PrivateLinkCloudProvider;
    linkIdentifier: string;
    state: ConnectionState;
    ipAddress?: string | null;
    name: string;
    providerConnectionId: string;
    region: string;
    createdAt: any;
    bindings: Array<{
      __typename?: "EndpointServiceBinding";
      projectId: string;
      serviceId: string;
      connectionId: string;
      bindingType: EndpointBindingType;
      port: number;
      hostname: string;
      createdAt: any;
    }>;
  }>;
};

export type ListPrivateLinkConnectionsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type ListPrivateLinkConnectionsQuery = {
  __typename?: "Query";
  connections: Array<{
    __typename?: "PrivateEndpointConnection";
    connectionId: string;
    principalId: string;
    cloudProvider: PrivateLinkCloudProvider;
    linkIdentifier: string;
    state: ConnectionState;
    ipAddress?: string | null;
    name: string;
    providerConnectionId: string;
    region: string;
    createdAt: any;
    bindings: Array<{
      __typename?: "EndpointServiceBinding";
      projectId: string;
      serviceId: string;
      connectionId: string;
      bindingType: EndpointBindingType;
      port: number;
      hostname: string;
      createdAt: any;
    }>;
  }>;
};

export type ListPrivateLinkRegionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ListPrivateLinkRegionsQuery = {
  __typename?: "Query";
  regions: Array<{
    __typename?: "PrivateLinkAvailableRegion";
    region: string;
    cloudProvider: PrivateLinkCloudProvider;
    serviceName: string;
  }>;
};

export type GetPrivateLinkServiceConnectionsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
}>;

export type GetPrivateLinkServiceConnectionsQuery = {
  __typename?: "Query";
  connections: {
    __typename?: "PrivateLinkServiceConnectionsResult";
    connections: Array<{
      __typename?: "PrivateEndpointConnection";
      connectionId: string;
      principalId: string;
      cloudProvider: PrivateLinkCloudProvider;
      linkIdentifier: string;
      state: ConnectionState;
      ipAddress?: string | null;
      name: string;
      providerConnectionId: string;
      region: string;
      createdAt: any;
      bindings: Array<{
        __typename?: "EndpointServiceBinding";
        projectId: string;
        serviceId: string;
        connectionId: string;
        bindingType: EndpointBindingType;
        port: number;
        hostname: string;
        createdAt: any;
      }>;
    }>;
  };
};

export type GetSupportCasesQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
}>;

export type GetSupportCasesQuery = {
  __typename?: "Query";
  getSupportCases: Array<{
    __typename?: "SupportCase";
    id: string;
    caseNumber: string;
    subject: string;
    isClosed: boolean;
    createdDate: any;
    suppliedEmail?: string | null;
    impact?: string | null;
    isProduction?: boolean | null;
    messages: Array<{
      __typename?: "SupportCaseMessage";
      fromName?: string | null;
      incoming: boolean;
      textBody?: string | null;
      htmlBody?: string | null;
      messageDate: any;
      attachments: Array<{
        __typename?: "SupportCaseAttachment";
        contentDocumentId: string;
        title: string;
        fileExtension?: string | null;
        contentSize: number;
        url: string;
      }>;
    }>;
  }>;
};

export type GetCrossRegionBackupsStatusQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
}>;

export type GetCrossRegionBackupsStatusQuery = {
  __typename?: "Query";
  crossRegionBackupsStatusV2?: {
    __typename?: "CrossRegionBackupStatusV2";
    enabled: boolean;
    regions: Array<{
      __typename?: "BackupRegion";
      region: string;
      createdAt: any;
    }>;
  } | null;
};

export type GetBackupsRetentionStatusQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
}>;

export type GetBackupsRetentionStatusQuery = {
  __typename?: "Query";
  backupsRetentionStatus: {
    __typename?: "BackupsRetentionStatusResponse";
    retType: string;
    retCount: number;
  };
};

export type ListForkRegionsQueryVariables = Exact<{
  projectId: Scalars["ID"]["input"];
  serviceId: Scalars["ID"]["input"];
}>;

export type ListForkRegionsQuery = {
  __typename?: "Query";
  listForkRegions: {
    __typename?: "ListForkRegionsResponse";
    regions?: Array<string> | null;
  };
};

export type BillingTimelineQueryVariables = Exact<{
  billingAccountId: Scalars["ID"]["input"];
}>;

export type BillingTimelineQuery = {
  __typename?: "Query";
  billingTimeline: {
    __typename?: "BillingTimeline";
    currency: string;
    timelineBegin: any;
    timelineEnd: any;
    dailyCompositions: Array<{
      __typename?: "DailyComposition";
      date: any;
      total: number;
      products: Array<{
        __typename?: "DailyCompositionProductCost";
        productId: string;
        productName: string;
        cost: number;
      }>;
    }>;
  };
};

export type UserSessionsQueryVariables = Exact<{ [key: string]: never }>;

export type UserSessionsQuery = {
  __typename?: "Query";
  userSessions: Array<{
    __typename?: "UserSession";
    sid: string;
    deviceType: string;
    deviceName: string;
    ipAddress: string;
    country: string;
    city: string;
    created?: any | null;
    lastUsed?: any | null;
    isCurrent: boolean;
  }>;
};
